// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Author         : G-axon
Template Name  : Jumbo React - Admin Template
Version        : 1.0
*/
/*=============================================================
    Table of Contents:
    =============================
    A. Globals
        01. Custom Animation
    B. Base
        01. Base Styles
        02. Typography Styles
    C. Layouts
        01. App Layout Styles
        02. Sidebar Styles
        03. Header Styles
        04. Main Content Styles
        05. Footer Styles
        06. Right Sidebar Styles
    D. UI Components
        01. Alert Styles
        02. Avatar Styles
        03. Badges Styles
        04. Blockquotes Styles
        05. Bottom Navigation Styles
        06. Breadcrumb Styles
        07. Button Styles
        08. Button Group Styles
        09. Callout Styles
        10. Cards Styles
        11. Charts Styles
        12. Chips Styles
        13. Carousel Styles
        14. Color Picker Styles
        15. Drawer Styles
        16. E-commerce Styles
        17. Grids List Styles
        18. Icons Styles
        19. Label Styles
        20. List Styles
        21. Nav Style
        22. Pricing Styles
        23. Progressbar Styles
        24. Popover Styles
        25. React Joyride Styles
        26. Tables Styles
        27. Tabs Styles
        28. Testimonial Styles
        29. Time Lines Style
        30. Joyride Tour Styles
        31. Form Styles
    E. Pages
        01. Login Styles
        02. Error Styles
        03. Editor Styles
        04. Contact Page Styles
        05. Portfolio Styles
        06. Faqs Styles
        07. Dashboard Styles
    F. Slider
    G. Modules
        01. App Module Style
        02. Chat Module Styles
        03. Mails Module Styles
        04. Contact Module Styles
        05. Calendar Module Style
  =============================================================*/
/* Globals
   ========================================================================== */
.jr-menu-icon .menu-icon {
  position: relative;
  width: 70%;
  height: 1px;
  min-height: 1px;
  color: inherit;
  background-color: #808080;
  display: block;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  margin: 6px 0;
  cursor: pointer;
}
.jr-menu-icon .menu-icon:after, .jr-menu-icon .menu-icon:before {
  position: absolute;
  display: block;
  color: inherit;
  background-color: inherit;
  left: 0;
  height: 1px;
  min-height: 1px;
  content: "";
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.jr-menu-icon .menu-icon:after {
  width: 120%;
  bottom: -6px;
}
.jr-menu-icon .menu-icon:before {
  width: 130%;
  top: -6px;
}
.jr-menu-icon:hover .menu-icon {
  width: 100%;
}
.jr-menu-icon:hover .menu-icon:after, .jr-menu-icon:hover .menu-icon:before {
  width: 100%;
}

.timeline-badge, .user-list .user-avatar, .jr-fab-btn, .user-avatar, .size-50 {
  height: 50px !important;
  width: 50px !important;
  line-height: 50px;
}

.jr-btn-fab-lg, .size-60 {
  height: 60px !important;
  width: 60px !important;
  line-height: 60px;
}

.size-80 {
  height: 80px !important;
  width: 80px !important;
  line-height: 80px;
}

.size-100 {
  height: 100px !important;
  width: 100px !important;
  line-height: 100px;
}

.size-20 {
  height: 20px !important;
  width: 20px !important;
  line-height: 20px;
}

.icon, .jr-btn-fab-xs, .jr-menu-icon, .size-30 {
  height: 30px !important;
  width: 30px !important;
  line-height: 30px;
}

.jr-btn-fab-sm, .size-40 {
  height: 40px !important;
  width: 40px !important;
  line-height: 40px;
}

.profile-intro img.avatar-circle, .size-120 {
  height: 120px !important;
  width: 120px !important;
  line-height: 120px;
}

.icon-addon {
  display: inline-block;
  text-align: center;
  background-color: inherit;
}

.jr-card {
  padding: 24px 30px;
  margin-bottom: 34px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #ced4da;
  position: relative;
}

/* Ripple magic */
.ripple-effect {
  position: relative;
  overflow: hidden;
}
.ripple-effect:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}
.ripple-effect:hover:after {
  animation: ripple 1s ease-out;
}

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(60, 60);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(100, 100);
  }
}
@-webkit-keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(60, 60);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(100, 100);
  }
}
.quick-menu .icon-alert:after {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  -moz-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  -o-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  animation: pulse 2s infinite;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
.chat-avatar-mode .chat-mode.offline, .chat-avatar-mode .chat-mode.online {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  -moz-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  -o-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  animation: online 2s infinite;
}

@-webkit-keyframes online {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
@keyframes online {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
.chat-avatar-mode .chat-mode.away {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  -moz-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  -o-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  animation: away 2s infinite;
}

@-webkit-keyframes away {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
  }
}
@keyframes away {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
    box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
  }
}
/*Different size images set in Equal block height and width*/
.brand-logo, .grid-thumb-equal {
  position: relative;
  padding-bottom: 68%;
  height: 0;
  width: 100%;
  overflow: hidden;
}

.brand-logo .brand-logo-inner, .grid-thumb-cover {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
}

.grid-thumb-cover img {
  height: auto;
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  width: 100%;
}

a.badge-dark, a.badge-info, a.badge-warning, a.badge-danger, a.badge-success, a.btn-dark, a.btn-success, a.btn-warning, a.btn-danger, a.btn-info {
  color: #fff !important;
}
a.badge-dark:hover, a.badge-info:hover, a.badge-warning:hover, a.badge-danger:hover, a.badge-success:hover, a.btn-dark:hover, a.btn-success:hover, a.btn-warning:hover, a.btn-danger:hover, a.btn-info:hover, a.badge-dark:focus, a.badge-info:focus, a.badge-warning:focus, a.badge-danger:focus, a.badge-success:focus, a.btn-dark:focus, a.btn-success:focus, a.btn-warning:focus, a.btn-danger:focus, a.btn-info:focus {
  color: #fff !important;
}

.carousel-control-next, .carousel-control-prev {
  cursor: pointer;
}

.btn:not([disabled]):not(.disabled):active,
.btn-info:not([disabled]):not(.disabled):active,
.btn-success:not([disabled]):not(.disabled):active,
.btn-warning:not([disabled]):not(.disabled):active,
.btn-danger:not([disabled]):not(.disabled):active,
.btn-light:not([disabled]):not(.disabled):active,
.btn-dark:not([disabled]):not(.disabled):active,
.btn-primary:not([disabled]):not(.disabled):active,
.btn-secondary:not([disabled]):not(.disabled):active, .btn:not([disabled]):not(.disabled).active,
.btn-info:not([disabled]):not(.disabled).active,
.btn-success:not([disabled]):not(.disabled).active,
.btn-warning:not([disabled]):not(.disabled).active,
.btn-danger:not([disabled]):not(.disabled).active,
.btn-light:not([disabled]):not(.disabled).active,
.btn-dark:not([disabled]):not(.disabled).active,
.btn-primary:not([disabled]):not(.disabled).active,
.btn-secondary:not([disabled]):not(.disabled).active {
  background-image: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
.btn:not([disabled]):not(.disabled):active:focus,
.btn-info:not([disabled]):not(.disabled):active:focus,
.btn-success:not([disabled]):not(.disabled):active:focus,
.btn-warning:not([disabled]):not(.disabled):active:focus,
.btn-danger:not([disabled]):not(.disabled):active:focus,
.btn-light:not([disabled]):not(.disabled):active:focus,
.btn-dark:not([disabled]):not(.disabled):active:focus,
.btn-primary:not([disabled]):not(.disabled):active:focus,
.btn-secondary:not([disabled]):not(.disabled):active:focus, .btn:not([disabled]):not(.disabled).active:focus,
.btn-info:not([disabled]):not(.disabled).active:focus,
.btn-success:not([disabled]):not(.disabled).active:focus,
.btn-warning:not([disabled]):not(.disabled).active:focus,
.btn-danger:not([disabled]):not(.disabled).active:focus,
.btn-light:not([disabled]):not(.disabled).active:focus,
.btn-dark:not([disabled]):not(.disabled).active:focus,
.btn-primary:not([disabled]):not(.disabled).active:focus,
.btn-secondary:not([disabled]):not(.disabled).active:focus {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-25 {
  max-width: 25% !important;
}

.mw-50 {
  max-width: 50% !important;
}

.mw-75 {
  max-width: 75% !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mw-auto {
  max-width: auto !important;
}

.mh-25 {
  max-height: 25% !important;
}

.mh-50 {
  max-height: 50% !important;
}

.mh-75 {
  max-height: 75% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.mh-auto {
  max-height: auto !important;
}

.bg-primary {
  background-color: #3f51b5 !important;
}

.text-primary {
  color: #3f51b5 !important;
}
.text-primary.icon-outline {
  border-color: #3f51b5 !important;
}

.bg-primary.lighten-5 {
  background-color: #e8eaf6 !important;
}

.text-primary.text-lighten-5 {
  color: #e8eaf6 !important;
}
.text-primary.text-lighten-5.icon-outline {
  border-color: #e8eaf6 !important;
}

.bg-primary.lighten-4 {
  background-color: #c5cae9 !important;
}

.text-primary.text-lighten-4 {
  color: #c5cae9 !important;
}
.text-primary.text-lighten-4.icon-outline {
  border-color: #c5cae9 !important;
}

.bg-primary.lighten-3 {
  background-color: #9fa8da !important;
}

.text-primary.text-lighten-3 {
  color: #9fa8da !important;
}
.text-primary.text-lighten-3.icon-outline {
  border-color: #9fa8da !important;
}

.bg-primary.lighten-2 {
  background-color: #7986cb !important;
}

.text-primary.text-lighten-2 {
  color: #7986cb !important;
}
.text-primary.text-lighten-2.icon-outline {
  border-color: #7986cb !important;
}

.bg-primary.lighten-1 {
  background-color: #5c6bc0 !important;
}

.text-primary.text-lighten-1 {
  color: #5c6bc0 !important;
}
.text-primary.text-lighten-1.icon-outline {
  border-color: #5c6bc0 !important;
}

.bg-primary.darken-1 {
  background-color: #3949ab !important;
}

.text-primary.text-darken-1 {
  color: #3949ab !important;
}
.text-primary.text-darken-1.icon-outline {
  border-color: #3949ab !important;
}

.bg-primary.darken-2 {
  background-color: #303f9f !important;
}

.text-primary.text-darken-2 {
  color: #303f9f !important;
}
.text-primary.text-darken-2.icon-outline {
  border-color: #303f9f !important;
}

.bg-primary.darken-3 {
  background-color: #283593 !important;
}

.text-primary.text-darken-3 {
  color: #283593 !important;
}
.text-primary.text-darken-3.icon-outline {
  border-color: #283593 !important;
}

.bg-primary.darken-4 {
  background-color: #1a237e !important;
}

.text-primary.text-darken-4 {
  color: #1a237e !important;
}
.text-primary.text-darken-4.icon-outline {
  border-color: #1a237e !important;
}

.bg-primary.accent-1 {
  background-color: #8c9eff !important;
}

.text-primary.text-accent-1 {
  color: #8c9eff !important;
}
.text-primary.text-accent-1.icon-outline {
  border-color: #8c9eff !important;
}

.bg-primary.accent-2 {
  background-color: #536dfe !important;
}

.text-primary.text-accent-2 {
  color: #536dfe !important;
}
.text-primary.text-accent-2.icon-outline {
  border-color: #536dfe !important;
}

.bg-primary.accent-3 {
  background-color: #3d5afe !important;
}

.text-primary.text-accent-3 {
  color: #3d5afe !important;
}
.text-primary.text-accent-3.icon-outline {
  border-color: #3d5afe !important;
}

.bg-primary.accent-4 {
  background-color: #304ffe !important;
}

.text-primary.text-accent-4 {
  color: #304ffe !important;
}
.text-primary.text-accent-4.icon-outline {
  border-color: #304ffe !important;
}

.bg-red {
  background-color: #F44336 !important;
}

.text-red {
  color: #F44336 !important;
}
.text-red.icon-outline {
  border-color: #F44336 !important;
}

.bg-red.lighten-5 {
  background-color: #FFEBEE !important;
}

.text-red.text-lighten-5 {
  color: #FFEBEE !important;
}
.text-red.text-lighten-5.icon-outline {
  border-color: #FFEBEE !important;
}

.bg-red.lighten-4 {
  background-color: #FFCDD2 !important;
}

.text-red.text-lighten-4 {
  color: #FFCDD2 !important;
}
.text-red.text-lighten-4.icon-outline {
  border-color: #FFCDD2 !important;
}

.bg-red.lighten-3 {
  background-color: #EF9A9A !important;
}

.text-red.text-lighten-3 {
  color: #EF9A9A !important;
}
.text-red.text-lighten-3.icon-outline {
  border-color: #EF9A9A !important;
}

.bg-red.lighten-2 {
  background-color: #E57373 !important;
}

.text-red.text-lighten-2 {
  color: #E57373 !important;
}
.text-red.text-lighten-2.icon-outline {
  border-color: #E57373 !important;
}

.bg-red.lighten-1 {
  background-color: #EF5350 !important;
}

.text-red.text-lighten-1 {
  color: #EF5350 !important;
}
.text-red.text-lighten-1.icon-outline {
  border-color: #EF5350 !important;
}

.bg-red.darken-1 {
  background-color: #E53935 !important;
}

.text-red.text-darken-1 {
  color: #E53935 !important;
}
.text-red.text-darken-1.icon-outline {
  border-color: #E53935 !important;
}

.bg-red.darken-2 {
  background-color: #D32F2F !important;
}

.text-red.text-darken-2 {
  color: #D32F2F !important;
}
.text-red.text-darken-2.icon-outline {
  border-color: #D32F2F !important;
}

.bg-red.darken-3 {
  background-color: #C62828 !important;
}

.text-red.text-darken-3 {
  color: #C62828 !important;
}
.text-red.text-darken-3.icon-outline {
  border-color: #C62828 !important;
}

.bg-red.darken-4 {
  background-color: #B71C1C !important;
}

.text-red.text-darken-4 {
  color: #B71C1C !important;
}
.text-red.text-darken-4.icon-outline {
  border-color: #B71C1C !important;
}

.bg-red.accent-1 {
  background-color: #FF8A80 !important;
}

.text-red.text-accent-1 {
  color: #FF8A80 !important;
}
.text-red.text-accent-1.icon-outline {
  border-color: #FF8A80 !important;
}

.bg-red.accent-2 {
  background-color: #FF5252 !important;
}

.text-red.text-accent-2 {
  color: #FF5252 !important;
}
.text-red.text-accent-2.icon-outline {
  border-color: #FF5252 !important;
}

.bg-red.accent-3 {
  background-color: #FF1744 !important;
}

.text-red.text-accent-3 {
  color: #FF1744 !important;
}
.text-red.text-accent-3.icon-outline {
  border-color: #FF1744 !important;
}

.bg-red.accent-4 {
  background-color: #D50000 !important;
}

.text-red.text-accent-4 {
  color: #D50000 !important;
}
.text-red.text-accent-4.icon-outline {
  border-color: #D50000 !important;
}

.bg-pink {
  background-color: #e91e63 !important;
}

.text-pink {
  color: #e91e63 !important;
}
.text-pink.icon-outline {
  border-color: #e91e63 !important;
}

.bg-pink.lighten-5 {
  background-color: #fce4ec !important;
}

.text-pink.text-lighten-5 {
  color: #fce4ec !important;
}
.text-pink.text-lighten-5.icon-outline {
  border-color: #fce4ec !important;
}

.bg-pink.lighten-4 {
  background-color: #f8bbd0 !important;
}

.text-pink.text-lighten-4 {
  color: #f8bbd0 !important;
}
.text-pink.text-lighten-4.icon-outline {
  border-color: #f8bbd0 !important;
}

.bg-pink.lighten-3 {
  background-color: #f48fb1 !important;
}

.text-pink.text-lighten-3 {
  color: #f48fb1 !important;
}
.text-pink.text-lighten-3.icon-outline {
  border-color: #f48fb1 !important;
}

.bg-pink.lighten-2 {
  background-color: #f06292 !important;
}

.text-pink.text-lighten-2 {
  color: #f06292 !important;
}
.text-pink.text-lighten-2.icon-outline {
  border-color: #f06292 !important;
}

.bg-pink.lighten-1 {
  background-color: #ec407a !important;
}

.text-pink.text-lighten-1 {
  color: #ec407a !important;
}
.text-pink.text-lighten-1.icon-outline {
  border-color: #ec407a !important;
}

.bg-pink.darken-1 {
  background-color: #d81b60 !important;
}

.text-pink.text-darken-1 {
  color: #d81b60 !important;
}
.text-pink.text-darken-1.icon-outline {
  border-color: #d81b60 !important;
}

.bg-pink.darken-2 {
  background-color: #c2185b !important;
}

.text-pink.text-darken-2 {
  color: #c2185b !important;
}
.text-pink.text-darken-2.icon-outline {
  border-color: #c2185b !important;
}

.bg-pink.darken-3 {
  background-color: #ad1457 !important;
}

.text-pink.text-darken-3 {
  color: #ad1457 !important;
}
.text-pink.text-darken-3.icon-outline {
  border-color: #ad1457 !important;
}

.bg-pink.darken-4 {
  background-color: #880e4f !important;
}

.text-pink.text-darken-4 {
  color: #880e4f !important;
}
.text-pink.text-darken-4.icon-outline {
  border-color: #880e4f !important;
}

.bg-pink.accent-1 {
  background-color: #ff80ab !important;
}

.text-pink.text-accent-1 {
  color: #ff80ab !important;
}
.text-pink.text-accent-1.icon-outline {
  border-color: #ff80ab !important;
}

.bg-pink.accent-2 {
  background-color: #ff4081 !important;
}

.text-pink.text-accent-2 {
  color: #ff4081 !important;
}
.text-pink.text-accent-2.icon-outline {
  border-color: #ff4081 !important;
}

.bg-pink.accent-3 {
  background-color: #f50057 !important;
}

.text-pink.text-accent-3 {
  color: #f50057 !important;
}
.text-pink.text-accent-3.icon-outline {
  border-color: #f50057 !important;
}

.bg-pink.accent-4 {
  background-color: #c51162 !important;
}

.text-pink.text-accent-4 {
  color: #c51162 !important;
}
.text-pink.text-accent-4.icon-outline {
  border-color: #c51162 !important;
}

.bg-purple {
  background-color: #9C27B0 !important;
}

.text-purple {
  color: #9C27B0 !important;
}
.text-purple.icon-outline {
  border-color: #9C27B0 !important;
}

.bg-purple.lighten-5 {
  background-color: #f3e5f5 !important;
}

.text-purple.text-lighten-5 {
  color: #f3e5f5 !important;
}
.text-purple.text-lighten-5.icon-outline {
  border-color: #f3e5f5 !important;
}

.bg-purple.lighten-4 {
  background-color: #e1bee7 !important;
}

.text-purple.text-lighten-4 {
  color: #e1bee7 !important;
}
.text-purple.text-lighten-4.icon-outline {
  border-color: #e1bee7 !important;
}

.bg-purple.lighten-3 {
  background-color: #ce93d8 !important;
}

.text-purple.text-lighten-3 {
  color: #ce93d8 !important;
}
.text-purple.text-lighten-3.icon-outline {
  border-color: #ce93d8 !important;
}

.bg-purple.lighten-2 {
  background-color: #ba68c8 !important;
}

.text-purple.text-lighten-2 {
  color: #ba68c8 !important;
}
.text-purple.text-lighten-2.icon-outline {
  border-color: #ba68c8 !important;
}

.bg-purple.lighten-1 {
  background-color: #ab47bc !important;
}

.text-purple.text-lighten-1 {
  color: #ab47bc !important;
}
.text-purple.text-lighten-1.icon-outline {
  border-color: #ab47bc !important;
}

.bg-purple.darken-1 {
  background-color: #8e24aa !important;
}

.text-purple.text-darken-1 {
  color: #8e24aa !important;
}
.text-purple.text-darken-1.icon-outline {
  border-color: #8e24aa !important;
}

.bg-purple.darken-2 {
  background-color: #7b1fa2 !important;
}

.text-purple.text-darken-2 {
  color: #7b1fa2 !important;
}
.text-purple.text-darken-2.icon-outline {
  border-color: #7b1fa2 !important;
}

.bg-purple.darken-3 {
  background-color: #6a1b9a !important;
}

.text-purple.text-darken-3 {
  color: #6a1b9a !important;
}
.text-purple.text-darken-3.icon-outline {
  border-color: #6a1b9a !important;
}

.bg-purple.darken-4 {
  background-color: #4a148c !important;
}

.text-purple.text-darken-4 {
  color: #4a148c !important;
}
.text-purple.text-darken-4.icon-outline {
  border-color: #4a148c !important;
}

.bg-purple.accent-1 {
  background-color: #ea80fc !important;
}

.text-purple.text-accent-1 {
  color: #ea80fc !important;
}
.text-purple.text-accent-1.icon-outline {
  border-color: #ea80fc !important;
}

.bg-purple.accent-2 {
  background-color: #e040fb !important;
}

.text-purple.text-accent-2 {
  color: #e040fb !important;
}
.text-purple.text-accent-2.icon-outline {
  border-color: #e040fb !important;
}

.bg-purple.accent-3 {
  background-color: #d500f9 !important;
}

.text-purple.text-accent-3 {
  color: #d500f9 !important;
}
.text-purple.text-accent-3.icon-outline {
  border-color: #d500f9 !important;
}

.bg-purple.accent-4 {
  background-color: #aa00ff !important;
}

.text-purple.text-accent-4 {
  color: #aa00ff !important;
}
.text-purple.text-accent-4.icon-outline {
  border-color: #aa00ff !important;
}

.bg-deep-purple {
  background-color: #673ab7 !important;
}

.text-deep-purple {
  color: #673ab7 !important;
}
.text-deep-purple.icon-outline {
  border-color: #673ab7 !important;
}

.bg-deep-purple.lighten-5 {
  background-color: #ede7f6 !important;
}

.text-deep-purple.text-lighten-5 {
  color: #ede7f6 !important;
}
.text-deep-purple.text-lighten-5.icon-outline {
  border-color: #ede7f6 !important;
}

.bg-deep-purple.lighten-4 {
  background-color: #d1c4e9 !important;
}

.text-deep-purple.text-lighten-4 {
  color: #d1c4e9 !important;
}
.text-deep-purple.text-lighten-4.icon-outline {
  border-color: #d1c4e9 !important;
}

.bg-deep-purple.lighten-3 {
  background-color: #b39ddb !important;
}

.text-deep-purple.text-lighten-3 {
  color: #b39ddb !important;
}
.text-deep-purple.text-lighten-3.icon-outline {
  border-color: #b39ddb !important;
}

.bg-deep-purple.lighten-2 {
  background-color: #9575cd !important;
}

.text-deep-purple.text-lighten-2 {
  color: #9575cd !important;
}
.text-deep-purple.text-lighten-2.icon-outline {
  border-color: #9575cd !important;
}

.bg-deep-purple.lighten-1 {
  background-color: #7e57c2 !important;
}

.text-deep-purple.text-lighten-1 {
  color: #7e57c2 !important;
}
.text-deep-purple.text-lighten-1.icon-outline {
  border-color: #7e57c2 !important;
}

.bg-deep-purple.darken-1 {
  background-color: #5e35b1 !important;
}

.text-deep-purple.text-darken-1 {
  color: #5e35b1 !important;
}
.text-deep-purple.text-darken-1.icon-outline {
  border-color: #5e35b1 !important;
}

.bg-deep-purple.darken-2 {
  background-color: #512da8 !important;
}

.text-deep-purple.text-darken-2 {
  color: #512da8 !important;
}
.text-deep-purple.text-darken-2.icon-outline {
  border-color: #512da8 !important;
}

.bg-deep-purple.darken-3 {
  background-color: #4527a0 !important;
}

.text-deep-purple.text-darken-3 {
  color: #4527a0 !important;
}
.text-deep-purple.text-darken-3.icon-outline {
  border-color: #4527a0 !important;
}

.bg-deep-purple.darken-4 {
  background-color: #311b92 !important;
}

.text-deep-purple.text-darken-4 {
  color: #311b92 !important;
}
.text-deep-purple.text-darken-4.icon-outline {
  border-color: #311b92 !important;
}

.bg-deep-purple.accent-1 {
  background-color: #b388ff !important;
}

.text-deep-purple.text-accent-1 {
  color: #b388ff !important;
}
.text-deep-purple.text-accent-1.icon-outline {
  border-color: #b388ff !important;
}

.bg-deep-purple.accent-2 {
  background-color: #7c4dff !important;
}

.text-deep-purple.text-accent-2 {
  color: #7c4dff !important;
}
.text-deep-purple.text-accent-2.icon-outline {
  border-color: #7c4dff !important;
}

.bg-deep-purple.accent-3 {
  background-color: #651fff !important;
}

.text-deep-purple.text-accent-3 {
  color: #651fff !important;
}
.text-deep-purple.text-accent-3.icon-outline {
  border-color: #651fff !important;
}

.bg-deep-purple.accent-4 {
  background-color: #6200ea !important;
}

.text-deep-purple.text-accent-4 {
  color: #6200ea !important;
}
.text-deep-purple.text-accent-4.icon-outline {
  border-color: #6200ea !important;
}

.bg-indigo {
  background-color: #3f51b5 !important;
}

.text-indigo {
  color: #3f51b5 !important;
}
.text-indigo.icon-outline {
  border-color: #3f51b5 !important;
}

.bg-indigo.lighten-5 {
  background-color: #e8eaf6 !important;
}

.text-indigo.text-lighten-5 {
  color: #e8eaf6 !important;
}
.text-indigo.text-lighten-5.icon-outline {
  border-color: #e8eaf6 !important;
}

.bg-indigo.lighten-4 {
  background-color: #c5cae9 !important;
}

.text-indigo.text-lighten-4 {
  color: #c5cae9 !important;
}
.text-indigo.text-lighten-4.icon-outline {
  border-color: #c5cae9 !important;
}

.bg-indigo.lighten-3 {
  background-color: #9fa8da !important;
}

.text-indigo.text-lighten-3 {
  color: #9fa8da !important;
}
.text-indigo.text-lighten-3.icon-outline {
  border-color: #9fa8da !important;
}

.bg-indigo.lighten-2 {
  background-color: #7986cb !important;
}

.text-indigo.text-lighten-2 {
  color: #7986cb !important;
}
.text-indigo.text-lighten-2.icon-outline {
  border-color: #7986cb !important;
}

.bg-indigo.lighten-1 {
  background-color: #5c6bc0 !important;
}

.text-indigo.text-lighten-1 {
  color: #5c6bc0 !important;
}
.text-indigo.text-lighten-1.icon-outline {
  border-color: #5c6bc0 !important;
}

.bg-indigo.darken-1 {
  background-color: #3949ab !important;
}

.text-indigo.text-darken-1 {
  color: #3949ab !important;
}
.text-indigo.text-darken-1.icon-outline {
  border-color: #3949ab !important;
}

.bg-indigo.darken-2 {
  background-color: #303f9f !important;
}

.text-indigo.text-darken-2 {
  color: #303f9f !important;
}
.text-indigo.text-darken-2.icon-outline {
  border-color: #303f9f !important;
}

.bg-indigo.darken-3 {
  background-color: #283593 !important;
}

.text-indigo.text-darken-3 {
  color: #283593 !important;
}
.text-indigo.text-darken-3.icon-outline {
  border-color: #283593 !important;
}

.bg-indigo.darken-4 {
  background-color: #1a237e !important;
}

.text-indigo.text-darken-4 {
  color: #1a237e !important;
}
.text-indigo.text-darken-4.icon-outline {
  border-color: #1a237e !important;
}

.bg-indigo.accent-1 {
  background-color: #8c9eff !important;
}

.text-indigo.text-accent-1 {
  color: #8c9eff !important;
}
.text-indigo.text-accent-1.icon-outline {
  border-color: #8c9eff !important;
}

.bg-indigo.accent-2 {
  background-color: #536dfe !important;
}

.text-indigo.text-accent-2 {
  color: #536dfe !important;
}
.text-indigo.text-accent-2.icon-outline {
  border-color: #536dfe !important;
}

.bg-indigo.accent-3 {
  background-color: #3d5afe !important;
}

.text-indigo.text-accent-3 {
  color: #3d5afe !important;
}
.text-indigo.text-accent-3.icon-outline {
  border-color: #3d5afe !important;
}

.bg-indigo.accent-4 {
  background-color: #304ffe !important;
}

.text-indigo.text-accent-4 {
  color: #304ffe !important;
}
.text-indigo.text-accent-4.icon-outline {
  border-color: #304ffe !important;
}

.bg-blue {
  background-color: #2196F3 !important;
}

.text-blue {
  color: #2196F3 !important;
}
.text-blue.icon-outline {
  border-color: #2196F3 !important;
}

.bg-blue.lighten-5 {
  background-color: #E3F2FD !important;
}

.text-blue.text-lighten-5 {
  color: #E3F2FD !important;
}
.text-blue.text-lighten-5.icon-outline {
  border-color: #E3F2FD !important;
}

.bg-blue.lighten-4 {
  background-color: #BBDEFB !important;
}

.text-blue.text-lighten-4 {
  color: #BBDEFB !important;
}
.text-blue.text-lighten-4.icon-outline {
  border-color: #BBDEFB !important;
}

.bg-blue.lighten-3 {
  background-color: #90CAF9 !important;
}

.text-blue.text-lighten-3 {
  color: #90CAF9 !important;
}
.text-blue.text-lighten-3.icon-outline {
  border-color: #90CAF9 !important;
}

.bg-blue.lighten-2 {
  background-color: #64B5F6 !important;
}

.text-blue.text-lighten-2 {
  color: #64B5F6 !important;
}
.text-blue.text-lighten-2.icon-outline {
  border-color: #64B5F6 !important;
}

.bg-blue.lighten-1 {
  background-color: #42A5F5 !important;
}

.text-blue.text-lighten-1 {
  color: #42A5F5 !important;
}
.text-blue.text-lighten-1.icon-outline {
  border-color: #42A5F5 !important;
}

.bg-blue.darken-1 {
  background-color: #1E88E5 !important;
}

.text-blue.text-darken-1 {
  color: #1E88E5 !important;
}
.text-blue.text-darken-1.icon-outline {
  border-color: #1E88E5 !important;
}

.bg-blue.darken-2 {
  background-color: #1976D2 !important;
}

.text-blue.text-darken-2 {
  color: #1976D2 !important;
}
.text-blue.text-darken-2.icon-outline {
  border-color: #1976D2 !important;
}

.bg-blue.darken-3 {
  background-color: #1565C0 !important;
}

.text-blue.text-darken-3 {
  color: #1565C0 !important;
}
.text-blue.text-darken-3.icon-outline {
  border-color: #1565C0 !important;
}

.bg-blue.darken-4 {
  background-color: #0D47A1 !important;
}

.text-blue.text-darken-4 {
  color: #0D47A1 !important;
}
.text-blue.text-darken-4.icon-outline {
  border-color: #0D47A1 !important;
}

.bg-blue.accent-1 {
  background-color: #82B1FF !important;
}

.text-blue.text-accent-1 {
  color: #82B1FF !important;
}
.text-blue.text-accent-1.icon-outline {
  border-color: #82B1FF !important;
}

.bg-blue.accent-2 {
  background-color: #448AFF !important;
}

.text-blue.text-accent-2 {
  color: #448AFF !important;
}
.text-blue.text-accent-2.icon-outline {
  border-color: #448AFF !important;
}

.bg-blue.accent-3 {
  background-color: #2979FF !important;
}

.text-blue.text-accent-3 {
  color: #2979FF !important;
}
.text-blue.text-accent-3.icon-outline {
  border-color: #2979FF !important;
}

.bg-blue.accent-4 {
  background-color: #2962FF !important;
}

.text-blue.text-accent-4 {
  color: #2962FF !important;
}
.text-blue.text-accent-4.icon-outline {
  border-color: #2962FF !important;
}

.bg-light-blue {
  background-color: #03a9f4 !important;
}

.text-light-blue {
  color: #03a9f4 !important;
}
.text-light-blue.icon-outline {
  border-color: #03a9f4 !important;
}

.bg-light-blue.lighten-5 {
  background-color: #e1f5fe !important;
}

.text-light-blue.text-lighten-5 {
  color: #e1f5fe !important;
}
.text-light-blue.text-lighten-5.icon-outline {
  border-color: #e1f5fe !important;
}

.bg-light-blue.lighten-4 {
  background-color: #b3e5fc !important;
}

.text-light-blue.text-lighten-4 {
  color: #b3e5fc !important;
}
.text-light-blue.text-lighten-4.icon-outline {
  border-color: #b3e5fc !important;
}

.bg-light-blue.lighten-3 {
  background-color: #81d4fa !important;
}

.text-light-blue.text-lighten-3 {
  color: #81d4fa !important;
}
.text-light-blue.text-lighten-3.icon-outline {
  border-color: #81d4fa !important;
}

.bg-light-blue.lighten-2 {
  background-color: #4fc3f7 !important;
}

.text-light-blue.text-lighten-2 {
  color: #4fc3f7 !important;
}
.text-light-blue.text-lighten-2.icon-outline {
  border-color: #4fc3f7 !important;
}

.bg-light-blue.lighten-1 {
  background-color: #29b6f6 !important;
}

.text-light-blue.text-lighten-1 {
  color: #29b6f6 !important;
}
.text-light-blue.text-lighten-1.icon-outline {
  border-color: #29b6f6 !important;
}

.bg-light-blue.darken-1 {
  background-color: #039be5 !important;
}

.text-light-blue.text-darken-1 {
  color: #039be5 !important;
}
.text-light-blue.text-darken-1.icon-outline {
  border-color: #039be5 !important;
}

.bg-light-blue.darken-2 {
  background-color: #0288d1 !important;
}

.text-light-blue.text-darken-2 {
  color: #0288d1 !important;
}
.text-light-blue.text-darken-2.icon-outline {
  border-color: #0288d1 !important;
}

.bg-light-blue.darken-3 {
  background-color: #0277bd !important;
}

.text-light-blue.text-darken-3 {
  color: #0277bd !important;
}
.text-light-blue.text-darken-3.icon-outline {
  border-color: #0277bd !important;
}

.bg-light-blue.darken-4 {
  background-color: #01579b !important;
}

.text-light-blue.text-darken-4 {
  color: #01579b !important;
}
.text-light-blue.text-darken-4.icon-outline {
  border-color: #01579b !important;
}

.bg-light-blue.accent-1 {
  background-color: #80d8ff !important;
}

.text-light-blue.text-accent-1 {
  color: #80d8ff !important;
}
.text-light-blue.text-accent-1.icon-outline {
  border-color: #80d8ff !important;
}

.bg-light-blue.accent-2 {
  background-color: #40c4ff !important;
}

.text-light-blue.text-accent-2 {
  color: #40c4ff !important;
}
.text-light-blue.text-accent-2.icon-outline {
  border-color: #40c4ff !important;
}

.bg-light-blue.accent-3 {
  background-color: #00b0ff !important;
}

.text-light-blue.text-accent-3 {
  color: #00b0ff !important;
}
.text-light-blue.text-accent-3.icon-outline {
  border-color: #00b0ff !important;
}

.bg-light-blue.accent-4 {
  background-color: #0091ea !important;
}

.text-light-blue.text-accent-4 {
  color: #0091ea !important;
}
.text-light-blue.text-accent-4.icon-outline {
  border-color: #0091ea !important;
}

.bg-cyan {
  background-color: #00bcd4 !important;
}

.text-cyan {
  color: #00bcd4 !important;
}
.text-cyan.icon-outline {
  border-color: #00bcd4 !important;
}

.bg-cyan.lighten-5 {
  background-color: #e0f7fa !important;
}

.text-cyan.text-lighten-5 {
  color: #e0f7fa !important;
}
.text-cyan.text-lighten-5.icon-outline {
  border-color: #e0f7fa !important;
}

.bg-cyan.lighten-4 {
  background-color: #b2ebf2 !important;
}

.text-cyan.text-lighten-4 {
  color: #b2ebf2 !important;
}
.text-cyan.text-lighten-4.icon-outline {
  border-color: #b2ebf2 !important;
}

.bg-cyan.lighten-3 {
  background-color: #80deea !important;
}

.text-cyan.text-lighten-3 {
  color: #80deea !important;
}
.text-cyan.text-lighten-3.icon-outline {
  border-color: #80deea !important;
}

.bg-cyan.lighten-2 {
  background-color: #4dd0e1 !important;
}

.text-cyan.text-lighten-2 {
  color: #4dd0e1 !important;
}
.text-cyan.text-lighten-2.icon-outline {
  border-color: #4dd0e1 !important;
}

.bg-cyan.lighten-1 {
  background-color: #26c6da !important;
}

.text-cyan.text-lighten-1 {
  color: #26c6da !important;
}
.text-cyan.text-lighten-1.icon-outline {
  border-color: #26c6da !important;
}

.bg-cyan.darken-1 {
  background-color: #00acc1 !important;
}

.text-cyan.text-darken-1 {
  color: #00acc1 !important;
}
.text-cyan.text-darken-1.icon-outline {
  border-color: #00acc1 !important;
}

.bg-cyan.darken-2 {
  background-color: #0097a7 !important;
}

.text-cyan.text-darken-2 {
  color: #0097a7 !important;
}
.text-cyan.text-darken-2.icon-outline {
  border-color: #0097a7 !important;
}

.bg-cyan.darken-3 {
  background-color: #00838f !important;
}

.text-cyan.text-darken-3 {
  color: #00838f !important;
}
.text-cyan.text-darken-3.icon-outline {
  border-color: #00838f !important;
}

.bg-cyan.darken-4 {
  background-color: #006064 !important;
}

.text-cyan.text-darken-4 {
  color: #006064 !important;
}
.text-cyan.text-darken-4.icon-outline {
  border-color: #006064 !important;
}

.bg-cyan.accent-1 {
  background-color: #84ffff !important;
}

.text-cyan.text-accent-1 {
  color: #84ffff !important;
}
.text-cyan.text-accent-1.icon-outline {
  border-color: #84ffff !important;
}

.bg-cyan.accent-2 {
  background-color: #18ffff !important;
}

.text-cyan.text-accent-2 {
  color: #18ffff !important;
}
.text-cyan.text-accent-2.icon-outline {
  border-color: #18ffff !important;
}

.bg-cyan.accent-3 {
  background-color: #00e5ff !important;
}

.text-cyan.text-accent-3 {
  color: #00e5ff !important;
}
.text-cyan.text-accent-3.icon-outline {
  border-color: #00e5ff !important;
}

.bg-cyan.accent-4 {
  background-color: #00b8d4 !important;
}

.text-cyan.text-accent-4 {
  color: #00b8d4 !important;
}
.text-cyan.text-accent-4.icon-outline {
  border-color: #00b8d4 !important;
}

.bg-teal {
  background-color: #009688 !important;
}

.text-teal {
  color: #009688 !important;
}
.text-teal.icon-outline {
  border-color: #009688 !important;
}

.bg-teal.lighten-5 {
  background-color: #e0f2f1 !important;
}

.text-teal.text-lighten-5 {
  color: #e0f2f1 !important;
}
.text-teal.text-lighten-5.icon-outline {
  border-color: #e0f2f1 !important;
}

.bg-teal.lighten-4 {
  background-color: #b2dfdb !important;
}

.text-teal.text-lighten-4 {
  color: #b2dfdb !important;
}
.text-teal.text-lighten-4.icon-outline {
  border-color: #b2dfdb !important;
}

.bg-teal.lighten-3 {
  background-color: #80cbc4 !important;
}

.text-teal.text-lighten-3 {
  color: #80cbc4 !important;
}
.text-teal.text-lighten-3.icon-outline {
  border-color: #80cbc4 !important;
}

.bg-teal.lighten-2 {
  background-color: #4db6ac !important;
}

.text-teal.text-lighten-2 {
  color: #4db6ac !important;
}
.text-teal.text-lighten-2.icon-outline {
  border-color: #4db6ac !important;
}

.bg-teal.lighten-1 {
  background-color: #26a69a !important;
}

.text-teal.text-lighten-1 {
  color: #26a69a !important;
}
.text-teal.text-lighten-1.icon-outline {
  border-color: #26a69a !important;
}

.bg-teal.darken-1 {
  background-color: #00897b !important;
}

.text-teal.text-darken-1 {
  color: #00897b !important;
}
.text-teal.text-darken-1.icon-outline {
  border-color: #00897b !important;
}

.bg-teal.darken-2 {
  background-color: #00796b !important;
}

.text-teal.text-darken-2 {
  color: #00796b !important;
}
.text-teal.text-darken-2.icon-outline {
  border-color: #00796b !important;
}

.bg-teal.darken-3 {
  background-color: #00695c !important;
}

.text-teal.text-darken-3 {
  color: #00695c !important;
}
.text-teal.text-darken-3.icon-outline {
  border-color: #00695c !important;
}

.bg-teal.darken-4 {
  background-color: #004d40 !important;
}

.text-teal.text-darken-4 {
  color: #004d40 !important;
}
.text-teal.text-darken-4.icon-outline {
  border-color: #004d40 !important;
}

.bg-teal.accent-1 {
  background-color: #a7ffeb !important;
}

.text-teal.text-accent-1 {
  color: #a7ffeb !important;
}
.text-teal.text-accent-1.icon-outline {
  border-color: #a7ffeb !important;
}

.bg-teal.accent-2 {
  background-color: #64ffda !important;
}

.text-teal.text-accent-2 {
  color: #64ffda !important;
}
.text-teal.text-accent-2.icon-outline {
  border-color: #64ffda !important;
}

.bg-teal.accent-3 {
  background-color: #1de9b6 !important;
}

.text-teal.text-accent-3 {
  color: #1de9b6 !important;
}
.text-teal.text-accent-3.icon-outline {
  border-color: #1de9b6 !important;
}

.bg-teal.accent-4 {
  background-color: #00bfa5 !important;
}

.text-teal.text-accent-4 {
  color: #00bfa5 !important;
}
.text-teal.text-accent-4.icon-outline {
  border-color: #00bfa5 !important;
}

.bg-green {
  background-color: #4CAF50 !important;
}

.text-green {
  color: #4CAF50 !important;
}
.text-green.icon-outline {
  border-color: #4CAF50 !important;
}

.bg-green.lighten-5 {
  background-color: #E8F5E9 !important;
}

.text-green.text-lighten-5 {
  color: #E8F5E9 !important;
}
.text-green.text-lighten-5.icon-outline {
  border-color: #E8F5E9 !important;
}

.bg-green.lighten-4 {
  background-color: #C8E6C9 !important;
}

.text-green.text-lighten-4 {
  color: #C8E6C9 !important;
}
.text-green.text-lighten-4.icon-outline {
  border-color: #C8E6C9 !important;
}

.bg-green.lighten-3 {
  background-color: #A5D6A7 !important;
}

.text-green.text-lighten-3 {
  color: #A5D6A7 !important;
}
.text-green.text-lighten-3.icon-outline {
  border-color: #A5D6A7 !important;
}

.bg-green.lighten-2 {
  background-color: #81C784 !important;
}

.text-green.text-lighten-2 {
  color: #81C784 !important;
}
.text-green.text-lighten-2.icon-outline {
  border-color: #81C784 !important;
}

.bg-green.lighten-1 {
  background-color: #66BB6A !important;
}

.text-green.text-lighten-1 {
  color: #66BB6A !important;
}
.text-green.text-lighten-1.icon-outline {
  border-color: #66BB6A !important;
}

.bg-green.darken-1 {
  background-color: #43A047 !important;
}

.text-green.text-darken-1 {
  color: #43A047 !important;
}
.text-green.text-darken-1.icon-outline {
  border-color: #43A047 !important;
}

.bg-green.darken-2 {
  background-color: #388E3C !important;
}

.text-green.text-darken-2 {
  color: #388E3C !important;
}
.text-green.text-darken-2.icon-outline {
  border-color: #388E3C !important;
}

.bg-green.darken-3 {
  background-color: #2E7D32 !important;
}

.text-green.text-darken-3 {
  color: #2E7D32 !important;
}
.text-green.text-darken-3.icon-outline {
  border-color: #2E7D32 !important;
}

.bg-green.darken-4 {
  background-color: #1B5E20 !important;
}

.text-green.text-darken-4 {
  color: #1B5E20 !important;
}
.text-green.text-darken-4.icon-outline {
  border-color: #1B5E20 !important;
}

.bg-green.accent-1 {
  background-color: #B9F6CA !important;
}

.text-green.text-accent-1 {
  color: #B9F6CA !important;
}
.text-green.text-accent-1.icon-outline {
  border-color: #B9F6CA !important;
}

.bg-green.accent-2 {
  background-color: #69F0AE !important;
}

.text-green.text-accent-2 {
  color: #69F0AE !important;
}
.text-green.text-accent-2.icon-outline {
  border-color: #69F0AE !important;
}

.bg-green.accent-3 {
  background-color: #00E676 !important;
}

.text-green.text-accent-3 {
  color: #00E676 !important;
}
.text-green.text-accent-3.icon-outline {
  border-color: #00E676 !important;
}

.bg-green.accent-4 {
  background-color: #00C853 !important;
}

.text-green.text-accent-4 {
  color: #00C853 !important;
}
.text-green.text-accent-4.icon-outline {
  border-color: #00C853 !important;
}

.bg-light-green {
  background-color: #8bc34a !important;
}

.text-light-green {
  color: #8bc34a !important;
}
.text-light-green.icon-outline {
  border-color: #8bc34a !important;
}

.bg-light-green.lighten-5 {
  background-color: #f1f8e9 !important;
}

.text-light-green.text-lighten-5 {
  color: #f1f8e9 !important;
}
.text-light-green.text-lighten-5.icon-outline {
  border-color: #f1f8e9 !important;
}

.bg-light-green.lighten-4 {
  background-color: #dcedc8 !important;
}

.text-light-green.text-lighten-4 {
  color: #dcedc8 !important;
}
.text-light-green.text-lighten-4.icon-outline {
  border-color: #dcedc8 !important;
}

.bg-light-green.lighten-3 {
  background-color: #c5e1a5 !important;
}

.text-light-green.text-lighten-3 {
  color: #c5e1a5 !important;
}
.text-light-green.text-lighten-3.icon-outline {
  border-color: #c5e1a5 !important;
}

.bg-light-green.lighten-2 {
  background-color: #aed581 !important;
}

.text-light-green.text-lighten-2 {
  color: #aed581 !important;
}
.text-light-green.text-lighten-2.icon-outline {
  border-color: #aed581 !important;
}

.bg-light-green.lighten-1 {
  background-color: #9ccc65 !important;
}

.text-light-green.text-lighten-1 {
  color: #9ccc65 !important;
}
.text-light-green.text-lighten-1.icon-outline {
  border-color: #9ccc65 !important;
}

.bg-light-green.darken-1 {
  background-color: #7cb342 !important;
}

.text-light-green.text-darken-1 {
  color: #7cb342 !important;
}
.text-light-green.text-darken-1.icon-outline {
  border-color: #7cb342 !important;
}

.bg-light-green.darken-2 {
  background-color: #689f38 !important;
}

.text-light-green.text-darken-2 {
  color: #689f38 !important;
}
.text-light-green.text-darken-2.icon-outline {
  border-color: #689f38 !important;
}

.bg-light-green.darken-3 {
  background-color: #558b2f !important;
}

.text-light-green.text-darken-3 {
  color: #558b2f !important;
}
.text-light-green.text-darken-3.icon-outline {
  border-color: #558b2f !important;
}

.bg-light-green.darken-4 {
  background-color: #33691e !important;
}

.text-light-green.text-darken-4 {
  color: #33691e !important;
}
.text-light-green.text-darken-4.icon-outline {
  border-color: #33691e !important;
}

.bg-light-green.accent-1 {
  background-color: #ccff90 !important;
}

.text-light-green.text-accent-1 {
  color: #ccff90 !important;
}
.text-light-green.text-accent-1.icon-outline {
  border-color: #ccff90 !important;
}

.bg-light-green.accent-2 {
  background-color: #b2ff59 !important;
}

.text-light-green.text-accent-2 {
  color: #b2ff59 !important;
}
.text-light-green.text-accent-2.icon-outline {
  border-color: #b2ff59 !important;
}

.bg-light-green.accent-3 {
  background-color: #76ff03 !important;
}

.text-light-green.text-accent-3 {
  color: #76ff03 !important;
}
.text-light-green.text-accent-3.icon-outline {
  border-color: #76ff03 !important;
}

.bg-light-green.accent-4 {
  background-color: #64dd17 !important;
}

.text-light-green.text-accent-4 {
  color: #64dd17 !important;
}
.text-light-green.text-accent-4.icon-outline {
  border-color: #64dd17 !important;
}

.bg-lime {
  background-color: #cddc39 !important;
}

.text-lime {
  color: #cddc39 !important;
}
.text-lime.icon-outline {
  border-color: #cddc39 !important;
}

.bg-lime.lighten-5 {
  background-color: #f9fbe7 !important;
}

.text-lime.text-lighten-5 {
  color: #f9fbe7 !important;
}
.text-lime.text-lighten-5.icon-outline {
  border-color: #f9fbe7 !important;
}

.bg-lime.lighten-4 {
  background-color: #f0f4c3 !important;
}

.text-lime.text-lighten-4 {
  color: #f0f4c3 !important;
}
.text-lime.text-lighten-4.icon-outline {
  border-color: #f0f4c3 !important;
}

.bg-lime.lighten-3 {
  background-color: #e6ee9c !important;
}

.text-lime.text-lighten-3 {
  color: #e6ee9c !important;
}
.text-lime.text-lighten-3.icon-outline {
  border-color: #e6ee9c !important;
}

.bg-lime.lighten-2 {
  background-color: #dce775 !important;
}

.text-lime.text-lighten-2 {
  color: #dce775 !important;
}
.text-lime.text-lighten-2.icon-outline {
  border-color: #dce775 !important;
}

.bg-lime.lighten-1 {
  background-color: #d4e157 !important;
}

.text-lime.text-lighten-1 {
  color: #d4e157 !important;
}
.text-lime.text-lighten-1.icon-outline {
  border-color: #d4e157 !important;
}

.bg-lime.darken-1 {
  background-color: #c0ca33 !important;
}

.text-lime.text-darken-1 {
  color: #c0ca33 !important;
}
.text-lime.text-darken-1.icon-outline {
  border-color: #c0ca33 !important;
}

.bg-lime.darken-2 {
  background-color: #afb42b !important;
}

.text-lime.text-darken-2 {
  color: #afb42b !important;
}
.text-lime.text-darken-2.icon-outline {
  border-color: #afb42b !important;
}

.bg-lime.darken-3 {
  background-color: #9e9d24 !important;
}

.text-lime.text-darken-3 {
  color: #9e9d24 !important;
}
.text-lime.text-darken-3.icon-outline {
  border-color: #9e9d24 !important;
}

.bg-lime.darken-4 {
  background-color: #827717 !important;
}

.text-lime.text-darken-4 {
  color: #827717 !important;
}
.text-lime.text-darken-4.icon-outline {
  border-color: #827717 !important;
}

.bg-lime.accent-1 {
  background-color: #f4ff81 !important;
}

.text-lime.text-accent-1 {
  color: #f4ff81 !important;
}
.text-lime.text-accent-1.icon-outline {
  border-color: #f4ff81 !important;
}

.bg-lime.accent-2 {
  background-color: #eeff41 !important;
}

.text-lime.text-accent-2 {
  color: #eeff41 !important;
}
.text-lime.text-accent-2.icon-outline {
  border-color: #eeff41 !important;
}

.bg-lime.accent-3 {
  background-color: #c6ff00 !important;
}

.text-lime.text-accent-3 {
  color: #c6ff00 !important;
}
.text-lime.text-accent-3.icon-outline {
  border-color: #c6ff00 !important;
}

.bg-lime.accent-4 {
  background-color: #aeea00 !important;
}

.text-lime.text-accent-4 {
  color: #aeea00 !important;
}
.text-lime.text-accent-4.icon-outline {
  border-color: #aeea00 !important;
}

.bg-yellow {
  background-color: #ffeb3b !important;
}

.text-yellow {
  color: #ffeb3b !important;
}
.text-yellow.icon-outline {
  border-color: #ffeb3b !important;
}

.bg-yellow.lighten-5 {
  background-color: #fffde7 !important;
}

.text-yellow.text-lighten-5 {
  color: #fffde7 !important;
}
.text-yellow.text-lighten-5.icon-outline {
  border-color: #fffde7 !important;
}

.bg-yellow.lighten-4 {
  background-color: #fff9c4 !important;
}

.text-yellow.text-lighten-4 {
  color: #fff9c4 !important;
}
.text-yellow.text-lighten-4.icon-outline {
  border-color: #fff9c4 !important;
}

.bg-yellow.lighten-3 {
  background-color: #fff59d !important;
}

.text-yellow.text-lighten-3 {
  color: #fff59d !important;
}
.text-yellow.text-lighten-3.icon-outline {
  border-color: #fff59d !important;
}

.bg-yellow.lighten-2 {
  background-color: #fff176 !important;
}

.text-yellow.text-lighten-2 {
  color: #fff176 !important;
}
.text-yellow.text-lighten-2.icon-outline {
  border-color: #fff176 !important;
}

.bg-yellow.lighten-1 {
  background-color: #ffee58 !important;
}

.text-yellow.text-lighten-1 {
  color: #ffee58 !important;
}
.text-yellow.text-lighten-1.icon-outline {
  border-color: #ffee58 !important;
}

.bg-yellow.darken-1 {
  background-color: #fdd835 !important;
}

.text-yellow.text-darken-1 {
  color: #fdd835 !important;
}
.text-yellow.text-darken-1.icon-outline {
  border-color: #fdd835 !important;
}

.bg-yellow.darken-2 {
  background-color: #fbc02d !important;
}

.text-yellow.text-darken-2 {
  color: #fbc02d !important;
}
.text-yellow.text-darken-2.icon-outline {
  border-color: #fbc02d !important;
}

.bg-yellow.darken-3 {
  background-color: #f9a825 !important;
}

.text-yellow.text-darken-3 {
  color: #f9a825 !important;
}
.text-yellow.text-darken-3.icon-outline {
  border-color: #f9a825 !important;
}

.bg-yellow.darken-4 {
  background-color: #f57f17 !important;
}

.text-yellow.text-darken-4 {
  color: #f57f17 !important;
}
.text-yellow.text-darken-4.icon-outline {
  border-color: #f57f17 !important;
}

.bg-yellow.accent-1 {
  background-color: #ffff8d !important;
}

.text-yellow.text-accent-1 {
  color: #ffff8d !important;
}
.text-yellow.text-accent-1.icon-outline {
  border-color: #ffff8d !important;
}

.bg-yellow.accent-2 {
  background-color: #ffff00 !important;
}

.text-yellow.text-accent-2 {
  color: #ffff00 !important;
}
.text-yellow.text-accent-2.icon-outline {
  border-color: #ffff00 !important;
}

.bg-yellow.accent-3 {
  background-color: #ffea00 !important;
}

.text-yellow.text-accent-3 {
  color: #ffea00 !important;
}
.text-yellow.text-accent-3.icon-outline {
  border-color: #ffea00 !important;
}

.bg-yellow.accent-4 {
  background-color: #ffd600 !important;
}

.text-yellow.text-accent-4 {
  color: #ffd600 !important;
}
.text-yellow.text-accent-4.icon-outline {
  border-color: #ffd600 !important;
}

.bg-amber {
  background-color: #ffc107 !important;
}

.text-amber {
  color: #ffc107 !important;
}
.text-amber.icon-outline {
  border-color: #ffc107 !important;
}

.bg-amber.lighten-5 {
  background-color: #fff8e1 !important;
}

.text-amber.text-lighten-5 {
  color: #fff8e1 !important;
}
.text-amber.text-lighten-5.icon-outline {
  border-color: #fff8e1 !important;
}

.bg-amber.lighten-4 {
  background-color: #ffecb3 !important;
}

.text-amber.text-lighten-4 {
  color: #ffecb3 !important;
}
.text-amber.text-lighten-4.icon-outline {
  border-color: #ffecb3 !important;
}

.bg-amber.lighten-3 {
  background-color: #ffe082 !important;
}

.text-amber.text-lighten-3 {
  color: #ffe082 !important;
}
.text-amber.text-lighten-3.icon-outline {
  border-color: #ffe082 !important;
}

.bg-amber.lighten-2 {
  background-color: #ffd54f !important;
}

.text-amber.text-lighten-2 {
  color: #ffd54f !important;
}
.text-amber.text-lighten-2.icon-outline {
  border-color: #ffd54f !important;
}

.bg-amber.lighten-1 {
  background-color: #ffca28 !important;
}

.text-amber.text-lighten-1 {
  color: #ffca28 !important;
}
.text-amber.text-lighten-1.icon-outline {
  border-color: #ffca28 !important;
}

.bg-amber.darken-1 {
  background-color: #ffb300 !important;
}

.text-amber.text-darken-1 {
  color: #ffb300 !important;
}
.text-amber.text-darken-1.icon-outline {
  border-color: #ffb300 !important;
}

.bg-amber.darken-2 {
  background-color: #ffa000 !important;
}

.text-amber.text-darken-2 {
  color: #ffa000 !important;
}
.text-amber.text-darken-2.icon-outline {
  border-color: #ffa000 !important;
}

.bg-amber.darken-3 {
  background-color: #ff8f00 !important;
}

.text-amber.text-darken-3 {
  color: #ff8f00 !important;
}
.text-amber.text-darken-3.icon-outline {
  border-color: #ff8f00 !important;
}

.bg-amber.darken-4 {
  background-color: #ff6f00 !important;
}

.text-amber.text-darken-4 {
  color: #ff6f00 !important;
}
.text-amber.text-darken-4.icon-outline {
  border-color: #ff6f00 !important;
}

.bg-amber.accent-1 {
  background-color: #ffe57f !important;
}

.text-amber.text-accent-1 {
  color: #ffe57f !important;
}
.text-amber.text-accent-1.icon-outline {
  border-color: #ffe57f !important;
}

.bg-amber.accent-2 {
  background-color: #ffd740 !important;
}

.text-amber.text-accent-2 {
  color: #ffd740 !important;
}
.text-amber.text-accent-2.icon-outline {
  border-color: #ffd740 !important;
}

.bg-amber.accent-3 {
  background-color: #ffc400 !important;
}

.text-amber.text-accent-3 {
  color: #ffc400 !important;
}
.text-amber.text-accent-3.icon-outline {
  border-color: #ffc400 !important;
}

.bg-amber.accent-4 {
  background-color: #ffab00 !important;
}

.text-amber.text-accent-4 {
  color: #ffab00 !important;
}
.text-amber.text-accent-4.icon-outline {
  border-color: #ffab00 !important;
}

.bg-orange {
  background-color: #ff9800 !important;
}

.text-orange {
  color: #ff9800 !important;
}
.text-orange.icon-outline {
  border-color: #ff9800 !important;
}

.bg-orange.lighten-5 {
  background-color: #fff3e0 !important;
}

.text-orange.text-lighten-5 {
  color: #fff3e0 !important;
}
.text-orange.text-lighten-5.icon-outline {
  border-color: #fff3e0 !important;
}

.bg-orange.lighten-4 {
  background-color: #ffe0b2 !important;
}

.text-orange.text-lighten-4 {
  color: #ffe0b2 !important;
}
.text-orange.text-lighten-4.icon-outline {
  border-color: #ffe0b2 !important;
}

.bg-orange.lighten-3 {
  background-color: #ffcc80 !important;
}

.text-orange.text-lighten-3 {
  color: #ffcc80 !important;
}
.text-orange.text-lighten-3.icon-outline {
  border-color: #ffcc80 !important;
}

.bg-orange.lighten-2 {
  background-color: #ffb74d !important;
}

.text-orange.text-lighten-2 {
  color: #ffb74d !important;
}
.text-orange.text-lighten-2.icon-outline {
  border-color: #ffb74d !important;
}

.bg-orange.lighten-1 {
  background-color: #ffa726 !important;
}

.text-orange.text-lighten-1 {
  color: #ffa726 !important;
}
.text-orange.text-lighten-1.icon-outline {
  border-color: #ffa726 !important;
}

.bg-orange.darken-1 {
  background-color: #fb8c00 !important;
}

.text-orange.text-darken-1 {
  color: #fb8c00 !important;
}
.text-orange.text-darken-1.icon-outline {
  border-color: #fb8c00 !important;
}

.bg-orange.darken-2 {
  background-color: #f57c00 !important;
}

.text-orange.text-darken-2 {
  color: #f57c00 !important;
}
.text-orange.text-darken-2.icon-outline {
  border-color: #f57c00 !important;
}

.bg-orange.darken-3 {
  background-color: #ef6c00 !important;
}

.text-orange.text-darken-3 {
  color: #ef6c00 !important;
}
.text-orange.text-darken-3.icon-outline {
  border-color: #ef6c00 !important;
}

.bg-orange.darken-4 {
  background-color: #e65100 !important;
}

.text-orange.text-darken-4 {
  color: #e65100 !important;
}
.text-orange.text-darken-4.icon-outline {
  border-color: #e65100 !important;
}

.bg-orange.accent-1 {
  background-color: #ffd180 !important;
}

.text-orange.text-accent-1 {
  color: #ffd180 !important;
}
.text-orange.text-accent-1.icon-outline {
  border-color: #ffd180 !important;
}

.bg-orange.accent-2 {
  background-color: #ffab40 !important;
}

.text-orange.text-accent-2 {
  color: #ffab40 !important;
}
.text-orange.text-accent-2.icon-outline {
  border-color: #ffab40 !important;
}

.bg-orange.accent-3 {
  background-color: #ff9100 !important;
}

.text-orange.text-accent-3 {
  color: #ff9100 !important;
}
.text-orange.text-accent-3.icon-outline {
  border-color: #ff9100 !important;
}

.bg-orange.accent-4 {
  background-color: #ff6d00 !important;
}

.text-orange.text-accent-4 {
  color: #ff6d00 !important;
}
.text-orange.text-accent-4.icon-outline {
  border-color: #ff6d00 !important;
}

.bg-deep-orange {
  background-color: #ff5722 !important;
}

.text-deep-orange {
  color: #ff5722 !important;
}
.text-deep-orange.icon-outline {
  border-color: #ff5722 !important;
}

.bg-deep-orange.lighten-5 {
  background-color: #fbe9e7 !important;
}

.text-deep-orange.text-lighten-5 {
  color: #fbe9e7 !important;
}
.text-deep-orange.text-lighten-5.icon-outline {
  border-color: #fbe9e7 !important;
}

.bg-deep-orange.lighten-4 {
  background-color: #ffccbc !important;
}

.text-deep-orange.text-lighten-4 {
  color: #ffccbc !important;
}
.text-deep-orange.text-lighten-4.icon-outline {
  border-color: #ffccbc !important;
}

.bg-deep-orange.lighten-3 {
  background-color: #ffab91 !important;
}

.text-deep-orange.text-lighten-3 {
  color: #ffab91 !important;
}
.text-deep-orange.text-lighten-3.icon-outline {
  border-color: #ffab91 !important;
}

.bg-deep-orange.lighten-2 {
  background-color: #ff8a65 !important;
}

.text-deep-orange.text-lighten-2 {
  color: #ff8a65 !important;
}
.text-deep-orange.text-lighten-2.icon-outline {
  border-color: #ff8a65 !important;
}

.bg-deep-orange.lighten-1 {
  background-color: #ff7043 !important;
}

.text-deep-orange.text-lighten-1 {
  color: #ff7043 !important;
}
.text-deep-orange.text-lighten-1.icon-outline {
  border-color: #ff7043 !important;
}

.bg-deep-orange.darken-1 {
  background-color: #f4511e !important;
}

.text-deep-orange.text-darken-1 {
  color: #f4511e !important;
}
.text-deep-orange.text-darken-1.icon-outline {
  border-color: #f4511e !important;
}

.bg-deep-orange.darken-2 {
  background-color: #e64a19 !important;
}

.text-deep-orange.text-darken-2 {
  color: #e64a19 !important;
}
.text-deep-orange.text-darken-2.icon-outline {
  border-color: #e64a19 !important;
}

.bg-deep-orange.darken-3 {
  background-color: #d84315 !important;
}

.text-deep-orange.text-darken-3 {
  color: #d84315 !important;
}
.text-deep-orange.text-darken-3.icon-outline {
  border-color: #d84315 !important;
}

.bg-deep-orange.darken-4 {
  background-color: #bf360c !important;
}

.text-deep-orange.text-darken-4 {
  color: #bf360c !important;
}
.text-deep-orange.text-darken-4.icon-outline {
  border-color: #bf360c !important;
}

.bg-deep-orange.accent-1 {
  background-color: #ff9e80 !important;
}

.text-deep-orange.text-accent-1 {
  color: #ff9e80 !important;
}
.text-deep-orange.text-accent-1.icon-outline {
  border-color: #ff9e80 !important;
}

.bg-deep-orange.accent-2 {
  background-color: #ff6e40 !important;
}

.text-deep-orange.text-accent-2 {
  color: #ff6e40 !important;
}
.text-deep-orange.text-accent-2.icon-outline {
  border-color: #ff6e40 !important;
}

.bg-deep-orange.accent-3 {
  background-color: #ff3d00 !important;
}

.text-deep-orange.text-accent-3 {
  color: #ff3d00 !important;
}
.text-deep-orange.text-accent-3.icon-outline {
  border-color: #ff3d00 !important;
}

.bg-deep-orange.accent-4 {
  background-color: #dd2c00 !important;
}

.text-deep-orange.text-accent-4 {
  color: #dd2c00 !important;
}
.text-deep-orange.text-accent-4.icon-outline {
  border-color: #dd2c00 !important;
}

.bg-brown {
  background-color: #795548 !important;
}

.text-brown {
  color: #795548 !important;
}
.text-brown.icon-outline {
  border-color: #795548 !important;
}

.bg-brown.lighten-5 {
  background-color: #efebe9 !important;
}

.text-brown.text-lighten-5 {
  color: #efebe9 !important;
}
.text-brown.text-lighten-5.icon-outline {
  border-color: #efebe9 !important;
}

.bg-brown.lighten-4 {
  background-color: #d7ccc8 !important;
}

.text-brown.text-lighten-4 {
  color: #d7ccc8 !important;
}
.text-brown.text-lighten-4.icon-outline {
  border-color: #d7ccc8 !important;
}

.bg-brown.lighten-3 {
  background-color: #bcaaa4 !important;
}

.text-brown.text-lighten-3 {
  color: #bcaaa4 !important;
}
.text-brown.text-lighten-3.icon-outline {
  border-color: #bcaaa4 !important;
}

.bg-brown.lighten-2 {
  background-color: #a1887f !important;
}

.text-brown.text-lighten-2 {
  color: #a1887f !important;
}
.text-brown.text-lighten-2.icon-outline {
  border-color: #a1887f !important;
}

.bg-brown.lighten-1 {
  background-color: #8d6e63 !important;
}

.text-brown.text-lighten-1 {
  color: #8d6e63 !important;
}
.text-brown.text-lighten-1.icon-outline {
  border-color: #8d6e63 !important;
}

.bg-brown.darken-1 {
  background-color: #6d4c41 !important;
}

.text-brown.text-darken-1 {
  color: #6d4c41 !important;
}
.text-brown.text-darken-1.icon-outline {
  border-color: #6d4c41 !important;
}

.bg-brown.darken-2 {
  background-color: #5d4037 !important;
}

.text-brown.text-darken-2 {
  color: #5d4037 !important;
}
.text-brown.text-darken-2.icon-outline {
  border-color: #5d4037 !important;
}

.bg-brown.darken-3 {
  background-color: #4e342e !important;
}

.text-brown.text-darken-3 {
  color: #4e342e !important;
}
.text-brown.text-darken-3.icon-outline {
  border-color: #4e342e !important;
}

.bg-brown.darken-4 {
  background-color: #3e2723 !important;
}

.text-brown.text-darken-4 {
  color: #3e2723 !important;
}
.text-brown.text-darken-4.icon-outline {
  border-color: #3e2723 !important;
}

.bg-blue-grey {
  background-color: #607d8b !important;
}

.text-blue-grey {
  color: #607d8b !important;
}
.text-blue-grey.icon-outline {
  border-color: #607d8b !important;
}

.bg-blue-grey.lighten-5 {
  background-color: #eceff1 !important;
}

.text-blue-grey.text-lighten-5 {
  color: #eceff1 !important;
}
.text-blue-grey.text-lighten-5.icon-outline {
  border-color: #eceff1 !important;
}

.bg-blue-grey.lighten-4 {
  background-color: #cfd8dc !important;
}

.text-blue-grey.text-lighten-4 {
  color: #cfd8dc !important;
}
.text-blue-grey.text-lighten-4.icon-outline {
  border-color: #cfd8dc !important;
}

.bg-blue-grey.lighten-3 {
  background-color: #b0bec5 !important;
}

.text-blue-grey.text-lighten-3 {
  color: #b0bec5 !important;
}
.text-blue-grey.text-lighten-3.icon-outline {
  border-color: #b0bec5 !important;
}

.bg-blue-grey.lighten-2 {
  background-color: #90a4ae !important;
}

.text-blue-grey.text-lighten-2 {
  color: #90a4ae !important;
}
.text-blue-grey.text-lighten-2.icon-outline {
  border-color: #90a4ae !important;
}

.bg-blue-grey.lighten-1 {
  background-color: #78909c !important;
}

.text-blue-grey.text-lighten-1 {
  color: #78909c !important;
}
.text-blue-grey.text-lighten-1.icon-outline {
  border-color: #78909c !important;
}

.bg-blue-grey.darken-1 {
  background-color: #546e7a !important;
}

.text-blue-grey.text-darken-1 {
  color: #546e7a !important;
}
.text-blue-grey.text-darken-1.icon-outline {
  border-color: #546e7a !important;
}

.bg-blue-grey.darken-2 {
  background-color: #455a64 !important;
}

.text-blue-grey.text-darken-2 {
  color: #455a64 !important;
}
.text-blue-grey.text-darken-2.icon-outline {
  border-color: #455a64 !important;
}

.bg-blue-grey.darken-3 {
  background-color: #37474f !important;
}

.text-blue-grey.text-darken-3 {
  color: #37474f !important;
}
.text-blue-grey.text-darken-3.icon-outline {
  border-color: #37474f !important;
}

.bg-blue-grey.darken-4 {
  background-color: #263238 !important;
}

.text-blue-grey.text-darken-4 {
  color: #263238 !important;
}
.text-blue-grey.text-darken-4.icon-outline {
  border-color: #263238 !important;
}

.bg-grey {
  background-color: #9e9e9e !important;
}

.text-grey {
  color: #9e9e9e !important;
}
.text-grey.icon-outline {
  border-color: #9e9e9e !important;
}

.bg-grey.lighten-5 {
  background-color: #fafafa !important;
}

.text-grey.text-lighten-5 {
  color: #fafafa !important;
}
.text-grey.text-lighten-5.icon-outline {
  border-color: #fafafa !important;
}

.bg-grey.lighten-4 {
  background-color: #f5f5f5 !important;
}

.text-grey.text-lighten-4 {
  color: #f5f5f5 !important;
}
.text-grey.text-lighten-4.icon-outline {
  border-color: #f5f5f5 !important;
}

.bg-grey.lighten-3 {
  background-color: #eeeeee !important;
}

.text-grey.text-lighten-3 {
  color: #eeeeee !important;
}
.text-grey.text-lighten-3.icon-outline {
  border-color: #eeeeee !important;
}

.bg-grey.lighten-2 {
  background-color: #e0e0e0 !important;
}

.text-grey.text-lighten-2 {
  color: #e0e0e0 !important;
}
.text-grey.text-lighten-2.icon-outline {
  border-color: #e0e0e0 !important;
}

.bg-grey.lighten-1 {
  background-color: #bdbdbd !important;
}

.text-grey.text-lighten-1 {
  color: #bdbdbd !important;
}
.text-grey.text-lighten-1.icon-outline {
  border-color: #bdbdbd !important;
}

.bg-grey.darken-1 {
  background-color: #757575 !important;
}

.text-grey.text-darken-1 {
  color: #757575 !important;
}
.text-grey.text-darken-1.icon-outline {
  border-color: #757575 !important;
}

.bg-grey.darken-2 {
  background-color: #616161 !important;
}

.text-grey.text-darken-2 {
  color: #616161 !important;
}
.text-grey.text-darken-2.icon-outline {
  border-color: #616161 !important;
}

.bg-grey.darken-3 {
  background-color: #424242 !important;
}

.text-grey.text-darken-3 {
  color: #424242 !important;
}
.text-grey.text-darken-3.icon-outline {
  border-color: #424242 !important;
}

.bg-grey.darken-4 {
  background-color: #212121 !important;
}

.text-grey.text-darken-4 {
  color: #212121 !important;
}
.text-grey.text-darken-4.icon-outline {
  border-color: #212121 !important;
}

.bg-black {
  background-color: #000000 !important;
}

.text-black {
  color: #000000 !important;
}
.text-black.icon-outline {
  border-color: #000000 !important;
}

.bg-white {
  background-color: #FFFFFF !important;
}

.text-white {
  color: #FFFFFF !important;
}
.text-white.icon-outline {
  border-color: #FFFFFF !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.text-transparent {
  color: transparent !important;
}
.text-transparent.icon-outline {
  border-color: transparent !important;
}

/*Custom Animation*/
@keyframes flipCenter {
  0% {
    animation-timing-function: ease-in;
    opacity: 0;
    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);
  }
  40% {
    animation-timing-function: ease-in;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  60% {
    opacity: 1;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  80% {
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  100% {
    transform: perspective(100000px);
  }
}
@-webkit-keyframes flipCenter {
  0% {
    animation-timing-function: ease-in;
    opacity: 0;
    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);
  }
  40% {
    animation-timing-function: ease-in;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  60% {
    opacity: 1;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  80% {
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  100% {
    transform: perspective(100000px);
  }
}
.flipCenter {
  animation-name: flipCenter;
  backface-visibility: visible;
}

@keyframes desployDown {
  0% {
    transform: scaleY(0);
    transform-origin: center top 0;
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
    transform-origin: center top 0;
  }
}
@-webkit-keyframes desployDown {
  0% {
    transform: scaleY(0);
    transform-origin: center top 0;
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
    transform-origin: center top 0;
  }
}
.desployDown {
  animation-name: desployDown;
  backface-visibility: visible;
}

@keyframes fadeInRightTiny {
  0% {
    opacity: 0;
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
@-webkit-keyframes fadeInRightTiny {
  0% {
    opacity: 0;
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
.fadeInRightTiny {
  animation-name: fadeInRightTiny;
}

@keyframes fadeInLeftTiny {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
@-webkit-keyframes fadeInLeftTiny {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
.fadeInLeftTiny {
  animation-name: fadeInLeftTiny;
}

@keyframes slideInRightTiny {
  0% {
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
@-webkit-keyframes slideInRightTiny {
  0% {
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
.slideInRightTiny {
  animation-name: slideInRightTiny;
}

@keyframes slideInLeftTiny {
  0% {
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
@-webkit-keyframes slideInLeftTiny {
  0% {
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
.slideInLeftTiny {
  animation-name: slideInLeftTiny;
}

@keyframes slideInUpTiny {
  0% {
    transform: translate3d(0px, 5%, 0px);
  }
  100% {
    transform: none;
  }
}
@-webkit-keyframes slideInUpTiny {
  0% {
    transform: translate3d(0px, 5%, 0px);
  }
  100% {
    transform: none;
  }
}
.slideInUpTiny {
  animation-name: slideInUpTiny;
}

/*Animation Durations*/
.animation-duration-1 {
  animation-duration: 0.1s;
}

.animation-duration-2 {
  animation-duration: 0.2s;
}

.animation-duration-3 {
  animation-duration: 0.3s;
}

.animation-duration-4 {
  animation-duration: 0.4s;
}

.animation-duration-5 {
  animation-duration: 0.5s;
}

.animation-duration-6 {
  animation-duration: 0.6s;
}

.animation-duration-7 {
  animation-duration: 0.7s;
}

.animation-duration-8 {
  animation-duration: 0.8s;
}

.animation-duration-9 {
  animation-duration: 0.9s;
}

.animation-duration-10 {
  animation-duration: 1s;
}

.animation-duration-11 {
  animation-duration: 1.1s;
}

.animation-duration-12 {
  animation-duration: 1.2s;
}

.animation-duration-13 {
  animation-duration: 1.3s;
}

.animation-duration-14 {
  animation-duration: 1.4s;
}

.animation-duration-15 {
  animation-duration: 1.5s;
}

.animation-duration-16 {
  animation-duration: 1.6s;
}

.animation-duration-17 {
  animation-duration: 1.7s;
}

.animation-duration-18 {
  animation-duration: 1.8s;
}

.animation-duration-19 {
  animation-duration: 1.9s;
}

.animation-duration-20 {
  animation-duration: 2s;
}

.animation-duration-21 {
  animation-duration: 2.1s;
}

.animation-duration-22 {
  animation-duration: 2.2s;
}

.animation-duration-23 {
  animation-duration: 2.3s;
}

.animation-duration-24 {
  animation-duration: 2.4s;
}

.animation-duration-25 {
  animation-duration: 2.5s;
}

.animation-duration-26 {
  animation-duration: 2.6s;
}

.animation-duration-27 {
  animation-duration: 2.7s;
}

.animation-duration-28 {
  animation-duration: 2.8s;
}

.animation-duration-29 {
  animation-duration: 2.9s;
}

.animation-duration-30 {
  animation-duration: 3s;
}

.animation-duration-31 {
  animation-duration: 3.1s;
}

.animation-duration-32 {
  animation-duration: 3.2s;
}

.animation-duration-33 {
  animation-duration: 3.3s;
}

.animation-duration-34 {
  animation-duration: 3.4s;
}

.animation-duration-35 {
  animation-duration: 3.5s;
}

.animation-duration-36 {
  animation-duration: 3.6s;
}

.animation-duration-37 {
  animation-duration: 3.7s;
}

.animation-duration-38 {
  animation-duration: 3.8s;
}

.animation-duration-39 {
  animation-duration: 3.9s;
}

.animation-duration-40 {
  animation-duration: 4s;
}

.animation-delay-1 {
  animation-delay: 0.1s;
}

.animation-delay-2 {
  animation-delay: 0.2s;
}

.animation-delay-3 {
  animation-delay: 0.3s;
}

.animation-delay-4 {
  animation-delay: 0.4s;
}

.animation-delay-5 {
  animation-delay: 0.5s;
}

.animation-delay-6 {
  animation-delay: 0.6s;
}

.animation-delay-7 {
  animation-delay: 0.7s;
}

.animation-delay-8 {
  animation-delay: 0.8s;
}

.animation-delay-9 {
  animation-delay: 0.9s;
}

.animation-delay-10 {
  animation-delay: 1s;
}

.animation-delay-11 {
  animation-delay: 1.1s;
}

.animation-delay-12 {
  animation-delay: 1.2s;
}

.animation-delay-13 {
  animation-delay: 1.3s;
}

.animation-delay-14 {
  animation-delay: 1.4s;
}

.animation-delay-15 {
  animation-delay: 1.5s;
}

.animation-delay-16 {
  animation-delay: 1.6s;
}

.animation-delay-17 {
  animation-delay: 1.7s;
}

.animation-delay-18 {
  animation-delay: 1.8s;
}

.animation-delay-19 {
  animation-delay: 1.9s;
}

.animation-delay-20 {
  animation-delay: 2s;
}

.animation-delay-21 {
  animation-delay: 2.1s;
}

.animation-delay-22 {
  animation-delay: 2.2s;
}

.animation-delay-23 {
  animation-delay: 2.3s;
}

.animation-delay-24 {
  animation-delay: 2.4s;
}

.animation-delay-25 {
  animation-delay: 2.5s;
}

.animation-delay-26 {
  animation-delay: 2.6s;
}

.animation-delay-27 {
  animation-delay: 2.6s;
}

.animation-delay-28 {
  animation-delay: 2.8s;
}

.animation-delay-29 {
  animation-delay: 2.9s;
}

.animation-delay-30 {
  animation-delay: 3s;
}

.animation-delay-31 {
  animation-delay: 3.1s;
}

.animation-delay-32 {
  animation-delay: 3.2s;
}

.animation-delay-33 {
  animation-delay: 3.3s;
}

.animation-delay-34 {
  animation-delay: 3.4s;
}

.animation-delay-35 {
  animation-delay: 3.5s;
}

.animation-delay-36 {
  animation-delay: 3.6s;
}

.animation-delay-37 {
  animation-delay: 3.7s;
}

.animation-delay-38 {
  animation-delay: 3.8s;
}

.animation-delay-39 {
  animation-delay: 3.9s;
}

.animation-delay-40 {
  animation-delay: 4s;
}

.animation-delay-41 {
  animation-delay: 4.1s;
}

.animation-delay-42 {
  animation-delay: 4.2s;
}

.animation-delay-43 {
  animation-delay: 4.3s;
}

.animation-delay-44 {
  animation-delay: 4.4s;
}

.animation-delay-45 {
  animation-delay: 4.5s;
}

.animation-delay-46 {
  animation-delay: 4.6s;
}

.animation-delay-47 {
  animation-delay: 4.7s;
}

.animation-delay-48 {
  animation-delay: 4.8s;
}

.animation-delay-49 {
  animation-delay: 4.9s;
}

.animation-delay-50 {
  animation-delay: 5s;
}

/* Base
   ========================================================================== */
/*Base Styles*/
html {
  height: 100%;
}

body {
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #5c5c5c;
  background-color: #fff;
  height: 100%;
  overflow: hidden;
}

body.ios-mobile-view-height {
  height: auto !important;
  overflow: visible !important;
}

#nprogress .bar {
  z-index: 5000 !important;
  background: #3f51b5 !important;
}

#nprogress .peg {
  -webkit-box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
  -moz-box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
  -o-box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
  box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
}

#nprogress .spinner {
  z-index: 5000 !important;
}

#nprogress .spinner-icon {
  border-top-color: #3f51b5 !important;
  border-left-color: #3f51b5 !important;
}

.text-transform-none {
  text-transform: none;
}

.br-break {
  word-break: break-all !important;
}

.font-weight-semibold {
  font-weight: 500 !important;
}

.z-index-20 {
  z-index: 20;
}

.border-bottom {
  border-bottom: solid 1px #dee2e6;
}

.col-with-divider div[class*=col-] {
  border-left: solid 1px #dee2e6;
}
.col-with-divider div[class*=col-]:first-child {
  border: 0 none;
}

.height-100 {
  height: 100px !important;
}

.height-150 {
  height: 150px !important;
}

.height-130 {
  height: 130px !important;
}

.height-200 {
  height: 200px !important;
}

.max-width-100 {
  max-width: 100px !important;
}

.max-height-120 {
  max-height: 120px !important;
}

.right-arrow {
  display: inline-block;
  color: #3f51b5;
  text-transform: capitalize;
}
.right-arrow:after {
  content: "\\f30f";
  font-family: "Material-Design-Iconic-Font";
  color: #3f51b5;
  margin-left: 8px;
  font-size: 20px;
  vertical-align: middle;
}
.right-arrow:hover, .right-arrow:focus {
  text-decoration: none;
}

.letter-spacing-base {
  letter-spacing: 3px;
}

.letter-spacing-lg {
  letter-spacing: 6px;
}

.letter-spacing-xl {
  letter-spacing: 8px;
}

.page-heading {
  margin-bottom: 38px;
}
.page-heading .title {
  text-transform: capitalize;
  font-weight: 600;
}
.page-heading .breadcrumb {
  padding: 0;
  background-color: transparent;
  margin-bottom: 0;
}
@media screen and (max-width: 575px) {
  .page-heading {
    margin-bottom: 18px;
  }
}

.sub-heading {
  font-size: 13px;
  color: #adb5bd;
  margin-bottom: 0;
}
.sub-heading:not(:last-child) {
  margin-bottom: 16px !important;
}

.manage-margin {
  margin-bottom: 0;
}
.manage-margin > * {
  margin-bottom: 6px;
}
.manage-margin > *:not(:last-child) {
  margin-right: 16px;
}

.no-shadow {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

.shadow-sm {
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}

.shadow {
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}

.shadow-lg {
  -webkit-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
}

.shadow-xl {
  -webkit-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
}

.avatar-shadow {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  -o-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
}

.remove-table-border td, .remove-table-border th {
  border: 0 none;
}

.media-list {
  margin-bottom: 10px;
}
.media-list:not(:last-child) {
  border-bottom: solid 1px #e9ecef;
  padding-bottom: 15px;
  margin-bottom: 20px;
  position: relative;
}

.border-2 {
  border: 2px solid #ced4da !important;
}

.border-w2 {
  border-width: 2px;
}

.border-primary {
  border-color: #3f51b5 !important;
}

.border-red {
  border-color: #F44336 !important;
}

.border-pink {
  border-color: #e91e63 !important;
}

.border-purple {
  border-color: #9C27B0 !important;
}

.border-deep-purple {
  border-color: #673ab7 !important;
}

.border-indigo {
  border-color: #3f51b5 !important;
}

.border-blue {
  border-color: #2196F3 !important;
}

.border-light-blue {
  border-color: #03a9f4 !important;
}

.border-cyan {
  border-color: #00bcd4 !important;
}

.border-teal {
  border-color: #009688 !important;
}

.border-green {
  border-color: #4CAF50 !important;
}

.border-light-green {
  border-color: #8bc34a !important;
}

.border-lime {
  border-color: #cddc39 !important;
}

.border-yellow {
  border-color: #ffeb3b !important;
}

.border-amber {
  border-color: #ffc107 !important;
}

.border-orange {
  border-color: #ff9800 !important;
}

.border-deep-orange {
  border-color: #ff5722 !important;
}

.border-brown {
  border-color: #795548 !important;
}

.border-blue-grey {
  border-color: #607d8b !important;
}

.border-grey {
  border-color: #9e9e9e !important;
}

.center-crop-img {
  position: relative;
  width: 100%;
  min-height: 120px;
  overflow: hidden;
}
.center-crop-img img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  width: auto;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.center-crop-img img.portrait {
  width: 100%;
  height: auto;
}

.pointer {
  cursor: pointer;
}

.icon-btn {
  height: 48px;
  display: flex;
  align-items: center;
  width: 48px;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  color: #6c757d;
}
.header-notifications .icon-btn {
  padding: 0 4px;
}

.avatar {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  color: #fafafa;
}

.avatar-lg {
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #fafafa;
}

.avatar-sm {
  width: 40px;
  height: 40px;
  text-align: center;
  color: #fafafa;
}

.animated {
  -webkit-animation-fill-mode: none !important;
  animation-fill-mode: none !important;
}

.overflow-hidden {
  overflow: hidden;
}

.icons-showcase > div {
  cursor: pointer;
  padding: 7px 15px;
  border-radius: 4px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-decoration {
  text-decoration: none !important;
}

.row-5 {
  margin-left: -5px;
  margin-right: -5px;
}
.row-5 > [class*=col-] {
  padding-left: 5px;
  padding-right: 5px;
}

.font-size-16 {
  font-size: 16px !important;
}

.material-icons {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  text-align: center;
  padding-bottom: 3px;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-image: linear-gradient(to bottom right, #ebebeb, #bebebe);
  border: solid 1px #ababab;
}

::selection {
  background-color: #006FC9;
  color: #fff;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 2px 30px 2px 2px;
  border: none;
  cursor: pointer;
}

.my-tooltip > .tooltip-inner {
  background-color: #fff;
  color: #808080;
  border: 1px solid #d8dcdf;
}

.my-tooltip [class\$=arrow] {
  display: none;
}

::-ms-clear {
  display: none;
}

.hs-button {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  cursor: pointer;
  display: inline-block;
  font-weight: 700;
  line-height: 12px;
  position: relative;
  text-align: center;
  transition: all 0.15s linear;
  background-color: #ff7a59;
  border-color: #ff7a59;
  color: #fff;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  font-size: 14px;
  padding: 12px 24px;
}

.hs-button:hover, .hs-button:focus {
  background-color: #ff8f73;
  border-color: #ff8f73;
}

.hs-button:active {
  background-color: #e66e50;
  border-color: #e66e50;
}

label {
  font-size: 14px;
  width: 130px;
  text-align: right;
  color: #33475b;
  display: block;
  float: none;
  width: auto;
  font-weight: 500;
  text-align: left;
  line-height: 20px;
  padding-top: 0;
  margin-bottom: 4px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.hs-video-form label {
  color: #fff !important;
}

.hs-video-form .hs-back-button {
  background-color: #fff;
  width: 20%;
  height: 38px;
  margin-right: 10px;
  border: 1px solid;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  border-radius: 3px;
}

.hs-video-form .hs-button {
  width: 70%;
}

.hs-video-form .hs-button span {
  font-size: 15px;
}

.hs-video-form .hs-richtext {
  color: #fff !important;
}

.hs-video-form .legal-consent-container {
  max-height: 180px !important;
  overflow-y: scroll !important;
}

.hs-video-form .legal-consent-container:after {
  content: "";
  display: block;
  height: 100px;
  width: 100%;
}

.hs-video-form .legal-consent-wrapper {
  position: relative;
}

.hs-video-form .legal-consent-overlay {
  position: absolute;
  pointer-events: none;
  left: 0;
  bottom: 0;
  height: 100px;
  width: 100%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #292929 100%);
}

.hs-error-msgs label {
  color: #f2545b;
}

.hs-input {
  display: inline-block;
  width: 90%;
  max-width: 500px;
  height: 40px;
  padding: 9px 10px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: normal;
  line-height: 22px;
  color: #33475b;
  border: 1px solid #cbd6e2;
  box-sizing: border-box;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  border-radius: 3px;
}

.hs-input:not([type=file]) {
  background-color: #f5f8fa;
}

.hs-input[type=checkbox], .hs-input[type=radio] {
  cursor: pointer;
  width: auto;
  height: auto;
  padding: 0;
  margin: 3px 5px 3px 0px;
  line-height: normal;
  border: none;
}

.hs-input[type=file] {
  padding: initial;
  border: initial;
  line-height: initial;
  box-shadow: none;
}

select.is-placeholder {
  color: #bfbfbf;
}

select.is-placeholder:focus {
  color: #33475b;
}

.hs-input:-moz-placeholder {
  color: #bfbfbf;
}

.hs-input::-webkit-input-placeholder {
  color: #bfbfbf;
}

.hs-input option:disabled {
  color: #bfbfbf;
}

.hs-input input, .hs-input textarea {
  transition: border 0.2s linear;
}

.hs-input:focus {
  outline: none;
  border-color: rgba(82, 168, 236, 0.8);
}

textarea.hs-input {
  height: auto;
}

select[multiple].hs-input {
  height: inherit;
}

input.hs-input.error, div.field.error input, div.field.error textarea, div.field.error .chzn-choices, textarea.hs-input.error, select.hs-input.error {
  border-color: #c87872 !important;
}

input.hs-input.error:focus, div.field.error input:focus, div.field.error textarea:focus, div.field.error .chzn-choices:focus, textarea.hs-input.error:focus, select.hs-input.error:focus {
  border-color: #b9554d !important;
}

.actions {
  margin-top: 18px;
  margin-bottom: 18px;
  padding: 17px 0px;
}

.inputs-list {
  margin: 0 0 5px;
  width: 100%;
  padding-left: 5px;
}

.inputs-list > li {
  display: block;
  padding: 0;
  width: 100%;
  padding-top: 0;
}

.inputs-list label {
  display: block;
  float: none;
  width: auto;
  padding: 0;
  line-height: 18px;
  text-align: left;
  white-space: normal;
  font-weight: normal;
}

.inputs-list:first-child {
  padding-top: 6px;
}

.inputs-list > li + li {
  padding-top: 2px;
}

ul.no-list {
  list-style: none;
}

.field {
  margin-bottom: 18px;
}

.hs-field-desc {
  color: #7c98b6;
  margin: 0px 0px 6px;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.hs-form-required {
  color: red;
}

.hs-richtext {
  margin-bottom: 3px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 24px;
  font-size: 14px;
  color: #33475b;
}

.hs-richtext hr {
  text-align: left;
  margin-left: 0;
  width: 91%;
}

.email-correction, .email-validation {
  padding-top: 3px;
  font-size: 12px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.email-correction a, .email-validation a {
  cursor: pointer;
}

@media (max-width: 400px), (min-device-width: 320px) and (max-device-width: 480px) {
  .email-correction form .form-columns-2 .hs-form-field, .email-correction form .form-columns-3 .hs-form-field, .email-validation form .form-columns-2 .hs-form-field, .email-validation form .form-columns-3 .hs-form-field {
    float: none;
    width: 100%;
  }
  .email-correction form .form-columns-2 .hs-form-field .hs-input, .email-correction form .form-columns-3 .hs-form-field .hs-input, .email-validation form .form-columns-2 .hs-form-field .hs-input, .email-validation form .form-columns-3 .hs-form-field .hs-input {
    width: 90%;
  }
  .email-correction form .form-columns-2 .hs-form-field input[type=checkbox], .email-correction form .form-columns-2 .hs-form-field input[type=radio], .email-correction form .form-columns-3 .hs-form-field input[type=checkbox], .email-correction form .form-columns-3 .hs-form-field input[type=radio], .email-validation form .form-columns-2 .hs-form-field input[type=checkbox], .email-validation form .form-columns-2 .hs-form-field input[type=radio], .email-validation form .form-columns-3 .hs-form-field input[type=checkbox], .email-validation form .form-columns-3 .hs-form-field input[type=radio] {
    width: 24px;
  }
}
.hs-button, .hs-form-field input[type=text], .hs-form-field input[type=email], .hs-form-field input[type=phone], .hs-form-field input[type=number], .hs-form-field input[type=tel], .hs-form-field input[type=date], .hs-form-field textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
}

.hs-default-font-element, .hs-main-font-element {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.hs-form label {
  margin: 0 !important;
  font-family: "Poppins", sans-serif !important;
}

.hs-form input[type=checkbox] {
  margin: 0 10px 0 0 !important;
}

.hs-form fieldset {
  max-width: unset !important;
}

.hs-input {
  max-width: unset !important;
  font-family: "Poppins", sans-serif !important;
}

.hs-form .input textarea {
  width: 100% !important;
}

.hs-form .input select {
  width: 100% !important;
}

.hs-form select {
  margin: 0 !important;
}

.hs-form textarea {
  margin: 0 !important;
}

.hs-form input[type=text], .hs-form input[type=email], .hs-form input[type=tel] {
  margin: 0 !important;
}

.hs-form input[type=file i]::-webkit-file-upload-button {
  cursor: pointer !important;
}

.hs-form ::placeholder {
  color: #bfbfbf !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.hs-form .input input[type=file] {
  width: 100% !important;
  margin: 0 !important;
}

.hs-form .input input[type=text] {
  width: 100% !important;
  border: 1px solid #cbd6e2;
  border-radius: 3px !important;
}

.hs-form .input input[type=text]::placeholder {
  font-size: 14px !important;
}

.hs-field-desc {
  text-align: left !important;
}

.hs-form body .hs-button.primary, body input[type=submit], body input[type=button] {
  float: none !important;
  margin: 0 !important;
}

.hs-form .actions {
  margin: 0 !important;
  text-align: left !important;
}

/* OVERRIDE DEFAULT REACT-DATES STYLES */

/* Will edit everything selected including everything between a range of dates */
.CalendarDay__selected_span {
  background: #3392E6 !important;
  border: 1px double #3392E6 !important;
  color: white !important;
}

/* Will edit selected date or the endpoints of a range of dates */
.CalendarDay__selected {
  background: #3392E6 !important;
  border: 1px double #3392E6 !important;
  color: white !important;
}

/* Will edit when hovered over. _span style also has this property */
.CalendarDay__selected:hover {
  opacity: 0.8 !important;
}

/* Will edit when the second date (end date) in a range of dates */
/* is not yet selected. Edits the dates between your mouse and said date */
.CalendarDay__hovered_span:hover,
.CalendarDay__hovered_span {
  background: #3392E6 !important;
}

.DayPickerKeyboardShortcuts_show__bottomRight::before {
  border-right: 33px solid #3392E6 !important;
  border-right-color: #3392E6 !important;
}

.CalendarMonth_table {
  margin-top: 8px;
}

.SingleDatePicker_picker {
  z-index: 100 !important;
}

.SingleDatePicker {
  display: block !important;
}

.SingleDatePickerInput {
  display: block !important;
}

.DateInput {
  display: block !important;
  width: 100% !important;
}

.DateInput_input {
  font-size: 14px !important;
  color: #808080 !important;
  border: 1px solid #ced4da !important;
  box-shadow: none !important;
  border-radius: 0.25rem !important;
  padding: 10px 0 5px 10px !important;
  font-weight: 400 !important;
  display: block !important;
  width: 100% !important;
  height: calc(2.25rem + 2px) !important;
}

.DateInput_input__focused {
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem !important;
}

.DateRangePicker {
  display: block !important;
}

.DateRangePickerInput {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.DateRangePickerInput_arrow {
  padding: 0 10px !important;
}

.DateInput_input__disabled {
  font-style: normal !important;
}

.hs-form input[type=text],
.hs-form input[type=email],
.hs-form input[type=tel] {
  border: none;
  box-shadow: none;
  border-radius: 5;
  padding: "5px 0 5px 0";
  font-weight: 400;
  font-size: 14px;
  font-family: "Roboto";
  letter-spacing: 2;
  line-height: 1.5;
  margin: 5px 0 10px 0;
  color: #0071B9;
  padding-bottom: 5px;
  border: 1px solid #cbd6e2;
  width: 100%;
}

.hs-form input[type=checkbox] {
  margin: 10px 10px 10px 0;
}

.hs-form input[type=text]:focus {
  outline: 0;
}

.hs-form input[type=email]:focus {
  outline: 0;
}

.hs-form input[type=tel]:focus {
  outline: 0;
}

.hs-form label {
  font-family: "Roboto";
  margin: 10px 0;
}

.hs-form .hs-form-field > label {
  color: #0071B9;
  font-family: "Roboto";
  margin: 10px 0;
}

.hs-form .hs-field-desc {
  color: #33475b;
  font-family: "Roboto";
  margin: 5px 0;
}

.hs-form select {
  background: whitesmoke;
  margin: 15px 0 25px 0;
  color: #5e7993;
  border-radius: 3px;
  font-family: "Roboto";
}

.hs-form select:focus {
  outline: none;
}

.hs-form select:active {
  outline: none;
}

.hs-form .hs-richtext {
  color: #5e7993;
  font-family: "Roboto";
  margin: 5px 0 20px 0;
  font-size: 14px;
}

.hs-form textarea {
  margin: 10px 0;
  color: #0071B9;
  border: 1px solid #d8dcdf;
  border-radius: 0.2rem;
  width: 100%;
}

.hs-form textarea:focus {
  outline: none;
}

body .hs-button.primary,
body input[type=submit],
body input[type=button] {
  background: #0071B9;
  color: #ffffff;
  border-radius: 0.2rem;
  padding: 1em;
  font-size: 14px;
  font-weight: 400;
  padding: 10px 20px;
  margin-bottom: -70px;
  font-family: "Roboto";
  border: 1px solid #0071B9;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  margin: 30px 0 0 10px;
}

body .hs-button.primary:hover,
body input[type=submit]:hover,
body input[type=button]:hover {
  cursor: pointer;
  opacity: 0.8;
}

body input[type=file] {
  margin: 25px 0 25px 0;
  font-family: "Roboto";
}

.hs-form .hs-error-msgs label {
  color: #d8000c;
  font-size: 13px;
  padding-bottom: 5px;
}

.material-icons {
  user-select: none;
}

.d-inline-block {
  user-select: none;
}

/*Typography Styles*/
h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-weight: 400;
  margin: 0 0 12px;
  color: inherit;
}

h1, .h1 {
  font-size: 24px;
  font-family: "Poppins", sans-serif;
}

h2, .h2 {
  font-size: 18px;
  font-family: "Poppins", sans-serif;
}

h3, .h3 {
  font-size: 16px;
}

h4, .h4 {
  font-size: 15px;
}

h5, .h5 {
  font-size: 13px;
}

h6, .h6 {
  font-size: 12px;
}

.text-strikethrough {
  text-decoration: line-through !important;
}

@media screen and (max-width: 991px) {
  h1, .h1 {
    font-size: 18px;
    font-family: "Poppins", sans-serif;
  }
  h2, .h2 {
    font-size: 16px;
    font-family: "Poppins", sans-serif;
  }
  h3, .h3 {
    font-size: 15px;
  }
}
.desc-list {
  margin-bottom: 0;
}
.desc-list li {
  padding: 24px 30px;
  border-bottom: 1px solid #ced4da;
  margin-left: -30px;
  margin-right: -30px;
}
.desc-list li:last-child {
  border-bottom: 0 none;
}
.desc-list li .card-title {
  margin-bottom: 6px;
}
.desc-list.even-odd li {
  border-bottom: 0 none;
}
.desc-list.even-odd li:nth-child(2n) {
  background-color: #dee2e6;
}

/* Layouts
   ========================================================================== */
/*App Layout Styles*/
#app-site,
.app-main {
  display: flex;
  width: 100%;
  height: 100%;
}

.app-container {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
}

.app-sidebar {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.app-main-container {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.app-header {
  min-height: 60px;
  z-index: 99;
  position: relative;
}

.app-main-content-wrapper {
  flex: 1;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.app-container.fixed-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
}
.app-container.collapsible-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
}
.app-container.collapsible-drawer .app-main-container {
  position: relative;
}
.app-container.mini-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
}
.app-container.mini-drawer .app-sidebar {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

/*Sidebar Styles*/
.side-nav {
  width: 200px;
  background-color: #f5f7f9 !important;
  color: #868e96 !important;
  border-right: solid 1px #e9ecef !important;
  z-index: 1250 !important;
  height: 100%;
}
.side-nav .user-profile {
  background-color: rgb(92.3284313725%, 93.862745098%, 95.3970588235%);
  padding: 13px 20px !important;
}
.side-nav .user-avatar {
  margin: 0 15px 0 0 !important;
  height: 44px !important;
  width: 44px !important;
  line-height: 44px;
}
.side-nav .user-detail .user-name {
  color: #3f51b5;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;
}

.user-detail .user-name {
  cursor: pointer;
}

/*Navbar Styles*/
ul.nav-menu {
  position: relative;
  font-size: 13px;
  list-style: outside none none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

ul.nav-menu li {
  position: relative;
  margin-bottom: 1px;
}

ul.nav-menu li.menu + .nav-header {
  margin-top: 40px;
}
ul.nav-menu li.menu .sub-menu {
  display: none;
}
ul.nav-menu li.menu.open > .sub-menu {
  display: block;
}
ul.nav-menu li.menu.open .menu.active > .sub-menu {
  display: block;
}

ul.nav-menu li a {
  color: #868e96;
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  border-radius: 0;
}
ul.nav-menu li a .badge {
  margin-bottom: 0;
  padding: 3px 8px 2px;
}

ul.nav-menu .nav-header {
  color: #868e96;
  padding: 4px 22px;
  font-size: 11px;
  text-transform: uppercase;
}
ul.nav-menu .nav-header:first-child {
  margin-top: 30px;
}

ul.nav-menu > li.selected > a,
ul.nav-menu > li.open > a,
ul.nav-menu > li > a:hover,
ul.nav-menu > li > a:focus {
  color: #3f51b5;
}

ul.nav-menu li.menu > a {
  padding: 16px 20px;
  border-left: 2px solid transparent;
}

ul.nav-menu li.menu.open > a {
  border-color: transparent;
}

ul.nav-menu li.menu > a:focus:before,
ul.nav-menu li.menu > a:hover:before {
  color: #3f51b5;
}

ul.nav-menu li i {
  margin-right: 12px;
  font-size: 15px;
}

ul.nav-menu li ul {
  list-style: outside none none;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
}

ul.nav-menu li ul.sub-menu li > a {
  padding: 7px 20px 7px 56px;
}

ul.nav-menu li ul.sub-menu > li > ul > li > a {
  padding-left: 76px;
}

ul.nav-menu li ul.sub-menu > li > ul > li > ul > li > a {
  padding-left: 96px;
}

ul.nav-menu li ul.sub-menu > li > ul > li > ul > li > ul > li > a {
  padding-left: 116px;
}

ul.nav-menu li.menu > a:before {
  color: #868e96;
  content: "\\f2fb";
  display: inline-block;
  float: right;
  font-family: "Material-Design-Iconic-Font";
  font-size: 15px;
  margin-left: 10px;
  position: relative;
  -webkit-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
  font-weight: normal;
}

ul.nav-menu li.menu.no-arrow > a:before {
  display: none;
}

ul.nav-menu li.menu.selected > a:before,
ul.nav-menu li.menu.open > a:before,
ul.nav-menu li.menu > a:focus:before,
ul.nav-menu li.menu li > a:hover:before {
  background-color: transparent;
  color: #3f51b5;
}

ul.nav-menu li.menu.open > a:before,
ul.nav-menu li.menu.active > a:before {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  padding: 3px 7px;
  margin-left: -7px;
  background-color: #3f51b5;
  color: #fff;
  border-radius: 4px;
  display: inline-block;
}

ul.nav-menu li.menu .sub-menu li > a:hover,
ul.nav-menu li.menu .sub-menu li > a:focus,
ul.nav-menu li.menu.open .sub-menu li > a.active:before,
ul.nav-menu li.menu .sub-menu li > a:focus:before,
ul.nav-menu li.menu .sub-menu li > a:hover:before {
  color: #3f51b5;
}

.app-container.mini-drawer .side-nav {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  width: 80px;
}
.app-container.mini-drawer .side-nav .nav-menu li span.nav-text, .app-container.mini-drawer .side-nav .customizer {
  display: none;
}
.app-container.mini-drawer .side-nav .user-profile .user-detail {
  display: none !important;
}
.app-container.mini-drawer .side-nav .nav-menu .menu.open > .sub-menu {
  display: none !important;
}
.app-container.mini-drawer .side-nav .nav-menu li {
  text-align: center;
}
.app-container.mini-drawer .side-nav .nav-menu li i {
  margin-right: 0;
}
.app-container.mini-drawer .side-nav .nav-menu li.nav-header {
  padding: 4px 5px;
}
.app-container.mini-drawer .side-nav ul.nav-menu li a {
  padding: 16px 20px;
}
.app-container.mini-drawer .side-nav ul.nav-menu ul.sub-menu li a {
  padding-left: 30px;
}
.app-container.mini-drawer .side-nav ul.nav-menu > li > a:before {
  display: none;
}
.app-container.mini-drawer .side-nav .mini-logo-img-hover {
  display: none;
}

.app-container.mini-drawer .side-nav:hover {
  width: 200px;
}
.app-container.mini-drawer .side-nav:hover .nav-menu li span.nav-text {
  display: inline-block !important;
}
.app-container.mini-drawer .side-nav:hover .user-profile .user-detail {
  display: flex !important;
}
.app-container.mini-drawer .side-nav:hover .nav-menu .menu.open > .sub-menu {
  display: block !important;
}
.app-container.mini-drawer .side-nav:hover .customizer {
  display: flex !important;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li {
  text-align: left;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li i {
  margin-right: 16px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li a {
  padding: 16px 20px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li.nav-header {
  padding: 4px 22px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu li a {
  padding: 7px 20px 7px 56px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > a {
  padding-left: 76px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > ul > li > a {
  padding-left: 96px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > ul > li > ul > li > a {
  padding-left: 116px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu > li > a:before {
  display: block;
}
.app-container.mini-drawer .side-nav:hover .mini-logo-img {
  display: none;
}
.app-container.mini-drawer .side-nav:hover .mini-logo-img-hover {
  display: block;
}

.customizer {
  padding: 20px 35px;
}
.customizer img {
  padding: 5px;
  cursor: pointer;
}

.user-info ul li {
  font-size: 15px;
}

.rmc-drawer-left .rmc-drawer-sidebar, .rmc-drawer-right .rmc-drawer-sidebar {
  height: 100%;
}

.rmc-drawer-sidebar {
  position: fixed;
  transition: -webkit-transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
  overflow: hidden;
}
.rmc-drawer.rmc-drawer-left .rmc-drawer-sidebar {
  left: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  z-index: 903;
}
.rmc-drawer.rmc-drawer-right .rmc-drawer-sidebar {
  right: 0;
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
  z-index: 903;
}
.rmc-drawer.rmc-drawer-top .rmc-drawer-sidebar {
  z-index: 903;
}
.rmc-drawer.rmc-drawer-bottom .rmc-drawer-sidebar {
  z-index: 903;
}

@media (max-width: 1025px) {
  .rmc-drawer-draghandle {
    background-color: transparent;
  }
}

.drawer-container {
  position: relative;
}
.drawer-container .main {
  position: relative;
  padding: 10px;
  box-sizing: border-box;
}

.rmc-drawer-overlay {
  z-index: 902;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-out;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100%;
  min-width: 100% !important;
}

.app-sidebar.rmc-drawer.rmc-drawer-docked {
  position: relative;
}

/*Header Styles*/
.jr-menu-icon {
  outline: none !important;
  -webkit-justify-content: flex-start !important;
  justify-content: flex-start !important;
  padding: 0 5px !important;
  margin-right: 15px;
  display: flex;
  cursor: pointer;
  align-items: center;
}

.app-main-header {
  background-color: #fff;
  color: #808080;
  max-height: 70px;
  position: relative;
}
.app-main-header .search-bar input {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  background-color: transparent;
  color: #808080;
  font-weight: 200;
}
.app-main-header .search-bar input + .search-icon {
  top: 0;
}
.app-main-header .search-bar input + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
  font-size: 32px;
}
.app-main-header .search-bar input::placeholder {
  color: grey;
}
.app-main-header .search-bar input:focus {
  background-color: #fff;
  color: #808080;
}
.app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
.jr-card .app-main-header {
  border: 1px solid #ced4da;
  border-radius: 8px;
}

.app-logo {
  margin-right: 12px;
}
.app-logo img {
  height: 35px;
}
@media screen and (max-width: 575px) {
  .app-logo img {
    height: 28px;
  }
}
.app-header .app-logo {
  margin-right: 20px;
}
@media screen and (max-width: 991px) {
  .app-header .app-logo {
    margin-right: auto;
  }
}

.react-logo-white.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .react-logo-white.d-lg-block {
    display: none !important;
  }
}
.sidebar-header {
  min-height: 70px;
  padding: 10px 22px;
}

.app-toolbar {
  min-height: 60px;
  padding: 0 17px 0 0;
}
.app-toolbar .search-bar {
  margin-right: auto;
  max-width: 320px;
  width: 300px;
}
@media screen and (max-width: 1199px) {
  .app-toolbar .search-bar {
    width: 240px;
  }
}
@media screen and (max-width: 1099px) {
  .app-toolbar .search-bar {
    width: 200px;
  }
}
@media screen and (max-width: 767px) {
  .app-toolbar .search-bar {
    margin-left: 40px;
    width: 180px;
  }
}
@media screen and (max-width: 575px) {
  .app-toolbar {
    padding: 0 17px;
  }
}
@media screen and (max-width: 1199px) {
  .app-toolbar {
    padding: 0 17px;
  }
}
.app-top-nav .app-toolbar {
  min-height: 40px;
}

@media screen and (max-width: 1199px) {
  .app-header-horizontal .app-toolbar .search-bar {
    margin-right: 10px;
  }
}

.app-toolbar-special .search-bar {
  width: 200px;
}
@media screen and (max-width: 991px) {
  .app-toolbar-special .search-bar {
    width: 280px;
  }
}
@media screen and (max-width: 767px) {
  .app-toolbar-special .search-bar {
    width: 200px;
  }
}

.app-toolbar .nav-searchbox .search-bar {
  margin-left: 0;
  width: 100%;
}
.app-toolbar .nav-searchbox .search-bar input {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  color: #5c5c5c;
}
.app-toolbar .nav-searchbox .search-bar input + .search-icon i {
  color: rgba(92, 92, 92, 0.8);
}
.app-toolbar .nav-searchbox .search-bar input:focus {
  background-color: transparent;
  color: #5c5c5c;
}
.app-toolbar .nav-searchbox .search-bar input:focus + .search-icon i {
  color: rgba(92, 92, 92, 0.8);
}

.header-notifications {
  margin-bottom: 0;
}
.header-notifications li {
  vertical-align: middle;
}
@media screen and (max-width: 449px) {
  .header-notifications .list-inline-item:not(:last-child) {
    margin-right: 0;
  }
}

.dropdown-menu {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}

.quick-menu .dropdown-menu {
  padding: 5px 10px;
  width: 350px;
}
.quick-menu .dropdown-menu .jr-card-header {
  margin: -5px -10px 5px;
  padding: 10px 10px 10px 20px;
  border-bottom: 1px solid #dee2e6;
  z-index: 10;
}
.quick-menu .dropdown-menu:after {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #fff;
  top: -9px;
  content: "";
  height: 9px;
  position: absolute;
  right: 8px;
  width: 10px;
}
.quick-menu .dropdown-menu:before {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #000;
  top: -10px;
  content: "";
  height: 10px;
  position: absolute;
  right: 8px;
  width: 10px;
}
@media screen and (max-width: 449px) {
  .quick-menu .dropdown-menu {
    width: 230px;
  }
}
@media screen and (max-width: 359px) {
  .quick-menu .dropdown-menu {
    width: 180px;
  }
}
.quick-menu .messages-list .user-avatar {
  position: relative;
}
.quick-menu .messages-list .badge {
  position: absolute;
  left: -4px;
  top: -4px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  padding: 0;
}

.app-header .nav-searchbox.quick-menu .dropdown-menu {
  width: 200px;
  left: 0 !important;
  right: auto !important;
}
.app-header .nav-searchbox.quick-menu .dropdown-menu:after {
  right: auto;
  left: 8px;
}
.app-header .nav-searchbox.quick-menu .dropdown-menu:before {
  right: auto;
  left: 8px;
}
@media screen and (max-width: 400px) {
  .app-header .nav-searchbox.quick-menu {
    display: none;
  }
}

@media screen and (max-width: 575px) {
  .app-header .nav-searchbox.quick-menu .dropdown-menu {
    width: 200px;
  }
}
@media screen and (max-width: 399px) {
  .app-header .nav-searchbox.quick-menu .dropdown-menu {
    width: 100px;
  }
}
.language-list li {
  display: block !important;
}

.messages-list.language-list ul li {
  padding: 7px 6px 6px;
}

.messages-list ul li {
  position: relative;
  padding: 20px 10px 14px;
  border-bottom: 1px solid #dee2e6;
}
.messages-list ul li .user-name a {
  color: #3f51b5;
}
.messages-list ul li .sub-heading {
  font-size: 11px;
  margin-bottom: 6px !important;
}
.messages-list ul li .sub-heading.mb-0 {
  margin-bottom: 0 !important;
}
.messages-list ul li:last-child {
  border-bottom: 0 none;
}
.messages-list ul li .jr-btn {
  margin-right: 0 !important;
}
.messages-list ul li .jr-btn-xs {
  font-size: 11px !important;
  padding: 5px !important;
}

.quick-menu .icon-btn {
  color: #808080;
}
.quick-menu .icon-alert {
  position: relative;
}
.quick-menu .icon-alert:after {
  display: block;
  position: absolute;
  content: "";
  right: 0;
  top: 0;
  z-index: 10;
  width: 8px;
  height: 8px;
  background-color: #f44336;
  border-radius: 50%;
}
.quick-menu i.animated.infinite {
  -moz-animation-iteration-count: 25;
  -webkit-animation-iteration-count: 25;
  -o-animation-iteration-count: 25;
  animation-iteration-count: 25;
}

.quick-menu .dropdown-menu {
  display: block;
  visibility: hidden;
  left: auto !important;
  right: 0 !important;
  opacity: 0;
  transform: translate3d(0px, 100px, 0px) !important;
  -webkit-transition: all 200ms linear 0ms;
  -o-transition: all 200ms linear 0ms;
  transition: all 200ms linear 0ms;
}
.quick-menu.show .dropdown-menu {
  opacity: 1;
  transform: translate3d(0px, 30px, 0px) !important;
  visibility: visible;
}

.user-nav .quick-menu .dropdown-menu {
  width: 200px;
  padding: 0 0 15px;
}
.user-nav .quick-menu .dropdown-menu:after {
  border-bottom-color: #fff;
}
.user-nav .quick-menu .user-profile {
  position: relative;
  padding: 20px 25px;
  background-color: #fff;
  margin-bottom: 15px;
  border-radius: 0.25rem 0.25rem 0 0;
}

.module-box-header-right {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}

.app-top-header {
  position: relative;
  z-index: 9999;
}

/*Navbar Styles*/
.app-main-menu .navbar-nav {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.navbar-nav {
  position: relative;
}
.navbar-nav li {
  position: relative;
}
.navbar-nav li:hover > ul.sub-menu, .navbar-nav li:focus > ul.sub-menu {
  opacity: 1;
  visibility: visible;
  top: 100%;
}
.navbar-nav li:hover > a, .navbar-nav li:focus > a {
  color: #3f51b5;
}
.navbar-nav li a {
  display: block;
  color: #868e96;
  padding: 10px 0;
  font-size: 14px;
}
.navbar-nav li a:hover, .navbar-nav li a:focus {
  text-decoration: none;
  color: #3f51b5;
}
.navbar-nav li.mega-menu {
  position: static;
}
.navbar-nav li.mega-menu ul.sub-menu {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 85%;
  margin: 0 auto;
  left: 0;
  right: 0;
}
.navbar-nav li.mega-menu ul.sub-menu li {
  width: 25%;
  padding: 0 15px;
}
.navbar-nav > li:last-child ul.sub-menu {
  left: auto;
  right: 0;
}
.navbar-nav > li:last-child ul.sub-menu ul.sub-menu {
  left: auto;
  right: 100%;
  top: 50px;
}
.navbar-nav > li:last-child ul.sub-menu li:hover > ul.sub-menu,
.navbar-nav > li:last-child ul.sub-menu li:focus > ul.sub-menu {
  top: 0;
}
.navbar-nav li.nav-item {
  padding: 0 10px;
}
.navbar-nav li.nav-item > a {
  padding: 23px 0;
}
.navbar-nav li.nav-item.active > a {
  color: #3f51b5;
}
.navbar-nav li.nav-item:hover > a, .navbar-nav li.nav-item:focus > a, .navbar-nav li.nav-item > a:hover, .navbar-nav li.nav-item > a:focus {
  color: #3f51b5;
}
.navbar-nav ul.sub-menu {
  list-style: none;
  border: solid 1px #ced4da;
  position: absolute;
  left: 0;
  top: 100px;
  opacity: 0;
  padding: 10px 0;
  background-color: #fff;
  visibility: hidden;
  border-radius: 4px;
  -webkit-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.navbar-nav ul.sub-menu li a {
  padding: 5px 15px;
  width: 200px;
  font-size: 14px;
}
.navbar-nav ul.sub-menu li a.active {
  color: #3f51b5;
}
.navbar-nav ul.sub-menu li > ul.sub-menu {
  left: 100%;
  right: auto;
  top: 50px;
}
.navbar-nav ul.sub-menu li:hover > ul.sub-menu, .navbar-nav ul.sub-menu li:focus > ul.sub-menu {
  top: 0;
}
.navbar-nav ul.sub-menu li a i {
  margin-right: 10px;
}
.navbar-nav ul.sub-menu li.active > a {
  color: #3f51b5;
}
.navbar-nav .nav-arrow > a {
  position: relative;
}
.navbar-nav .nav-arrow > a:before {
  color: #868e96;
  content: "\\f2fb";
  display: inline-block;
  float: right;
  font-family: "Material-Design-Iconic-Font";
  font-size: 15px;
  margin-left: 10px;
  position: relative;
  -webkit-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
  font-weight: normal;
}
.navbar-nav .nav-arrow a:hover:before, .navbar-nav .nav-arrow a:focus:before {
  color: #3f51b5;
}
.navbar-nav .nav-arrow:hover > a:before, .navbar-nav .nav-arrow:focus > a:before, .navbar-nav .nav-arrow.active > a:before {
  color: #3f51b5;
}
.navbar-nav ul.sub-menu-half {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 300px;
}
.navbar-nav ul.sub-menu-half li {
  width: 50%;
}
.navbar-nav ul.sub-menu-half li a {
  width: 100%;
}
@media screen and (max-width: 1099px) {
  .navbar-nav ul.sub-menu-half li a {
    font-size: 13px;
  }
}
@media screen and (max-width: 1099px) {
  .navbar-nav ul.sub-menu-half {
    width: 262px;
  }
}

.navbar-nav-mega {
  position: static !important;
}

.app-top-nav {
  background-color: #3f51b5;
}
.app-top-nav .navbar-nav li.nav-item {
  padding: 0 30px;
}
.app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
  padding: 13px 0;
}
.app-top-nav .navbar-nav li.nav-item:hover > a, .app-top-nav .navbar-nav li.nav-item:focus > a, .app-top-nav .navbar-nav li.nav-item > a:hover, .app-top-nav .navbar-nav li.nav-item > a:focus, .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #E91E63;
}
.app-top-nav .navbar-nav ul.sub-menu {
  margin-top: 0;
}

/*Main Content Styles*/
.app-main-content {
  flex: 1;
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 575px) {
  .app-main-content {
    padding: 0;
  }
}

.app-wrapper {
  padding: 36px 40px 0 40px;
  width: 100%;
}
@media screen and (max-width: 575px) {
  .app-wrapper {
    padding: 20px;
  }
}

/*Footer Styles*/
.app-footer {
  padding: 0 40px;
  border-top: solid 1px rgb(90%, 90%, 90%);
  background-color: #fff;
  color: #868e96;
  line-height: 50px;
  min-height: 50px;
}
.app-footer a {
  color: #868e96;
}
.app-footer a:hover {
  color: #3f51b5;
}
@media screen and (max-width: 575px) {
  .app-footer {
    padding: 20px;
  }
}
@media screen and (max-width: 400px) {
  .app-footer {
    font-size: 12px;
  }
}

/*Right Sidebar Styles*/
.color-theme {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: 300px;
  height: 100%;
}
@media screen and (max-width: 499px) {
  .color-theme {
    max-width: 250px;
  }
}

.color-theme-header {
  background-color: #3f51b5;
  color: #fff;
  padding: 19px 25px 20px;
  text-transform: uppercase;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.color-theme-header .color-theme-title {
  margin-bottom: 0;
}

.color-theme-body {
  padding: 28px 25px;
}
.color-theme-body h3 {
  margin-bottom: 20px;
}
@media screen and (max-width: 499px) {
  .color-theme-body {
    padding: 25px 15px;
  }
}

.color-option {
  list-style: none;
  padding-left: 0;
  margin: 0 -7px 10px;
}
.color-option li {
  position: relative;
  display: inline-block;
  padding: 0 7px;
  margin-bottom: 10px;
}
.color-option li a {
  height: 45px;
  width: 45px;
  line-height: 45px;
  display: inline-block;
  color: transparent !important;
  position: relative;
}
.color-option li a:before {
  content: "\\f26b";
  font-family: "Material-Design-Iconic-Font";
  font-size: 20px;
  height: 45px;
  width: 45px;
  line-height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  text-align: center;
  display: none;
  z-index: 2;
}
.color-option li a.active:before {
  display: block;
}

.cr-op-dark-sidebar li a:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  background-color: #5c5c5c;
  width: 8px;
}

.theme-option {
  position: fixed;
  top: 10%;
  right: 0;
  z-index: 1500;
  background-color: #0070cd;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -o-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  color: #fff;
}
.theme-option span.icon-btn {
  position: relative;
  z-index: 1505;
}

.app-sidebar-content.right-sidebar .rmc-drawer-sidebar {
  z-index: 1506;
  color: #5c5c5c;
  background-color: #fff;
}

.material-switch {
  margin-bottom: 24px;
}
.material-switch > input[type=checkbox] {
  display: none;
}
.material-switch > label {
  cursor: pointer;
  height: 0;
  position: relative;
  width: 40px;
}
.material-switch > label:before {
  background: rgb(0, 0, 0);
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  content: "";
  height: 16px;
  margin-top: -8px;
  position: absolute;
  opacity: 0.3;
  transition: all 0.4s ease-in-out;
  width: 40px;
}
.material-switch > label:after {
  background: rgb(255, 255, 255);
  border-radius: 16px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  content: "";
  height: 24px;
  left: -4px;
  margin-top: -8px;
  position: absolute;
  top: -4px;
  transition: all 0.3s ease-in-out;
  width: 24px;
}
.material-switch > input[type=checkbox]:checked + label::before {
  background: #000;
  opacity: 0.5;
}
.material-switch > input[type=checkbox]:checked + label::after {
  background: #495057;
  left: 20px;
}

@media screen and (max-width: 499px) {
  .color-theme .jr-btn {
    padding: 10px 15px !important;
  }
}
/* UI Components
   ========================================================================== */
/*Alert Styles*/
.alert {
  border: 0 none;
  padding: 20px 24px;
  border-radius: 8px;
  position: relative;
}
.alert .close {
  line-height: inherit;
  font-weight: 300;
}
.alert .alert-addon {
  width: 60px;
  background-color: rgba(0, 0, 0, 0.2);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}

.alert-dismissible {
  padding-right: 60px;
}

.alert-addon-card {
  padding-left: 80px;
}

/*Avatar Styles*/
.user-avatar {
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  position: relative;
  overflow: hidden;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  border-radius: 50%;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  border: 1px solid #ced4da;
}
.user-avatar.avatar-shadow {
  border: 0 none;
}

.user-profile {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}
.user-profile .user-detail {
  -webkit-flex: 1;
  flex: 1;
  -ms-flex-align: center;
  -webkit-align-self: center;
  align-self: center;
}

.user-detail .user-name {
  margin-bottom: 2px;
  font-weight: 400;
  text-transform: capitalize;
}
.user-detail .user-description {
  font-size: 12px;
  margin-bottom: 0;
  color: #adb5bd;
}

.user-thumb {
  position: relative;
}
.messages-list .user-thumb {
  margin-right: 8px;
}

/*Badges Styles*/
.badge {
  font-weight: 400;
  padding: 3px 8px;
  line-height: inherit;
  margin-bottom: 6px;
  border-radius: 2px;
}
.badge:not(:last-child) {
  margin-right: 15px;
}
table .badge {
  margin-bottom: 0;
}

.badge-pill {
  border-radius: 20px;
}

.badge-border {
  border: 2px solid !important;
}

.badge-outline {
  background-color: transparent;
  border: 1px solid #ced4da;
}

/*Blockquotes Styles*/
blockquote {
  padding: 10px 0 10px 20px;
  font-size: 13px !important;
}
blockquote .blockquote-footer {
  font-size: 13px !important;
}

.blockquote {
  border-left: 5px solid #e9ecef;
}

.blockquote-reverse {
  border-left: 0 none;
  border-right: 5px solid #e9ecef;
  text-align: right;
  padding-left: 0;
  padding-right: 20px;
}

/*Bottom Navigation Styles*/
.bottom-navigation button {
  min-width: 10px !important;
}

/*Breadcrumb Styles*/
.breadcrumb {
  border-radius: 2px;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: "\\f2fb";
  font-family: "Material-Design-Iconic-Font";
  font-size: 16px;
  line-height: 1;
  vertical-align: middle;
}

/*Button Styles*/
button {
  outline: 0 none !important;
  cursor: pointer;
  border: 1px solid transparent;
}

.jr-btn {
  position: relative;
  display: inline-block;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.2;
  border-radius: 4px;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
}
.jr-btn:hover, .jr-btn:focus, .jr-btn:active {
  outline: 0 none;
  text-decoration: none;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}
.login-content .jr-btn {
  padding: 10px 35px;
}

.btn:hover, .btn:focus, .btn:active {
  outline: 0 none;
  text-decoration: none;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}
.login-content .btn {
  padding: 10px 35px;
}

.btn,
.btn-info,
.btn-success,
.btn-warning,
.btn-danger,
.btn-light,
.btn-dark,
.btn-primary,
.btn-secondary {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

.show > .btn.dropdown-toggle:focus,
.show > .btn-info.dropdown-toggle:focus,
.show > .btn-success.dropdown-toggle:focus,
.show > .btn-warning.dropdown-toggle:focus,
.show > .btn-danger.dropdown-toggle:focus,
.show > .btn-light.dropdown-toggle:focus,
.show > .btn-dark.dropdown-toggle:focus,
.show > .btn-primary.dropdown-toggle:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

.jr-btn,
.jr-fab-btn,
.jr-flat-btn,
.btn {
  margin-bottom: 6px;
}
.jr-btn:not(:last-child),
.jr-fab-btn:not(:last-child),
.jr-flat-btn:not(:last-child),
.btn:not(:last-child) {
  margin-right: 15px;
}
.form-inline .jr-btn,
.form-inline .jr-fab-btn,
.form-inline .jr-flat-btn,
.form-inline .btn {
  margin-bottom: 0;
  min-height: 35px;
}
.navbar .jr-btn,
.navbar .jr-fab-btn,
.navbar .jr-flat-btn,
.navbar .btn {
  margin-bottom: 0;
}

.btn-primary:focus, .btn-primary.focus {
  box-shadow: none !important;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-append > .btn {
  margin-right: 0;
  margin-bottom: 0;
  line-height: inherit;
}

.jr-fab-btn {
  position: relative;
  display: inline-flex;
  border-radius: 50%;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  background-color: #eeeeee;
  overflow: hidden;
}
.jr-fab-btn:hover, .jr-fab-btn:focus {
  outline: 0 none;
  text-decoration: none;
}

.jr-btn,
.jr-flat-btn {
  padding: 12px 20px;
}
.jr-btn i + span, .jr-btn span + i,
.jr-flat-btn i + span,
.jr-flat-btn span + i {
  margin-left: 6px;
}

.jr-flat-btn {
  background-color: transparent;
  color: #5c5c5c;
}
.jr-flat-btn:hover, .jr-flat-btn:focus, .jr-flat-btn:active {
  background-color: #f5f5f5;
  color: #5c5c5c;
}

.jr-btn-group {
  margin: 0 -8px;
}
.jr-btn-group:not(:last-child) {
  margin-bottom: 16px;
}
.jr-btn-group .jr-btn, .jr-btn-group .jr-fab-btn {
  margin: 0 8px 18px;
}

.jr-btn-rounded {
  border-radius: 50px !important;
}

.jr-btn-lg, .btn-group-lg > .jr-btn {
  padding: 16px 24px;
}

.jr-btn-sm, .btn-group-sm > .jr-btn {
  padding: 8px 15px;
}

.jr-btn-xs {
  padding: 6px 10px;
}

.jr-btn-fab-lg,
.jr-btn-lg,
.btn-group-lg > .jr-btn {
  font-size: 1.25rem;
}
.jr-btn-fab-lg i,
.jr-btn-lg i,
.btn-group-lg > .jr-btn i {
  font-size: calc(1.25rem + 2px);
}

.jr-btn-fab-sm,
.jr-btn-sm,
.btn-group-sm > .jr-btn {
  font-size: calc(0.875rem - 2px);
}
.jr-btn-fab-sm i,
.jr-btn-sm i,
.btn-group-sm > .jr-btn i {
  font-size: calc(0.875rem - 2px);
}

.jr-btn-fab-xs,
.jr-btn-xs {
  font-size: 10px;
}
.jr-btn-fab-xs i,
.jr-btn-xs i {
  font-size: 10px;
}

.complex-btn-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-width: 200px;
  width: 100%;
}

.complex-btn {
  position: relative;
  height: 200px;
  overflow: hidden;
  width: 33.333%;
  border: 0 none;
}
@media screen and (max-width: 767px) {
  .complex-btn {
    width: 100%;
    height: 100px;
  }
}
.complex-btn:hover {
  z-index: 1;
}
.complex-btn:hover .img-btn-overlay {
  opacity: 0.15;
}
.complex-btn:hover .img-marked {
  opacity: 0;
}
.complex-btn:hover .img-title {
  border: 4px solid currentColor;
}
.complex-btn .img-btn {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  color: #fff;
}
.complex-btn .img-src {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-size: cover;
  background-position: center 40%;
}
.complex-btn .img-btn-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #000;
  opacity: 0.4;
  -webkit-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.complex-btn .img-title {
  position: relative;
  padding: 16px 32px 14px;
}
.complex-btn .img-marked {
  height: 3px;
  width: 18px;
  background: #fff;
  position: absolute;
  bottom: -2px;
  left: calc(50% - 9px);
  -webkit-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-group-mins {
  margin: 0 -5px;
}
.btn-group-mins .btn, .btn-group-mins .jr-btn {
  margin: 0 5px 5px;
}

.jr-btn.jr-btn-label i {
  background-color: rgba(255, 255, 255, 0.2);
  width: 40px;
  height: 100%;
  line-height: 42px;
  text-align: center;
}

.jr-btn.jr-btn-label.left i {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
}

.jr-btn.jr-btn-label.right i {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.jr-btn.jr-btn-label.left i + span {
  margin-left: 30px;
}

.jr-btn.jr-btn-label.right i + span {
  margin-right: 30px;
  margin-left: 0;
}

.jr-btn.jr-btn-label.jr-btn-lg i, .btn-group-lg > .jr-btn.jr-btn-label i {
  line-height: 54px;
}

.jr-btn.jr-btn-label.jr-btn-sm i, .btn-group-sm > .jr-btn.jr-btn-label i {
  line-height: 32px;
}

.jr-btn.jr-btn-label.jr-btn-xs i {
  line-height: 24px;
  width: 30px;
}

.btn-primary {
  background-color: #3f51b5;
  color: #fff;
}
.btn-primary:hover, .btn-primary:focus {
  background-color: rgb(22.1239151398%, 28.4450337512%, 63.56235937%);
  color: #fff;
}

.btn-red {
  background-color: #F44336;
  color: #fff;
}
.btn-red:hover, .btn-red:focus {
  background-color: rgb(95.1674065853%, 17.4065852756%, 11.6953385128%);
  color: #fff;
}

.btn-pink {
  background-color: #e91e63;
  color: #fff;
}
.btn-pink:hover, .btn-pink:focus {
  background-color: rgb(84.8416289593%, 8.2956259427%, 34.3137254902%);
  color: #fff;
}

.btn-purple {
  background-color: #9C27B0;
  color: #fff;
}
.btn-purple:hover, .btn-purple:focus {
  background-color: rgb(53.9206566347%, 13.4801641587%, 60.8335613315%);
  color: #fff;
}

.btn-deep-purple {
  background-color: #673ab7;
  color: #fff;
}
.btn-deep-purple:hover, .btn-deep-purple:focus {
  background-color: rgb(36.1182979416%, 20.3384590351%, 64.1713448865%);
  color: #fff;
}

.btn-indigo {
  background-color: #3f51b5;
  color: #fff;
}
.btn-indigo:hover, .btn-indigo:focus {
  background-color: rgb(22.1239151398%, 28.4450337512%, 63.56235937%);
  color: #fff;
}

.btn-blue {
  background-color: #2196F3;
  color: #fff;
}
.btn-blue:hover, .btn-blue:focus {
  background-color: rgb(5.0377073906%, 54.1553544495%, 93.197586727%);
  color: #fff;
}

.btn-light-blue {
  background-color: #03a9f4;
  color: #fff;
}
.btn-light-blue:hover, .btn-light-blue:focus {
  background-color: rgb(1.0550130984%, 59.4324045408%, 85.8077319997%);
  color: #fff;
}

.btn-cyan {
  background-color: #00bcd4;
  color: #fff;
}
.btn-cyan:hover, .btn-cyan:focus {
  background-color: rgb(0%, 64.8575656678%, 73.137254902%);
  color: #fff;
}

.btn-teal {
  background-color: #009688;
  color: #fff;
}
.btn-teal:hover, .btn-teal:focus {
  background-color: rgb(0%, 48.8235294118%, 44.2666666667%);
  color: #fff;
}

.btn-green {
  background-color: #4CAF50;
  color: #fff;
}
.btn-green:hover, .btn-green:focus {
  background-color: rgb(26.7760331224%, 61.6553394266%, 28.1852980236%);
  color: #fff;
}

.btn-light-green {
  background-color: #8bc34a;
  color: #fff;
}
.btn-light-green:hover, .btn-light-green:focus {
  background-color: rgb(49.5281099992%, 71.7167032788%, 23.7734927996%);
  color: #fff;
}

.btn-lime {
  background-color: #cddc39;
  color: #fff;
}
.btn-lime:hover, .btn-lime:focus {
  background-color: rgb(77.4627619288%, 83.8121686443%, 14.8152823361%);
  color: #fff;
}

.btn-yellow {
  background-color: #ffeb3b;
  color: #fff;
}
.btn-yellow:hover, .btn-yellow:focus {
  background-color: rgb(100%, 91.1364545818%, 13.137254902%);
  color: #fff;
}

.btn-amber {
  background-color: #ffc107;
  color: #fff;
}
.btn-amber:hover, .btn-amber:focus {
  background-color: rgb(92.7450980392%, 69.5588235294%, 0%);
  color: #fff;
}

.btn-orange {
  background-color: #ff9800;
  color: #fff;
}
.btn-orange:hover, .btn-orange:focus {
  background-color: rgb(90%, 53.6470588235%, 0%);
  color: #fff;
}

.btn-deep-orange {
  background-color: #ff5722;
  color: #fff;
}
.btn-deep-orange:hover, .btn-deep-orange:focus {
  background-color: rgb(100%, 26.5158371041%, 3.3333333333%);
  color: #fff;
}

.btn-brown {
  background-color: #795548;
  color: #fff;
}
.btn-brown:hover, .btn-brown:focus {
  background-color: rgb(41.1815503403%, 28.9291882556%, 24.5047241695%);
  color: #fff;
}

.btn-blue-grey {
  background-color: #607d8b;
  color: #fff;
}
.btn-blue-grey:hover, .btn-blue-grey:focus {
  background-color: rgb(33.5619524406%, 43.700458907%, 48.5949103045%);
  color: #fff;
}

.btn-grey {
  background-color: #9e9e9e;
  color: #fff;
}
.btn-grey:hover, .btn-grey:focus {
  background-color: rgb(56.9607843137%, 56.9607843137%, 56.9607843137%);
  color: #fff;
}

.jr-btn-shadow {
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -moz-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -o-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
}
.jr-btn-shadow:hover, .jr-btn-shadow:focus {
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -moz-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -o-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
}
.jr-btn-shadow:active {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

.jr-btn.disabled,
.jr-btn.disabled {
  pointer-events: none;
  opacity: 0.65;
}

.jr-btn-default {
  background-color: #fff;
  color: #5c5c5c;
  border: 1px solid #dee2e6;
}
.jr-btn-default:hover, .jr-btn-default:focus {
  background-color: rgb(95%, 95%, 95%);
  color: #5c5c5c;
}

.jr-btn-secondary {
  background-color: #E91E63;
  color: #fff;
}
.jr-btn-secondary:hover, .jr-btn-secondary:focus {
  background-color: rgb(84.8416289593%, 8.2956259427%, 34.3137254902%);
  color: #fff;
}

.jr-flat-btn.jr-btn-primary {
  background-color: transparent;
  color: #3f51b5;
}
.jr-flat-btn.jr-btn-primary:hover, .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(63, 81, 181, 0.12);
  color: #3f51b5;
}

.bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent;
  color: #fff;
}
.bg-primary .jr-flat-btn.jr-btn-primary:hover, .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.jr-flat-btn.jr-btn-secondary {
  background-color: transparent;
  color: #E91E63;
}
.jr-flat-btn.jr-btn-secondary:hover, .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(233, 30, 99, 0.12);
  color: #E91E63;
}

.bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent;
  color: #fff;
}
.bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.jr-btn-hover:hover:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.06);
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.action-btn {
  height: 40px;
  width: 40px;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  vertical-align: middle;
  color: rgba(0, 0, 0, 0.54);
}
.action-btn:hover, .action-btn:focus, .action-btn:active {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.64);
}
.circle-check .action-btn {
  height: 24px;
  width: 24px;
  font-size: 16px;
}
.chat-main-header .action-btn {
  color: #fff;
}

.action-replay .jr-btn-default {
  font-size: 14px;
  padding: 5px 10px;
  border-color: #6c757d !important;
}

.btn-outline-primary:focus,
.btn-outline-secondary:focus {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

/*Button Group Styles*/
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .jr-btn,
.btn-group-vertical > .jr-btn {
  position: relative;
  flex: 0 1 auto;
  border-color: #dee2e6;
}
.btn-group > .jr-btn:hover,
.btn-group-vertical > .jr-btn:hover {
  z-index: 2;
}
.btn-group > .jr-btn:focus, .btn-group > .jr-btn:active, .btn-group > .jr-btn.active,
.btn-group-vertical > .jr-btn:focus,
.btn-group-vertical > .jr-btn:active,
.btn-group-vertical > .jr-btn.active {
  z-index: 2;
}
.btn-group > .jr-btn.active,
.btn-group-vertical > .jr-btn.active {
  background-color: #3f51b5;
  color: #fff;
  border-color: #3f51b5;
}
.btn-group > .jr-btn.jr-flat-btn,
.btn-group-vertical > .jr-btn.jr-flat-btn {
  border-color: transparent;
}
.btn-group > .jr-btn.jr-flat-btn.active,
.btn-group-vertical > .jr-btn.jr-flat-btn.active {
  background-color: transparent;
  color: #3f51b5;
}
.btn-group > .jr-btn.jr-flat-btn.active:hover, .btn-group > .jr-btn.jr-flat-btn.active:focus,
.btn-group-vertical > .jr-btn.jr-flat-btn.active:hover,
.btn-group-vertical > .jr-btn.jr-flat-btn.active:focus {
  background-color: rgba(63, 81, 181, 0.12);
  color: #3f51b5;
}
.btn-group .jr-btn + .jr-btn,
.btn-group .jr-btn + .btn-group,
.btn-group .btn-group + .jr-btn,
.btn-group .btn-group + .btn-group,
.btn-group-vertical .jr-btn + .jr-btn,
.btn-group-vertical .jr-btn + .btn-group,
.btn-group-vertical .btn-group + .jr-btn,
.btn-group-vertical .btn-group + .btn-group {
  margin-left: -1px;
}

.btn-group.no-border > .btn-group > .jr-btn, .btn-group.no-border > .btn-group-vertical > .jr-btn, .btn-group.no-border > .jr-btn,
.btn-group-vertical.no-border > .btn-group > .jr-btn,
.btn-group-vertical.no-border > .btn-group-vertical > .jr-btn,
.btn-group-vertical.no-border > .jr-btn {
  border-color: transparent;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .jr-btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0;
}

.btn-group > .jr-btn:first-child {
  margin-left: 0;
}
.btn-group > .jr-btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .jr-btn:last-child:not(:first-child),
.btn-group > .dropdown-toggle:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group > .btn-group {
  float: left;
}

.btn-group > .btn-group:not(:first-child):not(:last-child) > .jr-btn {
  border-radius: 0;
}

.btn-group > .btn-group:first-child:not(:last-child) > .jr-btn:last-child,
.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.jr-btn + .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.jr-btn + .dropdown-toggle-split::after {
  margin-left: 0;
}

.jr-btn-sm + .dropdown-toggle-split, .btn-group-sm > .jr-btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.jr-btn-lg + .dropdown-toggle-split, .btn-group-lg > .jr-btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group.show .dropdown-toggle {
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  -o-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn-group.show .dropdown-toggle.btn-link {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical .jr-btn,
.btn-group-vertical .btn-group {
  width: 100%;
}
.btn-group-vertical > .jr-btn + .jr-btn,
.btn-group-vertical > .jr-btn + .btn-group,
.btn-group-vertical > .btn-group + .jr-btn,
.btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-left: 0;
}
.btn-group-vertical > .jr-btn:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.btn-group-vertical > .jr-btn:first-child:not(:last-child) {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .jr-btn:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .jr-btn {
  border-radius: 0;
}
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .jr-btn:last-child,
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

[data-toggle=buttons] > .jr-btn input[type=radio],
[data-toggle=buttons] > .jr-btn input[type=checkbox],
[data-toggle=buttons] > .btn-group > .jr-btn input[type=radio],
[data-toggle=buttons] > .btn-group > .jr-btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

.btn-group > .jr-btn,
.btn-group > .btn,
.btn-group-vertical > .jr-btn,
.btn-group-vertical > .btn {
  margin-right: 0;
  margin-bottom: 0;
}

/*Callout Styles*/
.card-image .grid-thumb-equal {
  padding-bottom: 82%;
}

/*Product listing page style*/
.product-row {
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  text-align: right;
}
.product-row.even {
  text-align: left;
}

.product-col {
  order: 1;
  width: 50%;
}

.odd .product-thumb {
  order: 2;
}

.product-content {
  padding: 20px 55px;
}

.product-row .grid-thumb-equal {
  padding-bottom: 69%;
}

.product-thumb img {
  width: 100%;
}

.product-content h4 {
  margin-bottom: 25px;
}

@media screen and (max-width: 1230px) {
  .product-row .grid-thumb-equal {
    padding-bottom: 71%;
  }
}
@media screen and (max-width: 1199px) {
  .product-content h4 {
    margin-bottom: 10px;
  }
  .product-content {
    padding: 20px 35px;
  }
  .product-row .grid-thumb-equal {
    padding-bottom: 85%;
  }
}
@media screen and (max-width: 991px) {
  .card-image .grid-thumb-equal {
    padding-bottom: 120%;
  }
}
@media screen and (max-width: 767px) {
  .product-row {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center;
  }
  .product-row.even {
    text-align: center;
  }
  .product-content {
    padding: 20px 0;
  }
  .product-col,
  .odd .product-thumb {
    order: 1;
    width: 100%;
  }
  .product-row .grid-thumb-equal {
    padding-bottom: 44%;
  }
  .card-image .grid-thumb-equal {
    padding-bottom: 44%;
  }
}
/*Cards Styles*/
.profile-intro {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.profile-intro img.avatar-circle {
  display: inline-block;
  border-radius: 50%;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  position: relative;
  margin: 0 auto;
  -webkit-transform: translateY(50px);
  -ms-transform: translateY(50px);
  transform: translateY(50px);
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  z-index: 1;
}
.profile-intro:hover .avatar-circle {
  -webkit-transition: border-radius 0.4s ease 0.1s;
  -o-transition: border-radius 0.4s ease 0.1s;
  transition: border-radius 0.4s ease 0.1s;
  border-radius: 25%;
}

.profile-intro .card-image {
  position: relative;
  width: 100%;
  min-height: 100%;
  background-image: url("http://via.placeholder.com/1920x1072");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.profile-intro .pi-content {
  padding: 70px 40px 24px;
}
.profile-intro .pi-footer {
  padding: 0 40px 24px;
}
.profile-intro .icon {
  display: inline-block;
  -webkit-transition: all 0.2s ease 0s;
  -o-transition: all 0.2s ease 0s;
  transition: all 0.2s ease 0s;
  color: #3f51b5;
}
.profile-intro .icon:hover, .profile-intro .icon:focus, .profile-intro .icon:active {
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
}
.profile-intro .icon:not(:last-child) {
  margin-right: 10px;
}

.layer:before {
  display: block;
  content: "";
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
}

.card.jr-card-full-height,
.jr-card.jr-card-full-height {
  height: calc(100% - 34px);
}
@media screen and (max-width: 575px) {
  .card.jr-card-full-height,
  .jr-card.jr-card-full-height {
    height: auto;
  }
}

.jr-card > .jr-card-body:first-child {
  margin-top: 6px;
}
.jr-card.p-0 > .jr-card-body:first-child {
  margin-top: 0;
}
.jr-card .jr-card-thumb {
  margin: -24px -30px 0;
}
.jr-card .jr-card-thumb .card-img {
  border-radius: 8px 8px 0 0;
}
@media screen and (max-width: 575px) {
  .jr-card {
    margin-bottom: 18px;
  }
}

.jr-card-header {
  margin-bottom: 24px;
}
.jr-card-header .card-heading {
  margin-bottom: 4px;
}
.jr-card-header .badge {
  margin-bottom: 0;
}
.jr-card-header .badge:last-child {
  margin-left: 10px;
}
@media screen and (max-width: 575px) {
  .jr-card-header {
    margin-bottom: 18px;
  }
}

.jr-entry-header {
  margin-bottom: 24px;
}
.jr-entry-header .entry-heading {
  margin-bottom: 4px;
}
.jr-entry-header .entry-description {
  margin-bottom: 0;
  font-size: 13px;
  color: #6c757d;
}
@media screen and (max-width: 575px) {
  .jr-entry-header {
    margin-bottom: 18px;
  }
}

.card {
  margin-bottom: 34px;
}
@media screen and (max-width: 575px) {
  .card {
    margin-bottom: 18px;
  }
}

.card-header {
  font-size: 16px;
}
.card-header .badge {
  margin-bottom: 0;
}
.card-header .badge:last-child {
  margin-left: 10px;
}

.card-title {
  font-size: 16px;
  text-transform: capitalize;
}

.card-subtitle {
  font-size: 14px;
  color: #495057;
}
.card-subtitle:not(:last-child) {
  margin-bottom: 16px;
}

.card-mt-footer {
  padding: 0 15px 20px;
  margin-top: -10px;
}

.jr-card-social {
  font-size: 22px;
  padding-top: 26px;
}

.social-link {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin: 0 -5px 10px;
}
.social-link li {
  padding: 0 5px;
  margin-bottom: 5px;
}
.social-link li a {
  color: #5c5c5c;
}
.social-link li.active a, .social-link li a:hover, .social-link li a:focus {
  color: #E91E63;
}
.jr-card-social .social-link {
  margin-bottom: 0;
  -webkit-justify-content: space-around;
  justify-content: space-around;
}

.jr-cart-ab {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  color: #fff;
  font-size: 16px;
}
.jr-cart-ab i {
  vertical-align: middle;
  font-size: 25px;
}

.img-overlay-card {
  border-radius: 8px;
  margin-bottom: 34px;
}
@media screen and (max-width: 1199px) {
  .img-overlay-card .center-crop-img {
    min-height: 135px;
  }
}
@media screen and (max-width: 767px) {
  .img-overlay-card .center-crop-img {
    min-height: 160px;
  }
}
@media screen and (max-width: 575px) {
  .img-overlay-card {
    margin-bottom: 18px;
  }
}

/*Charts Styles*/
.chart-header {
  padding: 15px 18px;
}
.chart-header .card-title h4 {
  color: #fff;
  margin-bottom: 4px;
}
.chart-header .title h4 {
  margin-bottom: 4px;
}
.chart-header p {
  margin-bottom: 4px;
}

/*Chips Styles*/
.chip-outline {
  background-color: transparent !important;
  border: 1px solid #adb5bd !important;
}

/*Carousel Styles*/
.carousel-caption h3 {
  font-size: 18px;
}

/*Color Picker Styles*/
.cp-color {
  width: 36px;
  height: 14px;
  border-radius: 2px;
}

.cp-swatch {
  padding: 5px;
  background: #fff;
  border-radius: 1px;
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  display: inline-block;
  cursor: pointer;
}

.cp-popover {
  position: absolute;
  z-index: 2;
}

.cp-cover {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.photoshop-picker,
.swatches-picker,
.alpha-picker,
.hue-picker {
  width: 100% !important;
}

.material-picker {
  width: 100% !important;
  height: 100% !important;
}

.rc-time-picker-input {
  height: 31px !important;
}

.date-btn {
  display: inline-block;
  vertical-align: top;
}

.dateInputCreateUser .DateInput,
.dateInputCreateUser .SingleDatePickerInput {
  background: transparent !important;
}

.dateInputCreateUser .DateInput_input {
  font-size: 15px !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  border: none !important;
  padding: 10px 0 5px 0px !important;
  font-weight: 400 !important;
  display: block !important;
  width: 100% !important;
  height: calc(2.25rem + 2px) !important;
  outline: none !important;
  background-color: transparent !important;
  transition: 0.2s all ease-in-out;
}

.dateInputCreateUserDark .DateInput_input {
  color: white !important;
}

.dateInputCreateUserWarn .DateInput_input {
  color: red !important;
}

.dateInputCreateUserWarn .DateInput_input::placeholder {
  color: red !important;
}

.dateInputCreateUser .DateInput_input::placeholder {
  font-size: 15px !important;
  transition: 0.2s all ease-in-out;
}

.dateInputCreateUser .DateInput,
.dateInputCreateUser .SingleDatePickerInput {
  background: transparent !important;
}

.dateInputEditUser .DateInput_input {
  font-size: 12px !important;
  font-family: "roboto";
  box-shadow: none !important;
  border-radius: 0 !important;
  border: none !important;
  padding: 5px 0px !important;
  font-weight: 400 !important;
  display: block !important;
  width: 100% !important;
  height: 28px !important;
  outline: none !important;
  background-color: transparent !important;
  background: transparent !important;
  transition: 0.2s all ease-in-out;
}

.dateInputEditUserDark .DateInput_input {
  color: white !important;
  background-color: #1c2938 !important;
  background: #1c2938 !important;
}

.dateInputEditUserDark1 .DateInput_input {
  color: #d5d5d5 !important;
  background-color: #1C1C1C !important;
  background: #1C1C1C !important;
}

.dateInputEditUserDark2 .DateInput_input {
  color: #ebebed !important;
  background-color: #333333 !important;
  background: #333333 !important;
}

.dateInputEditUserDark3 .DateInput_input {
  color: #e7e7e7 !important;
  background-color: #262335 !important;
  background: #262335 !important;
}

.dateInputEditUserLight1 .DateInput_input {
  color: #949494 !important;
  background-color: #ffffff !important;
  background: #ffffff !important;
}

.dateInputEditUserLight2 .DateInput_input {
  color: #333333 !important;
  background-color: #fafafa !important;
  background: #fafafa !important;
}

.dateInputEditUserContrast .DateInput_input {
  color: #000000 !important;
  background-color: transparent !important;
  background: transparent !important;
}

.dateInputEditUser .DateInput_input::placeholder {
  font-size: 12px !important;
  transition: 0.2s all ease-in-out;
}

/*Drawer Styles*/
.drawer {
  width: 250px;
}

.full-drawer {
  width: 100%;
}

/*E-commerce Styles*/
.product-item, .product-item-vertical {
  overflow: hidden;
}

.product-item-vertical .card-image .grid-thumb-equal {
  padding-bottom: 110%;
}
@media screen and (max-width: 1199px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 74%;
  }
}
@media screen and (max-width: 991px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 110%;
  }
}
@media screen and (max-width: 829px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 120%;
  }
}
@media screen and (max-width: 767px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 44%;
  }
}

/*Grids List Styles*/
.gl-image,
.gl-list,
.gl-advanced,
.gl-single-line {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  overflow: hidden;
}

.gl {
  max-width: 100%;
  max-height: 360px;
  transform: translateZ(0);
}
.gl.row.no-gutters {
  margin: 0 -2px;
}
.gl.row.no-gutters .col, .gl.row.no-gutters > [class*=col-] {
  padding-right: 2px;
  padding-left: 2px;
  margin-bottom: 4px;
}

.gl-single-line .slg {
  -ms-flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: 100%;
}

.title-gradient {
  background: -webkit-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
}

.title-gradient-bottom {
  background: -webkit-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: -o-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
}

.g-title {
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}

.grid {
  height: 100%;
  display: block;
  position: relative;
  overflow: hidden;
}
.grid > img {
  top: 50%;
  left: 50%;
  position: relative;
  transform: translate(-50%, -50%);
  display: flex;
  padding: 0;
  flex-wrap: wrap;
}

.g-ul {
  display: flex;
  padding: 0;
  flex-wrap: wrap;
  overflow-y: auto;
  list-style: none;
  -webkit-overflow-scrolling: touch;
}

.gradient-text {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 20px;
  color: white;
}

.title-gradient-bottom {
  padding: 20px;
  bottom: 0;
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  background: -webkit-linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
  background: -o-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent 100%) !important;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
}

.title-gradient-top {
  padding: 10px;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent 100%) !important;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
}

.grid-thumb img {
  max-height: 185px;
}

.gl-advanced-grid {
  position: relative;
}

/*Icons Styles*/
.icon {
  display: inline-block;
  text-align: center;
}

.icons-wrapper {
  display: inline-block;
}
.icons-wrapper + .icons-wrapper {
  margin-left: 25px;
}

/*Label Styles*/
label {
  margin-bottom: 0;
}

/*List Styles*/
.pinned-list {
  position: relative;
  height: 370px;
  overflow: auto;
  width: auto;
}

.user-list {
  width: 100%;
  padding: 20px 15px 10px;
}
.user-list.card {
  padding-left: 30px;
}
@media screen and (max-width: 575px) {
  .user-list.card {
    padding-left: 15px;
  }
}
.user-list .user-avatar {
  margin-right: 20px;
  margin-bottom: 10px;
}
.user-list h3 {
  font-weight: 700;
  margin-bottom: 8px;
}
.user-list a[class*=meta-] i {
  margin-right: 6px;
}
.user-list a[class*=meta-]:hover {
  text-decoration: none;
}
.user-list a[class*=meta-] {
  display: inline-block;
  color: #5c5c5c;
  font-size: 13px;
  font-weight: 700;
}

.user-list .img-section {
  width: 230px;
}
@media screen and (max-width: 649px) {
  .user-list .img-section {
    width: 100%;
  }
}
.user-list .description {
  width: calc(100% - 300px);
}
@media screen and (max-width: 649px) {
  .user-list .description {
    width: 100%;
  }
}
.user-list .jr-btn-list li:not(:last-child) {
  margin-right: 10px;
}
.user-list .jr-btn-list .btn-light {
  background-color: rgb(82.8431372549%, 82.8431372549%, 82.8431372549%);
  border-color: rgb(82.8431372549%, 82.8431372549%, 82.8431372549%);
  color: #5c5c5c;
  font-weight: 600;
}
.user-list .jr-btn-list .btn-light:hover, .user-list .jr-btn-list .btn-light:focus, .user-list .jr-btn-list .btn-light:active {
  background-color: rgb(77.8431372549%, 77.8431372549%, 77.8431372549%);
  border-color: rgb(77.8431372549%, 77.8431372549%, 77.8431372549%);
}
.user-list .jr-btn-list.badge-list li:not(:last-child) {
  margin-right: 0;
}

.list-inline {
  margin-left: -5px;
  margin-right: -5px;
}
.list-inline li {
  padding: 0 5px;
  display: inline-block;
}
.list-inline li.media {
  display: flex;
}

.card-strip {
  border-bottom: solid 1px #dee2e6;
  margin-bottom: 10px;
}

.jr-mbtn-list {
  margin-left: -20px;
}

.img-res {
  max-width: 100%;
  height: auto;
}

.nav-link {
  cursor: pointer;
  padding: 0.5rem;
}

.card-header.bg-primary .nav-link {
  color: #fff;
}
.card-header.bg-primary .nav-link.active, .card-header.bg-primary .nav-link:hover, .card-header.bg-primary .nav-link:focus {
  color: #000;
  background-color: #fff;
}
.card-header.bg-primary .nav-link.disabled {
  color: #f8f9fa;
}
.card-header.bg-primary .nav-link.disabled:hover {
  color: #212529;
}

/*Pricing Styles*/
.pt-classic .package,
.pt-default .package,
.pt-dark .package,
.pt-circle .package {
  position: relative;
  padding: 0;
  overflow: hidden;
  border-radius: 10px;
  -webkit-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.pt-classic .package:hover, .pt-classic .package:focus, .pt-classic .package:active,
.pt-default .package:hover,
.pt-default .package:focus,
.pt-default .package:active,
.pt-dark .package:hover,
.pt-dark .package:focus,
.pt-dark .package:active,
.pt-circle .package:hover,
.pt-circle .package:focus,
.pt-circle .package:active {
  -webkit-transform: scale(1.05);
  -ms-transform: scale(1.05);
  transform: scale(1.05);
}
.pt-classic .package.highlight,
.pt-default .package.highlight,
.pt-dark .package.highlight,
.pt-circle .package.highlight {
  -webkit-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
  transform: scale(1.05);
  z-index: 2;
}
.pt-classic .package-header,
.pt-default .package-header,
.pt-dark .package-header,
.pt-circle .package-header {
  padding: 35px;
  text-align: center;
}
.pt-classic .package-header > .price,
.pt-default .package-header > .price,
.pt-dark .package-header > .price,
.pt-circle .package-header > .price {
  display: inline-block;
  font-size: 36px;
  font-weight: 700;
  margin-left: 0;
  margin-bottom: 12px;
}
.pt-classic .package-header > .price > i,
.pt-default .package-header > .price > i,
.pt-dark .package-header > .price > i,
.pt-circle .package-header > .price > i {
  display: inline-block;
  margin-right: 6px;
  font-weight: bold;
}
.pt-classic .package-header h5,
.pt-default .package-header h5,
.pt-dark .package-header h5,
.pt-circle .package-header h5 {
  color: inherit;
}
.pt-classic .package-items,
.pt-default .package-items,
.pt-dark .package-items,
.pt-circle .package-items {
  list-style: none;
  font-size: 14px;
  margin: 0;
  padding: 50px 50px 120px;
}
.pt-classic .package-items li,
.pt-default .package-items li,
.pt-dark .package-items li,
.pt-circle .package-items li {
  margin-bottom: 16px;
}
.pt-classic .package-items li:before, .pt-classic .package-items li:after,
.pt-default .package-items li:before,
.pt-default .package-items li:after,
.pt-dark .package-items li:before,
.pt-dark .package-items li:after,
.pt-circle .package-items li:before,
.pt-circle .package-items li:after {
  content: " ";
  display: table;
}
.pt-classic .package-items li:after,
.pt-default .package-items li:after,
.pt-dark .package-items li:after,
.pt-circle .package-items li:after {
  clear: both;
}
.pt-classic .package-items li,
.pt-default .package-items li,
.pt-dark .package-items li,
.pt-circle .package-items li {
  line-height: inherit;
}
.pt-classic .package-items li i,
.pt-default .package-items li i,
.pt-dark .package-items li i,
.pt-circle .package-items li i {
  float: left;
  min-width: 20px;
  margin-right: 16px;
  line-height: inherit;
}
.pt-classic .package-items li span,
.pt-default .package-items li span,
.pt-dark .package-items li span,
.pt-circle .package-items li span {
  display: block;
  overflow: hidden;
}
.pt-classic .package-footer,
.pt-default .package-footer,
.pt-dark .package-footer,
.pt-circle .package-footer {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  padding: 40px 50px;
  text-align: center;
}
.pt-classic .package-footer .btn,
.pt-default .package-footer .btn,
.pt-dark .package-footer .btn,
.pt-circle .package-footer .btn {
  color: inherit;
  padding: 10px 30px;
  border: 0 none;
}

.pt-classic .package {
  border: 0 none;
  border-radius: 0;
}

.pt-dark .package:hover {
  border-radius: 20px;
}

.pt-circle .package-header {
  border-radius: 50%;
  height: 224px;
  width: 224px;
  margin: 40px auto 0;
  -webkit-align-items: center;
  align-items: center;
}
.pt-circle .package-header .price {
  margin-top: 30px;
}

@media only screen and (max-width: 991px) {
  .pt-classic .package-header,
  .pt-default .package-header,
  .pt-dark .package-header,
  .pt-circle .package-header {
    padding: 30px 20px;
  }
  .pt-classic .package-items,
  .pt-default .package-items,
  .pt-dark .package-items,
  .pt-circle .package-items {
    padding: 30px 20px 120px;
  }
  .pt-circle .package-header {
    height: 204px;
    width: 204px;
  }
}
@media only screen and (max-width: 767px) {
  .pt-classic .package:hover, .pt-classic .package:focus, .pt-classic .package:active, .pt-classic .package.highlight,
  .pt-default .package:hover,
  .pt-default .package:focus,
  .pt-default .package:active,
  .pt-default .package.highlight,
  .pt-dark .package:hover,
  .pt-dark .package:focus,
  .pt-dark .package:active,
  .pt-dark .package.highlight,
  .pt-circle .package:hover,
  .pt-circle .package:focus,
  .pt-circle .package:active,
  .pt-circle .package.highlight {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }
}
/*Progressbar Styles*/
.pb-wrapper {
  display: flex;
  align-items: center;
}

.pb-btn-wrapper {
  margin: 8px;
  position: relative;
}
.pb-btn-wrapper .btn-success {
  background-color: #4CAF50;
}
.pb-btn-wrapper .btn-success:hover {
  background-color: #388E3C;
}

.fab-progress {
  color: #4CAF50;
  position: absolute;
  top: -6px;
  left: -6px;
  z-index: 1;
}

.btn-progress {
  color: #4CAF50;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px;
}

/*Popover Styles*/
.popover {
  z-index: 1510;
  max-height: 400px;
}

.popover-inner {
  max-height: 400px;
}

.popover-header {
  background-color: transparent;
  border-bottom: 0 none;
  color: #000;
  font-size: 18px;
  padding: 15px 20px 0;
}

.popover-body {
  padding: 15px 20px;
  max-height: 355px;
  overflow: auto;
}

/*Tables Styles*/
.table-header {
  padding-right: 2px !important;
  min-height: 64px;
  padding-left: 24px;
  align-items: center;
}
.table-header.highlight-light {
  color: #616161;
  background-color: #e0e0e0;
}
.table-header.highlight-dark {
  color: #fff;
  background-color: #616161;
}

.spacer {
  -webkit-flex: 1 1 100%;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
}

.actions {
  color: #F44336;
}

.title {
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}

.table-hover tbody tr:hover {
  background-color: rgba(63, 81, 181, 0.075);
}

.table-material {
  width: 100% !important;
  max-width: 100% !important;
  background-color: !important;
}
.table-material th,
.table-material td {
  padding: 0.75rem !important;
  vertical-align: top !important;
  border-top: 1px solid #dee2e6 !important;
}
.table-material thead th {
  vertical-align: bottom !important;
  border-bottom: 2px solid #dee2e6 !important;
}
.table-material tbody + tbody {
  border-top: 2px solid #dee2e6 !important;
}
.table-material .table-material {
  background-color: #fff !important;
}

.d-flex-stretch {
  -webkit-align-items: stretch;
  align-items: stretch;
  display: -webkit-flex;
  display: -webkit-box;
  display: -moz-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.default-table {
  margin-bottom: 0;
}
.default-table thead th {
  font-weight: 400;
  font-size: 16px;
}
.default-table td {
  vertical-align: middle;
}

.table-unbordered th, .table-unbordered td {
  border: 0 none !important;
}
.table-unbordered .th-border-b th {
  border-bottom: 2px solid #ced4da !important;
}

.table-responsive-material {
  min-height: 0.01%;
  overflow-x: auto;
}

@media screen and (max-width: 767px) {
  .table-responsive-material {
    width: 100%;
    margin-bottom: 15px;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd;
  }
  .table-responsive-material > .table {
    margin-bottom: 0;
  }
  .table-responsive-material > .table > thead > tr > th,
  .table-responsive-material > .table > tbody > tr > th,
  .table-responsive-material > .table > tfoot > tr > th,
  .table-responsive-material > .table > thead > tr > td,
  .table-responsive-material > .table > tbody > tr > td,
  .table-responsive-material > .table > tfoot > tr > td {
    white-space: nowrap;
  }
  .table-responsive-material > .table-bordered {
    border: 0;
  }
  .table-responsive-material > .table-bordered > thead > tr > th:first-child,
  .table-responsive-material > .table-bordered > tbody > tr > th:first-child,
  .table-responsive-material > .table-bordered > tfoot > tr > th:first-child,
  .table-responsive-material > .table-bordered > thead > tr > td:first-child,
  .table-responsive-material > .table-bordered > tbody > tr > td:first-child,
  .table-responsive-material > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0;
  }
  .table-responsive-material > .table-bordered > thead > tr > th:last-child,
  .table-responsive-material > .table-bordered > tbody > tr > th:last-child,
  .table-responsive-material > .table-bordered > tfoot > tr > th:last-child,
  .table-responsive-material > .table-bordered > thead > tr > td:last-child,
  .table-responsive-material > .table-bordered > tbody > tr > td:last-child,
  .table-responsive-material > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0;
  }
  .table-responsive-material > .table-bordered > tbody > tr:last-child > th,
  .table-responsive-material > .table-bordered > tfoot > tr:last-child > th,
  .table-responsive-material > .table-bordered > tbody > tr:last-child > td,
  .table-responsive-material > .table-bordered > tfoot > tr:last-child > td {
    border-bottom: 0;
  }
}
.fst-td-br-tp-0 tr:first-child td {
  border-top: 0 none;
}

/*Tabs Styles*/
.tab {
  min-width: 10px !important;
}

.tab-icon > span {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/*Testimonial Styles*/
.testimonial-in-bg {
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: 5px 5px 6px rgba(0, 0, 0, 0.06);
  padding: 30px 30px 30px 150px;
  overflow: hidden;
  position: relative;
}
@media screen and (max-width: 450px) {
  .testimonial-in-bg {
    padding-left: 100px;
  }
}
.testimonial-in-bg .pic {
  display: inline-block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  top: 30px;
  left: 20px;
  border: 4px solid #ffa000;
}
@media screen and (max-width: 450px) {
  .testimonial-in-bg .pic {
    width: 50px;
    height: 50px;
  }
}
.testimonial-in-bg .pic img {
  width: 100%;
  height: auto;
}
.testimonial-in-bg .description {
  color: #bdbdbd;
  font-style: italic;
  font-weight: 400;
  line-height: 25px;
  margin-bottom: 15px;
  position: relative;
}
.testimonial-in-bg .description:before {
  content: "\\f1b2";
  font-family: "Material-Design-Iconic-Font";
  font-size: 24px;
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  transform: scaleX(-1);
  position: absolute;
  left: -24px;
}
.testimonial-in-bg .title {
  color: #ffa000;
  margin-bottom: 2px;
}

.classic-testimonial {
  text-align: center;
}
.classic-testimonial .pic {
  margin: 0 auto;
  margin-bottom: 30px;
  width: 120px;
  height: 120px;
}
@media screen and (max-width: 500px) {
  .classic-testimonial .pic {
    width: 80px;
    height: 80px;
  }
}
.classic-testimonial .pic img {
  width: 100%;
  height: 100%;
}

/*Time Lines Style*/
.timeline-left {
  float: left;
  margin-right: 20px;
}

.timeline-right {
  float: right;
  margin-left: 20px;
}

.timeline-circle {
  border-radius: 50%;
}

.timeline-section {
  margin-bottom: 25px;
}

.timeline-item {
  padding-bottom: 25px;
  padding-left: 80px;
  position: relative;
}
.timeline-item:before {
  border-left: solid 2px #dee2e6;
  content: "";
  left: 25px;
  position: absolute;
  top: 25px;
  bottom: -20px;
  width: 2px;
  z-index: 1;
}
.timeline-item:first-child:before {
  border-left-style: dashed;
}
.timeline-item:last-child:before {
  border-left-style: dashed;
  bottom: 25px;
}

.timeline-badge {
  position: absolute;
  left: 0;
  top: 16px;
  z-index: 2;
  font-size: 16px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
}
.timeline-badge.timeline-img {
  background-color: transparent;
}
.timeline-badge svg {
  vertical-align: calc(100% - 56px);
}

.timeline-badge.timeline-img:after {
  display: none;
}
.timeline-badge:after {
  position: absolute;
  content: "";
  width: 42px;
  height: 42px;
  background-color: transparent;
  border: 4px solid #fff;
  border-radius: 50%;
  left: 4px;
  top: 4px;
  z-index: 1;
}

.timeline-img > img,
.timeline-header-img > img {
  display: inline-block;
  max-width: 100%;
  height: auto;
}

.timeline-panel {
  padding: 20px 30px;
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #e9ecef;
}
.timeline-panel:after, .timeline-panel:before {
  content: "";
  position: absolute;
  border-style: solid;
  display: inline-block;
}
.timeline-panel:before {
  border-color: transparent #dee2e6;
  border-width: 10px 17px 10px 0;
  left: -17px;
  top: 30px;
}
.timeline-panel:after {
  border-color: transparent #fff;
  border-width: 10px 16px 10px 0;
  left: -16px;
  top: 30px;
}

.timeline-no-padding {
  padding: 0;
}

.timeline-no-shadow {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
.timeline-no-shadow:before, .timeline-no-shadow:after {
  display: none;
}

.timeline-panel-header, .timeline-header-img {
  margin-bottom: 10px;
}

.timeline-inverted .timeline-left {
  float: right;
  margin-right: 0;
  margin-left: 20px;
}

.timeline-heading {
  overflow: hidden;
  margin-bottom: 10px;
}

.timeline-body {
  clear: both;
}

/*Gxtl Center Style*/
.timeline-center .timeline-item {
  clear: both;
  float: right;
  width: 50%;
  padding-left: 55px;
}
.timeline-center .timeline-item:before {
  left: 0;
}

.timeline-center .timeline-badge {
  left: -25px;
  right: auto;
}
.timeline-center .timeline-time {
  position: absolute;
  top: 32px;
  left: -150px;
  right: auto;
  z-index: 2;
}
.timeline-center .timeline-inverted {
  float: left;
  text-align: right;
  padding-left: 0;
  padding-right: 55px;
}
.timeline-center .timeline-inverted:before {
  border-left: 0 none;
  border-right: solid 2px #dee2e6;
  left: auto;
  right: -2px;
}
.timeline-center .timeline-inverted .timeline-badge {
  left: auto;
  right: -25px;
}
.timeline-center .timeline-inverted .timeline-panel:before {
  border-width: 10px 0 10px 17px;
  left: auto;
  right: -17px;
}
.timeline-center .timeline-inverted .timeline-panel:after {
  border-width: 10px 0 10px 16px;
  left: auto;
  right: -16px;
}
.timeline-center .timeline-inverted .timeline-time {
  position: absolute;
  top: 32px;
  right: -150px;
  left: auto;
  z-index: 2;
}

/*Gxtl Zigzag Style*/
.timeline-zigzag .timeline-item {
  padding-left: 150px;
}
.timeline-zigzag .timeline-item + .timeline-item {
  margin-top: -80px;
}
.timeline-zigzag .timeline-img {
  width: 90px;
  height: 90px;
  left: 5px;
}
.timeline-zigzag .timeline-img > img {
  width: 100%;
}
.timeline-zigzag .timeline-inverted .timeline-img {
  right: 5px !important;
}
.timeline-zigzag .timeline-item:before {
  -webkit-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  -o-transform: rotate(35deg);
  transform: rotate(35deg);
  top: 20px;
  bottom: 20px;
}
.timeline-zigzag .timeline-inverted {
  padding-left: 0;
  padding-right: 150px;
}
.timeline-zigzag .timeline-inverted:before {
  -webkit-transform: rotate(-35deg);
  -ms-transform: rotate(-35deg);
  -o-transform: rotate(-35deg);
  transform: rotate(-35deg);
}
.timeline-zigzag .timeline-item:first-child:before {
  border-left-style: solid;
}
.timeline-zigzag .timeline-item:last-child:before {
  display: none;
}

.timeline-item:last-child:before {
  bottom: 25px;
}

@media screen and (max-width: 991px) {
  .timeline-zigzag .timeline-item + .timeline-item {
    margin-top: -60px;
  }
  .timeline-zigzag .timeline-item:before {
    bottom: 0;
  }
  .timeline-zigzag .timeline-item {
    padding-left: 120px;
  }
  .timeline-zigzag .timeline-inverted {
    padding-right: 120px;
    padding-left: 0;
  }
}
@media screen and (max-width: 767px) {
  .timeline-center .timeline-item {
    float: none;
    padding-left: 80px;
    width: auto;
  }
  .timeline-center .timeline-item:before {
    left: 25px;
  }
  .timeline-center .timeline-badge {
    left: 0;
  }
  .timeline-center .timeline-inverted {
    float: none;
    text-align: left;
    padding-right: 0;
  }
  .timeline-center .timeline-inverted:before {
    border-left: solid 2px #dee2e6;
    border-right: 0 none;
    left: 24px;
    right: auto;
  }
  .timeline-center .timeline-inverted .timeline-badge {
    right: auto;
    left: 0;
  }
  .timeline-center .timeline-inverted .timeline-panel:before {
    border-width: 10px 17px 10px 0;
    left: -17px;
    right: auto;
  }
  .timeline-center .timeline-inverted .timeline-panel:after {
    border-width: 10px 16px 10px 0;
    left: -16px;
    right: auto;
  }
  .timeline-inverted .timeline-panel-header {
    float: none;
  }
  .timeline-inverted .timeline-left {
    float: left;
    margin-left: 0;
    margin-right: 20px;
  }
  .timeline-zigzag .timeline-panel {
    max-height: none;
    min-height: 10px;
    overflow-y: visible;
  }
  .timeline-zigzag .timeline-item {
    padding-left: 100px;
  }
  .timeline-zigzag .timeline-item + .timeline-item {
    margin-top: 0;
  }
  .timeline-zigzag .timeline-item:before {
    transform: none;
    top: 25px;
    bottom: -25px;
    left: 45px;
  }
  .timeline-zigzag .timeline-item:last-child:before {
    bottom: 0;
  }
  .timeline-zigzag .timeline-inverted:before {
    transform: none;
  }
  .timeline-center .timeline-time, .timeline-center .timeline-inverted .timeline-time {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    margin-bottom: 6px;
  }
  .timeline-center .timeline-time-item .timeline-panel::before {
    top: 10px;
  }
  .timeline-center .timeline-time-item .timeline-panel::after {
    top: 11px;
  }
}
@media screen and (max-width: 399px) {
  .timeline-left {
    float: none;
    margin-right: 0;
  }
  .timeline-right {
    float: none;
    margin-left: 0;
  }
  .timeline-inverted .timeline-left {
    float: none;
    margin-right: 0;
  }
}
/*Form Styles*/
@media screen and (max-width: 575px) {
  .horizontal-stepper p, .horizontal-stepper span {
    opacity: 0;
    visibility: hidden;
    font-size: 12px;
  }
  .horizontal-stepper.active p, .horizontal-stepper.active span {
    opacity: 1;
    visibility: visible;
  }
  .horizontal-stepper > *, .horizontal-stepper > button > * {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .horizontal-stepper .stepperlabel, .horizontal-stepper .stepperbutton, .horizontal-stepper .stepperlabel span:first-child, .horizontal-stepper .stepperbutton span:first-child {
    opacity: 1;
    visibility: visible;
  }
  .horizontal-stepper-linear {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.form-checkbox {
  position: relative;
  z-index: 1;
}

.form-checkbox > input {
  height: 18px;
  opacity: 0;
  position: absolute;
  padding: 10px;
  top: 0;
  width: 18px;
  z-index: 2;
  cursor: pointer;
}

.form-control-checkbox .form-checkbox > input {
  height: 48px;
  width: 48px;
}

.form-control-checkbox .form-checkbox {
  height: 48px;
  display: flex;
  align-items: center;
  width: 48px;
  justify-content: center;
}

.form-checkbox > input + .check {
  border: 1px solid #868e96;
  border-radius: 2px;
  color: #3f51b5;
  cursor: pointer;
  display: inline-block;
  height: 18px;
  position: relative;
  width: 18px;
  z-index: -1;
}

.form-checkbox > input.sm + .check {
  border: 1px solid #868e96;
  border-radius: 2px;
  color: #3f51b5;
  cursor: pointer;
  display: inline-block;
  height: 14px;
  position: relative;
  top: 3px;
  width: 14px;
  z-index: -1;
}

.form-checkbox > input + .check i {
  display: none;
  left: 1px;
  opacity: 0;
  position: absolute;
  top: 2px;
}

.form-checkbox > input.sm + .check i {
  display: none;
  left: 1px;
  opacity: 0;
  position: absolute;
  top: 2px;
}

.form-checkbox > input:checked + span i {
  display: block;
  opacity: 1;
}

/*Radio and Checkbox styles*/
.checkbox-replace {
  padding-left: 20px;
}

.checkbox-replace input[type=checkbox],
.radio-replace input[type=radio] {
  margin-left: -20px;
  position: absolute;
}

.form-inline .checkbox-replace label {
  padding-left: 5px;
}

.form-inline .checkbox-replace,
.form-inline .radio-replace {
  margin-right: 20px;
}

.form-inline .checkbox-replace:last-child {
  margin-right: 0;
}

.checkbox-replace label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 5px;
}

.checkbox-replace label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 18px;
  height: 18px;
  left: 0;
  top: 0;
  margin-left: -20px;
  margin-top: 2px;
  border: 1px solid #868e96;
  border-radius: 3px;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}

.checkbox-replace label::after {
  display: inline-block;
  position: absolute;
  width: 12px;
  height: 12px;
  left: 3px;
  top: 5px;
  margin-left: -20px;
  font-size: 11px;
  color: #495057;
}

.checkbox-replace input[type=checkbox] {
  opacity: 0;
  z-index: 1;
  cursor: pointer;
}

.checkbox-replace input[type=checkbox]:focus + label::before {
  outline: 0 none;
}

.checkbox-replace input[type=checkbox]:checked + label::after {
  background-color: #ced4da;
  content: "";
}

.checkbox-replace input[type=checkbox]:disabled + label {
  opacity: 0.65;
}

.checkbox-replace input[type=checkbox]:disabled + label::before {
  background-color: #fff;
  cursor: not-allowed;
}

.checkbox-replace.checkbox-inline {
  margin-top: 0;
}

.checkbox-primary label::before {
  border-color: #3f51b5;
}

.checkbox-primary input[type=checkbox]:checked + label::after {
  background-color: #3f51b5;
}

.checkbox-danger label::before {
  border-color: #E91E63;
}

.checkbox-danger input[type=checkbox]:checked + label::after {
  border-color: #E91E63;
}

.checkbox-info label::before {
  border-color: #00bcd4;
}

.checkbox-info input[type=checkbox]:checked + label::after {
  border-color: #00bcd4;
}

.checkbox-warning label::before {
  border-color: #ff9800;
}

.checkbox-warning input[type=checkbox]:checked + label::after {
  border-color: #ff9800;
}

.checkbox-success label::before {
  border-color: #4caf50;
}

.checkbox-success input[type=checkbox]:checked + label::after {
  border-color: #4caf50;
}

.radio-replace {
  padding-left: 20px;
}

.radio-replace label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 5px;
}

.radio-replace label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 18px;
  height: 18px;
  left: 0;
  top: 0;
  margin-left: -20px;
  margin-top: 2px;
  border: 1px solid #ced4da;
  border-radius: 50%;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out;
  transition: border 0.15s ease-in-out;
}

.radio-replace label::after {
  display: inline-block;
  position: absolute;
  content: " ";
  width: 12px;
  height: 12px;
  left: 3px;
  top: 5px;
  margin-left: -20px;
  border-radius: 50%;
  background-color: #ced4da;
  -webkit-transform: rotate(scale(0, 0));
  -ms-transform: rotate(scale(0, 0));
  -o-transform: rotate(scale(0, 0));
  transform: rotate(scale(0, 0));
  -webkit-transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  -o-transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
}

.radio-replace input[type=radio] {
  opacity: 0;
  z-index: 1;
  cursor: pointer;
}

.radio-replace input[type=radio]:focus + label::before {
  outline: 0 none;
}

.radio-replace input[type=radio]:checked + label::after {
  -webkit-transform: rotate(scale(1, 1));
  -ms-transform: rotate(scale(1, 1));
  -o-transform: rotate(scale(1, 1));
  transform: rotate(scale(1, 1));
}

.radio-replace input[type=radio]:disabled + label {
  opacity: 0.65;
}

.radio-replace input[type=radio]:disabled + label::before {
  cursor: not-allowed;
}

.radio-replace.radio-inline {
  margin-top: 0;
}

.radio-primary input[type=radio] + label::after {
  background-color: #3f51b5;
}

.radio-primary input[type=radio]:checked + label::before {
  border-color: #3f51b5;
}

.radio-primary input[type=radio]:checked + label::after {
  background-color: #3f51b5;
}

.radio-danger input[type=radio] + label::after {
  background-color: #E91E63;
}

.radio-danger input[type=radio]:checked + label::before {
  border-color: #E91E63;
}

.radio-danger input[type=radio]:checked + label::after {
  background-color: #E91E63;
}

.radio-info input[type=radio] + label::after {
  background-color: #00bcd4;
}

.radio-info input[type=radio]:checked + label::before {
  border-color: #00bcd4;
}

.radio-info input[type=radio]:checked + label::after {
  background-color: #00bcd4;
}

.radio-warning input[type=radio] + label::after {
  background-color: #ff9800;
}

.radio-warning input[type=radio]:checked + label::before {
  border-color: #ff9800;
}

.radio-warning input[type=radio]:checked + label::after {
  background-color: #ff9800;
}

.radio-success input[type=radio] + label::after {
  background-color: #4caf50;
}

.radio-success input[type=radio]:checked + label::before {
  border-color: #4caf50;
}

.radio-success input[type=radio]:checked + label::after {
  background-color: #4caf50;
}

.form-horizontal .checkbox, .form-horizontal .checkbox-inline, .form-horizontal .radio, .form-horizontal .radio-inline {
  padding-top: 7px;
  margin-top: 0;
  margin-bottom: 0;
}

.form-horizontal .form-inline .checkbox,
.form-horizontal .form-inline .checkbox-inline,
.form-horizontal .form-inline .radio,
.form-horizontal .form-inline .radio-inline {
  padding-top: 0;
}

.form-horizontal .checkbox, .form-horizontal .radio {
  min-height: 27px;
}

.form-wizard .tab-content .pager.wizard .first a {
  margin-right: 8px;
}

.form-wizard .tab-content .pager.wizard .last a {
  margin-left: 8px;
}

.wizard-navbar {
  margin: 60px auto 20px;
}

.wizard-navbar > ul {
  display: table;
  width: 100%;
  text-align: center;
  margin: 0;
  font-weight: 600;
  padding: 0;
  list-style: none outside none;
  table-layout: fixed;
}

.wizard-navbar > ul li {
  display: table-cell;
  width: 1%;
  position: relative;
}

.wizard-navbar > ul li a {
  color: #868e96;
  position: relative;
  padding: 0 10px;
  display: block;
  text-decoration: none;
}

.wizard-navbar > ul li a span.wz-number {
  background-color: #e9ecef;
  border-radius: 50%;
  color: #adb5bd;
  display: block;
  height: 40px;
  left: 50%;
  line-height: 40px;
  margin-left: -20px;
  margin-top: -50px;
  position: absolute;
  text-align: center;
  -webkit-transition: all 300ms ease-in-out 0s;
  -o-transition: all 300ms ease-in-out 0s;
  transition: all 300ms ease-in-out 0s;
  width: 40px;
  z-index: 5;
}

.wizard-navbar > ul li.completed a span.wz-number {
  background-color: #3f51b5;
  color: #fff;
}

.wizard-navbar > ul li a.active span.wz-number {
  background-color: #E91E63;
  color: #fff;
}

.wizard-navbar > ul li a.active,
.wizard-navbar > ul li.completed a {
  color: #6c757d;
}

.wizard-navbar > ul li a:before,
.wizard-navbar > ul li a:after {
  content: "";
  position: absolute;
  height: 4px;
  width: 50%;
  background-color: #e9ecef;
  top: -32px;
  left: 0;
}

.wizard-navbar > ul li a:after {
  left: auto;
  right: 0;
}

.wizard-navbar > ul li a.active:before,
.wizard-navbar > ul li a.active:after {
  background-color: #E91E63;
}

.wizard-navbar > ul li.completed a:before,
.wizard-navbar > ul li.completed a:after {
  background-color: #3f51b5;
}

label.error {
  display: block;
  color: #f44336;
  font-weight: 400;
  margin: 5px 0;
}

@media screen and (max-width: 479px) {
  .wizard-navbar > ul li a span.wz-label {
    visibility: hidden;
  }
  .wizard-navbar > ul li a.active span.wz-label {
    visibility: visible;
  }
}
.form-checkbox-custom {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 12px;
}

.form-checkbox-custom .check {
  margin-right: 10px;
}

.react-switch {
  vertical-align: middle;
  margin-left: 4px;
}

/*Input Styles*/
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 12px;
  color: rgb(86.0784313725%, 86.0784313725%, 86.0784313725%);
}

::-moz-placeholder { /* Firefox 19+ */
  font-size: 12px;
  color: rgb(86.0784313725%, 86.0784313725%, 86.0784313725%);
}

:-ms-input-placeholder { /* IE 10+ */
  font-size: 12px;
  color: rgb(86.0784313725%, 86.0784313725%, 86.0784313725%);
}

:-moz-placeholder { /* Firefox 18- */
  font-size: 12px;
  color: rgb(86.0784313725%, 86.0784313725%, 86.0784313725%);
}

.module-box-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 14px;
}

.module-box-header ::-moz-placeholder { /* Firefox 19+ */
  font-size: 14px;
}

.module-box-header :-ms-input-placeholder { /* IE 10+ */
  font-size: 14px;
}

.module-box-header :-moz-placeholder { /* Firefox 18- */
  font-size: 14px;
}

.search-bar {
  background-color: #fff;
  position: relative;
}
.search-bar .form-group {
  width: 100%;
  height: 100%;
  margin-bottom: 0;
}
.search-bar input[type=search] {
  padding-right: 50px;
}
.search-bar .search-icon {
  background-color: transparent;
  border: 0 none;
  color: rgb(52.453084238%, 55.8764621729%, 58.9194647816%);
  height: 36px;
  width: 30px;
}
.search-bar .form-control {
  box-shadow: none;
}
.search-bar .form-control.form-control-lg + .search-icon {
  position: absolute;
  right: 14px;
  top: 6px;
}
.search-bar .search-icon {
  position: absolute;
  right: 14px;
  top: 3px;
}
.search-bar.right-side-icon input[type=search] {
  padding-right: 16px;
  padding-left: 50px;
}
.search-bar.right-side-icon .search-icon {
  position: absolute;
  left: 14px;
  top: 2px;
}
.search-bar.right-side-icon .form-control {
  box-shadow: none;
}
.search-bar.right-side-icon .form-control.form-control-lg + .search-icon {
  position: absolute;
  left: 14px;
  top: 6px;
}

.nav-searchbox .search-bar input + .search-icon i {
  color: rgba(92, 92, 92, 0.8);
}

/* Removing arrows for input type number in Chrome, Safari, Edge, Opera */
.inputClassComponent::-webkit-outer-spin-button,
.inputClassComponent::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Removing arrows for input type number in Firefox */
.inputClassComponent[type=number] {
  -moz-appearance: textfield;
}

@media screen and (max-width: 767px) {
  .jr-card .app-main-header .search-bar {
    width: 150px;
  }
}
/* Pages
   ========================================================================== */
/*Login Styles*/
/*Login Styles*/
.indexPage {
  background-color: #f4f6f8;
  height: 100vh;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0;
  margin: 0;
}
@media screen and (max-width: 575px) {
  .indexPage {
    height: 100%;
  }
}

.landingPage {
  background-color: #fff;
  height: 680px;
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: cover;
}
@media screen and (max-width: 575px) {
  .landingPage {
    height: 100%;
  }
}

.login-container {
  position: relative;
  height: 100%;
}

.login-content {
  width: 420px;
  margin: auto;
  padding: 35px 35px 20px;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #ced4da;
  font-size: 14px;
  max-width: 94%;
}

.login-header {
  margin-bottom: 30px;
}

.login-content .form-control {
  background-color: #f5f5f5;
}
.login-content .form-control:focus {
  box-shadow: none;
  border-color: #3f51b5;
}

.login-content .btn, .login-content .jr-btn {
  padding: 10px 35px !important;
}

.app-login-container {
  position: relative;
  max-width: 680px;
  width: 94%;
  margin: 0 auto;
}
.app-login-container .loader-view {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  z-index: 2;
}

.app-login-main-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background-color: #fff;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  font-size: 14px;
  overflow: hidden;
}

.app-login-content {
  padding: 35px 35px 20px;
  width: 60%;
  order: 1;
}
@media screen and (max-width: 575px) {
  .app-login-content {
    width: 100%;
    order: 2;
  }
}

.app-login-header {
  margin-bottom: 30px;
}

.app-login-content .form-control {
  background-color: #f5f5f5;
}
.app-login-content .form-control:focus {
  box-shadow: none;
  border-color: #3f51b5;
}

.app-login-content .btn, .login-content .jr-btn {
  padding: 10px 35px !important;
}

.app-logo-content {
  background-color: #3f51b5;
  padding: 35px 35px 20px;
  width: 40%;
  order: 2;
}
@media screen and (max-width: 575px) {
  .app-logo-content {
    width: 100%;
    order: 1;
  }
}

.app-social-block {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.app-social-block .social-link, .app-social-block .social-link li {
  margin: 0;
}
.app-social-block .social-link span {
  border: solid 1px #3f51b5;
  border-radius: 50%;
  color: #3f51b5;
}
.app-social-block .social-link span:hover, .app-social-block .social-link span:focus {
  color: #fff;
  background-color: #3f51b5;
}
.app-social-block p {
  margin-bottom: 0;
}

/*Error Styles*/
.page-error-container {
  padding: 30px 0;
  position: relative;
}
@media screen and (max-width: 575px) {
  .page-error-container {
    padding: 15px 0;
  }
}

.page-error-content {
  margin: 0 auto;
  padding: 40px 0;
  width: 380px;
  max-width: 94%;
}
@media screen and (max-width: 767px) {
  .page-error-content {
    padding: 15px 0;
  }
}
@media screen and (max-width: 575px) {
  .page-error-content {
    padding: 0;
  }
}

.error-code {
  color: #212529;
  font-size: 160px;
  text-align: center;
  line-height: 1;
  font-weight: 600;
  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);
}
@media screen and (max-width: 991px) {
  .error-code {
    font-size: 130px;
  }
}
@media screen and (max-width: 767px) {
  .error-code {
    font-size: 100px;
  }
}
@media screen and (max-width: 575px) {
  .error-code {
    font-size: 80px;
  }
}

.page-error-content h2 {
  margin-bottom: 50px;
}
@media screen and (max-width: 767px) {
  .page-error-content h2 {
    margin-bottom: 20px;
  }
}

/*Editor Styles*/
.rdw-inline-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.rdw-option-wrapper {
  margin-bottom: 6px;
}

/*Contact Page Styles*/
.contact-form {
  padding: 60px;
}

.contact-block .contact-info {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-align-content: stretch;
  -ms-flex-align: stretch;
  align-content: stretch;
}
.contact-block .contact-info li {
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  overflow: hidden;
  padding: 10px 40px;
  border-right: 2px solid #5c5c5c;
  word-wrap: break-word;
}
.contact-block .contact-info li:last-child {
  border: 0 none;
}
.contact-block .contact-info li > i {
  float: left;
  font-size: 16px;
  margin-right: 5px;
}
.contact-block .contact-info li .contact-body {
  overflow: hidden;
}
.contact-block .contact-info li .contact-body .icons-wrapper {
  margin-top: 15px;
  margin-left: 0;
}
.contact-block .contact-info li .contact-body .icon {
  background-color: #5c6bc0;
  color: #fff;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 6px;
}
.contact-block .contact-info li .contact-body .icon:last-child {
  margin-right: 0;
}
.contact-block .contact-info li .contact-body .twitter-icon {
  background-color: #40c4ff;
}
.contact-block .contact-info li .contact-body .google-icon {
  background-color: #EF5350;
}
.contact-block .contact-info li .contact-body .linkedin-icon {
  background-color: #0277bd;
}
.contact-block .contact-info.vertical {
  display: block;
  margin-bottom: 0;
}
.contact-block .contact-info.vertical li {
  padding: 0 0 24px;
  border-right: 0 none;
  border-bottom: 2px solid #5c5c5c;
  margin-bottom: 24px;
}
.contact-block .contact-info.vertical li:last-child {
  border: 0 none;
  margin-bottom: 0;
  padding-bottom: 0;
}

@media screen and (max-width: 767px) {
  .contact-form {
    padding: 30px;
  }
  .contact-block .contact-info {
    display: block;
    margin-bottom: 0;
  }
  .contact-block .contact-info li {
    padding: 0 0 24px;
    border-right: 0 none;
    border-bottom: 2px solid #5c5c5c;
    margin-bottom: 24px;
  }
  .contact-block .contact-info li:last-child {
    border: 0 none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .content-section {
    padding: 20px 10px 0;
    text-align: center;
  }
  .content-section h2 {
    font-size: 28px;
  }
  .content-section p {
    font-size: 18px;
  }
}
/*Portfolio Styles*/
.portfolio-section .card-image {
  margin-bottom: 20px;
}
.portfolio-section .card-image img {
  width: 100%;
  -webkit-transition: all 1200ms ease;
  -o-transition: all 1200ms ease;
  transition: all 1200ms ease;
}
.portfolio-section .card-image:hover img {
  -webkit-transform: scale(1.08);
  -ms-transform: scale(1.08);
  transform: scale(1.08);
}

.filter-with-bg-color ul {
  padding-left: 0;
  margin: 0 -10px 45px;
}
.filter-with-bg-color ul li {
  display: inline-block;
  margin-bottom: 10px;
  padding: 0 10px;
}
.filter-with-bg-color ul li a {
  text-transform: uppercase;
  font-size: 12px;
  padding: 10px 24px;
  border: 1px solid #3f51b5;
  display: block;
  text-decoration: none;
}
.filter-with-bg-color ul li a:hover, .filter-with-bg-color ul li a:focus, .filter-with-bg-color ul li a.active {
  cursor: pointer;
  background-color: #3f51b5;
  border-color: #3f51b5;
  color: #fff;
}
@media screen and (max-width: 575px) {
  .filter-with-bg-color ul {
    margin-bottom: 15px;
  }
}

/*Faqs Styles*/
.Collapsible {
  margin-bottom: 15px;
}

.Collapsible__contentInner {
  padding: 20px;
  border: 1px solid #e9ecef;
  background-color: #fff;
  border-top: 0;
}
.Collapsible__contentInner p {
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 20px;
}
.Collapsible__contentInner p:last-child {
  margin-bottom: 0;
}

.Collapsible__trigger {
  display: block;
  cursor: pointer;
  font-weight: 400;
  text-decoration: none;
  position: relative;
  padding: 18px 20px;
  border-radius: 8px;
  background: #3f51b5;
  color: #fff;
}
.Collapsible__trigger:after {
  content: "\\f2f9";
  font-family: "Material-Design-Iconic-Font";
  font-size: 20px;
  position: absolute;
  right: 24px;
  top: 16px;
  display: block;
  transition: transform 300ms;
}
.Collapsible__trigger.is-open {
  border-radius: 8px 8px 0 0;
}
.Collapsible__trigger.is-open:after {
  transform: rotateZ(180deg);
}

.categories-list {
  margin-bottom: 0;
}
.categories-list li {
  margin-bottom: 10px;
}
.categories-list li:last-child {
  margin-bottom: 0;
}
.categories-list li.active a {
  color: #3f51b5;
}
.categories-list .badge {
  font-size: 9px;
}

.articles-section .articles {
  margin-bottom: 26px;
}
.articles-section .articles:last-child {
  margin-bottom: 0;
}

.article-image {
  display: block;
  margin-bottom: 12px;
}
.article-image > img {
  border-radius: 8px;
  width: 100%;
}

.article-description p {
  font-weight: 500;
  margin-bottom: 2px;
}

.meta-wrapper {
  margin-bottom: 10px;
}

.meta-date,
.meta-comment {
  font-size: 14px;
  color: #adb5bd;
  display: inline-block;
}
.meta-date i,
.meta-comment i {
  display: inline-block;
  margin-right: 6px;
}

.meta-date + .meta-comment {
  margin-left: 10px;
}

/*Dashboard Styles*/
.box {
  position: relative;
}
.box .box-top,
.box .box-bottom {
  height: 100px;
  padding: 32px 15px;
  font-size: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 300;
}
.box .box-top .size-h5,
.box .box-bottom .size-h5 {
  font-size: 24px;
  margin-left: 2px;
}
.box .box-top .material-icons,
.box .box-bottom .material-icons {
  font-size: 40px;
  line-height: 40px;
}
.box .box-bottom {
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}
.box .box-info {
  position: absolute;
  width: 100%;
  top: 50%;
  margin-top: -12px;
  text-align: center;
}
.box .box-info span {
  height: 24px;
  display: inline-block;
  padding: 4px 10px;
  text-transform: uppercase;
  line-height: 14px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-size: 12px;
  color: #6c757d;
  border-radius: 1em;
}
.box .box-info span .material-icons {
  line-height: 14px;
  font-size: 11px;
}

.contact-list {
  margin-bottom: 14px;
}
.contact-list i {
  margin-right: 14px;
  color: #3f51b5;
}
.contact-list .media {
  margin-bottom: 10px;
}

.temp-section .temp-point,
.temp-section .detail-icon {
  font-size: 54px;
}

.assignment-table tbody tr:nth-child(odd) {
  background-color: #dee2e6 !important;
}
.assignment-table td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.status-cell {
  min-width: 100px;
  max-width: 120px;
  padding-right: 24px !important;
}
.status-cell .badge {
  min-width: 70px;
}

.thumbnail-list {
  margin-bottom: 0;
}
.thumbnail-list .thumbnail-item {
  padding: 0 2.5px;
  display: inline-block;
  width: 33.333%;
  margin-bottom: 5px;
}
@media screen and (max-width: 767px) {
  .thumbnail-list .thumbnail-item {
    width: 50%;
  }
}
@media screen and (max-width: 575px) {
  .thumbnail-list .thumbnail-item {
    width: 33.333%;
  }
}

.post-list .post-image .grid-thumb-equal {
  padding-bottom: 100%;
}

/*Ecommerce Dashboard Styles*/
.chart-f30 {
  font-size: 30px;
}
@media screen and (max-width: 1099px) {
  .chart-f30 {
    font-size: 20px;
  }
}

.chart-f20 {
  font-size: 20px;
}
@media screen and (max-width: 1099px) {
  .chart-f20 {
    font-size: 16px;
  }
}

.chart-order .col-5 {
  order: 2;
  text-align: center;
}
@media screen and (max-width: 575px) {
  .chart-order .col-5 {
    order: 1;
  }
}
.chart-order .col-7 {
  order: 1;
}
@media screen and (max-width: 575px) {
  .chart-order .col-7 {
    order: 2;
  }
}

.tab-notifications {
  margin-left: -30px;
  margin-right: -30px;
  border-bottom: 1px solid #adb5bd;
}
@media screen and (max-width: 567px) {
  .tab-notifications button,
  .tab-notifications button * {
    font-size: 12px !important;
  }
}

.chart-title h2 {
  font-size: 22px;
  margin-bottom: 5px;
}

.img-fluid {
  width: 100%;
}

.comment-footer button {
  margin-bottom: 6px;
}

/*Intranet Dashboard Styles*/
.net-chart {
  padding-left: 80px;
  padding-right: 15px;
  min-height: 100px;
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}
.net-chart .jr-card-thumb {
  margin: 0;
  width: 50px;
  height: 50px;
  color: #fff;
  font-size: 20px;
  border-radius: 50%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-transition: all 100ms ease;
  -o-transition: all 100ms ease;
  transition: all 100ms ease;
  position: absolute;
  left: 15px;
}
.net-chart:hover .jr-card-thumb {
  width: 70px;
  height: 100%;
  font-size: 30px;
  border-radius: 0;
  position: absolute;
  left: 0;
}

.net-chart-hr {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  min-height: 120px;
  padding-right: 8px;
  overflow: hidden;
}
.net-chart-hr .jr-card-thumb {
  margin: -30px 12px -30px -30px;
  min-width: 105px;
}
.net-chart-hr .grid-thumb-equal {
  padding-bottom: 130%;
}
.net-chart-hr .jr-card-body {
  width: calc(100% - 100px);
}

.user-profile {
  padding: 10px 0;
}

.mh-120 {
  min-height: 120px;
}

.jr-card-header-top {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-right: -16px;
}

.jr-card-header-color {
  padding: 10px 20px 20px;
  margin: -24px -30px 25px;
}

.todo-cell-group .todo-cell:not(:last-child) {
  margin-bottom: 8px;
}

.social-list-line {
  position: relative;
}
.social-list-line:not(:last-child):before {
  border-left: solid 1px #adb5bd;
  content: "";
  left: 20px;
  position: absolute;
  top: 5px;
  bottom: 0;
  width: 1px;
  z-index: 1;
}

.list-line-item {
  position: relative;
  padding-left: 40px;
}
.list-line-item:not(:last-child):before {
  border-left: solid 1px #adb5bd;
  content: "";
  left: 20px;
  position: absolute;
  top: -25px;
  bottom: -25px;
  width: 1px;
  z-index: 1;
}

.list-line-badge {
  position: absolute;
  left: 16px;
  top: 15px;
  z-index: 2;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: #adb5bd;
}

.circle-shape {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.project-list {
  line-height: 1;
}
.project-list:not(:last-child) {
  margin-bottom: 20px;
}
.project-list .circle-shape {
  margin-top: 4px;
  margin-right: 16px;
}
.project-list .project-name {
  display: block;
  margin-bottom: 4px;
  color: #5c5c5c;
}
.project-list .project-name:hover, .project-list .project-name:focus {
  color: #3f51b5;
  text-decoration: none;
}

.nav-pill-sales li + li {
  margin-right: -1px;
}
.nav-pill-sales .nav-link {
  background-color: #e9ecef;
  border-radius: 0;
  padding: 6px 15px;
  color: #6c757d;
  font-size: 13px;
  border: 1px solid #ced4da;
}
.nav-pill-sales .nav-link.active {
  background-color: #3f51b5;
  color: #fff;
  border-color: #3f51b5;
}
.nav-pill-sales .nav-link.active:hover, .nav-pill-sales .nav-link.active:focus {
  color: #fff;
}
.nav-pill-sales li:first-child .nav-link {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.nav-pill-sales li:last-child .nav-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.temp-week-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  color: rgb(50.3071614912%, 53.8850458638%, 57.0653875284%);
}
.temp-week-list li:not(:last-child) {
  margin-bottom: 10px;
}
@media screen and (max-width: 340px) {
  .temp-week-list li:not(:last-child) {
    margin-bottom: 20px;
  }
}
.temp-week-list img {
  width: 24px;
  height: 24px;
}
.temp-week-list span {
  display: inline-block;
}
.temp-week-list span.temp-point {
  margin: 0 20px;
}
@media screen and (max-width: 1199px) {
  .temp-week-list span.temp-point {
    margin: 0 10px;
  }
}
@media screen and (max-width: 1050px) {
  .temp-week-list span.temp-point {
    margin: 0 5px;
  }
}
@media screen and (max-width: 340px) {
  .temp-week-list span.temp-point {
    margin: 0 20px;
  }
}

.temp-section .temp-point {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 0;
}
.temp-section .temp-point sub, .temp-section .temp-point sup {
  font-size: 70%;
}

/*Dropzone Styles*/
.dropzone-card {
  position: relative;
}

.dropzone {
  margin-bottom: 20px;
}
.dropzone > div {
  margin: 0 auto;
  padding: 15px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}
.dropzone > div :last-child {
  margin-bottom: 0;
}
.dropzone .btn {
  margin-top: 20px;
}

.upload-file-list {
  list-style: none;
  padding-left: 0;
}
.upload-file-list li {
  margin-bottom: 5px;
}

.form-group-dropzone label {
  margin-bottom: 6px;
}
.form-group-dropzone .form-control {
  max-width: 200px;
  margin: 0 auto;
}

/* Slider
   ========================================================================== */
.brand-logo {
  border: 1px solid #dee2e6;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding-bottom: 75%;
}
.brand-logo .brand-logo-inner {
  text-align: center;
}
.brand-logo .brand-logo-inner:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.brand-logo .brand-logo-inner img {
  height: auto;
  max-height: 100%;
  max-width: 100%;
  display: inline-block;
  vertical-align: middle;
  width: auto !important;
}
.brand-logo:hover {
  -webkit-transition: all 0.4s ease-in-out 0.1s;
  -o-transition: all 0.4s ease-in-out 0.1s;
  transition: all 0.4s ease-in-out 0.1s;
  background-color: rgb(95%, 95%, 95%);
}
@media screen and (max-width: 575px) {
  .brand-logo {
    margin-bottom: 15px;
  }
}

.owl-app-frame.owl-carousel .owl-item img {
  display: inline-block;
  width: auto;
}

.carousel-item img {
  max-width: 100%;
}

/* Modules
   ========================================================================== */
/* App Module Style */
.app-wrapper-module {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: stretch;
  align-items: stretch;
  height: 100%;
}

.app-module {
  position: relative;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin: -36px -40px 0 -40px;
}
@media screen and (max-width: 575px) {
  .app-module {
    margin: -20px;
  }
}

.module-side {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 230px;
  -ms-flex: 0 1 230px;
  flex: 0 1 230px;
  max-width: 230px;
  min-width: 230px;
}

.module-side-header {
  border-bottom: solid 1px #e9ecef;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.module-side-header .user-detail {
  padding: 15px 10px;
  text-align: center;
}

.module-logo {
  padding: 10px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  min-height: 78px;
  font-size: 20px;
  background-color: rgb(97.8382352941%, 98.1470588235%, 98.4558823529%);
  color: rgb(18.5990534145%, 20.7450980392%, 22.891142664%);
}
.module-logo .zmdi {
  font-size: 28px;
}

.module-user-info, .module-side-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.module-user-detail {
  font-size: 12px;
}

.module-add-task {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 24px;
}

.module-nav {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}
.module-nav li {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.module-nav li a {
  padding: 12px 29px;
  color: #8f8f8f;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  text-decoration: none;
}
.module-nav li a:hover, .module-nav li a:focus {
  color: #5c5c5c;
}
.module-nav li a.active {
  color: #3f51b5;
}
.module-nav li i {
  margin-right: 16px;
  font-size: 16px;
}
.module-nav li span {
  display: inline-block;
  vertical-align: middle;
}
.module-nav li.module-nav-label {
  padding: 12px 29px;
}

.module-box {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: calc(100% - 231px);
}

.module-box-header {
  padding: 10px 26px;
  min-height: 79px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  background-color: #fff;
  border-bottom: solid 1px #e9ecef;
}
.module-box-header .search-bar.right-side-icon {
  min-width: 350px;
}
.module-box-header .search-bar.right-side-icon .form-control {
  border-radius: 0;
  height: 46px;
  padding: 10px 18px 10px 40px;
}
.module-box-header .search-bar.right-side-icon .form-control:focus {
  background-color: #f8f9fa;
}
.module-box-header .search-bar.right-side-icon .search-icon {
  width: 25px;
  height: 46px;
  font-size: 16px;
  left: 10px;
  top: 0;
  padding: 0;
}

.module-box-header-inner {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.module-box-content {
  background-color: #fff;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.module-box-topbar {
  padding: 8px 12px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: solid 1px #e9ecef;
}
.module-box-topbar button + button {
  border-radius: 0;
}

.module-box-topbar-todo {
  padding-left: 64px;
}
@media screen and (max-width: 575px) {
  .module-box-topbar-todo {
    padding-left: 27px;
  }
}

.module-list-icon {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  padding-right: 10px;
}

.bar-icon {
  margin-right: 15px;
}

.toolbar-separator {
  border-left: solid 1px #ced4da;
  height: 100%;
  width: 1px;
  margin: 0 12px;
}

.toolbar-left {
  margin-left: auto;
}

.module-list {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}

.module-list-item {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  padding: 15px 28px;
  border-bottom: solid 1px #e9ecef;
  z-index: 5;
  position: relative;
  cursor: pointer;
}
.module-list-item > .check-label {
  margin-left: 0;
  margin-bottom: 0;
}
.module-list-item.mail-cell {
  padding-left: 12px;
  -webkit-align-items: start;
  align-items: start;
}

.module-detail-header {
  margin-bottom: 10px;
}
.module-detail-header > .check-label {
  margin-right: auto;
}

.module-list-info {
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: calc(100% - 169px);
}

.module-todo-content {
  position: relative;
}
.module-todo-content .subject {
  margin-bottom: 5px;
}

.module-list-actions {
  text-align: right;
}

.app-module-sidenav {
  background-color: #fff;
  border-right: solid 1px #e9ecef;
  position: relative;
  z-index: 9;
}
.app-module-sidenav .chat-sidenav-main {
  max-width: 300px;
  min-width: 300px;
  width: 90%;
}

.module-date {
  max-width: 160px;
}
.module-date > div:before {
  display: none;
}

.module-detail-item {
  padding: 10px 28px;
}

.task-title {
  font-size: 18px;
}

.chat-todo-avatar {
  margin-right: 15px;
}

.modal-title {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
  width: 100%;
  font-size: 18px;
}

.loader-view-block, .loader-view {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
}

.module-date > div {
  -webkit-align-items: center;
  align-items: center;
}

@media screen and (max-width: 1199px) {
  .module-side {
    display: -webkit-block;
    display: -moz-block;
    display: -ms-block;
    display: -o-block;
    display: block;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 200px;
    min-width: 200px;
    background-color: #fff;
  }
  .module-box-header {
    position: relative;
    min-height: 58px;
    padding: 5px 26px 5px 75px;
  }
  .module-box-header .drawer-btn {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    border-right: solid 1px #e9ecef;
    height: 58px;
    width: 56px;
    border-radius: 0;
    font-size: 22px;
  }
  .module-box-header .search-bar.right-side-icon .form-control {
    height: 38px;
    padding: 5px 18px 5px 40px;
  }
  .module-box-header .search-bar.right-side-icon .search-icon {
    height: 38px;
  }
  .chat-loader-view {
    height: calc(100vh - 120px);
  }
  .module-box {
    max-width: 100%;
  }
}
@media screen and (min-width: 991px) {
  .modal-dialog {
    max-width: 750px;
  }
}
@media screen and (max-width: 991px) {
  .app-module {
    padding-top: 0;
  }
}
@media screen and (max-width: 599px) {
  .module-box-header .search-bar {
    margin-left: 0;
    max-width: none;
  }
  .module-box-header .search-bar.right-side-icon {
    min-width: 250px;
  }
}
@media screen and (max-width: 575px) {
  .module-list-item {
    padding: 10px 12px;
  }
  .module-list-info {
    max-width: 100%;
  }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu {
    right: auto !important;
    left: 0 !important;
  }
  .module-box-header .search-bar.right-side-icon {
    min-width: 200px;
  }
  .module-box-header .search-bar.right-side-icon .form-control {
    border-radius: 0.25rem;
  }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu:after {
    right: auto;
    left: 9px;
  }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu:before {
    right: auto;
    left: 9px;
  }
  .module-box-header .search-bar {
    padding-right: 2px;
  }
}
@media screen and (max-width: 399px) {
  .module-box-header .search-bar.right-side-icon {
    min-width: 100px;
  }
}
@media screen and (min-width: 399px) {
  .d-xs-flex {
    display: flex !important;
  }
}
/*Chat Module Styles*/
.chat-module {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.chat-module:before {
  left: -29px;
}

.chat-module-box {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  background-color: #f8f9fa;
  position: relative;
  width: 100%;
}

.chat-sidenav {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 315px;
  -ms-flex: 0 1 315px;
  flex: 0 1 315px;
  min-width: 315px;
  border-right: solid 1px #e9ecef;
}

.chat-box {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: 100%;
  position: relative;
  z-index: 2;
}

.chat-sidenav-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 25px 20px 12px;
  background-color: rgb(97.8382352941%, 98.1470588235%, 98.4558823529%);
}

.chat-user-hd {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 25px;
}

.chat-sidenav-header .search-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-bottom: 0;
}
.chat-sidenav-header .search-wrapper .search-bar.right-side-icon {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.chat-sidenav-header .search-wrapper .search-bar.right-side-icon .form-control {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
  padding-left: 42px;
  height: 42px;
}
.chat-sidenav-header .search-wrapper .search-bar.right-side-icon .search-icon {
  left: 10px;
  top: 0;
  height: 42px;
  padding: 0;
}

.chat-avatar {
  min-width: 50px;
}
.chat-user-item .chat-avatar {
  padding: 0 5px;
  min-width: 10px;
}
.chat-user-hd .chat-avatar {
  cursor: pointer;
}

.chat-avatar-mode {
  position: relative;
  max-width: 50px;
}
.chat-avatar-mode .chat-mode {
  display: block;
  position: absolute;
  left: 0;
  top: 2px;
  z-index: 1;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.chat-avatar-mode .chat-mode.small {
  width: 8px;
  height: 8px;
}
.chat-avatar-mode .chat-mode.online {
  background-color: #4CAF50;
}
.chat-avatar-mode .chat-mode.offline {
  background-color: #fff;
  border: solid 1px #4CAF50;
}
.chat-avatar-mode .chat-mode.away {
  background-color: #fdd835;
}
.chat-main-header-info .chat-avatar-mode {
  max-width: 60px;
}

.chat-sidenav-content {
  background-color: #fff;
}

.chat-sidenav-title {
  padding: 10px 16px;
  font-size: 13px;
  color: #00bcd4;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}

.chat-tabs-header {
  background-color: rgb(97.8382352941%, 98.1470588235%, 98.4558823529%) !important;
}

.chat-user {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.chat-user.chat-user-center {
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
}
.chat-user.chat-user-center .chat-avatar {
  margin-left: auto;
}

.chat-user-item {
  border-bottom: solid 1px #e9ecef;
  padding: 16px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  cursor: pointer;
  max-height: 96px;
}
.chat-user-item.active, .chat-user-item:hover {
  background-color: rgb(89.3820315011%, 90.4379620701%, 96.3042430087%);
}

.chat-user-row {
  margin: 0 -5px;
  -webkit-align-items: center;
  align-items: center;
}

.chat-info, .chat-contact-col {
  padding: 0 5px;
}
.chat-info p, .chat-contact-col p {
  margin-bottom: 0;
}
.chat-info .h4, .chat-contact-col .h4 {
  display: block;
  margin-bottom: 3px;
}

.chat-info-des {
  color: #6c757d;
  font-size: 13px;
}

.chat-date {
  padding: 0 5px;
  text-align: right;
}

.chat-box-main {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
}

.module-default {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  height: 100%;
  padding: 15px;
}

.s-128 {
  font-size: 128px !important;
  width: 128px !important;
  height: 128px !important;
  line-height: 128px !important;
  margin-bottom: 12px;
}

.chat-main {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.chat-main-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  border-bottom: solid 1px #e9ecef;
  padding: 16px;
  background-color: #fff;
  width: 100%;
}

.chat-main-header-info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-right: auto;
}

.chat-contact-name {
  font-size: 20px;
  font-weight: 500;
}

.chat-main-footer {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  border-top: solid 1px #e9ecef;
  padding: 16px;
  background-color: #fff;
  width: 100%;
}
.chat-main-footer .form-group {
  margin-bottom: 0;
}

.todo-main-footer {
  padding: 6px 16px;
}

.chat-item {
  padding: 16px;
}
.chat-item .bubble {
  padding: 8px 12px;
  background-color: #fff;
  border-radius: 20px 20px 20px 0px;
  position: relative;
  margin-left: 16px;
  max-width: 600px;
  border: solid 1px #ced4da;
}
.chat-item.flex-row-reverse .bubble {
  margin-right: 16px;
  margin-left: 0;
  background-color: rgb(89.3820315011%, 90.4379620701%, 96.3042430087%);
  border-radius: 20px 20px 0 20px;
}

.chat-btn {
  font-size: 38px !important;
  margin: 0 10px 0 -8px;
}

.chat-textarea {
  height: 40px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
}

.last-message-time {
  font-size: 11px;
  color: #adb5bd;
}

@media screen and (max-width: 1399px) {
  .s-128 {
    font-size: 100px !important;
    width: 100px !important;
    height: 100px !important;
    line-height: 100px !important;
  }
}
@media screen and (max-width: 1199px) {
  .chat-module {
    margin: -24px -29px -23px;
    padding-top: 0;
  }
  .chat-main-header {
    padding: 8px 24px;
  }
  .chat-main-header .size-60 {
    height: 50px !important;
    width: 50px !important;
    line-height: 50px;
  }
  .chat-main-header button {
    margin-bottom: 0;
  }
  .chat-main-header-info .chat-avatar-mode {
    max-width: 50px;
  }
  .chat-contact-name,
  .chat-sidenav-title {
    font-size: 16px;
  }
  .chat-main-footer {
    padding: 8px 16px;
  }
  .s-128 {
    font-size: 128px !important;
    width: 128px !important;
    height: 128px !important;
    line-height: 128px !important;
  }
}
@media screen and (max-width: 991px) {
  .s-128 {
    font-size: 100px !important;
    width: 100px !important;
    height: 100px !important;
    line-height: 100px !important;
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 767px) {
  .chat-sidenav-title,
  .chat-contact-name {
    font-size: 15px;
  }
  .s-128 {
    font-size: 80px !important;
    width: 80px !important;
    height: 80px !important;
    line-height: 80px !important;
  }
}
@media screen and (max-width: 575px) {
  .module-default h1 {
    font-size: 17px;
  }
  .s-128 {
    font-size: 40px !important;
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
  }
}
/*Mails Module Styles*/
.module-box-row {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}

.module-box-column {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
}

.mail-user-info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}
.mail-user-info .avatar {
  margin-right: 10px;
}
.mail-user-info .time, .mail-user-info button {
  margin-left: auto;
}
.mail-user-info .badge {
  margin-bottom: 0;
}

.module-list-item.mail-cell {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.mail-detail {
  padding: 24px !important;
}

.mail-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}

.mail-header-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.mail-header-content .subject {
  margin-bottom: 5px;
}

.show-detail {
  cursor: pointer;
}

.text-truncate, .module-list-content .message p, .module-list-content .subject {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.module-list-content .message {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  color: rgb(56.7620561738%, 60.9803921569%, 65.1987281399%);
  font-size: 13px;
}
.module-list-content .message p {
  margin-bottom: 8px;
}

.size {
  margin: 5px 0;
}

.sender-name {
  margin-right: 0;
  font-weight: 500;
  font-size: 15px;
}

.mail-header-actions {
  text-align: right;
  min-width: 100px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.mail-header-actions .icon-btn:not(:last-child) {
  margin-right: 3px;
}

@media screen and (max-width: 991px) {
  .module-list-item.mail-cell {
    padding-right: 20px;
  }
}
@media screen and (max-width: 576px) {
  .mail-list {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
    border-right: 0 none;
  }
  .mail-detail {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
  }
  .mail-detail .module-list-scroll {
    padding: 24px;
  }
}
@media screen and (max-width: 499px) {
  .mail-header {
    display: block;
    -webkit-align-items: flex-start;
    align-items: flex-start;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .mail-header-actions {
    text-align: left;
    min-width: 10px;
  }
  .MuiDialog-paperWidthSm-99 {
    max-width: 250px !important;
  }
}
/*Contact Module Styles*/
.contact-item {
  -webkit-align-items: center;
  align-items: center;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: solid 1px #e9ecef;
  padding: 8px 12px;
}

.contact-name {
  font-size: 15px;
}

.modal-box {
  position: relative;
}

.modal-w {
  max-width: 400px;
  min-width: 350px;
}
.modal-box-mail .modal-w {
  min-width: 600px;
}

.modal-box-header {
  color: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.modal-box-header h2 {
  color: #fff;
  position: relative;
}
.modal-box-header h2 button {
  position: absolute;
  right: 0;
  top: -10px;
  z-index: 1;
  color: #fff;
}

.modal-box-content {
  padding: 24px;
}
.modal-box-content .avatar {
  margin: 0 auto;
}

.modal-box-footer {
  padding: 0 24px 24px;
}
.modal-box-footer .attach-file {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 15px;
}

.btn-fixed {
  position: fixed !important;
  right: 40px;
  bottom: 60px;
  z-index: 100;
}

.draggable-icon {
  cursor: all-scroll;
  color: #6c757d;
}
.draggable-icon:hover, .draggable-icon:focus, .draggable-icon:active {
  cursor: all-scroll;
  color: #212529;
}

.module-side-nav {
  padding: 20px 0;
}

@media screen and (max-width: 767px) {
  .modal-box-mail .modal-w {
    min-width: 500px;
  }
  .modal-box-header h2 {
    font-size: 18px;
  }
}
@media screen and (max-width: 575px) {
  .modal-w {
    min-width: 300px;
  }
  .modal-box-mail .modal-w {
    min-width: 400px;
  }
  .modal-box-header h2 {
    font-size: 16px;
  }
}
@media screen and (max-width: 419px) {
  .modal-w {
    min-width: 250px;
  }
  .modal-box-mail .modal-w {
    min-width: 250px;
  }
}
@media screen and (max-width: 399px) {
  .con-inf-mw-100 {
    min-width: 100% !important;
  }
}
/* Calendar Module Style */
.app-calendar .rbc-calendar {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-height: calc(100vh - 160px);
}
.app-cul-calendar .rbc-calendar {
  min-height: calc(100vh - 200px);
}

.rbc-event {
  background-color: #3f51b5;
}

.rbc-event.rbc-selected {
  background-color: rgb(19.5419479267%, 25.1253616201%, 56.1443265831%);
}

.rbc-slot-selection {
  background-color: rgba(63, 81, 181, 0.7);
}

.rbc-toolbar button:active,
.rbc-toolbar button.rbc-active {
  color: #fff;
  background-image: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.rbc-toolbar button:active:hover,
.rbc-toolbar button.rbc-active:hover,
.rbc-toolbar button:active:focus,
.rbc-toolbar button.rbc-active:focus {
  color: #fff;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.rbc-toolbar button:focus {
  color: #fff;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.rbc-toolbar button:hover {
  color: #fff;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.rbc-month-row {
  min-height: 100px;
}

.rbc-event {
  min-height: 50px;
}

@media screen and (max-width: 867px) {
  .rbc-toolbar {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-align-items: flex-start;
    align-items: flex-start;
  }
  .rbc-toolbar .rbc-toolbar-label {
    margin: 8px 0;
  }
}
@media screen and (max-height: 600px) {
  .app-calendar .rbc-calendar {
    min-height: 400px;
  }
  .app-cul-calendar .rbc-calendar {
    min-height: 400px;
  }
}
@media screen and (max-width: 467px) {
  .rbc-toolbar {
    font-size: 12px;
  }
  .rbc-toolbar button {
    padding: 5px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./styles/app.scss","webpack://./styles/global/__global-dir.scss","webpack://./styles/global/_place-holder.scss","webpack://./styles/global/_variables.scss","webpack://./styles/global/_mixin.scss","webpack://./styles/bootstrap/_variables.scss","webpack://./styles/global/_sizes.scss","webpack://./styles/global/_color.scss","webpack://./styles/global/_custom-animation.scss","webpack://./styles/base/__base-dir.scss","webpack://./styles/base/_base.scss","webpack://./styles/base/_typography.scss","webpack://./styles/layout/__layout-dir.scss","webpack://./styles/layout/_app-layout.scss","webpack://./styles/layout/_sidebar.scss","webpack://./styles/layout/_header.scss","webpack://./styles/layout/_navbar.scss","webpack://./styles/layout/_main-content.scss","webpack://./styles/layout/_footer.scss","webpack://./styles/layout/_right-sidebar.scss","webpack://./styles/ui/__ui-dir.scss","webpack://./styles/ui/_alert.scss","webpack://./styles/ui/_avatar.scss","webpack://./styles/ui/_badges.scss","webpack://./styles/ui/_blockquotes.scss","webpack://./styles/ui/_bottom-navigation.scss","webpack://./styles/ui/_breadcrumb.scss","webpack://./styles/ui/_button.scss","webpack://./styles/ui/_button-group.scss","webpack://./styles/ui/_callout.scss","webpack://./styles/ui/_card.scss","webpack://./styles/ui/_charts.scss","webpack://./styles/ui/_chip.scss","webpack://./styles/ui/_carousel.scss","webpack://./styles/ui/_color-picker.scss","webpack://./styles/ui/_date-input.scss","webpack://./styles/ui/_drawer.scss","webpack://./styles/ui/_e-commerce.scss","webpack://./styles/ui/_grid-list.scss","webpack://./styles/ui/_icons.scss","webpack://./styles/ui/_label.scss","webpack://./styles/ui/_list.scss","webpack://./styles/ui/_nav.scss","webpack://./styles/ui/_pricing-tables.scss","webpack://./styles/ui/_progressbar.scss","webpack://./styles/ui/_popover.scss","webpack://./styles/ui/_tables.scss","webpack://./styles/ui/_tabs.scss","webpack://./styles/ui/_testimonial.scss","webpack://./styles/ui/_timeline.scss","webpack://./styles/ui/_form.scss","webpack://./styles/ui/_ad-form.scss","webpack://./styles/ui/_input.scss","webpack://./styles/pages/__pages-dir.scss","webpack://./styles/pages/_login.scss","webpack://./styles/pages/_error.scss","webpack://./styles/pages/_editor.scss","webpack://./styles/pages/_contact.scss","webpack://./styles/pages/_portfolio.scss","webpack://./styles/pages/_faq.scss","webpack://./styles/pages/_dashboard.scss","webpack://./styles/pages/_dropzone.scss","webpack://./styles/slider/_owl-carousel.scss","webpack://./styles/module/__module-dir.scss","webpack://./styles/module/_app-module.scss","webpack://./styles/module/_chat.scss","webpack://./styles/module/_mail.scss","webpack://./styles/module/_contact.scss","webpack://./styles/module/_calendar.scss"],"names":[],"mappings":"AAAA;;;;CAAA;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;gEAAA;ACLA;+EAAA;ACEE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,yBCqDW;EDpDX,cAAA;EE4BF,iCF3BE;EE4BF,4BF5BE;EE6BF,yBF7BE;EACA,aAAA;EACA,eAAA;AF0EJ;AExEI;EAEE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EEcJ,iCFbI;EEcJ,4BFdI;EEeJ,yBFfI;AF2EN;AExEI;EACE,WAAA;EACA,YAAA;AF0EN;AEvEI;EACE,WAAA;EACA,SAAA;AFyEN;AErEI;EACE,WAAA;AFuEN;AEtEM;EAEE,WAAA;AFuER;;AEjEA;EACE,uBAAA;EACA,sBAAA;EACA,iBCyGQ;AHrCV;;AEjEA;EACE,uBAAA;EACA,sBAAA;EACA,iBCoGQ;AHhCV;;AEjEA;EACE,uBAAA;EACA,sBAAA;EACA,iBC+FQ;AH3BV;;AEjEA;EACE,wBAAA;EACA,uBAAA;EACA,kBC0FS;AHtBX;;AEjEA;EACE,uBAAA;EACA,sBAAA;EACA,iBC8EQ;AHVV;;AEhEA;EACE,uBAAA;EACA,sBAAA;EACA,iBCwEQ;AHLV;;AEhEA;EACE,uBAAA;EACA,sBAAA;EACA,iBCmEQ;AHAV;;AEhEA;EACE,wBAAA;EACA,uBAAA;EACA,kBCkES;AHCX;;AEhEA;EACE,qBAAA;EACA,kBAAA;EACA,yBAAA;AFmEF;;AEhEA;EACE,kBCxBgB;EDyBhB,mBC1Be;ED2Bf,sBGnGS;EDyFP,kBDxDe;EDoEjB,yBC3BU;ED4BV,kBAAA;AFmEF;;AEhEA,iBAAA;AACA;EACE,kBAAA;EACA,gBAAA;AFmEF;AElEE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;EE5BA,mBF6BuB;EACvB,sCAAA;EACA,yBAAA;AFoEJ;AEjEE;EACE,6BAAA;AFmEJ;;AE/DA;EACE;IACE,sBAAA;IACA,YAAA;EFkEF;EEhEA;IACE,wBAAA;IACA,YAAA;EFkEF;EEhEA;IACE,UAAA;IACA,0BAAA;EFkEF;AACF;AE/DA;EACE;IACE,sBAAA;IACA,YAAA;EFiEF;EE/DA;IACE,wBAAA;IACA,YAAA;EFiEF;EE/DA;IACE,UAAA;IACA,0BAAA;EFiEF;AACF;AE7DA;EACE,cAAA;EErKA,gDFsKA;EErKA,6CFqKA;EEpKA,2CFoKA;EEnKA,wCFmKA;EACA,4BAAA;AFkEF;;AE/DA;EACE;IACE,kDAAA;EFkEF;EEhEA;IACE,mDAAA;EFkEF;EEhEA;IACE,gDAAA;EFkEF;AACF;AE/DA;EACE;IACE,+CAAA;IACA,0CAAA;EFiEF;EE/DA;IACE,gDAAA;IACA,2CAAA;EFiEF;EE/DA;IACE,6CAAA;IACA,wCAAA;EFiEF;AACF;AE7DA;EACE,cAAA;EEvMA,gDFwMA;EEvMA,6CFuMA;EEtMA,2CFsMA;EErMA,wCFqMA;EACA,6BAAA;AFkEF;;AE/DA;EACE;IACE,kDAAA;EFkEF;EEhEA;IACE,mDAAA;EFkEF;EEhEA;IACE,gDAAA;EFkEF;AACF;AE/DA;EACE;IACE,+CAAA;IACA,0CAAA;EFiEF;EE/DA;IACE,gDAAA;IACA,2CAAA;EFiEF;EE/DA;IACE,6CAAA;IACA,wCAAA;EFiEF;AACF;AE7DA;EACE,cAAA;EEzOA,gDF0OA;EEzOA,6CFyOA;EExOA,2CFwOA;EEvOA,wCFuOA;EACA,2BAAA;AFkEF;;AE/DA;EACE;IACE,kDAAA;EFkEF;EEhEA;IACE,mDAAA;EFkEF;EEhEA;IACE,gDAAA;EFkEF;AACF;AE/DA;EACE;IACE,+CAAA;IACA,0CAAA;EFiEF;EE/DA;IACE,gDAAA;IACA,2CAAA;EFiEF;EE/DA;IACE,6CAAA;IACA,wCAAA;EFiEF;AACF;AE9DA,4DAAA;AACA;EACE,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AFgEF;;AE7DA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AFgEF;;AE7DA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AFgEF;;AE5DA;EACE,sBAAA;AF+DF;AE7DE;EAEE,sBAAA;AF8DJ;;AEzDA;EACE,eAAA;AF4DF;;AEtDE;;;;;;;;;;;;;;;;;EAEE,sBAAA;EErTF,wBFsTE;EErTF,qBFqTE;EEpTF,mBFoTE;EEnTF,gBFmTE;AF2EJ;AEzEI;;;;;;;;;;;;;;;;;EExTF,wBFyTI;EExTJ,qBFwTI;EEvTJ,mBFuTI;EEtTJ,gBFsTI;AF8FN;;AMrZI;EACE,qBAAA;ANwZN;;AMzZI;EACE,qBAAA;AN4ZN;;AM7ZI;EACE,qBAAA;ANgaN;;AMjaI;EACE,sBAAA;ANoaN;;AMraI;EACE,sBAAA;ANwaN;;AMzaI;EACE,sBAAA;AN4aN;;AM7aI;EACE,sBAAA;ANgbN;;AMjbI;EACE,sBAAA;ANobN;;AMrbI;EACE,uBAAA;ANwbN;;AMzbI;EACE,uBAAA;AN4bN;;AM7bI;EACE,yBAAA;ANgcN;;AMjcI;EACE,yBAAA;ANocN;;AMrcI;EACE,yBAAA;ANwcN;;AMzcI;EACE,0BAAA;AN4cN;;AM7cI;EACE,0BAAA;ANgdN;;AMjdI;EACE,0BAAA;ANodN;;AMrdI;EACE,0BAAA;ANwdN;;AMzdI;EACE,0BAAA;AN4dN;;AM7dI;EACE,2BAAA;ANgeN;;AMjeI;EACE,2BAAA;ANoeN;;AOtHM;EACE,oCAAA;APyHR;;AOvHM;EACE,yBAAA;AP0HR;AOzHQ;EACE,gCAAA;AP2HV;;AOvHM;EACE,oCAAA;AP0HR;;AOxHM;EACE,yBAAA;AP2HR;AO1HQ;EACE,gCAAA;AP4HV;;AOlIM;EACE,oCAAA;APqIR;;AOnIM;EACE,yBAAA;APsIR;AOrIQ;EACE,gCAAA;APuIV;;AO7IM;EACE,oCAAA;APgJR;;AO9IM;EACE,yBAAA;APiJR;AOhJQ;EACE,gCAAA;APkJV;;AOxJM;EACE,oCAAA;AP2JR;;AOzJM;EACE,yBAAA;AP4JR;AO3JQ;EACE,gCAAA;AP6JV;;AOnKM;EACE,oCAAA;APsKR;;AOpKM;EACE,yBAAA;APuKR;AOtKQ;EACE,gCAAA;APwKV;;AO9KM;EACE,oCAAA;APiLR;;AO/KM;EACE,yBAAA;APkLR;AOjLQ;EACE,gCAAA;APmLV;;AOzLM;EACE,oCAAA;AP4LR;;AO1LM;EACE,yBAAA;AP6LR;AO5LQ;EACE,gCAAA;AP8LV;;AOpMM;EACE,oCAAA;APuMR;;AOrMM;EACE,yBAAA;APwMR;AOvMQ;EACE,gCAAA;APyMV;;AO/MM;EACE,oCAAA;APkNR;;AOhNM;EACE,yBAAA;APmNR;AOlNQ;EACE,gCAAA;APoNV;;AO1NM;EACE,oCAAA;AP6NR;;AO3NM;EACE,yBAAA;AP8NR;AO7NQ;EACE,gCAAA;AP+NV;;AOrOM;EACE,oCAAA;APwOR;;AOtOM;EACE,yBAAA;APyOR;AOxOQ;EACE,gCAAA;AP0OV;;AOhPM;EACE,oCAAA;APmPR;;AOjPM;EACE,yBAAA;APoPR;AOnPQ;EACE,gCAAA;APqPV;;AO3PM;EACE,oCAAA;AP8PR;;AO5PM;EACE,yBAAA;AP+PR;AO9PQ;EACE,gCAAA;APgQV;;AOhRM;EACE,oCAAA;APmRR;;AOjRM;EACE,yBAAA;APoRR;AOnRQ;EACE,gCAAA;APqRV;;AOjRM;EACE,oCAAA;APoRR;;AOlRM;EACE,yBAAA;APqRR;AOpRQ;EACE,gCAAA;APsRV;;AO5RM;EACE,oCAAA;AP+RR;;AO7RM;EACE,yBAAA;APgSR;AO/RQ;EACE,gCAAA;APiSV;;AOvSM;EACE,oCAAA;AP0SR;;AOxSM;EACE,yBAAA;AP2SR;AO1SQ;EACE,gCAAA;AP4SV;;AOlTM;EACE,oCAAA;APqTR;;AOnTM;EACE,yBAAA;APsTR;AOrTQ;EACE,gCAAA;APuTV;;AO7TM;EACE,oCAAA;APgUR;;AO9TM;EACE,yBAAA;APiUR;AOhUQ;EACE,gCAAA;APkUV;;AOxUM;EACE,oCAAA;AP2UR;;AOzUM;EACE,yBAAA;AP4UR;AO3UQ;EACE,gCAAA;AP6UV;;AOnVM;EACE,oCAAA;APsVR;;AOpVM;EACE,yBAAA;APuVR;AOtVQ;EACE,gCAAA;APwVV;;AO9VM;EACE,oCAAA;APiWR;;AO/VM;EACE,yBAAA;APkWR;AOjWQ;EACE,gCAAA;APmWV;;AOzWM;EACE,oCAAA;AP4WR;;AO1WM;EACE,yBAAA;AP6WR;AO5WQ;EACE,gCAAA;AP8WV;;AOpXM;EACE,oCAAA;APuXR;;AOrXM;EACE,yBAAA;APwXR;AOvXQ;EACE,gCAAA;APyXV;;AO/XM;EACE,oCAAA;APkYR;;AOhYM;EACE,yBAAA;APmYR;AOlYQ;EACE,gCAAA;APoYV;;AO1YM;EACE,oCAAA;AP6YR;;AO3YM;EACE,yBAAA;AP8YR;AO7YQ;EACE,gCAAA;AP+YV;;AOrZM;EACE,oCAAA;APwZR;;AOtZM;EACE,yBAAA;APyZR;AOxZQ;EACE,gCAAA;AP0ZV;;AO1aM;EACE,oCAAA;AP6aR;;AO3aM;EACE,yBAAA;AP8aR;AO7aQ;EACE,gCAAA;AP+aV;;AO3aM;EACE,oCAAA;AP8aR;;AO5aM;EACE,yBAAA;AP+aR;AO9aQ;EACE,gCAAA;APgbV;;AOtbM;EACE,oCAAA;APybR;;AOvbM;EACE,yBAAA;AP0bR;AOzbQ;EACE,gCAAA;AP2bV;;AOjcM;EACE,oCAAA;APocR;;AOlcM;EACE,yBAAA;APqcR;AOpcQ;EACE,gCAAA;APscV;;AO5cM;EACE,oCAAA;AP+cR;;AO7cM;EACE,yBAAA;APgdR;AO/cQ;EACE,gCAAA;APidV;;AOvdM;EACE,oCAAA;AP0dR;;AOxdM;EACE,yBAAA;AP2dR;AO1dQ;EACE,gCAAA;AP4dV;;AOleM;EACE,oCAAA;APqeR;;AOneM;EACE,yBAAA;APseR;AOreQ;EACE,gCAAA;APueV;;AO7eM;EACE,oCAAA;APgfR;;AO9eM;EACE,yBAAA;APifR;AOhfQ;EACE,gCAAA;APkfV;;AOxfM;EACE,oCAAA;AP2fR;;AOzfM;EACE,yBAAA;AP4fR;AO3fQ;EACE,gCAAA;AP6fV;;AOngBM;EACE,oCAAA;APsgBR;;AOpgBM;EACE,yBAAA;APugBR;AOtgBQ;EACE,gCAAA;APwgBV;;AO9gBM;EACE,oCAAA;APihBR;;AO/gBM;EACE,yBAAA;APkhBR;AOjhBQ;EACE,gCAAA;APmhBV;;AOzhBM;EACE,oCAAA;AP4hBR;;AO1hBM;EACE,yBAAA;AP6hBR;AO5hBQ;EACE,gCAAA;AP8hBV;;AOpiBM;EACE,oCAAA;APuiBR;;AOriBM;EACE,yBAAA;APwiBR;AOviBQ;EACE,gCAAA;APyiBV;;AO/iBM;EACE,oCAAA;APkjBR;;AOhjBM;EACE,yBAAA;APmjBR;AOljBQ;EACE,gCAAA;APojBV;;AOpkBM;EACE,oCAAA;APukBR;;AOrkBM;EACE,yBAAA;APwkBR;AOvkBQ;EACE,gCAAA;APykBV;;AOrkBM;EACE,oCAAA;APwkBR;;AOtkBM;EACE,yBAAA;APykBR;AOxkBQ;EACE,gCAAA;AP0kBV;;AOhlBM;EACE,oCAAA;APmlBR;;AOjlBM;EACE,yBAAA;APolBR;AOnlBQ;EACE,gCAAA;APqlBV;;AO3lBM;EACE,oCAAA;AP8lBR;;AO5lBM;EACE,yBAAA;AP+lBR;AO9lBQ;EACE,gCAAA;APgmBV;;AOtmBM;EACE,oCAAA;APymBR;;AOvmBM;EACE,yBAAA;AP0mBR;AOzmBQ;EACE,gCAAA;AP2mBV;;AOjnBM;EACE,oCAAA;APonBR;;AOlnBM;EACE,yBAAA;APqnBR;AOpnBQ;EACE,gCAAA;APsnBV;;AO5nBM;EACE,oCAAA;AP+nBR;;AO7nBM;EACE,yBAAA;APgoBR;AO/nBQ;EACE,gCAAA;APioBV;;AOvoBM;EACE,oCAAA;AP0oBR;;AOxoBM;EACE,yBAAA;AP2oBR;AO1oBQ;EACE,gCAAA;AP4oBV;;AOlpBM;EACE,oCAAA;APqpBR;;AOnpBM;EACE,yBAAA;APspBR;AOrpBQ;EACE,gCAAA;APupBV;;AO7pBM;EACE,oCAAA;APgqBR;;AO9pBM;EACE,yBAAA;APiqBR;AOhqBQ;EACE,gCAAA;APkqBV;;AOxqBM;EACE,oCAAA;AP2qBR;;AOzqBM;EACE,yBAAA;AP4qBR;AO3qBQ;EACE,gCAAA;AP6qBV;;AOnrBM;EACE,oCAAA;APsrBR;;AOprBM;EACE,yBAAA;APurBR;AOtrBQ;EACE,gCAAA;APwrBV;;AO9rBM;EACE,oCAAA;APisBR;;AO/rBM;EACE,yBAAA;APksBR;AOjsBQ;EACE,gCAAA;APmsBV;;AOzsBM;EACE,oCAAA;AP4sBR;;AO1sBM;EACE,yBAAA;AP6sBR;AO5sBQ;EACE,gCAAA;AP8sBV;;AO9tBM;EACE,oCAAA;APiuBR;;AO/tBM;EACE,yBAAA;APkuBR;AOjuBQ;EACE,gCAAA;APmuBV;;AO/tBM;EACE,oCAAA;APkuBR;;AOhuBM;EACE,yBAAA;APmuBR;AOluBQ;EACE,gCAAA;APouBV;;AO1uBM;EACE,oCAAA;AP6uBR;;AO3uBM;EACE,yBAAA;AP8uBR;AO7uBQ;EACE,gCAAA;AP+uBV;;AOrvBM;EACE,oCAAA;APwvBR;;AOtvBM;EACE,yBAAA;APyvBR;AOxvBQ;EACE,gCAAA;AP0vBV;;AOhwBM;EACE,oCAAA;APmwBR;;AOjwBM;EACE,yBAAA;APowBR;AOnwBQ;EACE,gCAAA;APqwBV;;AO3wBM;EACE,oCAAA;AP8wBR;;AO5wBM;EACE,yBAAA;AP+wBR;AO9wBQ;EACE,gCAAA;APgxBV;;AOtxBM;EACE,oCAAA;APyxBR;;AOvxBM;EACE,yBAAA;AP0xBR;AOzxBQ;EACE,gCAAA;AP2xBV;;AOjyBM;EACE,oCAAA;APoyBR;;AOlyBM;EACE,yBAAA;APqyBR;AOpyBQ;EACE,gCAAA;APsyBV;;AO5yBM;EACE,oCAAA;AP+yBR;;AO7yBM;EACE,yBAAA;APgzBR;AO/yBQ;EACE,gCAAA;APizBV;;AOvzBM;EACE,oCAAA;AP0zBR;;AOxzBM;EACE,yBAAA;AP2zBR;AO1zBQ;EACE,gCAAA;AP4zBV;;AOl0BM;EACE,oCAAA;APq0BR;;AOn0BM;EACE,yBAAA;APs0BR;AOr0BQ;EACE,gCAAA;APu0BV;;AO70BM;EACE,oCAAA;APg1BR;;AO90BM;EACE,yBAAA;APi1BR;AOh1BQ;EACE,gCAAA;APk1BV;;AOx1BM;EACE,oCAAA;AP21BR;;AOz1BM;EACE,yBAAA;AP41BR;AO31BQ;EACE,gCAAA;AP61BV;;AOn2BM;EACE,oCAAA;APs2BR;;AOp2BM;EACE,yBAAA;APu2BR;AOt2BQ;EACE,gCAAA;APw2BV;;AOx3BM;EACE,oCAAA;AP23BR;;AOz3BM;EACE,yBAAA;AP43BR;AO33BQ;EACE,gCAAA;AP63BV;;AOz3BM;EACE,oCAAA;AP43BR;;AO13BM;EACE,yBAAA;AP63BR;AO53BQ;EACE,gCAAA;AP83BV;;AOp4BM;EACE,oCAAA;APu4BR;;AOr4BM;EACE,yBAAA;APw4BR;AOv4BQ;EACE,gCAAA;APy4BV;;AO/4BM;EACE,oCAAA;APk5BR;;AOh5BM;EACE,yBAAA;APm5BR;AOl5BQ;EACE,gCAAA;APo5BV;;AO15BM;EACE,oCAAA;AP65BR;;AO35BM;EACE,yBAAA;AP85BR;AO75BQ;EACE,gCAAA;AP+5BV;;AOr6BM;EACE,oCAAA;APw6BR;;AOt6BM;EACE,yBAAA;APy6BR;AOx6BQ;EACE,gCAAA;AP06BV;;AOh7BM;EACE,oCAAA;APm7BR;;AOj7BM;EACE,yBAAA;APo7BR;AOn7BQ;EACE,gCAAA;APq7BV;;AO37BM;EACE,oCAAA;AP87BR;;AO57BM;EACE,yBAAA;AP+7BR;AO97BQ;EACE,gCAAA;APg8BV;;AOt8BM;EACE,oCAAA;APy8BR;;AOv8BM;EACE,yBAAA;AP08BR;AOz8BQ;EACE,gCAAA;AP28BV;;AOj9BM;EACE,oCAAA;APo9BR;;AOl9BM;EACE,yBAAA;APq9BR;AOp9BQ;EACE,gCAAA;APs9BV;;AO59BM;EACE,oCAAA;AP+9BR;;AO79BM;EACE,yBAAA;APg+BR;AO/9BQ;EACE,gCAAA;APi+BV;;AOv+BM;EACE,oCAAA;AP0+BR;;AOx+BM;EACE,yBAAA;AP2+BR;AO1+BQ;EACE,gCAAA;AP4+BV;;AOl/BM;EACE,oCAAA;APq/BR;;AOn/BM;EACE,yBAAA;APs/BR;AOr/BQ;EACE,gCAAA;APu/BV;;AO7/BM;EACE,oCAAA;APggCR;;AO9/BM;EACE,yBAAA;APigCR;AOhgCQ;EACE,gCAAA;APkgCV;;AOlhCM;EACE,oCAAA;APqhCR;;AOnhCM;EACE,yBAAA;APshCR;AOrhCQ;EACE,gCAAA;APuhCV;;AOnhCM;EACE,oCAAA;APshCR;;AOphCM;EACE,yBAAA;APuhCR;AOthCQ;EACE,gCAAA;APwhCV;;AO9hCM;EACE,oCAAA;APiiCR;;AO/hCM;EACE,yBAAA;APkiCR;AOjiCQ;EACE,gCAAA;APmiCV;;AOziCM;EACE,oCAAA;AP4iCR;;AO1iCM;EACE,yBAAA;AP6iCR;AO5iCQ;EACE,gCAAA;AP8iCV;;AOpjCM;EACE,oCAAA;APujCR;;AOrjCM;EACE,yBAAA;APwjCR;AOvjCQ;EACE,gCAAA;APyjCV;;AO/jCM;EACE,oCAAA;APkkCR;;AOhkCM;EACE,yBAAA;APmkCR;AOlkCQ;EACE,gCAAA;APokCV;;AO1kCM;EACE,oCAAA;AP6kCR;;AO3kCM;EACE,yBAAA;AP8kCR;AO7kCQ;EACE,gCAAA;AP+kCV;;AOrlCM;EACE,oCAAA;APwlCR;;AOtlCM;EACE,yBAAA;APylCR;AOxlCQ;EACE,gCAAA;AP0lCV;;AOhmCM;EACE,oCAAA;APmmCR;;AOjmCM;EACE,yBAAA;APomCR;AOnmCQ;EACE,gCAAA;APqmCV;;AO3mCM;EACE,oCAAA;AP8mCR;;AO5mCM;EACE,yBAAA;AP+mCR;AO9mCQ;EACE,gCAAA;APgnCV;;AOtnCM;EACE,oCAAA;APynCR;;AOvnCM;EACE,yBAAA;AP0nCR;AOznCQ;EACE,gCAAA;AP2nCV;;AOjoCM;EACE,oCAAA;APooCR;;AOloCM;EACE,yBAAA;APqoCR;AOpoCQ;EACE,gCAAA;APsoCV;;AO5oCM;EACE,oCAAA;AP+oCR;;AO7oCM;EACE,yBAAA;APgpCR;AO/oCQ;EACE,gCAAA;APipCV;;AOvpCM;EACE,oCAAA;AP0pCR;;AOxpCM;EACE,yBAAA;AP2pCR;AO1pCQ;EACE,gCAAA;AP4pCV;;AO5qCM;EACE,oCAAA;AP+qCR;;AO7qCM;EACE,yBAAA;APgrCR;AO/qCQ;EACE,gCAAA;APirCV;;AO7qCM;EACE,oCAAA;APgrCR;;AO9qCM;EACE,yBAAA;APirCR;AOhrCQ;EACE,gCAAA;APkrCV;;AOxrCM;EACE,oCAAA;AP2rCR;;AOzrCM;EACE,yBAAA;AP4rCR;AO3rCQ;EACE,gCAAA;AP6rCV;;AOnsCM;EACE,oCAAA;APssCR;;AOpsCM;EACE,yBAAA;APusCR;AOtsCQ;EACE,gCAAA;APwsCV;;AO9sCM;EACE,oCAAA;APitCR;;AO/sCM;EACE,yBAAA;APktCR;AOjtCQ;EACE,gCAAA;APmtCV;;AOztCM;EACE,oCAAA;AP4tCR;;AO1tCM;EACE,yBAAA;AP6tCR;AO5tCQ;EACE,gCAAA;AP8tCV;;AOpuCM;EACE,oCAAA;APuuCR;;AOruCM;EACE,yBAAA;APwuCR;AOvuCQ;EACE,gCAAA;APyuCV;;AO/uCM;EACE,oCAAA;APkvCR;;AOhvCM;EACE,yBAAA;APmvCR;AOlvCQ;EACE,gCAAA;APovCV;;AO1vCM;EACE,oCAAA;AP6vCR;;AO3vCM;EACE,yBAAA;AP8vCR;AO7vCQ;EACE,gCAAA;AP+vCV;;AOrwCM;EACE,oCAAA;APwwCR;;AOtwCM;EACE,yBAAA;APywCR;AOxwCQ;EACE,gCAAA;AP0wCV;;AOhxCM;EACE,oCAAA;APmxCR;;AOjxCM;EACE,yBAAA;APoxCR;AOnxCQ;EACE,gCAAA;APqxCV;;AO3xCM;EACE,oCAAA;AP8xCR;;AO5xCM;EACE,yBAAA;AP+xCR;AO9xCQ;EACE,gCAAA;APgyCV;;AOtyCM;EACE,oCAAA;APyyCR;;AOvyCM;EACE,yBAAA;AP0yCR;AOzyCQ;EACE,gCAAA;AP2yCV;;AOjzCM;EACE,oCAAA;APozCR;;AOlzCM;EACE,yBAAA;APqzCR;AOpzCQ;EACE,gCAAA;APszCV;;AOt0CM;EACE,oCAAA;APy0CR;;AOv0CM;EACE,yBAAA;AP00CR;AOz0CQ;EACE,gCAAA;AP20CV;;AOv0CM;EACE,oCAAA;AP00CR;;AOx0CM;EACE,yBAAA;AP20CR;AO10CQ;EACE,gCAAA;AP40CV;;AOl1CM;EACE,oCAAA;APq1CR;;AOn1CM;EACE,yBAAA;APs1CR;AOr1CQ;EACE,gCAAA;APu1CV;;AO71CM;EACE,oCAAA;APg2CR;;AO91CM;EACE,yBAAA;APi2CR;AOh2CQ;EACE,gCAAA;APk2CV;;AOx2CM;EACE,oCAAA;AP22CR;;AOz2CM;EACE,yBAAA;AP42CR;AO32CQ;EACE,gCAAA;AP62CV;;AOn3CM;EACE,oCAAA;APs3CR;;AOp3CM;EACE,yBAAA;APu3CR;AOt3CQ;EACE,gCAAA;APw3CV;;AO93CM;EACE,oCAAA;APi4CR;;AO/3CM;EACE,yBAAA;APk4CR;AOj4CQ;EACE,gCAAA;APm4CV;;AOz4CM;EACE,oCAAA;AP44CR;;AO14CM;EACE,yBAAA;AP64CR;AO54CQ;EACE,gCAAA;AP84CV;;AOp5CM;EACE,oCAAA;APu5CR;;AOr5CM;EACE,yBAAA;APw5CR;AOv5CQ;EACE,gCAAA;APy5CV;;AO/5CM;EACE,oCAAA;APk6CR;;AOh6CM;EACE,yBAAA;APm6CR;AOl6CQ;EACE,gCAAA;APo6CV;;AO16CM;EACE,oCAAA;AP66CR;;AO36CM;EACE,yBAAA;AP86CR;AO76CQ;EACE,gCAAA;AP+6CV;;AOr7CM;EACE,oCAAA;APw7CR;;AOt7CM;EACE,yBAAA;APy7CR;AOx7CQ;EACE,gCAAA;AP07CV;;AOh8CM;EACE,oCAAA;APm8CR;;AOj8CM;EACE,yBAAA;APo8CR;AOn8CQ;EACE,gCAAA;APq8CV;;AO38CM;EACE,oCAAA;AP88CR;;AO58CM;EACE,yBAAA;AP+8CR;AO98CQ;EACE,gCAAA;APg9CV;;AOh+CM;EACE,oCAAA;APm+CR;;AOj+CM;EACE,yBAAA;APo+CR;AOn+CQ;EACE,gCAAA;APq+CV;;AOj+CM;EACE,oCAAA;APo+CR;;AOl+CM;EACE,yBAAA;APq+CR;AOp+CQ;EACE,gCAAA;APs+CV;;AO5+CM;EACE,oCAAA;AP++CR;;AO7+CM;EACE,yBAAA;APg/CR;AO/+CQ;EACE,gCAAA;APi/CV;;AOv/CM;EACE,oCAAA;AP0/CR;;AOx/CM;EACE,yBAAA;AP2/CR;AO1/CQ;EACE,gCAAA;AP4/CV;;AOlgDM;EACE,oCAAA;APqgDR;;AOngDM;EACE,yBAAA;APsgDR;AOrgDQ;EACE,gCAAA;APugDV;;AO7gDM;EACE,oCAAA;APghDR;;AO9gDM;EACE,yBAAA;APihDR;AOhhDQ;EACE,gCAAA;APkhDV;;AOxhDM;EACE,oCAAA;AP2hDR;;AOzhDM;EACE,yBAAA;AP4hDR;AO3hDQ;EACE,gCAAA;AP6hDV;;AOniDM;EACE,oCAAA;APsiDR;;AOpiDM;EACE,yBAAA;APuiDR;AOtiDQ;EACE,gCAAA;APwiDV;;AO9iDM;EACE,oCAAA;APijDR;;AO/iDM;EACE,yBAAA;APkjDR;AOjjDQ;EACE,gCAAA;APmjDV;;AOzjDM;EACE,oCAAA;AP4jDR;;AO1jDM;EACE,yBAAA;AP6jDR;AO5jDQ;EACE,gCAAA;AP8jDV;;AOpkDM;EACE,oCAAA;APukDR;;AOrkDM;EACE,yBAAA;APwkDR;AOvkDQ;EACE,gCAAA;APykDV;;AO/kDM;EACE,oCAAA;APklDR;;AOhlDM;EACE,yBAAA;APmlDR;AOllDQ;EACE,gCAAA;APolDV;;AO1lDM;EACE,oCAAA;AP6lDR;;AO3lDM;EACE,yBAAA;AP8lDR;AO7lDQ;EACE,gCAAA;AP+lDV;;AOrmDM;EACE,oCAAA;APwmDR;;AOtmDM;EACE,yBAAA;APymDR;AOxmDQ;EACE,gCAAA;AP0mDV;;AO1nDM;EACE,oCAAA;AP6nDR;;AO3nDM;EACE,yBAAA;AP8nDR;AO7nDQ;EACE,gCAAA;AP+nDV;;AO3nDM;EACE,oCAAA;AP8nDR;;AO5nDM;EACE,yBAAA;AP+nDR;AO9nDQ;EACE,gCAAA;APgoDV;;AOtoDM;EACE,oCAAA;APyoDR;;AOvoDM;EACE,yBAAA;AP0oDR;AOzoDQ;EACE,gCAAA;AP2oDV;;AOjpDM;EACE,oCAAA;APopDR;;AOlpDM;EACE,yBAAA;APqpDR;AOppDQ;EACE,gCAAA;APspDV;;AO5pDM;EACE,oCAAA;AP+pDR;;AO7pDM;EACE,yBAAA;APgqDR;AO/pDQ;EACE,gCAAA;APiqDV;;AOvqDM;EACE,oCAAA;AP0qDR;;AOxqDM;EACE,yBAAA;AP2qDR;AO1qDQ;EACE,gCAAA;AP4qDV;;AOlrDM;EACE,oCAAA;APqrDR;;AOnrDM;EACE,yBAAA;APsrDR;AOrrDQ;EACE,gCAAA;APurDV;;AO7rDM;EACE,oCAAA;APgsDR;;AO9rDM;EACE,yBAAA;APisDR;AOhsDQ;EACE,gCAAA;APksDV;;AOxsDM;EACE,oCAAA;AP2sDR;;AOzsDM;EACE,yBAAA;AP4sDR;AO3sDQ;EACE,gCAAA;AP6sDV;;AOntDM;EACE,oCAAA;APstDR;;AOptDM;EACE,yBAAA;APutDR;AOttDQ;EACE,gCAAA;APwtDV;;AO9tDM;EACE,oCAAA;APiuDR;;AO/tDM;EACE,yBAAA;APkuDR;AOjuDQ;EACE,gCAAA;APmuDV;;AOzuDM;EACE,oCAAA;AP4uDR;;AO1uDM;EACE,yBAAA;AP6uDR;AO5uDQ;EACE,gCAAA;AP8uDV;;AOpvDM;EACE,oCAAA;APuvDR;;AOrvDM;EACE,yBAAA;APwvDR;AOvvDQ;EACE,gCAAA;APyvDV;;AO/vDM;EACE,oCAAA;APkwDR;;AOhwDM;EACE,yBAAA;APmwDR;AOlwDQ;EACE,gCAAA;APowDV;;AOpxDM;EACE,oCAAA;APuxDR;;AOrxDM;EACE,yBAAA;APwxDR;AOvxDQ;EACE,gCAAA;APyxDV;;AOrxDM;EACE,oCAAA;APwxDR;;AOtxDM;EACE,yBAAA;APyxDR;AOxxDQ;EACE,gCAAA;AP0xDV;;AOhyDM;EACE,oCAAA;APmyDR;;AOjyDM;EACE,yBAAA;APoyDR;AOnyDQ;EACE,gCAAA;APqyDV;;AO3yDM;EACE,oCAAA;AP8yDR;;AO5yDM;EACE,yBAAA;AP+yDR;AO9yDQ;EACE,gCAAA;APgzDV;;AOtzDM;EACE,oCAAA;APyzDR;;AOvzDM;EACE,yBAAA;AP0zDR;AOzzDQ;EACE,gCAAA;AP2zDV;;AOj0DM;EACE,oCAAA;APo0DR;;AOl0DM;EACE,yBAAA;APq0DR;AOp0DQ;EACE,gCAAA;APs0DV;;AO50DM;EACE,oCAAA;AP+0DR;;AO70DM;EACE,yBAAA;APg1DR;AO/0DQ;EACE,gCAAA;APi1DV;;AOv1DM;EACE,oCAAA;AP01DR;;AOx1DM;EACE,yBAAA;AP21DR;AO11DQ;EACE,gCAAA;AP41DV;;AOl2DM;EACE,oCAAA;APq2DR;;AOn2DM;EACE,yBAAA;APs2DR;AOr2DQ;EACE,gCAAA;APu2DV;;AO72DM;EACE,oCAAA;APg3DR;;AO92DM;EACE,yBAAA;APi3DR;AOh3DQ;EACE,gCAAA;APk3DV;;AOx3DM;EACE,oCAAA;AP23DR;;AOz3DM;EACE,yBAAA;AP43DR;AO33DQ;EACE,gCAAA;AP63DV;;AOn4DM;EACE,oCAAA;APs4DR;;AOp4DM;EACE,yBAAA;APu4DR;AOt4DQ;EACE,gCAAA;APw4DV;;AO94DM;EACE,oCAAA;APi5DR;;AO/4DM;EACE,yBAAA;APk5DR;AOj5DQ;EACE,gCAAA;APm5DV;;AOz5DM;EACE,oCAAA;AP45DR;;AO15DM;EACE,yBAAA;AP65DR;AO55DQ;EACE,gCAAA;AP85DV;;AO96DM;EACE,oCAAA;APi7DR;;AO/6DM;EACE,yBAAA;APk7DR;AOj7DQ;EACE,gCAAA;APm7DV;;AO/6DM;EACE,oCAAA;APk7DR;;AOh7DM;EACE,yBAAA;APm7DR;AOl7DQ;EACE,gCAAA;APo7DV;;AO17DM;EACE,oCAAA;AP67DR;;AO37DM;EACE,yBAAA;AP87DR;AO77DQ;EACE,gCAAA;AP+7DV;;AOr8DM;EACE,oCAAA;APw8DR;;AOt8DM;EACE,yBAAA;APy8DR;AOx8DQ;EACE,gCAAA;AP08DV;;AOh9DM;EACE,oCAAA;APm9DR;;AOj9DM;EACE,yBAAA;APo9DR;AOn9DQ;EACE,gCAAA;APq9DV;;AO39DM;EACE,oCAAA;AP89DR;;AO59DM;EACE,yBAAA;AP+9DR;AO99DQ;EACE,gCAAA;APg+DV;;AOt+DM;EACE,oCAAA;APy+DR;;AOv+DM;EACE,yBAAA;AP0+DR;AOz+DQ;EACE,gCAAA;AP2+DV;;AOj/DM;EACE,oCAAA;APo/DR;;AOl/DM;EACE,yBAAA;APq/DR;AOp/DQ;EACE,gCAAA;APs/DV;;AO5/DM;EACE,oCAAA;AP+/DR;;AO7/DM;EACE,yBAAA;APggER;AO//DQ;EACE,gCAAA;APigEV;;AOvgEM;EACE,oCAAA;AP0gER;;AOxgEM;EACE,yBAAA;AP2gER;AO1gEQ;EACE,gCAAA;AP4gEV;;AOlhEM;EACE,oCAAA;APqhER;;AOnhEM;EACE,yBAAA;APshER;AOrhEQ;EACE,gCAAA;APuhEV;;AO7hEM;EACE,oCAAA;APgiER;;AO9hEM;EACE,yBAAA;APiiER;AOhiEQ;EACE,gCAAA;APkiEV;;AOxiEM;EACE,oCAAA;AP2iER;;AOziEM;EACE,yBAAA;AP4iER;AO3iEQ;EACE,gCAAA;AP6iEV;;AOnjEM;EACE,oCAAA;APsjER;;AOpjEM;EACE,yBAAA;APujER;AOtjEQ;EACE,gCAAA;APwjEV;;AOxkEM;EACE,oCAAA;AP2kER;;AOzkEM;EACE,yBAAA;AP4kER;AO3kEQ;EACE,gCAAA;AP6kEV;;AOzkEM;EACE,oCAAA;AP4kER;;AO1kEM;EACE,yBAAA;AP6kER;AO5kEQ;EACE,gCAAA;AP8kEV;;AOplEM;EACE,oCAAA;APulER;;AOrlEM;EACE,yBAAA;APwlER;AOvlEQ;EACE,gCAAA;APylEV;;AO/lEM;EACE,oCAAA;APkmER;;AOhmEM;EACE,yBAAA;APmmER;AOlmEQ;EACE,gCAAA;APomEV;;AO1mEM;EACE,oCAAA;AP6mER;;AO3mEM;EACE,yBAAA;AP8mER;AO7mEQ;EACE,gCAAA;AP+mEV;;AOrnEM;EACE,oCAAA;APwnER;;AOtnEM;EACE,yBAAA;APynER;AOxnEQ;EACE,gCAAA;AP0nEV;;AOhoEM;EACE,oCAAA;APmoER;;AOjoEM;EACE,yBAAA;APooER;AOnoEQ;EACE,gCAAA;APqoEV;;AO3oEM;EACE,oCAAA;AP8oER;;AO5oEM;EACE,yBAAA;AP+oER;AO9oEQ;EACE,gCAAA;APgpEV;;AOtpEM;EACE,oCAAA;APypER;;AOvpEM;EACE,yBAAA;AP0pER;AOzpEQ;EACE,gCAAA;AP2pEV;;AOjqEM;EACE,oCAAA;APoqER;;AOlqEM;EACE,yBAAA;APqqER;AOpqEQ;EACE,gCAAA;APsqEV;;AO5qEM;EACE,oCAAA;AP+qER;;AO7qEM;EACE,yBAAA;APgrER;AO/qEQ;EACE,gCAAA;APirEV;;AOvrEM;EACE,oCAAA;AP0rER;;AOxrEM;EACE,yBAAA;AP2rER;AO1rEQ;EACE,gCAAA;AP4rEV;;AOlsEM;EACE,oCAAA;APqsER;;AOnsEM;EACE,yBAAA;APssER;AOrsEQ;EACE,gCAAA;APusEV;;AO7sEM;EACE,oCAAA;APgtER;;AO9sEM;EACE,yBAAA;APitER;AOhtEQ;EACE,gCAAA;APktEV;;AOluEM;EACE,oCAAA;APquER;;AOnuEM;EACE,yBAAA;APsuER;AOruEQ;EACE,gCAAA;APuuEV;;AOnuEM;EACE,oCAAA;APsuER;;AOpuEM;EACE,yBAAA;APuuER;AOtuEQ;EACE,gCAAA;APwuEV;;AO9uEM;EACE,oCAAA;APivER;;AO/uEM;EACE,yBAAA;APkvER;AOjvEQ;EACE,gCAAA;APmvEV;;AOzvEM;EACE,oCAAA;AP4vER;;AO1vEM;EACE,yBAAA;AP6vER;AO5vEQ;EACE,gCAAA;AP8vEV;;AOpwEM;EACE,oCAAA;APuwER;;AOrwEM;EACE,yBAAA;APwwER;AOvwEQ;EACE,gCAAA;APywEV;;AO/wEM;EACE,oCAAA;APkxER;;AOhxEM;EACE,yBAAA;APmxER;AOlxEQ;EACE,gCAAA;APoxEV;;AO1xEM;EACE,oCAAA;AP6xER;;AO3xEM;EACE,yBAAA;AP8xER;AO7xEQ;EACE,gCAAA;AP+xEV;;AOryEM;EACE,oCAAA;APwyER;;AOtyEM;EACE,yBAAA;APyyER;AOxyEQ;EACE,gCAAA;AP0yEV;;AOhzEM;EACE,oCAAA;APmzER;;AOjzEM;EACE,yBAAA;APozER;AOnzEQ;EACE,gCAAA;APqzEV;;AO3zEM;EACE,oCAAA;AP8zER;;AO5zEM;EACE,yBAAA;AP+zER;AO9zEQ;EACE,gCAAA;APg0EV;;AOt0EM;EACE,oCAAA;APy0ER;;AOv0EM;EACE,yBAAA;AP00ER;AOz0EQ;EACE,gCAAA;AP20EV;;AOj1EM;EACE,oCAAA;APo1ER;;AOl1EM;EACE,yBAAA;APq1ER;AOp1EQ;EACE,gCAAA;APs1EV;;AO51EM;EACE,oCAAA;AP+1ER;;AO71EM;EACE,yBAAA;APg2ER;AO/1EQ;EACE,gCAAA;APi2EV;;AOv2EM;EACE,oCAAA;AP02ER;;AOx2EM;EACE,yBAAA;AP22ER;AO12EQ;EACE,gCAAA;AP42EV;;AO53EM;EACE,oCAAA;AP+3ER;;AO73EM;EACE,yBAAA;APg4ER;AO/3EQ;EACE,gCAAA;APi4EV;;AO73EM;EACE,oCAAA;APg4ER;;AO93EM;EACE,yBAAA;APi4ER;AOh4EQ;EACE,gCAAA;APk4EV;;AOx4EM;EACE,oCAAA;AP24ER;;AOz4EM;EACE,yBAAA;AP44ER;AO34EQ;EACE,gCAAA;AP64EV;;AOn5EM;EACE,oCAAA;APs5ER;;AOp5EM;EACE,yBAAA;APu5ER;AOt5EQ;EACE,gCAAA;APw5EV;;AO95EM;EACE,oCAAA;APi6ER;;AO/5EM;EACE,yBAAA;APk6ER;AOj6EQ;EACE,gCAAA;APm6EV;;AOz6EM;EACE,oCAAA;AP46ER;;AO16EM;EACE,yBAAA;AP66ER;AO56EQ;EACE,gCAAA;AP86EV;;AOp7EM;EACE,oCAAA;APu7ER;;AOr7EM;EACE,yBAAA;APw7ER;AOv7EQ;EACE,gCAAA;APy7EV;;AO/7EM;EACE,oCAAA;APk8ER;;AOh8EM;EACE,yBAAA;APm8ER;AOl8EQ;EACE,gCAAA;APo8EV;;AO18EM;EACE,oCAAA;AP68ER;;AO38EM;EACE,yBAAA;AP88ER;AO78EQ;EACE,gCAAA;AP+8EV;;AOr9EM;EACE,oCAAA;APw9ER;;AOt9EM;EACE,yBAAA;APy9ER;AOx9EQ;EACE,gCAAA;AP09EV;;AOh+EM;EACE,oCAAA;APm+ER;;AOj+EM;EACE,yBAAA;APo+ER;AOn+EQ;EACE,gCAAA;APq+EV;;AO3+EM;EACE,oCAAA;AP8+ER;;AO5+EM;EACE,yBAAA;AP++ER;AO9+EQ;EACE,gCAAA;APg/EV;;AOt/EM;EACE,oCAAA;APy/ER;;AOv/EM;EACE,yBAAA;AP0/ER;AOz/EQ;EACE,gCAAA;AP2/EV;;AOjgFM;EACE,oCAAA;APogFR;;AOlgFM;EACE,yBAAA;APqgFR;AOpgFQ;EACE,gCAAA;APsgFV;;AOthFM;EACE,oCAAA;APyhFR;;AOvhFM;EACE,yBAAA;AP0hFR;AOzhFQ;EACE,gCAAA;AP2hFV;;AOvhFM;EACE,oCAAA;AP0hFR;;AOxhFM;EACE,yBAAA;AP2hFR;AO1hFQ;EACE,gCAAA;AP4hFV;;AOliFM;EACE,oCAAA;APqiFR;;AOniFM;EACE,yBAAA;APsiFR;AOriFQ;EACE,gCAAA;APuiFV;;AO7iFM;EACE,oCAAA;APgjFR;;AO9iFM;EACE,yBAAA;APijFR;AOhjFQ;EACE,gCAAA;APkjFV;;AOxjFM;EACE,oCAAA;AP2jFR;;AOzjFM;EACE,yBAAA;AP4jFR;AO3jFQ;EACE,gCAAA;AP6jFV;;AOnkFM;EACE,oCAAA;APskFR;;AOpkFM;EACE,yBAAA;APukFR;AOtkFQ;EACE,gCAAA;APwkFV;;AO9kFM;EACE,oCAAA;APilFR;;AO/kFM;EACE,yBAAA;APklFR;AOjlFQ;EACE,gCAAA;APmlFV;;AOzlFM;EACE,oCAAA;AP4lFR;;AO1lFM;EACE,yBAAA;AP6lFR;AO5lFQ;EACE,gCAAA;AP8lFV;;AOpmFM;EACE,oCAAA;APumFR;;AOrmFM;EACE,yBAAA;APwmFR;AOvmFQ;EACE,gCAAA;APymFV;;AO/mFM;EACE,oCAAA;APknFR;;AOhnFM;EACE,yBAAA;APmnFR;AOlnFQ;EACE,gCAAA;APonFV;;AO1nFM;EACE,oCAAA;AP6nFR;;AO3nFM;EACE,yBAAA;AP8nFR;AO7nFQ;EACE,gCAAA;AP+nFV;;AOroFM;EACE,oCAAA;APwoFR;;AOtoFM;EACE,yBAAA;APyoFR;AOxoFQ;EACE,gCAAA;AP0oFV;;AOhpFM;EACE,oCAAA;APmpFR;;AOjpFM;EACE,yBAAA;APopFR;AOnpFQ;EACE,gCAAA;APqpFV;;AO3pFM;EACE,oCAAA;AP8pFR;;AO5pFM;EACE,yBAAA;AP+pFR;AO9pFQ;EACE,gCAAA;APgqFV;;AOhrFM;EACE,oCAAA;APmrFR;;AOjrFM;EACE,yBAAA;APorFR;AOnrFQ;EACE,gCAAA;APqrFV;;AOjrFM;EACE,oCAAA;APorFR;;AOlrFM;EACE,yBAAA;APqrFR;AOprFQ;EACE,gCAAA;APsrFV;;AO5rFM;EACE,oCAAA;AP+rFR;;AO7rFM;EACE,yBAAA;APgsFR;AO/rFQ;EACE,gCAAA;APisFV;;AOvsFM;EACE,oCAAA;AP0sFR;;AOxsFM;EACE,yBAAA;AP2sFR;AO1sFQ;EACE,gCAAA;AP4sFV;;AOltFM;EACE,oCAAA;APqtFR;;AOntFM;EACE,yBAAA;APstFR;AOrtFQ;EACE,gCAAA;APutFV;;AO7tFM;EACE,oCAAA;APguFR;;AO9tFM;EACE,yBAAA;APiuFR;AOhuFQ;EACE,gCAAA;APkuFV;;AOxuFM;EACE,oCAAA;AP2uFR;;AOzuFM;EACE,yBAAA;AP4uFR;AO3uFQ;EACE,gCAAA;AP6uFV;;AOnvFM;EACE,oCAAA;APsvFR;;AOpvFM;EACE,yBAAA;APuvFR;AOtvFQ;EACE,gCAAA;APwvFV;;AO9vFM;EACE,oCAAA;APiwFR;;AO/vFM;EACE,yBAAA;APkwFR;AOjwFQ;EACE,gCAAA;APmwFV;;AOzwFM;EACE,oCAAA;AP4wFR;;AO1wFM;EACE,yBAAA;AP6wFR;AO5wFQ;EACE,gCAAA;AP8wFV;;AO9xFM;EACE,oCAAA;APiyFR;;AO/xFM;EACE,yBAAA;APkyFR;AOjyFQ;EACE,gCAAA;APmyFV;;AO/xFM;EACE,oCAAA;APkyFR;;AOhyFM;EACE,yBAAA;APmyFR;AOlyFQ;EACE,gCAAA;APoyFV;;AO1yFM;EACE,oCAAA;AP6yFR;;AO3yFM;EACE,yBAAA;AP8yFR;AO7yFQ;EACE,gCAAA;AP+yFV;;AOrzFM;EACE,oCAAA;APwzFR;;AOtzFM;EACE,yBAAA;APyzFR;AOxzFQ;EACE,gCAAA;AP0zFV;;AOh0FM;EACE,oCAAA;APm0FR;;AOj0FM;EACE,yBAAA;APo0FR;AOn0FQ;EACE,gCAAA;APq0FV;;AO30FM;EACE,oCAAA;AP80FR;;AO50FM;EACE,yBAAA;AP+0FR;AO90FQ;EACE,gCAAA;APg1FV;;AOt1FM;EACE,oCAAA;APy1FR;;AOv1FM;EACE,yBAAA;AP01FR;AOz1FQ;EACE,gCAAA;AP21FV;;AOj2FM;EACE,oCAAA;APo2FR;;AOl2FM;EACE,yBAAA;APq2FR;AOp2FQ;EACE,gCAAA;APs2FV;;AO52FM;EACE,oCAAA;AP+2FR;;AO72FM;EACE,yBAAA;APg3FR;AO/2FQ;EACE,gCAAA;APi3FV;;AOv3FM;EACE,oCAAA;AP03FR;;AOx3FM;EACE,yBAAA;AP23FR;AO13FQ;EACE,gCAAA;AP43FV;;AO54FM;EACE,oCAAA;AP+4FR;;AO74FM;EACE,yBAAA;APg5FR;AO/4FQ;EACE,gCAAA;APi5FV;;AO74FM;EACE,oCAAA;APg5FR;;AO94FM;EACE,yBAAA;APi5FR;AOh5FQ;EACE,gCAAA;APk5FV;;AOx5FM;EACE,oCAAA;AP25FR;;AOz5FM;EACE,yBAAA;AP45FR;AO35FQ;EACE,gCAAA;AP65FV;;AOn6FM;EACE,oCAAA;APs6FR;;AOp6FM;EACE,yBAAA;APu6FR;AOt6FQ;EACE,gCAAA;APw6FV;;AO96FM;EACE,oCAAA;APi7FR;;AO/6FM;EACE,yBAAA;APk7FR;AOj7FQ;EACE,gCAAA;APm7FV;;AOz7FM;EACE,oCAAA;AP47FR;;AO17FM;EACE,yBAAA;AP67FR;AO57FQ;EACE,gCAAA;AP87FV;;AOp8FM;EACE,oCAAA;APu8FR;;AOr8FM;EACE,yBAAA;APw8FR;AOv8FQ;EACE,gCAAA;APy8FV;;AO/8FM;EACE,oCAAA;APk9FR;;AOh9FM;EACE,yBAAA;APm9FR;AOl9FQ;EACE,gCAAA;APo9FV;;AO19FM;EACE,oCAAA;AP69FR;;AO39FM;EACE,yBAAA;AP89FR;AO79FQ;EACE,gCAAA;AP+9FV;;AOr+FM;EACE,oCAAA;APw+FR;;AOt+FM;EACE,yBAAA;APy+FR;AOx+FQ;EACE,gCAAA;AP0+FV;;AOj+FE;EACE,oCAAA;APo+FJ;;AOl+FE;EACE,yBAAA;APq+FJ;AOp+FI;EACE,gCAAA;APs+FN;;AO5+FE;EACE,oCAAA;AP++FJ;;AO7+FE;EACE,yBAAA;APg/FJ;AO/+FI;EACE,gCAAA;APi/FN;;AOv/FE;EACE,wCAAA;AP0/FJ;;AOx/FE;EACE,6BAAA;AP2/FJ;AO1/FI;EACE,oCAAA;AP4/FN;;AQ94GA,mBAAA;AAEA;EACE;IACE,kCAAA;IACA,UAAA;IACA,yDAAA;ERg5GF;EQ94GA;IACE,kCAAA;IACA,wDAAA;ERg5GF;EQ94GA;IACE,UAAA;IACA,wDAAA;ERg5GF;EQ94GA;IACE,wDAAA;ERg5GF;EQ94GA;IACE,gCAAA;ERg5GF;AACF;AQ74GA;EACE;IACE,kCAAA;IACA,UAAA;IACA,yDAAA;ER+4GF;EQ74GA;IACE,kCAAA;IACA,wDAAA;ER+4GF;EQ74GA;IACE,UAAA;IACA,wDAAA;ER+4GF;EQ74GA;IACE,wDAAA;ER+4GF;EQ74GA;IACE,gCAAA;ER+4GF;AACF;AQ54GA;EACE,0BAAA;EACA,4BAAA;AR84GF;;AQ34GA;EACE;IACE,oBAAA;IACA,8BAAA;ER84GF;EQ54GA;IACE,UAAA;IACA,oBAAA;IACA,8BAAA;ER84GF;AACF;AQ34GA;EACE;IACE,oBAAA;IACA,8BAAA;ER64GF;EQ34GA;IACE,UAAA;IACA,oBAAA;IACA,8BAAA;ER64GF;AACF;AQ14GA;EACE,2BAAA;EACA,4BAAA;AR44GF;;AQz4GA;EACE;IACE,UAAA;IACA,qCAAA;ER44GF;EQ14GA;IACE,UAAA;IACA,eAAA;ER44GF;AACF;AQz4GA;EACE;IACE,UAAA;IACA,qCAAA;ER24GF;EQz4GA;IACE,UAAA;IACA,eAAA;ER24GF;AACF;AQx4GA;EACE,+BAAA;AR04GF;;AQv4GA;EACE;IACE,UAAA;IACA,sCAAA;ER04GF;EQx4GA;IACE,UAAA;IACA,eAAA;ER04GF;AACF;AQv4GA;EACE;IACE,UAAA;IACA,sCAAA;ERy4GF;EQv4GA;IACE,UAAA;IACA,eAAA;ERy4GF;AACF;AQt4GA;EACE,8BAAA;ARw4GF;;AQr4GA;EACE;IACE,qCAAA;ERw4GF;EQt4GA;IACE,eAAA;ERw4GF;AACF;AQr4GA;EACE;IACE,qCAAA;ERu4GF;EQr4GA;IACE,eAAA;ERu4GF;AACF;AQp4GA;EACE,gCAAA;ARs4GF;;AQn4GA;EACE;IACE,sCAAA;ERs4GF;EQp4GA;IACE,eAAA;ERs4GF;AACF;AQn4GA;EACE;IACE,sCAAA;ERq4GF;EQn4GA;IACE,eAAA;ERq4GF;AACF;AQl4GA;EACE,+BAAA;ARo4GF;;AQj4GA;EACE;IACE,oCAAA;ERo4GF;EQl4GA;IACE,eAAA;ERo4GF;AACF;AQj4GA;EACE;IACE,oCAAA;ERm4GF;EQj4GA;IACE,eAAA;ERm4GF;AACF;AQh4GA;EACE,6BAAA;ARk4GF;;AQ/3GA,sBAAA;AACA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,sBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,sBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,sBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,wBAAA;ARk4GF;;AQ/3GA;EACE,sBAAA;ARk4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,mBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,mBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,mBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,mBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,qBAAA;ARg4GF;;AQ73GA;EACE,mBAAA;ARg4GF;;AS96HA;+EAAA;ACAA,cAAA;AAEA;EACE,YAAA;AVk7HF;;AU/6HA;EAEI,iCPQqB;EOPrB,ePWa;EOVb,gBLsR0B;EKpR5B,cPmFW;EOlFX,sBPiFQ;EOhFR,YAAA;EACA,gBAAA;AVg7HF;;AU76HA;EACE,uBAAA;EACA,4BAAA;AVg7HF;;AU76HA;EACE,wBAAA;EACA,8BAAA;AVg7HF;;AU76HA;EN1BE,gEM2BA;EN1BA,6DM0BA;ENzBA,2DMyBA;ENxBA,wDMwBA;AVm7HF;;AUh7HA;EACE,wBAAA;AVm7HF;;AUh7HA;EACE,oCAAA;EACA,qCAAA;AVm7HF;;AU56HA;EACE,oBAAA;AV+6HF;;AU56HA;EACE,gCAAA;AV+6HF;;AU56HA;EACE,2BAAA;AV+6HF;;AU56HA;EACE,WAAA;AV+6HF;;AU54HA;EACE,gCAAA;AV+4HF;;AU54HA;EACE,8BAAA;AV+4HF;AU94HE;EACE,cAAA;AVg5HJ;;AU54HA;EACE,wBAAA;AV+4HF;;AU54HA;EACE,wBAAA;AV+4HF;;AU54HA;EACE,wBAAA;AV+4HF;;AU54HA;EACE,wBAAA;AV+4HF;;AU54HA;EACE,2BAAA;AV+4HF;;AU54HA;EACE,4BAAA;AV+4HF;;AU54HA;EACE,qBAAA;EACA,cPxEY;EOyEZ,0BAAA;AV+4HF;AU94HE;EACE,gBAAA;EACA,0CAAA;EACA,cP7EU;EO8EV,gBAAA;EACA,eAAA;EACA,sBAAA;AVg5HJ;AU74HE;EAEE,qBAAA;AV84HJ;;AU14HA;EACE,mBPlBoB;AH+5HtB;;AU14HA;EACE,mBPrBkB;AHk6HpB;;AU14HA;EACE,mBPxBkB;AHq6HpB;;AU14HA;EACE,mBAAA;AV64HF;AU34HE;EACE,0BAAA;EACA,gBAAA;AV64HJ;AU14HE;EACE,UAAA;EACA,6BAAA;EACA,gBAAA;AV44HJ;AUz4HE;EAdF;IAeI,mBAAA;EV44HF;AACF;;AUz4HA;EACE,eP/Je;EOgKf,cLxKS;EKyKT,gBAAA;AV44HF;AU34HE;EACE,8BAAA;AV64HJ;;AUz4HA;EACE,gBAAA;AV44HF;AU34HE;EACE,kBAAA;AV64HJ;AU54HI;EACE,kBAAA;AV84HN;;AUx4HA;ENpME,mCMqMA;ENpMA,gCMoMA;ENnMA,8BMmMA;ENlMA,2BMkMA;AV84HF;;AU34HA;ENxME,mDMyMA;ENxMA,gDMwMA;ENvMA,8CMuMA;ENtMA,2CMsMA;AVi5HF;;AU94HA;EN5ME,mDM6MA;EN5MA,gDM4MA;EN3MA,8CM2MA;EN1MA,2CM0MA;AVo5HF;;AUj5HA;ENhNE,qDMiNA;ENhNA,kDMgNA;EN/MA,gDM+MA;EN9MA,6CM8MA;AVu5HF;;AUp5HA;ENpNE,mDMqNA;ENpNA,gDMoNA;ENnNA,8CMmNA;ENlNA,2CMkNA;AV05HF;;AUv5HA;ENxNE,kDMyNA;ENxNA,+CMwNA;ENvNA,6CMuNA;ENtNA,0CMsNA;AV65HF;;AUz5HE;EACE,cAAA;AV45HJ;;AUv5HA;EACE,mBAAA;AV05HF;AUz5HE;EACE,gCAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AV25HJ;;AUv5HA;EACE,oCAAA;AV05HF;;AUv5HA;EACE,iBAAA;AV05HF;;AUl5HM;EACE,gCAAA;AVq5HR;;AUt5HM;EACE,gCAAA;AVy5HR;;AU15HM;EACE,gCAAA;AV65HR;;AU95HM;EACE,gCAAA;AVi6HR;;AUl6HM;EACE,gCAAA;AVq6HR;;AUt6HM;EACE,gCAAA;AVy6HR;;AU16HM;EACE,gCAAA;AV66HR;;AU96HM;EACE,gCAAA;AVi7HR;;AUl7HM;EACE,gCAAA;AVq7HR;;AUt7HM;EACE,gCAAA;AVy7HR;;AU17HM;EACE,gCAAA;AV67HR;;AU97HM;EACE,gCAAA;AVi8HR;;AUl8HM;EACE,gCAAA;AVq8HR;;AUt8HM;EACE,gCAAA;AVy8HR;;AU18HM;EACE,gCAAA;AV68HR;;AU98HM;EACE,gCAAA;AVi9HR;;AUl9HM;EACE,gCAAA;AVq9HR;;AUt9HM;EACE,gCAAA;AVy9HR;;AU19HM;EACE,gCAAA;AV69HR;;AU99HM;EACE,gCAAA;AVi+HR;;AUz9HA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AV49HF;AU19HE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,oCAAA;EACA,gCAAA;AV49HJ;AUz9HE;EACE,WAAA;EACA,YAAA;AV29HJ;;AU16HA;EACE,eAAA;AV66HF;;AU16HA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,cLxUS;ALqvIX;AU36HE;EACE,cAAA;AV66HJ;;AUz6HA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AV46HF;;AUz6HA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AV46HF;;AUz6HA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AV46HF;;AU16HA;EACE,4CAAA;EACA,oCAAA;AV66HF;;AU16HA;EACE,gBAAA;AV66HF;;AU16HA;EACE,eAAA;EACA,iBAAA;EN7RE,kBDzDY;EOwVd,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AV66HF;;AU16HA;EACE,gCAAA;AV66HF;;AU16HA;EACE,iBAAA;EACA,kBAAA;AV66HF;AU36HE;EACE,iBAAA;EACA,kBAAA;AV66HJ;;AUz6HA;EACE,0BAAA;AV46HF;;AUz6HA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AV46HF;;AUz6HA;EACE,wBAAA;EACA,WAAA;EACA,YAAA;AV46HF;;AUz6HA;EACE,kBAAA;EACA,oEAAA;EACA,yBAAA;AV46HF;;AUz6HA;EACE,yBAAA;EACA,WAAA;AV46HF;;AUz6HA;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AV46HF;;AUz6HA;EACE,sBAAA;EACA,cAAA;EACA,yBAAA;AV46HF;;AUz6HA;EACE,aAAA;AV46HF;;AUx6HA;EACE,aAAA;AV26HF;;AUp6HA;EACE,2DAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AVu6HF;;AUr6HA;EACE,yBAAA;EACA,qBAAA;AVw6HF;;AUt6HA;EACE,yBAAA;EACA,qBAAA;AVy6HF;;AUv6HA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,2DAAA;AV06HF;;AUx6HA;EACE,sBAAA;AV26HF;;AUz6HA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AV46HF;;AU16HA;EACE,UAAA;AV66HF;;AU36HA;EACE,eAAA;AV86HF;;AU56HA;EACE,sBAAA;AV+6HF;;AU76HA;EACE,4BAAA;EACA,6BAAA;AVg7HF;;AU96HA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;AVi7HF;;AUh7HC;EACC,kBAAA;AVm7HF;;AUj7HA;EACE,kBAAA;EACA,oBAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,+EAAA;AVo7HF;;AUl7HA;EACE,cAAA;AVq7HF;;AUn7HA;EACE,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,2DAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AVs7HF;;AUp7HA;EACE,yBAAA;AVu7HF;;AUr7HA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AVw7HF;;AUt7HA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AVy7HF;;AUv7HA;EACE,cAAA;AV07HF;;AUx7HA;EACE,cAAA;AV27HF;;AUz7HA;EACE,cAAA;AV47HF;;AU17HA;EACE,cAAA;AV67HF;;AU37HA;EACE,cAAA;AV87HF;;AU57HA;EACE,8BAAA;AV+7HF;;AU77HA;EACE,aAAA;EACA,qCAAA;AVg8HF;;AU97HA;EAAkB,YAAA;AVk8HlB;;AUl8H8B;EAC5B,eAAA;AVq8HF;;AUn8HA;EACE,gCAAA;AVs8HF;;AUp8HA;EACE,gCAAA;AVu8HF;;AUr8HA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;AVw8HF;;AUt8HA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;AVy8HF;;AUv8HA;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AV08HF;;AUx8HA;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AV28HF;;AUz8HA;EACE,gBAAA;AV48HF;;AU18HA;EACE,gBAAA;AV68HF;;AU38HA;EACE,gBAAA;AV88HF;;AU58HA;EACE,mBAAA;AV+8HF;;AU78HA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,2DAAA;AVg9HF;;AU98HA;EACE,UAAA;AVi9HF;;AU/8HA;EACE,kBAAA;EACA,2DAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AVk9HF;;AUh9HA;EACE,gBAAA;EACA,cAAA;EACA,UAAA;AVm9HF;;AUj9HA;EACE,gBAAA;EACA,eAAA;EACA,2DAAA;AVo9HF;;AUl9HA;EACE,eAAA;AVq9HF;;AUn9HA;EACE;IACE,WAAA;IAAW,WAAA;EVu9Hb;EUr9HA;IACE,UAAA;EVu9HF;EUr9HA;IACE,WAAA;EVu9HF;AACF;AUr9HA;EACE,wBAAA;EACA,qBAAA;AVu9HF;;AUr9HA;EACE,2DAAA;AVw9HF;;AUt9HA;EACE,oBAAA;EACA,6CAAA;AVy9HF;;AUt9HA;EACE,6BAAA;AVy9HF;;AUv9HA;EACE,2BAAA;AV09HF;;AUx9HA;EACE,2BAAA;EACA,6CAAA;AV29HF;;AUz9HA;EACE,sBAAA;AV49HF;;AU19HA;EACE,sBAAA;AV69HF;;AU39HA;EACE,oBAAA;AV89HF;;AU59HA;EACE,oBAAA;AV+9HF;;AU79HA;EACE,oBAAA;AVg+HF;;AU99HA;EACE,0BAAA;AVi+HF;;AU/9HA;EACE,yBAAA;EACA,2BAAA;EACA,0BAAA;AVk+HF;;AUh+HA;EACE,sBAAA;EACA,oBAAA;AVm+HF;;AUj+HA;EACE,sBAAA;EACA,yBAAA;EACA,6BAAA;AVo+HF;;AUl+HA;EACE,0BAAA;AVq+HF;;AUn+HA;EACE,2BAAA;AVs+HF;;AUp+HA;EACE,sBAAA;EACA,oBAAA;AVu+HF;;AUr+HA;EACE,oBAAA;EACA,2BAAA;AVw+HF;;AUj2HA,wCAAA;;AAGA,gFAAA;AACA;EACE,8BAAA;EACA,qCAAA;EACA,uBAAA;AVm2HF;;AUh2HA,iEAAA;AACA;EACE,8BAAA;EACA,qCAAA;EACA,uBAAA;AVm2HF;;AUh2HA,oEAAA;AACA;EACE,uBAAA;AVm2HF;;AUh2HA,kEAAA;AACA,0EAAA;AACA;;EAEE,8BAAA;AVm2HF;;AU/1HA;EACE,2CAAA;EACA,sCAAA;AVk2HF;;AU/1HA;EACE,eAAA;AVk2HF;;AU/1HA;EACE,uBAAA;AVk2HF;;AU/1HA;EACE,yBAAA;AVk2HF;;AU/1HA;EACE,yBAAA;AVk2HF;;AU/1HA;EACE,yBAAA;EACA,sBAAA;AVk2HF;;AU/1HA;EACE,0BAAA;EACA,yBAAA;EACA,oCAAA;EACA,2BAAA;EACA,iCAAA;EACA,mCAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,sCAAA;AVk2HF;;AU/1HA;EACE,oCAAA;EACA,iCAAA;AVk2HF;;AU/1HA;EACE,yBAAA;AVk2HF;;AU/1HA;EACI,wBAAA;EACA,8BAAA;EACA,yCAAA;AVk2HJ;;AU/1HA;EACE,0BAAA;AVk2HF;;AU/1HA;EACE,6BAAA;AVk2HF;;AU71HA;;;EAGI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AVg2HJ;;AU71HA;EACI,wBAAA;AVg2HJ;;AU71HA;EACI,UAAA;AVg2HJ;;AU71HA;EACI,UAAA;AVg2HJ;;AU71HA;EACI,UAAA;AVg2HJ;;AU71HA;EAEI,qBAAA;EACA,cAAA;AV+1HJ;;AU71HA;EACI,cAAA;EACA,qBAAA;EACA,cAAA;AVg2HJ;;AU71HA;EACI,cAAA;EACA,qBAAA;EACA,aAAA;AVg2HJ;;AU71HA;EACI,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AVg2HJ;;AU71HA;EACI,aAAA;AVg2HJ;;AU71HA;EACI,aAAA;AVg2HJ;;AU31HA;EACI,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;AV81HJ;;AU31HA;EACI,cAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;AV81HJ;;AU31HA;EACI,aAAA;AV81HJ;;AU31HA;;;EAGI,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;EACA,qBAAA;AV61HJ;;AU11HA;;;EAGI,eAAA;EACA,YAAA;AV61HJ;;AU11HA;EACI,qBAAA;EACA,qBAAA;AV61HJ;;AU11HA;EACI,cAAA;EACA,eAAA;EACA,mBAAA;AV61HJ;;AU11HA;EACE,iBAAA;AV61HF;;AU11HA;EACE,iBAAA;AV61HF;;AWj8JA,oBAAA;AACA;;EAEE,gBR8BqB;EQ7BrB,gBAAA;EACA,cR8Be;AHs6JjB;;AWj8JA;EACE,eRea;EQdb,kCAAA;AXo8JF;;AWj8JA;EACE,eRWa;EQVb,kCAAA;AXo8JF;;AWj8JA;EACE,eROa;AH67Jf;;AWj8JA;EACE,eRIa;AHg8Jf;;AWj8JA;EACE,eRCa;AHm8Jf;;AWj8JA;EACE,eRFa;AHs8Jf;;AWj8JA;EACE,wCAAA;AXo8JF;;AWj8JA;EACE;IACE,eRfW;IQgBX,kCAAA;EXo8JF;EWj8JA;IACE,eRnBW;IQoBX,kCAAA;EXm8JF;EWh8JA;IACE,eRvBW;EHy9Jb;AACF;AW/7JA;EACE,gBAAA;AXi8JF;AWh8JE;EACE,kBRuBc;EQtBd,gCAAA;EACA,kBAAA;EACA,mBAAA;AXk8JJ;AWh8JI;EACE,qBAAA;AXk8JN;AW/7JI;EACE,kBAAA;AXi8JN;AW37JI;EACE,qBAAA;AX67JN;AW37JM;EACE,yBNnEG;ALggKX;;AY1gKA;+EAAA;ACAA,oBAAA;AAEA;;EAEE,aAAA;EACA,WAAA;EACA,YAAA;Ab8gKF;;Aa3gKA;EToDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aSvDsB;ETwDtB,2BSxD4B;ETyD5B,uBSzD4B;ET0D5B,mBS1D4B;ET2D5B,yBS3DiC;ET4DjC,qBS5DiC;ET6DjC,iBS7DiC;EACjC,WAAA;AbwhKF;;AarhKA;ET+CE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aSlDsB;ETmDtB,8BSnD4B;EToD5B,0BSpD4B;ETqD5B,sBSrD4B;ETsD5B,yBStDoC;ETuDpC,qBSvDoC;ETwDpC,iBSxDoC;EACpC,YVwGe;EUvGf,gBVuGe;EUtGf,gBVsGe;AH47JjB;;Aa/hKA;ETwCE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aS3CsB;ET4CtB,8BS5C4B;ET6C5B,0BS7C4B;ET8C5B,sBS9C4B;ET+C5B,yBS/CoC;ETgDpC,qBShDoC;ETiDpC,iBSjDoC;EACpC,WAAA;EACA,gBAAA;EACA,kBAAA;Ab4iKF;;AaziKA;EACE,gBV+Fe;EU9Ff,WAAA;EACA,kBAAA;Ab4iKF;;AaziKA;EACE,OAAA;ET0BA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aS7BsB;ET8BtB,8BS9B4B;ET+B5B,0BS/B4B;ETgC5B,sBShC4B;ETiC5B,yBSjCoC;ETkCpC,qBSlCoC;ETmCpC,iBSnCoC;EACpC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AbsjKF;;AajjKI;EACE,sBAAA;ETTJ,kESUI;ETTJ,6DSSI;ETRJ,0DSQI;AbsjKN;AajjKI;EACE,sBAAA;EThBJ,kESiBI;EThBJ,6DSgBI;ETfJ,0DSeI;AbqjKN;AaljKI;EACE,kBAAA;AbojKN;Aa/iKI;EACE,sBAAA;ET3BJ,kES4BI;ET3BJ,6DS2BI;ET1BJ,0DS0BI;AbmjKN;AahjKI;EACE,WVoDc;EUnDd,eVmDc;EUlDd,eVkDc;AHggKpB;;AcznKA,iBAAA;AAEA;EACE,YXqHe;EWpHf,oCAAA;EACA,yBAAA;EACA,0CAAA;EACA,wBAAA;EACA,YAAA;Ad2nKF;AcznKE;EACE,oEXsDgB;EWrDhB,6BAAA;Ad2nKJ;AcxnKE;EACE,6BAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;Ad0nKJ;ActnKI;EACE,cXkCQ;EWjCR,eAAA;EACA,eXNW;EWOX,gBAAA;EACA,mBAAA;AdwnKN;;AclnKE;EACE,eAAA;AdqnKJ;;AcjnKA,gBAAA;AACA;EACE,kBAAA;EACA,eXtBe;EWuBf,6BAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AdonKF;;AcjnKA;EACE,kBAAA;EACA,kBAAA;AdonKF;;AchnKE;EACE,gBAAA;AdmnKJ;AcjnKE;EACE,aAAA;AdmnKJ;AcjnKE;EACE,cAAA;AdmnKJ;Ac/mKI;EACE,cAAA;AdinKN;;Ac5mKA;EACE,cXVmB;EWWnB,cAAA;EACA,eAAA;EACA,gBAAA;EAEA,qBAAA;EViBE,gBUhBqB;Ad8mKzB;Ac5mKE;EACE,gBAAA;EACA,oBAAA;Ad8mKJ;;AczmKE;EACE,cX1BiB;EW2BjB,iBAAA;EACA,eAAA;EACA,yBAAA;Ad4mKJ;Ac1mKI;EACE,gBAAA;Ad4mKN;;AcvmKA;;;;EAIE,cX/CY;AHypKd;;AcvmKA;EACE,kBAAA;EACA,kCAAA;Ad0mKF;;AcvmKA;EACE,yBAAA;Ad0mKF;;AcvmKA;;EAEE,cX7DY;AHuqKd;;AcvmKA;EACE,kBAAA;EACA,eAAA;Ad0mKF;;AcvmKA;EACE,6BAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;Ad0mKF;;AcvmKA;EACE,0BAAA;Ad0mKF;;AcvmKA;EACE,kBAAA;Ad0mKF;;AcvmKA;EACE,kBAAA;Ad0mKF;;AcvmKA;EACE,mBAAA;Ad0mKF;;AcvmKA;EACE,cXxFmB;EWyFnB,gBAAA;EACA,qBAAA;EACA,YAAA;EAEE,0CAAA;EACA,eAAA;EAEF,iBAAA;EACA,kBAAA;EV5HA,yCU6HA;EV5HA,oCU4HA;EV3HA,iCU2HA;EACA,mBAAA;Ad0mKF;;AcxmKA;EACE,aAAA;Ad2mKF;;AcxmKA;;;;EAIE,6BAAA;EACA,cXpHY;AH+tKd;;AcxmKA;;EVtIE,gCAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;AJmvKF;;Ac3mKA;EACE,gBAAA;EACA,iBAAA;EACA,yBX/HY;EWgIZ,WTnLS;EDyFP,kBDzDY;EWqJd,qBAAA;Ad8mKF;;Ac3mKA;;;;;EAKE,cX1IY;AHwvKd;;Ac1mKE;EVnKA,wCUoKE;EVnKF,mCUmKE;EVlKF,gCUkKE;EACA,WXjFgB;AHgsKpB;Ac7mKI;EAEE,aAAA;Ad8mKN;Ac3mKI;EACE,wBAAA;Ad6mKN;Ac1mKI;EACE,wBAAA;Ad4mKN;AczmKI;EACE,kBAAA;Ad2mKN;Ac1mKM;EACE,eAAA;Ad4mKR;AczmKM;EACE,gBAAA;Ad2mKR;ActmKM;EACE,kBAAA;AdwmKR;ActmKM;EACE,kBAAA;AdwmKR;AcnmKM;EACE,aAAA;AdqmKR;AcjmKI;EACE,aAAA;AdmmKN;;Ac7lKE;EACE,YXnIa;AHmuKjB;Ac9lKI;EACE,gCAAA;AdgmKN;Ac7lKI;EACE,wBAAA;Ad+lKN;Ac5lKI;EACE,yBAAA;Ad8lKN;Ac3lKI;EACE,wBAAA;Ad6lKN;AczlKM;EACE,gBAAA;Ad2lKR;Ac1lKQ;EACE,kBAAA;Ad4lKV;AczlKQ;EACE,kBAAA;Ad2lKV;AcxlKQ;EACE,iBAAA;Ad0lKV;ActlKM;EACE,0BAAA;AdwlKR;AcrlKM;EACE,kBAAA;AdulKR;AcplKM;EACE,kBAAA;AdslKR;AcnlKM;EACE,mBAAA;AdqlKR;AchlKM;EACE,cAAA;AdklKR;Ac9kKI;EACE,aAAA;AdglKN;Ac7kKI;EACE,cAAA;Ad+kKN;;Ac1kKA;EACE,kBAAA;Ad6kKF;Ac5kKE;EACE,YAAA;EACA,eAAA;Ad8kKJ;;AcxkKI;EACE,eAAA;Ad2kKN;;AcrkKE;EAEE,YAAA;AdukKJ;;AcnkKA;EACE,eAAA;EACA,2CAAA;EACA,mCAAA;EACA,gBAAA;AdskKF;AcpkKE;EACE,OAAA;EACA,oCAAA;EACA,4BAAA;EACA,YAAA;AdskKJ;AcnkKE;EACE,QAAA;EACA,mCAAA;EACA,2BAAA;EACA,YAAA;AdqkKJ;AclkKE;EACE,YAAA;AdokKJ;AcjkKE;EACE,YAAA;AdmkKJ;;Ac9jKE;EADF;IAEI,6BAAA;EdkkKF;AACF;;Ac/jKA;EACE,kBAAA;AdkkKF;AcjkKE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AdmkKJ;;Ac/jKA;EACE,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,YAAA;EACA,0BAAA;AdkkKF;;Ac9jKE;EACE,kBAAA;AdikKJ;;Aen9KA,gBAAA;AACA;EACE,wBAAA;EX+EA,8CW9EyB;EX+EzB,sCW/EyB;EAEzB,yBAAA;EAEA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;Afq9KF;;Ael9KA;EACE,sBVPS;EUQT,cZ8Ca;EY7Cb,gBAAA;EACA,kBAAA;Afq9KF;Aen9KE;EXkBA,wCWjBE;EXkBF,mCWlBE;EXmBF,gCWnBE;EACA,6BAAA;EACA,cZuCW;EYrCX,gBAAA;Afs9KJ;Aer9KI;EACE,MAAA;Afu9KN;Aet9KM;EACE,+BAAA;EACA,eAAA;Afw9KR;Aer9KI;EACE,WAAA;Afu9KN;Aen9KI;EACE,sBZwDI;EYvDJ,cZsBS;AH+7Kf;Aen9KQ;EACE,+BAAA;Afq9KV;Ae18KE;EACE,yBAAA;EX0CA,kBDxDe;AH29KnB;;Aex8KA;EACE,kBAAA;Af28KF;Aez8KE;EACE,YAAA;Af28KJ;Aez8KI;EAHF;IAII,YAAA;Ef48KJ;AACF;Aez8KE;EACE,kBAAA;Af28KJ;Aez8KI;EAHF;IAII,kBAAA;Ef48KJ;AACF;;Aev8KA;EACE,wBAAA;Af08KF;;Aev8KA;EACE;IACE,wBAAA;Ef08KF;AACF;Aev8KA;EACE,gBAAA;EACA,kBAAA;Afy8KF;;Aer8KA;EACE,gBZ2Be;EY1Bf,mBAAA;Afw8KF;Aet8KE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;Afw8KJ;Aet8KI;EALF;IAMI,YAAA;Efy8KJ;AACF;Aev8KI;EATF;IAUI,YAAA;Ef08KJ;AACF;Aex8KI;EAbF;IAcI,iBAAA;IACA,YAAA;Ef28KJ;AACF;Aex8KE;EAvBF;IAwBI,eAAA;Ef28KF;AACF;Aez8KE;EA3BF;IA4BI,eAAA;Ef48KF;AACF;Ae18KE;EACE,gBAAA;Af48KJ;;Aet8KI;EADF;IAEI,kBAAA;Ef08KJ;AACF;;Aer8KE;EACE,YAAA;Afw8KJ;Aet8KI;EAHF;IAII,YAAA;Efy8KJ;AACF;Aev8KI;EAPF;IAQI,YAAA;Ef08KJ;AACF;;Aep8KI;EACE,cAAA;EACA,WAAA;Afu8KN;Aep8KI;EX5HF,wCW6HI;EX5HJ,mCW4HI;EX3HJ,gCW2HI;EACA,sBV5JK;EU6JL,cZrEO;AH6gLb;Aet8KQ;EACE,4BAAA;Afw8KV;Aep8KM;EACE,6BAAA;EACA,cZ9EK;AHohLb;Aep8KU;EACE,4BAAA;Afs8KZ;;Ae97KA;EACE,gBAAA;Afi8KF;Ae/7KE;EACE,sBAAA;Afi8KJ;Ae77KI;EADF;IAEI,eAAA;Efg8KJ;AACF;;Ae57KA;EXpME,wBWqMA;EXpMA,qBWoMA;EXnMA,mBWmMA;EXlMA,gBWkMA;Afk8KF;;Ae77KE;EACE,iBAAA;EACA,YAAA;Afg8KJ;Ae97KI;EACE,sBAAA;EACA,4BAAA;EACA,gCAAA;EACA,WAAA;Afg8KN;Ae77KI;EACE,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;Af+7KN;Ae57KI;EACE,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;Af87KN;Ae37KI;EAnCF;IAoCI,YAAA;Ef87KJ;AACF;Ae57KI;EAvCF;IAwCI,YAAA;Ef+7KJ;AACF;Ae57KE;EACE,kBAAA;Af87KJ;Ae37KE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;Af67KJ;;Aex7KE;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;Af27KJ;Aex7KE;EACE,WAAA;EACA,SAAA;Af07KJ;Aev7KE;EACE,WAAA;EACA,SAAA;Afy7KJ;Aet7KE;EAjBF;IAkBI,aAAA;Efy7KF;AACF;;Aet7KA;EACE;IACE,YAAA;Efy7KF;AACF;Aet7KA;EACE;IACE,YAAA;Efw7KF;AACF;Aer7KA;EACE,yBAAA;Afu7KF;;Aep7KA;EACE,oBAAA;Afu7KF;;Aep7KA;EACE,kBAAA;EACA,uBAAA;EACA,gCAAA;Afu7KF;Aer7KE;EACE,cZ9PU;AHqrLd;Aep7KE;EACE,eAAA;EACA,6BAAA;Afs7KJ;Aep7KI;EACE,2BAAA;Afs7KN;Ael7KE;EACE,qBAAA;Afo7KJ;Aej7KE;EACE,0BAAA;Afm7KJ;Aeh7KE;EACE,0BAAA;EACA,uBAAA;Afk7KJ;;Ae76KE;EACE,cZvRW;AHusLf;Ae76KE;EACE,kBAAA;Af+6KJ;Ae76KI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,yBZxQG;ECKL,kBWoQyB;Af+6K7B;Ae16KE;EACE,kCAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;Af46KJ;;Aev6KE;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,kDAAA;EXnVF,wCWoVE;EXnVF,mCWmVE;EXlVF,gCWkVE;Af46KJ;Aez6KE;EACE,UAAA;EACA,iDAAA;EACA,mBAAA;Af26KJ;;Aet6KE;EACE,YAAA;EACA,iBAAA;Afy6KJ;Aev6KI;EACE,yBZ3SI;AHotLV;Aer6KE;EACE,kBAAA;EACA,kBAAA;EACA,sBZlTM;EYmTN,mBAAA;EXjTA,kCWkTuB;Afu6K3B;;Aen6KA;EXzVE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BWkUqB;EXjUrB,mBWiUqB;Afi7KvB;;Ae96KA;EACE,kBAAA;EACA,aAAA;Afi7KF;;AgB90LA,gBAAA;AAEE;EZ2DA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJiyLnE;;AgBt1LA;EACE,kBAAA;AhBy1LF;AgBv1LE;EACE,kBAAA;AhBy1LJ;AgBr1LM;EACE,UAAA;EACA,mBAAA;EACA,SAAA;AhBu1LR;AgBp1LM;EACE,cboCM;AHkzLd;AgBl1LI;EACE,cAAA;EACA,cboCe;EanCf,eAAA;EACA,eAAA;AhBo1LN;AgBj1LI;EAEE,qBAAA;EACA,cbsBQ;AH4zLd;AgB/0LI;EACE,gBAAA;AhBi1LN;AgB90LI;EZkBF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EYf7D,UAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;AhB01LN;AgBx1LM;EACE,UAAA;EACA,eAAA;AhB01LR;AgBn1LM;EACE,UAAA;EACA,QAAA;AhBq1LR;AgBl1LM;EACE,UAAA;EACA,WAAA;EACA,SAAA;AhBo1LR;AgBj1LM;;EAEE,MAAA;AhBm1LR;AgB90LE;EACE,eAAA;AhBg1LJ;AgB90LI;EACE,eAAA;AhBg1LN;AgB70LI;EACE,cb3BQ;AH02Ld;AgB30LE;EAIE,cbnCU;AH62Ld;AgBv0LE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,sBXjGO;EWkGP,kBAAA;EZTA,kBYUuB;EZrEzB,wCYsEE;EZrEF,mCYqEE;EZpEF,gCYoEE;AhB20LJ;AgBx0LM;EACE,iBAAA;EACA,YAAA;EACA,eAAA;AhB00LR;AgBx0LQ;EACE,cb1DI;AHo4Ld;AgBt0LM;EACE,UAAA;EACA,WAAA;EACA,SAAA;AhBw0LR;AgBr0LM;EAEE,MAAA;AhBs0LR;AgBn0LM;EACE,kBAAA;AhBq0LR;AgBl0LM;EACE,cb9EM;AHk5Ld;AgB9zLI;EACE,kBAAA;AhBg0LN;AgB9zLM;EACE,cblFa;EamFb,gBAAA;EACA,qBAAA;EACA,YAAA;EAEE,0CAAA;EACA,eAAA;EAEF,iBAAA;EACA,kBAAA;EZtHN,yCYuHM;EZtHN,oCYsHM;EZrHN,iCYqHM;EACA,mBAAA;AhBg0LR;AgB1zLM;EACE,cb1GM;AHs6Ld;AgBrzLM;EACE,cblHM;AHy6Ld;AgBlzLE;EZpHA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EYuH/D,YAAA;AhB8zLJ;AgB5zLI;EACE,UAAA;AhB8zLN;AgB5zLM;EACE,WAAA;AhB8zLR;AgB5zLQ;EAHF;IAII,eAAA;EhB+zLR;AACF;AgB3zLI;EAhBF;IAiBI,YAAA;EhB8zLJ;AACF;;AgB1zLA;EACE,2BAAA;AhB6zLF;;AgB1zLA;EACE,yBblJY;AH+8Ld;AgB1zLI;EACE,eAAA;AhB4zLN;AgBzzLI;EACE,WX7MK;EW8ML,eAAA;AhB2zLN;AgBxzLI;EAKE,cbjKM;AHu9LZ;AgBnzLI;EACE,aAAA;AhBqzLN;;AiBthMA,sBAAA;AACA;EACE,OAAA;EACA,WAAA;EACA,YAAA;AjByhMF;AiBvhME;EALF;IAMI,UAAA;EjB0hMF;AACF;;AiBvhMA;EACE,yBAAA;EACA,WAAA;AjB0hMF;AiBxhME;EAJF;IAKI,aAAA;EjB2hMF;AACF;;AkB5iMA,gBAAA;AAEA;EACE,eAAA;EACA,wCAAA;EACA,sBfyFQ;EexFR,cf0DmB;EezDnB,iBfwHc;EevHd,gBfuHc;AHu7LhB;AkB5iME;EACE,cfqDiB;AHy/LrB;AkB7iMI;EACE,cf6CQ;AHkgMd;AkB3iME;EAfF;IAgBI,aAAA;ElB8iMF;AACF;AkB5iME;EAnBF;IAoBI,eAAA;ElB+iMF;AACF;;AmBtkMA,uBAAA;AACA;Ef4DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,ae/DsB;EfgEtB,8BehE4B;EfiE5B,0BejE4B;EfkE5B,sBelE4B;EfmE5B,yBenEoC;EfoEpC,qBepEoC;EfqEpC,iBerEoC;EACpC,gBAAA;EACA,YAAA;AnBmlMF;AmBjlME;EALF;IAMI,gBAAA;EnBolMF;AACF;;AmBjlMA;EACE,yBhB8CY;EgB7CZ,WdNS;EcOT,uBAAA;EACA,yBAAA;Ef8CA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BerEqB;EfsErB,mBetEqB;EfgErB,sCe/DyB;EfgEzB,8BehEyB;AnBgmM3B;AmB9lME;EACE,gBAAA;AnBgmMJ;;AmB5lMA;EACE,kBAAA;AnB+lMF;AmB7lME;EACE,mBAAA;AnB+lMJ;AmB5lME;EAPF;IAQI,kBAAA;EnB+lMF;AACF;;AmB5lMA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AnB+lMF;AmB7lME;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AnB+lMJ;AmB5lME;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;AnB8lMJ;AmB5lMI;EACE,gBAAA;EACA,0CAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,Wd5DK;Ec6DL,kBAAA;EACA,aAAA;EACA,UAAA;AnB8lMN;AmBzlMI;EACE,cAAA;AnB2lMN;;AmBplMI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,yBhBKO;EgBJP,UAAA;AnBulMN;;AmBjlMA;EACE,eAAA;EACA,QAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EfqBE,2BDpFY;ECqFZ,8BDrFY;ECrCd,kDesGA;EfrGA,+CeqGA;EfpGA,6CeoGA;EfnGA,0CemGA;EACA,WdlGS;AL0rMX;AmBtlME;EACE,kBAAA;EACA,aAAA;AnBwlMJ;;AmBplMA;EACE,aAAA;EACA,chBpBW;EgBqBX,sBd7GS;ALosMX;;AmBnlMA;EACE,mBAAA;AnBslMF;AmBplME;EACE,aAAA;AnBslMJ;AmBnlME;EACE,eAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;AnBqlMJ;AmBnlMI;EACE,wBAAA;EACA,6CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AnBqlMN;AmBllMI;EACE,8BAAA;EACA,mBAAA;EACA,sCAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;AnBolMN;AmBhlME;EACE,gBdjJO;EckJP,YAAA;AnBklMJ;AmB/kME;EACE,mBdzJO;Ec0JP,UAAA;AnBilMJ;;AmB7kMA;EACE;IACE,6BAAA;EnBglMF;AACF;AoB/vMA;+EAAA;ACAA,eAAA;AACA;EACE,cAAA;EACA,kBAAA;EjB6FE,kBDxDe;EkBnCjB,kBAAA;ArBmwMF;AqBjwME;EACE,oBAAA;EACA,gBhBsR0B;AL6+L9B;AqBhwME;EACE,WlBgJM;EkB/IN,oCAAA;EjB+CF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aiBlDwB;EjBmDxB,8BiBnD8B;EjBoD9B,0BiBpD8B;EjBqD9B,sBiBrD8B;EjBsD9B,yBiBtDsC;EjBuDtC,qBiBvDsC;EjBwDtC,iBiBxDsC;EjBkEtC,+BiBjE2B;EjBkE3B,uBiBlE2B;EjBsE3B,2BiBrEuB;EjBsEvB,mBiBtEuB;EACrB,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;ArB8wMJ;;AqB1wMA;EACE,mBlBkIQ;AH2oMV;;AqB1wMA;EACE,kBlB+HQ;AH8oMV;;AsB5yMA,gBAAA;AACA;EAEE,4BAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;ElBoEA,+BkBnEyB;ElBoEzB,uBkBpEyB;ElBwEzB,2BkBvEqB;ElBwErB,mBkBxEqB;EACrB,sBAAA;EACA,cAAA;ElB+EE,kBkB9EqB;EACvB,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBnB2DU;AHqvMZ;AsB9yME;EACE,cAAA;AtBgzMJ;;AsB5yMA;ElBgCE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,+BkBvDqB;ElBwDrB,uBkBxDqB;AtB0zMvB;AsBxzME;EACE,eAAA;EACA,OAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;AtB0zMJ;;AsBrzME;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;AtBwzMJ;AsBtzME;EACE,eAAA;EACA,gBAAA;EACA,cjBvCO;AL+1MX;;AsBpzMA;EACE,kBAAA;AtBuzMF;AsBrzME;EACE,iBAAA;AtBuzMJ;;AuBl3MA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EnB2FE,kBD1De;AHq1MnB;AuBn3ME;EACE,kBAAA;AvBq3MJ;AuBl3ME;EACE,gBAAA;AvBo3MJ;;AuBh3MA;EnB+EI,mBmB9EqB;AvBm3MzB;;AuBh3MA;EACE,4BAAA;AvBm3MF;;AuBh3MA;EACE,6BAAA;EACA,yBpBsDU;AH6zMZ;;AwB94MA,qBAAA;AACA;EACE,yBAAA;EACA,0BAAA;AxBi5MF;AwB/4ME;EACE,0BAAA;AxBi5MJ;;AwB74MA;EACE,8BAAA;AxBg5MF;;AwB74MA;EACE,mBAAA;EACA,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AxBg5MF;;AyBn6MA,2BAAA;AAEE;EACE,0BAAA;AzBq6MJ;;A0Bx6MA,oBAAA;AACA;EtB+FI,kBD1De;AHu4MnB;;A0Bx6MA;EACE,gBAAA;EAEE,0CAAA;EACA,eAAA;EAEF,cAAA;EACA,sBAAA;A1By6MF;;A2Br7MA,gBAAA;AACA;EACE,0BAAA;EACA,eAAA;EACA,6BAAA;A3Bw7MF;;A2Br7MA;EACE,kBAAA;EACA,qBAAA;EACA,etBgR4B;EsB/Q5B,gBtBqR4B;EsBnR5B,gBxBwIgB;ECrDd,kBDzDY;EwBxBd,mBAAA;EACA,eAAA;EACA,kBAAA;A3Bu7MF;A2Br7ME;EAGE,eAAA;EACA,qBAAA;EvBrBF,mCuBsBE;EvBrBF,gCuBqBE;EvBpBF,8BuBoBE;EvBnBF,2BuBmBE;A3Bw7MJ;A2Br7ME;EACE,kBAAA;A3Bu7MJ;;A2Bl7ME;EAGE,eAAA;EACA,qBAAA;EvBnCF,mCuBoCE;EvBnCF,gCuBmCE;EvBlCF,8BuBkCE;EvBjCF,2BuBiCE;A3Bs7MJ;A2Bn7ME;EACE,kBAAA;A3Bq7MJ;;A2Bj7MA;;;;;;;;;EvB5CE,mCuBsDA;EvBrDA,gCuBqDA;EvBpDA,8BuBoDA;EvBnDA,2BuBmDA;A3Bs7MF;;A2Bz6MI;;;;;;;;;EvBnEF,mCuBoEI;EvBnEJ,gCuBmEI;EvBlEJ,8BuBkEI;EvBjEJ,2BuBiEI;A3Bu7MN;;A2Bl7MA;;;;EAIE,kBAAA;A3Bq7MF;A2Bl7ME;;;;EACE,kBAAA;A3Bu7MJ;A2Bp7ME;;;;EACE,gBAAA;EACA,gBAAA;A3By7MJ;A2Bt7ME;;;;EACE,gBAAA;A3B27MJ;;A2Bv7MA;EACE,2BAAA;A3B07MF;;A2Bv7MA;;EAEE,eAAA;EACA,gBAAA;EACA,oBAAA;A3B07MF;;A2Bv7MA;EACE,kBAAA;EACA,oBAAA;EvBbE,kBDtDmB;ECuCrB,+BuB+ByB;EvB9BzB,uBuB8ByB;EvB1BzB,2BuB2BqB;EvB1BrB,mBuB0BqB;EACrB,yBAAA;EACA,gBAAA;A3B27MF;A2Bz7ME;EAEE,eAAA;EACA,qBAAA;A3B07MJ;;A2Bt7MA;;EAEE,kBxBeY;AH06Md;A2Bv7ME;;;EAEE,gBAAA;A3B07MJ;;A2Bt7MA;EACE,6BAAA;EACA,cxBzCW;AHk+Mb;A2Bx7ME;EAGE,yBAAA;EACA,cxB9CS;AHs+Mb;;A2Bp7MA;EACE,cAAA;A3Bu7MF;A2Br7ME;EACE,mBAAA;A3Bu7MJ;A2Bp7ME;EAEE,kBAAA;A3Bq7MJ;;A2Bj7MA;EvB9DI,8BuB+DqB;A3Bo7MzB;;A2Bj7MA;EACE,kBxBvBe;AH28MjB;;A2Bj7MA;EACE,iBxBzBe;AH68MjB;;A2Bj7MA;EACE,iBxB5Be;AHg9MjB;;A2Bp6MA;;;EAEE,kBtB8F4B;AL00M9B;A2Bv6ME;;;EACE,8BAAA;A3B26MJ;;A2Bv6MA;;;EAEE,+BAAA;A3B26MF;A2B16ME;;;EACE,+BAAA;A3B86MJ;;A2B16MA;;EAEE,exBnEiB;AHg/MnB;A2B56ME;;EACE,exBrEe;AHo/MnB;;A2B36MA;EvBtJE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,auBmJsB;EvBlJtB,2BuBkJ4B;EvBjJ5B,uBuBiJ4B;EvBhJ5B,mBuBgJ4B;EvB/I5B,uBuB+IiC;EvB9IjC,mBuB8IiC;EvB7IjC,euB6IiC;EACjC,gBAAA;EACA,WAAA;A3Bw7MF;;A2Br7MA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;A3Bw7MF;A2Bt7ME;EAPF;IAQI,WAAA;IACA,aAAA;E3By7MF;AACF;A2Bx7ME;EACE,UAAA;A3B07MJ;A2Bz7MI;EACE,aAAA;A3B27MN;A2Bx7MI;EACE,UAAA;A3B07MN;A2Bv7MI;EACE,8BAAA;A3By7MN;A2Br7ME;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EvBnKF,2BuBoKuB;EvBnKvB,mBuBmKuB;EvBzKvB,+BuB0K2B;EvBzK3B,uBuByK2B;EACzB,WtBrPO;AL8qNX;A2Bv7ME;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,sBAAA;EACA,+BAAA;A3By7MJ;A2Bt7ME;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,gBtB7PO;EsB8PP,YAAA;EvB1OF,yDuB2OE;EvB1OF,oDuB0OE;EvBzOF,iDuByOE;A3B07MJ;A2Bv7ME;EACE,kBAAA;EACA,uBAAA;A3By7MJ;A2Bv7ME;EACE,WAAA;EACA,WAAA;EACA,gBtBnRO;EsBoRP,kBAAA;EACA,YAAA;EACA,qBAAA;EvBxPF,yDuByPE;EvBxPF,oDuBwPE;EvBvPF,iDuBuPE;A3B27MJ;;A2Bv7MA;EACE,cAAA;A3B07MF;A2Bx7ME;EAEE,iBAAA;A3By7MJ;;A2Bn7MA;EACE,0CAAA;EACA,WxBpJQ;EwBqJR,YAAA;EACA,iBAAA;EACA,kBAAA;A3Bs7MF;;A2Bn7MA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;A3Bs7MF;;A2Bn7MA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;A3Bs7MF;;A2Bn7MA;EACE,iBxB5KQ;AHkmNV;;A2Bn7MA;EACE,kBxBhLQ;EwBiLR,cAAA;A3Bs7MF;;A2Bn7MA;EACE,iBAAA;A3Bs7MF;;A2Bn7MA;EACE,iBAAA;A3Bs7MF;;A2Bn7MA;EACE,iBAAA;EACA,WxB9LQ;AHonNV;;A2B/6MM;EACE,yBpBVS;EoBWT,WtB1VG;AL4wNX;A2Bj7MQ;EAEE,mEAAA;EACA,WtB9VC;ALgxNX;;A2Bx7MM;EACE,yBpBVS;EoBWT,WtB1VG;ALqxNX;A2B17MQ;EAEE,qEAAA;EACA,WtB9VC;ALyxNX;;A2Bj8MM;EACE,yBpBVS;EoBWT,WtB1VG;AL8xNX;A2Bn8MQ;EAEE,oEAAA;EACA,WtB9VC;ALkyNX;;A2B18MM;EACE,yBpBVS;EoBWT,WtB1VG;ALuyNX;A2B58MQ;EAEE,qEAAA;EACA,WtB9VC;AL2yNX;;A2Bn9MM;EACE,yBpBVS;EoBWT,WtB1VG;ALgzNX;A2Br9MQ;EAEE,qEAAA;EACA,WtB9VC;ALozNX;;A2B59MM;EACE,yBpBVS;EoBWT,WtB1VG;ALyzNX;A2B99MQ;EAEE,mEAAA;EACA,WtB9VC;AL6zNX;;A2Br+MM;EACE,yBpBVS;EoBWT,WtB1VG;ALk0NX;A2Bv+MQ;EAEE,mEAAA;EACA,WtB9VC;ALs0NX;;A2B9+MM;EACE,yBpBVS;EoBWT,WtB1VG;AL20NX;A2Bh/MQ;EAEE,oEAAA;EACA,WtB9VC;AL+0NX;;A2Bv/MM;EACE,yBpBVS;EoBWT,WtB1VG;ALo1NX;A2Bz/MQ;EAEE,wDAAA;EACA,WtB9VC;ALw1NX;;A2BhgNM;EACE,yBpBVS;EoBWT,WtB1VG;AL61NX;A2BlgNQ;EAEE,yDAAA;EACA,WtB9VC;ALi2NX;;A2BzgNM;EACE,yBpBVS;EoBWT,WtB1VG;ALs2NX;A2B3gNQ;EAEE,qEAAA;EACA,WtB9VC;AL02NX;;A2BlhNM;EACE,yBpBVS;EoBWT,WtB1VG;AL+2NX;A2BphNQ;EAEE,qEAAA;EACA,WtB9VC;ALm3NX;;A2B3hNM;EACE,yBpBVS;EoBWT,WtB1VG;ALw3NX;A2B7hNQ;EAEE,qEAAA;EACA,WtB9VC;AL43NX;;A2BpiNM;EACE,yBpBVS;EoBWT,WtB1VG;ALi4NX;A2BtiNQ;EAEE,0DAAA;EACA,WtB9VC;ALq4NX;;A2B7iNM;EACE,yBpBVS;EoBWT,WtB1VG;AL04NX;A2B/iNQ;EAEE,yDAAA;EACA,WtB9VC;AL84NX;;A2BtjNM;EACE,yBpBVS;EoBWT,WtB1VG;ALm5NX;A2BxjNQ;EAEE,8CAAA;EACA,WtB9VC;ALu5NX;;A2B/jNM;EACE,yBpBVS;EoBWT,WtB1VG;AL45NX;A2BjkNQ;EAEE,0DAAA;EACA,WtB9VC;ALg6NX;;A2BxkNM;EACE,yBpBVS;EoBWT,WtB1VG;ALq6NX;A2B1kNQ;EAEE,qEAAA;EACA,WtB9VC;ALy6NX;;A2BjlNM;EACE,yBpBVS;EoBWT,WtB1VG;AL86NX;A2BnlNQ;EAEE,oEAAA;EACA,WtB9VC;ALk7NX;;A2B1lNM;EACE,yBpBVS;EoBWT,WtB1VG;ALu7NX;A2B5lNQ;EAEE,qEAAA;EACA,WtB9VC;AL27NX;;A2BtlNA;EvB1WE,kIuB2WA;EvB1WA,+HuB0WA;EvBzWA,6HuByWA;EvBxWA,0HuBwWA;A3B4lNF;A2B3lNE;EvB5WA,kIuB8WE;EvB7WF,+HuB6WE;EvB5WF,6HuB4WE;EvB3WF,0HuB2WE;A3B+lNJ;A2B5lNE;EvBjXA,mCuBkXE;EvBjXF,gCuBiXE;EvBhXF,8BuBgXE;EvB/WF,2BuB+WE;A3BimNJ;;A2B7lNA;;EAEE,oBAAA;EACA,aAAA;A3BgmNF;;A2B7lNA;EACE,sBtBxXS;EsByXT,cxBjSW;EwBkSX,yBAAA;A3BgmNF;A2B/lNE;EAEE,oCAAA;EACA,cxBtSS;AHs4Nb;;A2B5lNA;EACE,yBxB9UU;EwB+UV,WtBpYS;ALm+NX;A2B9lNE;EAEE,oEAAA;EACA,WtBxYO;ALu+NX;;A2B3lNA;EACE,6BAAA;EACA,cxB3VY;AHy7Nd;A2B5lNE;EAEE,yCAAA;EACA,cxBhWU;AH67Nd;;A2BxlNE;EACE,6BAAA;EACA,WtB1ZO;ALq/NX;A2BzlNI;EAEE,2CAAA;EACA,WtB/ZK;ALy/NX;;A2BrlNA;EACE,6BAAA;EACA,cxBjXU;AHy8NZ;A2BtlNE;EAEE,yCAAA;EACA,cxBtXQ;AH68NZ;;A2BllNE;EACE,6BAAA;EACA,WtBlbO;ALugOX;A2BnlNI;EAEE,2CAAA;EACA,WtBvbK;AL2gOX;;A2B/kNA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;EACA,qCAAA;A3BklNF;;A2B/kNA;EACE,wBAAA;EACA,uBAAA;A3BklNF;;A2B/kNA;EACE,YxB1TQ;EwB2TR,WxB3TQ;EwB4TR,4BAAA;EACA,2BAAA;EACA,oBAAA;EvBnYA,2BuBoYqB;EvBnYrB,mBuBmYqB;EvBzYrB,+BuB0YyB;EvBzYzB,uBuByYyB;EACzB,eAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;A3BolNF;A2BllNE;EAGE,qBAAA;EACA,0BAAA;A3BklNJ;A2B/kNE;EACE,YAAA;EACA,WAAA;EACA,eAAA;A3BilNJ;A2B9kNE;EACE,WtBxeO;ALwjOX;;A2B5kNA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;A3B+kNF;;A2B1kNE;;EvBzfA,mCuB0fE;EvBzfF,gCuByfE;EvBxfF,8BuBwfE;EvBvfF,2BuBufE;A3BilNJ;;A4B7kOA,sBAAA;AAKA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A5B4kOF;A4B1kOE;;EACE,kBAAA;EACA,cAAA;EACA,qBvBJO;ALilOX;AI98NE;;EwB1HI,UAAA;A5B4kON;A4B1kOI;;;;EAGE,UAAA;A5B6kON;A4B1kOI;;EACE,yBzB8BQ;EyB7BR,WvBtBK;EuBuBL,qBzB4BQ;AHijOd;A4B1kOI;;EACE,yBAAA;A5B6kON;A4B5kOM;;EACE,6BAAA;EACA,czBqBM;AH0jOd;A4B7kOQ;;;EAEE,yCAAA;EACA,czBgBI;AHgkOd;A4BxkOE;;;;;;;;EAIE,iBAAA;A5B8kOJ;;A4BvkOE;;;;EAGE,yBAAA;A5B2kOJ;;A4BtkOA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A5BykOF;A4BvkOE;EACE,WAAA;A5BykOJ;;A4BrkOA;EACE,gBAAA;A5BwkOF;;A4BnkOA;EACE,cAAA;A5BskOF;A4BpkOE;ExBqBE,0BwBpB6B;ExBqB7B,6BwBrB6B;A5BukOjC;;A4BjkOA;;ExB4BI,yBwB1B0B;ExB2B1B,4BwB3B0B;A5BqkO9B;;A4BhkOA;EACE,WAAA;A5BmkOF;;A4BhkOA;EACE,gBAAA;A5BmkOF;;A4B/jOE;;ExBFE,0BwBI6B;ExBH7B,6BwBG6B;A5BmkOjC;;A4B/jOA;ExBMI,yBwBL0B;ExBM1B,4BwBN0B;A5BmkO9B;;A4BnjOA;EACE,wBAAA;EACA,uBAAA;A5BsjOF;A4BpjOE;EACE,cAAA;A5BsjOJ;;A4BljOA;EACE,uBAAA;EACA,sBAAA;A5BqjOF;;A4BljOA;EACE,sBAAA;EACA,qBAAA;A5BqjOF;;A4BhjOA;ExBzJE,wDwB0JA;ExBzJA,qDwByJA;ExBxJA,mDwBwJA;ExBvJA,gDwBuJA;A5BsjOF;A4BnjOE;ExB7JA,wBwB8JE;ExB7JF,qBwB6JE;ExB5JF,mBwB4JE;ExB3JF,gBwB2JE;A5BwjOJ;;A4B/iOA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A5BkjOF;A4BhjOE;;EAEE,WAAA;A5BkjOJ;A4B/iOE;;;;EAIE,gBAAA;EACA,cAAA;A5BijOJ;A4B7iOI;EACE,gBAAA;A5B+iON;A4B5iOI;ExB5EA,6BwB6EgC;ExB5EhC,4BwB4EgC;A5B+iOpC;A4B5iOI;ExB9FA,yBwB+F6B;ExB9F7B,0BwB8F6B;A5B+iOjC;A4B3iOE;EACE,gBAAA;A5B6iOJ;A4BziOI;;ExB1FA,6BwB4FgC;ExB3FhC,4BwB2FgC;A5B4iOpC;A4BxiOE;ExB9GE,yBwB+G2B;ExB9G3B,0BwB8G2B;A5B2iO/B;;A4BliOI;;;;EAEE,kBAAA;EACA,sBAAA;A5BuiON;;A4B5hOE;;;;EAEE,eAAA;EACA,gBAAA;A5BiiOJ;;A6BhxOA,iBAAA;AAKE;EACE,mBAAA;A7B+wOJ;;A6BnwOA,6BAAA;AAEA;EACE,kBAAA;EACA,gBAAA;EzBuCA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2ByB9DqB;EzB+DrB,mByB/DqB;EzByDrB,+ByBxDyB;EzByDzB,uByBzDyB;EACzB,iBAAA;A7BixOF;A6B/wOE;EACE,gBAAA;A7BixOJ;;A6B7wOA;EACE,QAAA;EACA,UAAA;A7BgxOF;;A6B7wOA;EACE,QAAA;A7BgxOF;;A6B7wOA;EACE,kBAAA;A7BgxOF;;A6B7wOA;EACE,mBAAA;A7BgxOF;;A6B7wOA;EACE,WAAA;A7BgxOF;;A6B7wOA;EACE,mBAAA;A7BgxOF;;A6B7wOA;EACE;IACE,mBAAA;E7BgxOF;AACF;A6B7wOA;EACE;IACE,mBAAA;E7B+wOF;E6B7wOA;IACE,kBAAA;E7B+wOF;E6B7wOA;IACE,mBAAA;E7B+wOF;AACF;A6B5wOA;EAEI;IACE,oBAAA;E7B6wOJ;AACF;A6BzwOA;EACE;IzBxBA,qBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,ayBqBwB;IzBpBxB,8ByBoB8B;IzBnB9B,0ByBmB8B;IzBlB9B,sByBkB8B;IzBjB9B,uBATiE;IAUjE,mBAViE;IAWjE,eAXiE;IyB2B/D,kBAAA;E7BqxOF;E6BnxOE;IACE,kBAAA;E7BqxOJ;E6BjxOA;IACE,eAAA;E7BmxOF;E6BhxOA;;IAEE,QAAA;IACA,WAAA;E7BkxOF;E6BhxOA;IACE,mBAAA;E7BkxOF;E6B9wOE;IACE,mBAAA;E7BgxOJ;AACF;A8B93OA,eAAA;AACA;EACE,sBzBKS;EDyFP,kBDxDe;E2BpCjB,gBAAA;A9Bg4OF;A8B93OE;EACE,qBAAA;E1ByFA,kB0BvFuB;E1BPzB,mD0BQE;E1BPF,gD0BOE;E1BNF,8C0BME;E1BLF,2C0BKE;EACA,kBAAA;EACA,cAAA;EACA,mCAAA;EACA,+BAAA;EACA,2BAAA;E1BsBF,wC0BrBE;E1BsBF,mC0BtBE;E1BuBF,gC0BvBE;EACA,UAAA;A9Bo4OJ;A8Bh4OI;E1BgBF,gD0BfI;E1BgBJ,2C0BhBI;E1BiBJ,wC0BjBI;E1B0EF,kB0BzEyB;A9Bo4O7B;;A8B93OE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;E1BoBA,6DAAA;EACA,kC0BpB4D;E1BqB5D,4BAJ8C;EAK9C,sBAL+D;AJm3OnE;A8Bl4OE;EACE,uBAAA;A9Bo4OJ;A8Bj4OE;EACE,oBAAA;A9Bm4OJ;A8Bj4OE;EACE,qBAAA;E1BNF,oC0BOE;E1BNF,+B0BME;E1BLF,4B0BKE;EACA,cAAA;A9Bq4OJ;A8Bn4OI;EAGE,6BAAA;EACA,yBAAA;EACA,qBAAA;A9Bm4ON;A8B/3OE;EACE,kBAAA;A9Bi4OJ;;A8B53OE;EACE,cAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;A9B+3OJ;;A8B33OA;;EAEE,yBAAA;A9B83OF;A8B53OE;EAJF;;IAKI,YAAA;E9Bg4OF;AACF;;A8B13OE;EACE,eAAA;A9B63OJ;A8B13OE;EACE,aAAA;A9B43OJ;A8Bz3OE;EACE,qBAAA;A9B23OJ;A8Bz3OI;E1BJA,0B0BKyB;A9B23O7B;A8Bv3OE;EAnBF;IAoBI,mBAAA;E9B03OF;AACF;;A8Bv3OA;EACE,mBAAA;A9B03OF;A8Bx3OE;EACE,kBAAA;A9B03OJ;A8Bv3OE;EACE,gBAAA;A9By3OJ;A8Bv3OI;EACE,iBAAA;A9By3ON;A8Br3OE;EAfF;IAgBI,mBAAA;E9Bw3OF;AACF;;A8Br3OA;EACE,mBAAA;A9Bw3OF;A8Bt3OE;EACE,kBAAA;A9Bw3OJ;A8Br3OE;EACE,gBAAA;EACA,eAAA;EACA,czB/HO;ALs/OX;A8Bp3OE;EAbF;IAcI,mBAAA;E9Bu3OF;AACF;;A8Bp3OA;EACE,mB3BtEe;AH67OjB;A8Br3OE;EAHF;IAII,mBAAA;E9Bw3OF;AACF;;A8Br3OA;EACE,eAAA;A9Bw3OF;A8Bt3OE;EACE,gBAAA;A9Bw3OJ;A8Bt3OI;EACE,iBAAA;A9Bw3ON;;A8Bn3OA;EACE,e3B/Ia;E2BgJb,0BAAA;A9Bs3OF;;A8Bn3OA;EACE,eAAA;EACA,czBjKS;ALuhPX;A8Bp3OE;EACE,mB3BxJW;AH8gPf;;A8Bl3OA;EACE,oBAAA;EACA,iBAAA;A9Bq3OF;;A8Bl3OA;EACE,eAAA;EACA,iBAAA;A9Bq3OF;;A8Bl3OA;EACE,gBAAA;EACA,eAAA;E1BrIA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B0B8GqB;E1B7GrB,mB0B6GqB;EACrB,mBAAA;A9Bg4OF;A8B93OE;EACE,cAAA;EACA,kBAAA;A9Bg4OJ;A8B73OE;EACE,c3B9GS;AH6+Ob;A8B53OE;EAGE,c3BvJQ;AHmhPZ;A8Bz3OE;EACE,gBAAA;E1BtIF,qC0BuI2B;E1BtI3B,6B0BsI2B;A9B43O7B;;A8Bx3OA;E1B/JE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B0BwIqB;E1BvIrB,mB0BuIqB;E1B7IrB,qC0B8IyB;E1B7IzB,6B0B6IyB;EACzB,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WzB/NS;EyBgOT,e3B7Ma;AHolPf;A8Br4OE;EACE,sBAAA;EACA,eAAA;A9Bu4OJ;;A8Bn4OA;E1B/II,kBDxDe;E2ByMjB,mB3BlKe;AHwiPjB;A8Bp4OE;EACE;IACE,iBAAA;E9Bs4OJ;AACF;A8Bn4OE;EACE;IACE,iBAAA;E9Bq4OJ;AACF;A8Bl4OE;EAhBF;IAiBI,mBAAA;E9Bq4OF;AACF;;A+BtoPA,gBAAA;AAEA;EACE,kBAAA;A/BwoPF;A+BtoPI;EACE,W1BCK;E0BAL,kBAAA;A/BwoPN;A+BpoPE;EACE,kBAAA;A/BsoPJ;A+BpoPE;EACE,kBAAA;A/BsoPJ;;AgCrpPA,eAAA;AACA;EACE,wCAAA;EACA,oCAAA;AhCwpPF;;AiC3pPA,kBAAA;AAGE;EACE,e9BqBW;AHuoPf;;AkChqPA,sBAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AlCkqPF;;AkC/pPA;EACE,YAAA;EACA,gB7BHS;E6BIT,kBAAA;E9BTA,gD8BUA;E9BTA,6C8BSA;E9BRA,2C8BQA;E9BPA,wC8BOA;EACA,qBAAA;EACA,eAAA;AlCqqPF;;AkClqPA;EACE,kBAAA;EACA,UAAA;AlCqqPF;;AkClqPA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AlCqqPF;;AkClqPA;;;;EAIE,sBAAA;AlCqqPF;;AkClqPA;EACE,sBAAA;EACA,uBAAA;AlCqqPF;;AkClqPA;EACE,uBAAA;AlCqqPF;;AkClqPA;EACE,qBAAA;EACA,mBAAA;AlCqqPF;;AmCntPA;;EAEE,kCAAA;AnCstPF;;AmCltPA;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,kCAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,sCAAA;EACA,wBAAA;EACA,wCAAA;EACA,gCAAA;AnCqtPF;;AmCltPA;EACE,uBAAA;AnCqtPF;;AmCltPA;EACE,qBAAA;AnCqtPF;;AmCntPA;EACE,qBAAA;AnCstPF;;AmCntPA;EACE,0BAAA;EACA,gCAAA;AnCstPF;;AmCltPA;;EAEE,kCAAA;AnCqtPF;;AmCjtPA;EACE,0BAAA;EACA,qBAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,wCAAA;EACA,kCAAA;EACA,gCAAA;AnCotPF;;AmCjtPA;EACE,uBAAA;EACA,oCAAA;EACA,8BAAA;AnCotPF;;AmCjtPA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;AnCotPF;;AmCjtPA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;AnCotPF;;AmCjtPA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;AnCotPF;;AmCjtPA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;AnCotPF;;AmCjtPA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;AnCotPF;;AmCjtPA;EACE,yBAAA;EACA,wCAAA;EACA,kCAAA;AnCotPF;;AmCjtPA;EACE,0BAAA;EACA,gCAAA;AnCotPF;;AoC/zPA,gBAAA;AAEA;EACE,YAAA;ApCi0PF;;AoC9zPA;EACE,WAAA;ApCi0PF;;AqCx0PA,oBAAA;AAEA;EACE,gBAAA;ArC00PF;;AqCp0PE;EACE,oBAAA;ArCu0PJ;AqCr0PI;EAHF;IAII,mBAAA;ErCw0PJ;AACF;AqCt0PI;EAPF;IAQI,oBAAA;ErCy0PJ;AACF;AqCv0PI;EAXF;IAYI,oBAAA;ErC00PJ;AACF;AqCx0PI;EAfF;IAgBI,mBAAA;ErC20PJ;AACF;;AsCr2PA,oBAAA;AAEA;;;;ElC2DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EAqBjE,qCkC1EyB;ElC2EzB,6BkC3EyB;EACzB,gBAAA;AtCk3PF;;AsC/2PA;EACE,eAAA;EACA,iBAAA;EAEA,wBAAA;AtCi3PF;AsC/2PE;EACE,cAAA;AtCi3PJ;AsC/2PI;EAEE,kBAAA;EACA,iBAAA;EACA,kBAAA;AtCg3PN;;AsC12PE;EACE,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AtC62PJ;;AsCz2PA;EACE,+HAAA;EACA,0HAAA;EACA,uHAAA;AtC42PF;;AsCz2PA;EACE,4HAAA;EACA,uHAAA;EACA,oHAAA;AtC42PF;;AsCz2PA;EACE,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uDAAA;AtC42PF;;AsCz2PA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AtC42PF;AsC12PE;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AtC42PJ;;AsCx2PA;EACE,aAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;AtC22PF;;AsCx2PA;EACE,uDAAA;EACA,eAAA;EACA,YAAA;AtC22PF;;AsCx2PA;EACE,aAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uDAAA;EACA,+GAAA;EACA,iHAAA;EACA,uGAAA;AtC22PF;;AsCx2PA;EACE,aAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uDAAA;EAEA,iHAAA;EACA,oHAAA;EACA,yGAAA;AtC02PF;;AsCv2PA;EACE,iBAAA;AtC02PF;;AsCv2PA;EACE,kBAAA;AtC02PF;;AuC7+PA,eAAA;AAEA;EACE,qBAAA;EAEA,kBAAA;AvC8+PF;;AuC3+PA;EACE,qBAAA;AvC8+PF;AuC7+PE;EACE,iBAAA;AvC++PJ;;AwC1/PA,eAAA;AACA;EACE,gBAAA;AxC6/PF;;AyC//PA,cAAA;AAEA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;AzCigQF;;AyC9/PA;EACE,WAAA;EACA,uBAAA;AzCigQF;AyC//PE;EACE,kBAAA;AzCigQJ;AyC//PI;EAHF;IAII,kBAAA;EzCkgQJ;AACF;AyC//PE;EACE,kBAAA;EACA,mBAAA;AzCigQJ;AyC7/PE;EACE,gBAAA;EACA,kBAAA;AzC+/PJ;AyC5/PE;EACE,iBAAA;AzC8/PJ;AyC3/PE;EACE,qBAAA;AzC6/PJ;AyC1/PE;EACE,qBAAA;EACA,ctCqDS;EsCpDT,etCvBa;EsCwBb,gBAAA;AzC4/PJ;;AyCv/PE;EACE,YAAA;AzC0/PJ;AyCz/PI;EAFF;IAGI,WAAA;EzC4/PJ;AACF;AyCz/PE;EACE,yBAAA;AzC2/PJ;AyC1/PI;EAFF;IAGI,WAAA;EzC6/PJ;AACF;AyCz/PI;EACE,kBAAA;AzC2/PN;AyCx/PI;EACE,qEAAA;EACA,iEAAA;EACA,ctCwBO;EsCvBP,gBAAA;AzC0/PN;AyCx/PM;EAGE,qEAAA;EACA,iEAAA;AzCw/PR;AyCn/PM;EACE,eAAA;AzCq/PR;;AyC/+PA;EACE,iBAAA;EACA,kBAAA;AzCk/PF;AyCj/PE;EACE,cAAA;EACA,qBAAA;AzCm/PJ;AyCj/PI;EACE,aAAA;AzCm/PN;;AyC9+PA;EACE,gCAAA;EACA,mBAAA;AzCi/PF;;AyC9+PA;EACE,kBAAA;AzCi/PF;;AyC9+PA;EAEI,eAAA;EACA,YAAA;AzCg/PJ;;A0ClmQA;EACE,eAAA;EACA,eAAA;A1CqmQF;;A0CjmQE;EACE,WrCDO;ALqmQX;A0ClmQI;EAGE,WrCIK;EqCHL,sBrCPK;ALymQX;A0C/lQI;EACE,crCVK;AL2mQX;A0C9lQI;EACE,crCNK;ALsmQX;;A2CtnQA,iBAAA;AAME;;;;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EvCuFA,mBuCtFuB;EvC2BzB,wCuC1BE;EvC2BF,mCuC3BE;EvC4BF,gCuC5BE;A3CynQJ;A2CvnQI;;;;;;;;;;EAGE,8BAAA;EACA,0BAAA;EACA,sBAAA;A3CgoQN;A2C9nQI;;;;EACE,8BAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;A3CmoQN;A2ChoQE;;;;EACE,aAAA;EACA,kBAAA;A3CqoQJ;A2CnoQI;;;;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;A3CwoQN;A2CvoQM;;;;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;A3C4oQR;A2CxoQI;;;;EACE,cAAA;A3C6oQN;A2CzoQE;;;;EACE,gBAAA;EACA,eAAA;EACA,SAAA;EACA,wBAAA;A3C8oQJ;A2C5oQI;;;;EACE,mBAAA;A3CipQN;AIjrQE;;;;;;;EAEE,YAAA;EACA,cAAA;AJwrQJ;AItrQE;;;;EACE,WAAA;AJ2rQJ;A2ClqQI;;;;EAGE,oBAAA;A3CqqQN;A2CpqQM;;;;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;A3CyqQR;A2CtqQM;;;;EACE,cAAA;EACA,gBAAA;A3C2qQR;A2CtqQE;;;;EACE,SAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;A3C2qQJ;A2CzqQI;;;;EACE,cAAA;EACA,kBAAA;EACA,cAAA;A3C8qQN;;A2CzqQA;EACE,cAAA;EvCKE,gBuCJqB;A3C4qQzB;;A2CvqQI;EvCDA,mBuCEyB;A3C0qQ7B;;A2CpqQE;EvCRE,kBuCSuB;EACvB,aAAA;EACA,YAAA;EACA,mBAAA;EvCtBF,2BuCuBuB;EvCtBvB,mBuCsBuB;A3CwqQzB;A2CtqQI;EACE,gBAAA;A3CwqQN;;A2CnqQA;EAKI;;;;IACE,kBAAA;E3CqqQJ;E2CnqQE;;;;IACE,wBAAA;E3CwqQJ;E2CnqQE;IACE,aAAA;IACA,YAAA;E3CqqQJ;AACF;A2CjqQA;EAMM;;;;;;;;;;;;;IAIE,2BAAA;IACA,uBAAA;IACA,mBAAA;E3CuqQN;AACF;A4C9zQA,qBAAA;AAEA;EACE,aAAA;EACA,mBAAA;A5C+zQF;;A4C5zQA;EACE,WAAA;EACA,kBAAA;A5C+zQF;A4C9zQE;EACE,yBAAA;A5Cg0QJ;A4C/zQI;EACE,yBAAA;A5Ci0QN;;A4C5zQA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;A5C+zQF;;A4C5zQA;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;A5C+zQF;;A6C/1QA,iBAAA;AACA;EACE,aAAA;EACA,iBAAA;A7Ck2QF;;A6C/1QA;EACE,iBAAA;A7Ck2QF;;A6C/1QA;EACE,6BAAA;EACA,qBAAA;EACA,WxCIS;EwCHT,e1CWa;E0CVb,oBAAA;A7Ck2QF;;A6C/1QA;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;A7Ck2QF;;A8Cv3QA,gBAAA;AAEA;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;A9Cy3QF;A8Cv3QE;EACE,cAAA;EACA,yBAAA;A9Cy3QJ;A8Cv3QE;EACE,WzCNO;EyCOP,yBAAA;A9Cy3QJ;;A8Cr3QA;E1CyDE,sBAAA;EACA,kBAAA;EACA,cAAA;AJg0QF;;A8Cv3QA;EACE,cAAA;A9C03QF;;A8Cv3QA;E1CiDE,sBAAA;EACA,kBAAA;EACA,cAAA;AJ00QF;;A8Cz3QA;EACE,0CAAA;A9C43QF;;A8Cz3QA;EACE,sBAAA;EACA,0BAAA;EACA,4BAAA;A9C43QF;A8C13QE;;EAEE,2BAAA;EACA,8BAAA;EACA,wCAAA;A9C43QJ;A8Cz3QE;EACE,iCAAA;EACA,2CAAA;A9C23QJ;A8Cx3QE;EACE,wCAAA;A9C03QJ;A8Cv3QE;EACE,iCAAA;A9Cy3QJ;;A8Cr3QA;E1C0BE,4B0CzBqB;E1C0BrB,oB0C1BqB;EACrB,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;A9Cy3QF;;A8Ct3QA;EACE,gBAAA;A9Cy3QF;A8Cx3QE;EACE,gBAAA;EACA,eAAA;A9C03QJ;A8Cx3QE;EACE,sBAAA;A9C03QJ;;A8Cr3QE;EAEE,yBAAA;A9Cu3QJ;A8Cp3QE;EACE,2CAAA;A9Cs3QJ;;A8Cl3QA;EACE,iBAAA;EACA,gBAAA;A9Cq3QF;;A8Cl3QA;EACE;IACE,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,4CAAA;IACA,sBAAA;E9Cq3QF;E8Cn3QA;IACE,gBAAA;E9Cq3QF;E8Cn3QA;;;;;;IAME,mBAAA;E9Cq3QF;E8Cn3QA;IACE,SAAA;E9Cq3QF;E8Cn3QA;;;;;;IAME,cAAA;E9Cq3QF;E8Cn3QA;;;;;;IAME,eAAA;E9Cq3QF;E8Cn3QA;;;;IAIE,gBAAA;E9Cq3QF;AACF;A8Cj3QE;EACE,kBAAA;A9Cm3QJ;;A+CvgRA,cAAA;AAEA;EACE,0BAAA;A/CygRF;;A+CtgRA;E3CuDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJ89QnE;;AgD1hRA,qBAAA;AAEA;EACE,oCAAA;EACA,2CAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AhD4hRF;AgD1hRE;EAPF;IAQI,mBAAA;EhD6hRF;AACF;AgD3hRE;EACE,qBAAA;EACA,W7C+IM;E6C9IN,Y7C8IM;EC9DN,kB4C/EuB;EACvB,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;AhD6hRJ;AgD3hRI;EAXF;IAYI,W7CmII;I6ClIJ,Y7CkII;EH45QR;AACF;AgD5hRE;EACE,WAAA;EACA,YAAA;AhD8hRJ;AgD5hRE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AhD8hRJ;AgD5hRI;EACE,gBAAA;EAEE,0CAAA;EACA,eAAA;EAEF,0BAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AhD4hRN;AgDzhRE;EACE,cAAA;EACA,kBAAA;AhD2hRJ;;AgDthRA;EACE,kBAAA;AhDyhRF;AgDvhRE;EACE,cAAA;EACA,mBAAA;EACA,Y7C4FO;E6C3FP,a7C2FO;AH87QX;AgDvhRI;EANF;IAOI,W7CsFI;I6CrFJ,Y7CqFI;EHq8QR;AACF;AgDxhRE;EACE,WAAA;EACA,YAAA;AhD0hRJ;;AiDxmRA,mBAAA;AAEA;EACE,WAAA;EACA,kBAAA;AjD0mRF;;AiDvmRA;EACE,YAAA;EACA,iBAAA;AjD0mRF;;AiDvmRA;E7CoFI,kB6CnFqB;AjD0mRzB;;AiDvmRA;EACE,mBAAA;AjD0mRF;;AiDvmRA;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;AjD0mRF;AiDxmRE;EACE,8BAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;AjD0mRJ;AiDxmRE;EACE,yBAAA;AjD0mRJ;AiDxmRE;EACE,yBAAA;EACA,YAAA;AjD0mRJ;;AiDtmRA;EAGE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,W5C7CS;E4C8CT,kBAAA;E7C2CE,kBDtDmB;AHmnRvB;AiDrmRE;EACE,6BAAA;AjDumRJ;AiDrmRE;EACE,iCAAA;AjDumRJ;;AiDlmRE;EACE,aAAA;AjDqmRJ;AiDlmRE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,sBAAA;E7CqBA,kBDtDmB;E8CmCnB,SAAA;EACA,QAAA;EACA,UAAA;AjDomRJ;;AiDhmRA;;EAEE,qBAAA;EACA,eAAA;EACA,YAAA;AjDmmRF;;AiDhmRA;EACE,kBAAA;EACA,kBAAA;EACA,sB5CtFS;EDyFP,kBDxDe;E8CuDjB,yBAAA;AjDmmRF;AiDjmRE;EAEE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;AjDkmRJ;AiD/lRE;EACE,iCAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;AjDimRJ;AiD9lRE;EACE,8BAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;AjDgmRJ;;AiD5lRA;EACE,UAAA;AjD+lRF;;AiD5lRA;E7C1HE,wB6C2HA;E7C1HA,qB6C0HA;E7CzHA,mB6CyHA;E7CxHA,gB6CwHA;AjDkmRF;AiDjmRE;EAEE,aAAA;AjDkmRJ;;AiD9lRA;EACE,mBAAA;AjDimRF;;AiD7lRE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AjDgmRJ;;AiD5lRA;EACE,gBAAA;EACA,mBAAA;AjD+lRF;;AiD5lRA;EACE,WAAA;AjD+lRF;;AiD5lRA,oBAAA;AAEE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AjD8lRJ;AiD5lRI;EACE,OAAA;AjD8lRN;;AiDxlRE;EACE,WAAA;EACA,WAAA;AjD2lRJ;AiDxlRE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AjD0lRJ;AiDvlRE;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AjDylRJ;AiDvlRI;EACE,mBAAA;EACA,+BAAA;EACA,UAAA;EACA,WAAA;AjDylRN;AiDvlRI;EACE,UAAA;EACA,YAAA;AjDylRN;AiDrlRM;EACE,8BAAA;EACA,UAAA;EACA,YAAA;AjDulRR;AiDplRM;EACE,8BAAA;EACA,UAAA;EACA,YAAA;AjDslRR;AiDllRI;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;AjDolRN;;AiD/kRA,oBAAA;AAEE;EACE,mBAAA;AjDilRJ;AiD/kRI;EACE,iBAAA;AjDilRN;AiD7kRE;EACE,WAAA;EACA,YAAA;EACA,SAAA;AjD+kRJ;AiD9kRI;EACE,WAAA;AjDglRN;AiD5kRE;EACE,qBAAA;AjD8kRJ;AiD3kRE;E7C1MA,gCAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;E6CyME,SAAA;EACA,YAAA;AjDglRJ;AiD7kRE;EACE,eAAA;EACA,oBAAA;AjD+kRJ;AiD9kRI;E7CnNF,iCAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;AJoyRF;AiD/kRE;EACE,wBAAA;AjDilRJ;AiD9kRE;EACE,aAAA;AjDglRJ;;AiD5kRA;EACE,YAAA;AjD+kRF;;AiD5kRA;EACE;IACE,iBAAA;EjD+kRF;EiD5kRA;IACE,SAAA;EjD8kRF;EiD1kRE;IACE,mBAAA;EjD4kRJ;EiDzkRE;IACE,oBAAA;IACA,eAAA;EjD2kRJ;AACF;AiDvkRA;EAEI;IACE,WAAA;IACA,kBAAA;IACA,WAAA;EjDwkRJ;EiDvkRI;IACE,UAAA;EjDykRN;EiDrkRE;IACE,OAAA;EjDukRJ;EiDpkRE;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EjDskRJ;EiDpkRI;IACE,8BAAA;IACA,oBAAA;IACA,UAAA;IACA,WAAA;EjDskRN;EiDpkRI;IACE,WAAA;IACA,OAAA;EjDskRN;EiDlkRM;IACE,8BAAA;IACA,WAAA;IACA,WAAA;EjDokRR;EiDlkRM;IACE,8BAAA;IACA,WAAA;IACA,WAAA;EjDokRR;EiD7jRE;IACE,WAAA;EjD+jRJ;EiD5jRE;IACE,WAAA;IACA,cAAA;IACA,kBAAA;EjD8jRJ;EiDzjRE;IACE,gBAAA;IACA,gBAAA;IACA,mBAAA;EjD2jRJ;EiDxjRE;IACE,mBAAA;EjD0jRJ;EiDzjRI;IACE,aAAA;EjD2jRN;EiDxjRI;IACE,eAAA;IACA,SAAA;IACA,aAAA;IACA,UAAA;EjD0jRN;EiDvjRI;IACE,SAAA;EjDyjRN;EiDtjRE;IACE,eAAA;EjDwjRJ;EiDnjRE;IAEE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,kBAAA;EjDojRJ;EiDjjRE;IACE,SAAA;EjDmjRJ;EiDhjRE;IACE,SAAA;EjDkjRJ;AACF;AiD9iRA;EACE;IACE,WAAA;IACA,eAAA;EjDgjRF;EiD7iRA;IACE,WAAA;IACA,cAAA;EjD+iRF;EiD3iRE;IACE,WAAA;IACA,eAAA;EjD6iRJ;AACF;AkD58RA,cAAA;AACA;EAEI;IAEE,UAAA;IACA,kBAAA;IACA,eAAA;ElD48RJ;EkDx8RI;IAEE,UAAA;IACA,mBAAA;ElDy8RN;EkDr8RE;I9C2CF,qBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,a8C7C0B;I9C8C1B,8B8C9CgC;I9C+ChC,0B8C/CgC;I9CgDhC,sB8ChDgC;I9CiDhC,yB8CjDwC;I9CkDxC,qB8ClDwC;I9CmDxC,iB8CnDwC;ElDg9RxC;EkD78RE;IAIE,UAAA;IACA,mBAAA;ElD48RJ;EkDx8RA;IACE,0BAAA;IACA,2BAAA;ElD08RF;AACF;AmD7+RA;EACE,kBAAA;EACA,UAAA;AnD++RF;;AmD5+RA;EACE,YAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AnD++RF;;AmD5+RA;EACE,YAAA;EACA,WAAA;AnD++RF;;AmD5+RA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;AnD++RF;;AmD5+RA;EACE,yBAAA;EACA,kBAAA;EACA,chD0BY;EgDzBZ,eAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AnD++RF;;AmD5+RA;EACE,yBAAA;EACA,kBAAA;EACA,chDcY;EgDbZ,eAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AnD++RF;;AmD5+RA;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;AnD++RF;;AmD5+RA;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;AnD++RF;;AmD5+RA;EACE,cAAA;EACA,UAAA;AnD++RF;;AmD5+RA,4BAAA;AAEA;EACE,kBAAA;AnD8+RF;;AmD3+RA;;EAEE,kBAAA;EACA,kBAAA;AnD8+RF;;AmD3+RA;EACE,iBAAA;AnD8+RF;;AmD3+RA;;EAEE,kBAAA;AnD8+RF;;AmD3+RA;EACE,eAAA;AnD8+RF;;AmD3+RA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AnD8+RF;;AmD3+RA;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sB9ChHS;ED8BT,qE+CmFA;E/ClFA,gE+CkFA;E/CjFA,6D+CiFA;AnDg/RF;;AmD7+RA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,c9CtHS;ALsmSX;;AmD7+RA;EACE,UAAA;EACA,UAAA;EACA,eAAA;AnDg/RF;;AmD7+RA;EACE,eAAA;AnDg/RF;;AmD7+RA;EACE,yB9CvIS;E8CwIT,WAAA;AnDg/RF;;AmD7+RA;EACE,aAAA;AnDg/RF;;AmD7+RA;EACE,sB9CpJS;E8CqJT,mBAAA;AnDg/RF;;AmD7+RA;EACE,aAAA;AnDg/RF;;AmD7+RA;EACE,qBhD1GY;AH0lSd;;AmD7+RA;EACE,yBhD9GY;AH8lSd;;AmD7+RA;EACE,qBhDhHU;AHgmSZ;;AmD7+RA;EACE,qBhDpHU;AHomSZ;;AmD7+RA;EACE,qBhD3FK;AH2kSP;;AmD7+RA;EACE,qBhD/FK;AH+kSP;;AmD7+RA;EACE,qBhDlGQ;AHklSV;;AmD7+RA;EACE,qBhDtGQ;AHslSV;;AmD7+RA;EACE,qBhD5GQ;AH4lSV;;AmD7+RA;EACE,qBhDhHQ;AHgmSV;;AmD7+RA;EACE,kBAAA;AnDg/RF;;AmD7+RA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AnDg/RF;;AmD7+RA;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sB9C3NS;ED8BT,4C+C8LA;E/C7LA,uC+C6LA;E/C5LA,oC+C4LA;AnDk/RF;;AmD/+RA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,yB9CrOS;EDgCT,sCAAA;EACA,kCAAA;EACA,iCAAA;EACA,8BAAA;EATA,sE+C6MA;E/C5MA,iE+C4MA;E/C3MA,8D+C2MA;AnDu/RF;;AmDp/RA;EACE,UAAA;EACA,UAAA;EACA,eAAA;AnDu/RF;;AmDp/RA;EACE,eAAA;AnDu/RF;;AmDp/RA;E/CpNE,sCAAA;EACA,kCAAA;EACA,iCAAA;EACA,8BAAA;AJ4sSF;;AmDt/RA;EACE,aAAA;AnDy/RF;;AmDt/RA;EACE,mBAAA;AnDy/RF;;AmDt/RA;EACE,aAAA;AnDy/RF;;AmDt/RA;EACE,yBhDvNY;AHgtSd;;AmDt/RA;EACE,qBhD3NY;AHotSd;;AmDt/RA;EACE,yBhD/NY;AHwtSd;;AmDt/RA;EACE,yBhDjOU;AH0tSZ;;AmDt/RA;EACE,qBhDrOU;AH8tSZ;;AmDt/RA;EACE,yBhDzOU;AHkuSZ;;AmDt/RA;EACE,yBhDhNK;AHysSP;;AmDt/RA;EACE,qBhDpNK;AH6sSP;;AmDt/RA;EACE,yBhDxNK;AHitSP;;AmDt/RA;EACE,yBhD3NQ;AHotSV;;AmDt/RA;EACE,qBhD/NQ;AHwtSV;;AmDt/RA;EACE,yBhDnOQ;AH4tSV;;AmDt/RA;EACE,yBhDzOQ;AHkuSV;;AmDt/RA;EACE,qBhD7OQ;AHsuSV;;AmDt/RA;EACE,yBhDjPQ;AH0uSV;;AmDt/RA;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;AnDy/RF;;AmDt/RA;;;;EAIE,cAAA;AnDy/RF;;AmDt/RA;EACE,gBAAA;AnDy/RF;;AmDt/RA;EACE,iBAAA;AnDy/RF;;AmDt/RA;EACE,gBAAA;AnDy/RF;;AmDt/RA;EACE,sBAAA;AnDy/RF;;AmDt/RA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,mBAAA;AnDy/RF;;AmDt/RA;EACE,mBAAA;EACA,SAAA;EACA,kBAAA;AnDy/RF;;AmDt/RA;EACE,chD3TmB;EgD4TnB,kBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AnDy/RF;;AmDt/RA;EACE,yB9C1XS;E8C2XT,kBAAA;EAEA,c9C1XS;E8C2XT,cAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;E/CzWA,4C+C0WA;E/CzWA,uC+CyWA;E/CxWA,oC+CwWA;EACA,WAAA;EACA,UAAA;AnD0/RF;;AmDv/RA;EACE,yBhD3VY;EgD4VZ,W9C/YS;ALy4SX;;AmDv/RA;EACE,yBhD9VU;EgD+VV,W9CpZS;AL84SX;;AmDv/RA;;EAEE,c9CnZS;AL64SX;;AmDv/RA;;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yB9ChaS;E8CiaT,UAAA;EACA,OAAA;AnD0/RF;;AmDv/RA;EACE,UAAA;EACA,QAAA;AnD0/RF;;AmDv/RA;;EAEE,yBhDzXU;AHm3SZ;;AmDv/RA;;EAEE,yBhDhYY;AH03Sd;;AmDv/RA;EACE,cAAA;EACA,chDpWO;EgDqWP,gBAAA;EACA,aAAA;AnD0/RF;;AmDv/RA;EACE;IACE,kBAAA;EnD0/RF;EmDv/RA;IACE,mBAAA;EnDy/RF;AACF;AmDt/RA;E/CjZE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B+C0XqB;E/CzXrB,mB+CyXqB;EACrB,mBAAA;AnDmgSF;;AmDhgSA;EACE,kBAAA;AnDmgSF;;AmDhgSA;EACE,sBAAA;EACA,gBAAA;AnDmgSF;;AoD79SA,eAAA;AACA,8BAAA,wBAAA;EACE,eAAA;EACA,0DAAA;ApDg+SF;;AoD79SA,qBAAA,gBAAA;EACE,eAAA;EACA,0DAAA;ApDg+SF;;AoD79SA,yBAAA,WAAA;EACE,eAAA;EACA,0DAAA;ApDg+SF;;AoD79SA,oBAAA,gBAAA;EACE,eAAA;EACA,0DAAA;ApDg+SF;;AoD79SA,iDAAA,wBAAA;EACE,eAAA;ApDg+SF;;AoD79SA,wCAAA,gBAAA;EACE,eAAA;ApDg+SF;;AoD79SA,4CAAA,WAAA;EACE,eAAA;ApDg+SF;;AoD79SA,uCAAA,gBAAA;EACE,eAAA;ApDg+SF;;AoD59SA;EACE,sB/ChCS;E+CiCT,kBAAA;ApD+9SF;AoD99SE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;ApDg+SJ;AoD99SE;EACE,mBAAA;ApDg+SJ;AoD79SE;EACE,6BAAA;EACA,cAAA;EACA,yDAAA;EACA,YAAA;EACA,WAAA;ApD+9SJ;AoD59SE;EACE,gBAAA;ApD89SJ;AoD79SI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;ApD+9SN;AoD39SE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;ApD69SJ;AoDz9SI;EACE,mBAAA;EACA,kBAAA;ApD29SN;AoDx9SI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;ApD09SN;AoDv9SI;EACE,gBAAA;ApDy9SN;AoDx9SM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;ApD09SR;;AoDl9SI;EACE,4BAAA;ApDq9SN;;AoDh9SA,yEAAA;AACA;;EAEE,wBAAA;EACA,SAAA;ApDm9SF;;AoDh9SA,qDAAA;AACA;EACE,0BAAA;ApDm9SF;;AoDh9SA;EAEI;IACE,YAAA;EpDk9SJ;AACF;AqD1kTA;+EAAA;ACAA,eAAA;AACA,eAAA;AAEA;EACE,yBAAA;EACA,aAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;AtD6kTF;AsD5kTE;EARF;IASI,YAAA;EtD+kTF;AACF;;AsD5kTA;EACE,sBAAA;EACA,aAAA;EACA,iCAAA;EACA,4BAAA;EACA,sBAAA;AtD+kTF;AsD9kTE;EANF;IAOI,YAAA;EtDilTF;AACF;;AsD9kTA;EACE,kBAAA;EACA,YAAA;AtDilTF;;AsD9kTA;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,sBjD7BS;EDyFP,kBDxDe;EmDFjB,yBAAA;EACA,eAAA;EACA,cAAA;AtDilTF;;AsD9kTA;EACE,mBAAA;AtDilTF;;AsD9kTA;EACE,yBAAA;AtDilTF;AsD/kTE;EACE,gBAAA;EACA,qBnDMU;AH2kTd;;AsD7kTA;EACE,6BAAA;AtDglTF;;AsD7kTA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AtDglTF;AsD9kTE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;AtDglTJ;;AsD5kTA;ElDhBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EkDmBjE,sBjDxES;EDLT,mDkD8EA;ElD7EA,gDkD6EA;ElD5EA,8CkD4EA;ElD3EA,2CkD2EA;ElDgBE,mBkDfqB;EACvB,eAAA;EACA,gBAAA;AtD4lTF;;AsDzlTA;EACE,uBAAA;EACA,UAAA;EACA,QAAA;AtD4lTF;AsD1lTE;EALF;IAMI,WAAA;IACA,QAAA;EtD6lTF;AACF;;AsD1lTA;EACE,mBAAA;AtD6lTF;;AsD1lTA;EACE,yBAAA;AtD6lTF;AsD3lTE;EACE,gBAAA;EACA,qBnDhDU;AH6oTd;;AsDzlTA;EACE,6BAAA;AtD4lTF;;AsDzlTA;EACE,yBnDzDY;EmD0DZ,uBAAA;EACA,UAAA;EACA,QAAA;AtD4lTF;AsD1lTE;EANF;IAOI,WAAA;IACA,QAAA;EtD6lTF;AACF;;AsD1lTA;ElDjEE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BkD0CqB;ElDzCrB,mBkDyCqB;ElD/CrB,sCkDgDyB;ElD/CzB,8BkD+CyB;AtDymT3B;AsDvmTE;EAEE,SAAA;AtDwmTJ;AsDrmTE;EACE,yBAAA;ElDzCA,kBkD0CuB;EACvB,cnDjFU;AHwrTd;AsDrmTI;EAEE,WjDxIK;EiDyIL,yBnDtFQ;AH4rTd;AsDlmTE;EACE,gBAAA;AtDomTJ;;AuDzvTA,eAAA;AAEA;EACE,eAAA;EACA,kBAAA;AvD2vTF;AuDzvTE;EAJF;IAKI,eAAA;EvD4vTF;AACF;;AuDzvTA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AvD4vTF;AuD1vTE;EANF;IAOI,eAAA;EvD6vTF;AACF;AuD3vTE;EAVF;IAWI,UAAA;EvD8vTF;AACF;;AuD3vTA;EACE,clDXS;EkDYT,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kDAAA;AvD8vTF;AuD5vTE;EARF;IASI,gBAAA;EvD+vTF;AACF;AuD7vTE;EAZF;IAaI,gBAAA;EvDgwTF;AACF;AuD9vTE;EAhBF;IAiBI,eAAA;EvDiwTF;AACF;;AuD9vTA;EACE,mBpD4GQ;AHqpTV;AuD/vTE;EAHF;IAII,mBAAA;EvDkwTF;AACF;;AwDtzTA,gBAAA;AACA;EpD4DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJywTnE;;AwDh0TA;EACE,kBAAA;AxDm0TF;;AyDz0TA,sBAAA;AAEA;EACE,aAAA;AzD20TF;;AyDv0TE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;ErDmDF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BqD1EuB;ErD2EvB,mBqD3EuB;EACrB,8BAAA;EACA,uBAAA;EACA,sBAAA;AzDq1TJ;AyDn1TI;ErD0DF,mBAAA;EACA,eAAA;EACA,WAAA;EqD1DI,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,qBAAA;AzDu1TN;AyDr1TM;EACE,cAAA;AzDu1TR;AyDp1TM;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AzDs1TR;AyDn1TM;EACE,gBAAA;AzDq1TR;AyDp1TQ;EACE,gBAAA;EACA,cAAA;AzDs1TV;AyDn1TQ;EACE,yBAAA;EACA,WpDpCC;EDyFP,kBqDpD6B;EACvB,iBAAA;EACA,kBAAA;AzDq1TV;AyDp1TU;EACE,eAAA;AzDs1TZ;AyDl1TQ;EACE,yBAAA;AzDo1TV;AyDj1TQ;EACE,yBAAA;AzDm1TV;AyDh1TQ;EACE,yBAAA;AzDk1TV;AyD70TI;EACE,cAAA;EACA,gBAAA;AzD+0TN;AyD90TM;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AzDg1TR;AyD90TQ;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AzDg1TV;;AyDx0TA;EACE;IACE,aAAA;EzD20TF;EyDv0TE;IACE,cAAA;IACA,gBAAA;EzDy0TJ;EyDx0TI;IACE,iBAAA;IACA,oBAAA;IACA,gCAAA;IACA,mBAAA;EzD00TN;EyDx0TM;IACE,cAAA;IACA,gBAAA;IACA,iBAAA;EzD00TR;EyDp0TA;IACE,oBAAA;IACA,kBAAA;EzDs0TF;EyDr0TE;IACE,eAAA;EzDu0TJ;EyDr0TE;IACE,eAAA;EzDu0TJ;AACF;A0D77TA,mBAAA;AAGE;EACE,mBAAA;A1D67TJ;A0D57TI;EACE,WAAA;EtD+BJ,mCsD9BI;EtD+BJ,8BsD/BI;EtDgCJ,2BsDhCI;A1Dg8TN;A0D77TM;EACE,8BAAA;EACA,0BAAA;EACA,sBAAA;A1D+7TR;;A0Dx7TE;EACE,eAAA;EACA,oBAAA;A1D27TJ;A0D17TI;EACE,qBAAA;EACA,mBAAA;EACA,eAAA;A1D47TN;A0Dz7TI;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;A1D27TN;A0Dx7TI;EAGE,eAAA;EACA,yBvDgBQ;EuDfR,qBvDeQ;EuDdR,WrDrCK;AL69TX;A0Dr7TI;EA3BF;IA4BI,mBAAA;E1Dw7TJ;AACF;;A2Dz+TA,cAAA;AAEA;EACE,mBAAA;A3D2+TF;;A2Dv+TA;EACE,aAAA;EACA,yBAAA;EACA,sBtDHS;EsDIT,aAAA;A3D0+TF;A2Dx+TE;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;A3D0+TJ;A2Dx+TI;EACE,gBAAA;A3D0+TN;;A2Dp+TA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EvDiEE,kBuDhEqB;EACvB,mBAAA;EACA,WtD3BS;ALkgUX;A2Dr+TE;EACE,gBAAA;EAEE,0CAAA;EACA,eAAA;EAEF,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,2BAAA;A3Dq+TJ;A2Dl+TE;EvD+CE,0BuD9CuB;A3Do+T3B;A2Dn+TI;EACE,0BAAA;A3Dq+TN;;A2D/9TA;EACE,gBAAA;A3Dk+TF;A2Dj+TE;EACE,mBAAA;A3Dm+TJ;A2Dl+TI;EACE,gBAAA;A3Do+TN;A2Dj+TE;EACE,cxDTU;AH4+Td;A2Dj+TE;EACE,cAAA;A3Dm+TJ;;A2D99TE;EACE,mBAAA;A3Di+TJ;A2Dh+TI;EACE,gBAAA;A3Dk+TN;;A2D79TA;EACE,cAAA;EACA,mBAAA;A3Dg+TF;A2D/9TE;EvDUE,kBuDTuB;EACvB,WAAA;A3Di+TJ;;A2D59TE;EACE,gBAAA;EACA,kBAAA;A3D+9TJ;;A2D39TA;EACE,mBAAA;A3D89TF;;A2D39TA;;EAEE,eAAA;EACA,ctD9FS;EsD+FT,qBAAA;A3D89TF;A2D79TE;;EACE,qBAAA;EACA,iBAAA;A3Dg+TJ;;A2D39TE;EACE,iBAAA;A3D89TJ;;A4DllUA,mBAAA;AACA;EACE,kBAAA;A5DqlUF;A4DnlUE;;EAEE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBvD8S0B;ALuyT9B;A4DplUI;;EACE,eAAA;EACA,gBAAA;A5DulUN;A4DrlUI;;EACE,eAAA;EACA,iBAAA;A5DwlUN;A4DplUE;EACE,yCAAA;A5DslUJ;A4DnlUE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;A5DqlUJ;A4DnlUI;EACE,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBvDhCK;EuDiCL,qCAAA;EACA,eAAA;EACA,cvD7BK;EuD8BL,kBAAA;A5DqlUN;A4DplUM;EACE,iBAAA;EACA,eAAA;A5DslUR;;A4DhlUA;EACE,mBAAA;A5DmlUF;A4DjlUE;EACE,kBAAA;EACA,cAAA;A5DmlUJ;A4DhlUE;EACE,mBAAA;A5DklUJ;;A4D5kUE;;EAEE,eAAA;A5D+kUJ;;A4D1kUE;EACE,oCAAA;A5D6kUJ;A4D3kUE;EACE,iBAAA;EACA,oBAAA;A5D6kUJ;;A4DzkUA;EACE,gBAAA;EACA,gBAAA;EACA,8BAAA;A5D4kUF;A4D3kUE;EACE,eAAA;A5D6kUJ;;A4DzkUA;EACE,gBAAA;A5D4kUF;A4D3kUE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;A5D6kUJ;A4D3kUI;EANF;IAOI,UAAA;E5D8kUJ;AACF;A4D5kUI;EAVF;IAWI,cAAA;E5D+kUJ;AACF;;A4D1kUE;EACE,oBAAA;A5D6kUJ;;A4DzkUA,6BAAA;AACA;EACE,eAAA;A5D4kUF;A4D1kUE;EAHF;IAII,eAAA;E5D6kUF;AACF;;A4D1kUA;EACE,eAAA;A5D6kUF;A4D3kUE;EAHF;IAII,eAAA;E5D8kUF;AACF;;A4D1kUE;EACE,QAAA;EACA,kBAAA;A5D6kUJ;A4D3kUI;EAJF;IAKI,QAAA;E5D8kUJ;AACF;A4D3kUE;EACE,QAAA;A5D6kUJ;A4D3kUI;EAHF;IAII,QAAA;E5D8kUJ;AACF;;A4D1kUA;EACE,kBAAA;EACA,mBAAA;EACA,gCAAA;A5D6kUF;A4D3kUE;EACE;;IAEE,0BAAA;E5D6kUJ;AACF;;A4DxkUE;EACE,eAAA;EACA,kBAAA;A5D2kUJ;;A4DvkUA;EACE,WAAA;A5D0kUF;;A4DtkUE;EACE,kBAAA;A5DykUJ;;A4DrkUA,4BAAA;AACA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;ExD/HA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BwDwGqB;ExDvGrB,mBwDuGqB;A5DmlUvB;A4DjlUE;EACE,SAAA;EACA,WzDtCM;EyDuCN,YzDvCM;EyDwCN,WvD7LO;EuD8LP,eAAA;ExDrGA,kBDtDmB;ECmBrB,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,awDsIwB;ExDrIxB,8BwDqI8B;ExDpI9B,0BwDoI8B;ExDnI9B,sBwDmI8B;ExDlI9B,yBwDkIsC;ExDjItC,qBwDiIsC;ExDhItC,iBwDgIsC;ExDtHtC,+BwDuH2B;ExDtH3B,uBwDsH2B;ExDlH3B,2BwDmHuB;ExDlHvB,mBwDkHuB;ExDpKvB,kCwDqKE;ExDpKF,6BwDoKE;ExDnKF,0BwDmKE;EACA,kBAAA;EACA,UAAA;A5DimUJ;A4D9lUE;EACE,WAAA;EACA,YAAA;EACA,eAAA;ExDlHA,gBwDmHuB;EACvB,kBAAA;EACA,OAAA;A5DgmUJ;;A4D5lUA;ExD5JE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BwDqIqB;ExDpIrB,mBwDoIqB;EACrB,iBzD5DS;EyD6DT,kBAAA;EACA,gBAAA;A5D0mUF;A4DxmUE;EACE,8BAAA;EACA,gBAAA;A5D0mUJ;A4DvmUE;EACE,oBAAA;A5DymUJ;A4DtmUE;EACE,yBAAA;A5DwmUJ;;A4DpmUA;EACE,eAAA;A5DumUF;;A4DpmUA;EACE,iBzDnFS;AH0rUX;;A4DpmUA;ExDzLE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BwDkKqB;ExDjKrB,mBwDiKqB;EACrB,mBAAA;A5DknUF;;A4D/mUA;EACE,uBAAA;EACA,wBAAA;A5DknUF;;A4D7mUI;EACE,kBAAA;A5DgnUN;;A4D3mUA;EACE,kBAAA;A5D8mUF;A4D5mUE;EACE,8BAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;A5D8mUJ;;A4DzmUA;EACE,kBAAA;EACA,kBAAA;A5D4mUF;A4D1mUE;EACE,8BAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;A5D4mUJ;;A4DxmUA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;ExD7ME,kBwD8MqB;EACvB,YAAA;EACA,WAAA;EACA,yBvDrSS;ALg5UX;;A4DxmUA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;ExDvNE,kBDtDmB;AHy3UvB;;A4DxmUA;EACE,cAAA;A5D2mUF;A4DzmUE;EACE,mBAAA;A5D2mUJ;A4DxmUE;EACE,eAAA;EACA,kBAAA;A5D0mUJ;A4DvmUE;EACE,cAAA;EACA,kBAAA;EACA,czD3OS;AHo1Ub;A4DvmUI;EAEE,czDpRQ;EyDqRR,qBAAA;A5DwmUN;;A4DlmUE;EACE,kBAAA;A5DqmUJ;A4DnmUE;EACE,yBvDhVO;EuDiVP,gBAAA;EACA,iBAAA;EACA,cvD/UO;EuDgVP,eAAA;EACA,yBzD7QQ;AHk3UZ;A4DnmUI;EACE,yBzDvSQ;EyDwSR,WvD3VK;EuD4VL,qBzDzSQ;AH84Ud;A4DnmUM;EAEE,WvDhWG;ALo8UX;A4D/lUE;ExDjPE,2BDpFY;ECqFZ,8BDrFY;AHw6UhB;A4D/lUE;ExDnQE,4BDtEY;ECuEZ,+BDvEY;AH46UhB;;A4D9lUA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0DAAA;A5DimUF;A4D/lUE;EACE,mBAAA;A5DimUJ;A4DhmUI;EAFF;IAGI,mBAAA;E5DmmUJ;AACF;A4DhmUE;EACE,WAAA;EACA,YAAA;A5DkmUJ;A4D/lUE;EACE,qBAAA;A5DimUJ;A4D/lUI;EACE,cAAA;A5DimUN;A4D/lUM;EAHF;IAII,cAAA;E5DkmUN;AACF;A4DhmUM;EAPF;IAQI,aAAA;E5DmmUN;AACF;A4DjmUM;EAXF;IAYI,cAAA;E5DomUN;AACF;;A4D7lUE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;A5DgmUJ;A4D9lUI;EAEE,cAAA;A5D+lUN;;A6DpgVA,kBAAA;AACA;EACE,kBAAA;A7DugVF;;A6DpgVA;EACE,mBAAA;A7DugVF;A6DrgVE;EACE,cAAA;EACA,aAAA;EzDmDF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,ayDtDwB;EzDuDxB,8ByDvD8B;EzDwD9B,0ByDxD8B;EzDyD9B,sByDzD8B;EzD0D9B,yByD1DsC;EzD2DtC,qByD3DsC;EzD4DtC,iByD5DsC;EzDsEtC,+ByDrE2B;EzDsE3B,uByDtE2B;A7DkhV7B;A6DhhVI;EACE,gBAAA;A7DkhVN;A6D9gVE;EACE,gBAAA;A7DghVJ;;A6D5gVA;EACE,gBAAA;EACA,eAAA;A7D+gVF;A6D7gVE;EACE,kBAAA;A7D+gVJ;;A6D1gVE;EACE,kBAAA;A7D6gVJ;A6D1gVE;EACE,gBAAA;EACA,cAAA;A7D4gVJ;;A8DpjVA;+EAAA;AAEA;EAEE,yBAAA;EACA,sBzDES;EDyFP,kBDxDe;E2DjCjB,mBAAA;EACA,mBAAA;A9DsjVF;A8DpjVE;EAEE,kBAAA;A9DqjVJ;A8DnjVI;EACE,WAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;A9DqjVN;A8DljVI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;A9DojVN;A8DhjVE;E1DMA,6C0DLE;E1DMF,wC0DNE;E1DOF,qC0DPE;EACA,oCAAA;A9DojVJ;A8DjjVE;EAlCF;IAmCI,mBAAA;E9DojVF;AACF;;A8DhjVE;EACE,qBAAA;EACA,WAAA;A9DmjVJ;;A8D9iVE;EACE,eAAA;A9DijVJ;;A+DnmVA;+EAAA;ACAA,qBAAA;AAEA;E5D2DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4D9DsB;E5D+DtB,8B4D/D4B;E5DgE5B,0B4DhE4B;E5DiE5B,sB4DjE4B;E5DkE5B,yB4DlEoC;E5DmEpC,qB4DnEoC;E5DoEpC,iB4DpEoC;E5DmFpC,4B4DlFqB;E5DmFrB,oB4DnFqB;EACrB,YAAA;AhEknVF;;AgE/mVA;EACE,kBAAA;E5DoDA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DvDsB;E5DwDtB,2B4DxD4B;E5DyD5B,uB4DzD4B;E5D0D5B,mB4D1D4B;E5D2D5B,yB4D3DiC;E5D4DjC,qB4D5DiC;E5D6DjC,iB4D7DiC;EACjC,2BAAA;AhE4nVF;AgE1nVE;EALF;IAMI,aAAA;EhE6nVF;AACF;;AgE1nVA;EACE,kBAAA;EACA,UAAA;E5DyCA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4D5CsB;E5D6CtB,8B4D7C4B;E5D8C5B,0B4D9C4B;E5D+C5B,sB4D/C4B;E5DgD5B,yB4DhDoC;E5DiDpC,qB4DjDoC;E5DkDpC,iB4DlDoC;E5DsDpC,uBAAA;EACA,mBAAA;EACA,eAAA;E4DtDA,gBAAA;EACA,gBAAA;AhEyoVF;;AgEtoVA;EACE,gCAAA;E5DiCA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DpCsB;E5DqCtB,8B4DrC4B;E5DsC5B,0B4DtC4B;E5DuC5B,sB4DvC4B;E5DwC5B,yB4DxCoC;E5DyCpC,qB4DzCoC;E5D0CpC,iB4D1CoC;AhEmpVtC;AgEjpVE;EACE,kBAAA;EACA,kBAAA;AhEmpVJ;;AgE/oVA;EACE,aAAA;E5DuBA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4D9CqB;E5D+CrB,mB4D/CqB;E5DyCrB,+B4DxCyB;E5DyCzB,uB4DzCyB;EACzB,gBAAA;EACA,eAAA;EACA,qEAAA;EACA,yDAAA;AhE8pVF;AgE7pVE;EACE,eAAA;AhE+pVJ;;AgE3pVA;E5DUE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DbsB;E5DctB,8B4Dd4B;E5De5B,0B4Df4B;E5DgB5B,sB4DhB4B;E5DiB5B,yB4DjBoC;E5DkBpC,qB4DlBoC;E5DmBpC,iB4DnBoC;AhEwqVtC;;AgErqVA;EACE,eAAA;AhEwqVF;;AgEjqVA;E5DFE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;E4DKjE,aAAA;AhE8qVF;;AgE3qVA;EACE,gBAAA;EACA,eAAA;E5DTA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DMsB;E5DLtB,8B4DK4B;E5DJ5B,0B4DI4B;E5DH5B,sB4DG4B;E5DF5B,yB4DEoC;E5DDpC,qB4DCoC;E5DApC,iBAAA;EAUA,+B4DTyB;E5DUzB,uB4DVyB;AhEyrV3B;AgEvrVE;E5DbA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DUwB;E5DTxB,8B4DS8B;E5DR9B,0B4DQ8B;E5DP9B,sB4DO8B;E5DN9B,yB4DMsC;E5DLtC,qB4DKsC;E5DJtC,iB4DIsC;AhEmsVxC;AgEhsVE;EACE,kBAAA;EACA,cAAA;E5DnBF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4DJuB;E5DKvB,mB4DLuB;EACrB,qBAAA;AhE6sVJ;AgE3sVI;EAEE,c7DQO;AHosVb;AgEzsVI;EACE,c7DjCQ;AH4uVd;AgEvsVE;EACE,kBAAA;EACA,eAAA;AhEysVJ;AgEtsVE;EACE,qBAAA;EACA,sBAAA;AhEwsVJ;AgErsVE;EACE,kBAAA;AhEusVJ;;AgEnsVA;EACE,kBAAA;EACA,UAAA;E5DnDA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DgDsB;E5D/CtB,8B4D+C4B;E5D9C5B,0B4D8C4B;E5D7C5B,sB4D6C4B;E5D5C5B,yB4D4CoC;E5D3CpC,qB4D2CoC;E5D1CpC,iB4D0CoC;E5DtCpC,sBAAA;EACA,kBAAA;EACA,cAAA;E4DsCA,6BAAA;AhEktVF;;AgE/sVA;EACE,kBAAA;EACA,gBAAA;E5D3DA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DwDsB;E5DvDtB,8B4DuD4B;E5DtD5B,0B4DsD4B;E5DrD5B,sB4DqD4B;E5DpD5B,yB4DoDoC;E5DnDpC,qB4DmDoC;E5DlDpC,iB4DkDoC;E5DxCpC,+B4DyCyB;E5DxCzB,uB4DwCyB;EACzB,sB3DpHS;E2DqHT,gCAAA;AhE6tVF;AgE3tVE;EACE,gBAAA;AhE6tVJ;AgE3tVI;E5DjCA,gB4DkCyB;EACvB,YAAA;EACA,4BAAA;AhE6tVN;AgE3tVM;EACE,yB3D/HG;AL41VX;AgEztVI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;AhE2tVN;;AgEttVA;E5DzFE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4DkEqB;E5DjErB,mB4DiEqB;E5DvErB,sC4DwEyB;E5DvEzB,8B4DuEyB;AhEquV3B;;AgEluVA;EACE,sB3DtJS;EDsDT,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4D6FsB;E5D5FtB,8B4D4F4B;E5D3F5B,0B4D2F4B;E5D1F5B,sB4D0F4B;E5DzF5B,yB4DyFoC;E5DxFpC,qB4DwFoC;E5DvFpC,iB4DuFoC;AhE+uVtC;;AgE5uVA;EACE,iBAAA;E5DrGA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;E4DwGjE,gCAAA;AhEyvVF;AgEvvVE;E5DtEE,gB4DuEuB;AhEyvV3B;;AgErvVA;EACE,kBAAA;AhEwvVF;AgEtvVE;EAHF;IAII,kBAAA;EhEyvVF;AACF;;AgEtvVA;E5DtHE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4D+FqB;E5D9FrB,mB4D8FqB;EACrB,mBAAA;AhEowVF;;AgEjwVA;EACE,kBAAA;AhEowVF;;AgEjwVA;EACE,8BAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AhEowVF;;AgEjwVA;EACE,iBAAA;AhEowVF;;AgEjwVA;E5D3IE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DwIsB;E5DvItB,8B4DuI4B;E5DtI5B,0B4DsI4B;E5DrI5B,sB4DqI4B;E5DpI5B,yB4DoIoC;E5DnIpC,qB4DmIoC;E5DlIpC,iB4DkIoC;E5DxHpC,+B4DyHyB;E5DxHzB,uB4DwHyB;AhE+wV3B;;AgE5wVA;E5DhJE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4DyHqB;E5DxHrB,mB4DwHqB;EACrB,kBAAA;EACA,gCAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AhE0xVF;AgExxVE;EACE,cAAA;EACA,gBAAA;AhE0xVJ;AgEvxVE;EACE,kBAAA;E5DtIF,0B4DuIuB;E5DtIvB,kB4DsIuB;AhE0xVzB;;AgEtxVA;EACE,mBAAA;AhEyxVF;AgEvxVE;EACE,kBAAA;AhEyxVJ;;AgErxVA;E5D9JE,mBAAA;EACA,eAAA;EACA,WAAA;EAhBA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4D0KsB;E5DzKtB,8B4DyK4B;E5DxK5B,0B4DwK4B;E5DvK5B,sB4DuK4B;E5DtK5B,yB4DsKoC;E5DrKpC,qB4DqKoC;E5DpKpC,iB4DoKoC;EACpC,6BAAA;AhEoyVF;;AgEjyVA;EACE,kBAAA;AhEoyVF;AgElyVE;EACE,kBAAA;AhEoyVJ;;AgEhyVA;EACE,iBAAA;AhEmyVF;;AgEhyVA;EACE,sB3DrPS;E2DsPT,+BAAA;EACA,kBAAA;EACA,UAAA;AhEmyVF;AgEjyVE;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;AhEmyVJ;;AgE/xVA;EACE,gBAAA;AhEkyVF;AgEhyVE;EACE,aAAA;AhEkyVJ;;AgE9xVA;EACE,kBAAA;AhEiyVF;;AgE9xVA;EACE,eAAA;AhEiyVF;;AgE9xVA;EACE,kBAAA;AhEiyVF;;AgE9xVA;E5D/NE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EAqBjE,sC4D6MyB;E5D5MzB,8B4D4MyB;E5DxMzB,2B4DyMqB;E5DxMrB,mB4DwMqB;EACrB,WAAA;EACA,eAAA;AhE6yVF;;AgE1yVA;E5DvOE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DoOsB;E5DnOtB,8B4DmO4B;E5DlO5B,0B4DkO4B;E5DjO5B,sB4DiO4B;E5DhO5B,yB4DgOoC;E5D/NpC,qB4D+NoC;E5D9NpC,iB4D8NoC;E5DpNpC,+B4DqNyB;E5DpNzB,uB4DoNyB;E5DhNzB,2B4DiNqB;E5DhNrB,mB4DgNqB;AhEyzVvB;;AgEjzVA;E5DzNE,2B4D0NqB;E5DzNrB,mB4DyNqB;AhEqzVvB;;AgElzVA;EACE;I5DvPA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,iBAAA;IACA,c4DoPwB;I5DnPxB,2B4DmP+B;I5DlP/B,uB4DkP+B;I5DjP/B,mB4DiP+B;I5DhP/B,yB4DgPoC;I5D/OpC,qB4D+OoC;I5D9OpC,iB4D8OoC;I5D1OpC,sBAAA;IACA,kBAAA;IACA,cAAA;I4D0OE,gB7D/La;I6DgMb,gB7DhMa;I6DiMb,sB3DlTO;ELmnWT;EgE9zVA;IACE,kBAAA;IACA,gBAAA;IACA,0BAAA;EhEg0VF;EgE9zVE;IACE,kBAAA;IACA,OAAA;IACA,MAAA;IACA,UAAA;IACA,+BAAA;IACA,YAAA;IACA,WAAA;I5DxOF,gB4DyOyB;IACvB,eAAA;EhEg0VJ;EgE7zVE;IACE,YAAA;IACA,0BAAA;EhE+zVJ;EgE5zVE;IACE,YAAA;EhE8zVJ;EgE1zVA;IACE,2BAAA;EhE4zVF;EgEzzVA;IACE,eAAA;EhE2zVF;AACF;AgExzVA;EACE;IACE,gBAAA;EhE0zVF;AACF;AgEvzVA;EACE;IACE,cAAA;EhEyzVF;AACF;AgEtzVA;EACE;IACE,cAAA;IACA,eAAA;EhEwzVF;EgEtzVE;IACE,gBAAA;EhEwzVJ;AACF;AgEpzVA;EACE;IACE,kBAAA;EhEszVF;EgEnzVA;IACE,eAAA;EhEqzVF;EgEjzVE;IACE,sBAAA;IACA,kBAAA;EhEmzVJ;EgEhzVE;IACE,gBAAA;EhEkzVJ;EgEhzVI;I5DzSF,sB4D0S2B;EhEkzV7B;EgE7yVI;IACE,WAAA;IACA,SAAA;EhE+yVN;EgE5yVI;IACE,WAAA;IACA,SAAA;EhE8yVN;EgE1yVE;IACE,kBAAA;EhE4yVJ;AACF;AgExyVA;EAEI;IACE,gBAAA;EhEyyVJ;AACF;AgEryVA;EACE;IACE,wBAAA;EhEuyVF;AACF;AiEltWA,qBAAA;AAEA;E7DyEE,sBAAA;EACA,kBAAA;EACA,cAAA;AJ2oWF;AiEntWE;EACE,WAAA;AjEqtWJ;;AiEjtWA;E7DmDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DtDsB;E7DuDtB,2B6DvD4B;E7DwD5B,uB6DxD4B;E7DyD5B,mB6DzD4B;E7D0D5B,yB6D1DiC;E7D2DjC,qB6D3DiC;E7D4DjC,iB6D5DiC;E7DgEjC,sBAAA;EACA,kBAAA;EACA,cAAA;E6DhEA,yB5DLS;E4DMT,kBAAA;EACA,WAAA;AjEguWF;;AiE7tWA;E7D2CE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6D9CsB;E7D+CtB,8B6D/C4B;E7DgD5B,0B6DhD4B;E7DiD5B,sB6DjD4B;E7DkD5B,yB6DlDoC;E7DmDpC,qB6DnDoC;E7DoDpC,iB6DpDoC;E7DwDpC,uBAAA;EACA,mBAAA;EACA,eAAA;E6DxDA,gBAAA;EACA,+BAAA;AjE4uWF;;AiEzuWA;E7DoCE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DvCsB;E7DwCtB,8B6DxC4B;E7DyC5B,0B6DzC4B;E7D0C5B,sB6D1C4B;E7D2C5B,yB6D3CoC;E7D4CpC,qB6D5CoC;E7D6CpC,iB6D7CoC;E7DiDpC,sBAAA;EACA,kBAAA;EACA,cAAA;E6DjDA,eAAA;EACA,kBAAA;EACA,UAAA;AjEwvWF;;AiErvWA;E7D4BE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6D/BsB;E7DgCtB,8B6DhC4B;E7DiC5B,0B6DjC4B;E7DkC5B,sB6DlC4B;E7DmC5B,yB6DnCoC;E7DoCpC,qB6DpCoC;E7DqCpC,iB6DrCoC;EACpC,uBAAA;EACA,qEAAA;AjEkwWF;;AiE/vWA;E7DsBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;E6DnBjE,mBAAA;AjE4wWF;;AiEzwWA;E7DiBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DpBsB;E7DqBtB,8B6DrB4B;E7DsB5B,0B6DtB4B;E7DuB5B,sB6DvB4B;E7DwB5B,yB6DxBoC;E7DyBpC,qB6DzBoC;E7D0BpC,iB6D1BoC;EACpC,gBAAA;AjEsxWF;AiEpxWE;E7D2BA,sBAAA;EACA,kBAAA;EACA,cAAA;AJ4vWF;AiEtxWI;E7DjDF,wB6DkDI;E7DjDJ,qB6DiDI;E7DhDJ,mB6DgDI;E7D/CJ,gB6D+CI;E7D4CF,gB6D3CyB;EACvB,kBAAA;EACA,YAAA;AjE2xWN;AiExxWI;EACE,UAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;AjE0xWN;;AiErxWA;EACE,e9DwFQ;AHgsWV;AiEtxWE;EACE,cAAA;EACA,eAAA;AjEwxWJ;AiErxWE;EACE,eAAA;AjEuxWJ;;AiEnxWA;EACE,kBAAA;EACA,e9D0EQ;AH4sWV;AiEpxWE;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AjEsxWJ;AiEpxWI;EACE,UAAA;EACA,WAAA;AjEsxWN;AiEnxWI;EACE,yBAAA;AjEqxWN;AiEjxWI;EACE,sB5DlGK;E4DmGL,yBAAA;AjEmxWN;AiE/wWI;EACE,yBAAA;AjEixWN;AiE5wWE;EACE,e9DwCM;AHsuWV;;AiE1wWA;EACE,sB5DnHS;ALg4WX;;AiE1wWA;EACE,kBAAA;EACA,e9D3Ge;E8D4Gf,c9DvCK;EC5BL,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DgEsB;E7D/DtB,8B6D+D4B;E7D9D5B,0B6D8D4B;E7D7D5B,sB6D6D4B;E7D5D5B,yB6D4DoC;E7D3DpC,qB6D2DoC;E7D1DpC,iB6D0DoC;E7DhDpC,+B6DiDyB;E7DhDzB,uB6DgDyB;AjEwxW3B;;AiErxWA;EACE,gFAAA;AjEwxWF;;AiErxWA;E7D5EE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DyEsB;E7DxEtB,8B6DwE4B;E7DvE5B,0B6DuE4B;E7DtE5B,sB6DsE4B;E7DrE5B,yB6DqEoC;E7DpEpC,qB6DoEoC;E7DnEpC,iB6DmEoC;AjEkyWtC;AiEhyWE;E7D3DA,+B6D4D2B;E7D3D3B,uB6D2D2B;E7DvD3B,2B6DwDuB;E7DvDvB,mB6DuDuB;AjEoyWzB;AiElyWI;EACE,iBAAA;AjEoyWN;;AiE/xWA;EACE,gCAAA;EACA,aAAA;E7D3FA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DwFsB;E7DvFtB,8B6DuF4B;E7DtF5B,0B6DsF4B;E7DrF5B,sB6DqF4B;E7DpF5B,yB6DoFoC;E7DnFpC,qB6DmFoC;E7DlFpC,iB6DkFoC;E7DxEpC,+B6DyEyB;E7DxEzB,uB6DwEyB;EACzB,eAAA;EACA,gBAAA;AjE6yWF;AiE3yWE;EAEE,qEAAA;AjE4yWJ;;AiExyWA;EACE,cAAA;E7D/EA,2B6DgFqB;E7D/ErB,mB6D+EqB;AjE4yWvB;;AiEzyWA;EACE,cAAA;AjE4yWF;AiE1yWE;EACE,gBAAA;AjE4yWJ;AiEzyWE;EACE,cAAA;EACA,kBAAA;AjE2yWJ;;AiEvyWA;EACE,c5D1KS;E4D2KT,eAAA;AjE0yWF;;AiEvyWA;EACE,cAAA;EACA,iBAAA;AjE0yWF;;AiEnyWA;E7DvIE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DoIsB;E7DnItB,8B6DmI4B;E7DlI5B,0B6DkI4B;E7DjI5B,sB6DiI4B;E7DhI5B,yB6DgIoC;E7D/HpC,qB6D+HoC;E7D9HpC,iB6D8HoC;E7DpHpC,+B6DqHyB;E7DpHzB,uB6DoHyB;EACzB,YAAA;AjEizWF;;AiE9yWA;E7D7IE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6D0IsB;E7DzItB,8B6DyI4B;E7DxI5B,0B6DwI4B;E7DvI5B,sB6DuI4B;E7DtI5B,yB6DsIoC;E7DrIpC,qB6DqIoC;E7DpIpC,iB6DoIoC;E7D1HpC,+B6D2HyB;E7D1HzB,uB6D0HyB;E7DtHzB,2B6DuHqB;E7DtHrB,mB6DsHqB;EACrB,YAAA;EACA,aAAA;AjE6zWF;;AiE1zWA;EACE,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,mBAAA;AjE6zWF;;AiE1zWA;E7D7JE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6D0JsB;E7DzJtB,8B6DyJ4B;E7DxJ5B,0B6DwJ4B;E7DvJ5B,sB6DuJ4B;E7DtJ5B,yB6DsJoC;E7DrJpC,qB6DqJoC;E7DpJpC,iB6DoJoC;AjEu0WtC;;AiEp0WA;E7DjKE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B6D0IqB;E7DzIrB,mB6DyIqB;EACrB,gCAAA;EACA,aAAA;EACA,sB5D5NS;E4D6NT,WAAA;AjEk1WF;;AiE/0WA;E7D1KE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B6DmJqB;E7DlJrB,mB6DkJqB;EACrB,kBAAA;AjE61WF;;AiE11WA;EACE,eAAA;EACA,gBAAA;AjE61WF;;AiE11WA;E7DrLE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DkLsB;E7DjLtB,8B6DiL4B;E7DhL5B,0B6DgL4B;E7D/K5B,sB6D+K4B;E7D9K5B,yB6D8KoC;E7D7KpC,qB6D6KoC;E7D5KpC,iB6D4KoC;EACpC,6BAAA;EACA,aAAA;EACA,sB5D/OS;E4DgPT,WAAA;AjEu2WF;AiEr2WE;EACE,gBAAA;AjEu2WJ;;AiEn2WA;EACE,iBAAA;AjEs2WF;;AiEn2WA;EACE,aAAA;AjEs2WF;AiEp2WE;EACE,iBAAA;EACA,sB5DhQO;EDyFP,iC6DwKuB;EACvB,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AjEs2WJ;AiEl2WI;EACE,kBAAA;EACA,cAAA;EACA,qEAAA;E7DnLF,+B6DoLyB;AjEo2W7B;;AiE/1WA;EACE,0BAAA;EACA,qBAAA;AjEk2WF;;AiE/1WA;EACE,YAAA;E7D7RA,wB6D8RA;E7D7RA,qB6D6RA;E7D5RA,mB6D4RA;E7D3RA,gB6D2RA;E7DhME,gB6DiMqB;AjEq2WzB;;AiEl2WA;EACE,eAAA;EACA,c5D1RS;AL+nXX;;AiEl2WA;EACE;IACE,2BAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;EjEq2WF;AACF;AiEl2WA;EACE;IACE,yBAAA;IACA,cAAA;EjEo2WF;EiEj2WA;IACE,iBAAA;EjEm2WF;EiEj2WE;IACE,uBAAA;IACA,sBAAA;IACA,iBAAA;EjEm2WJ;EiEh2WE;IACE,gBAAA;EjEk2WJ;EiE71WE;IACE,eAAA;EjE+1WJ;EiE31WA;;IAEE,eAAA;EjE61WF;EiE11WA;IACE,iBAAA;EjE41WF;EiEz1WA;IACE,2BAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;EjE21WF;AACF;AiEx1WA;EACE;IACE,2BAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;IACA,mBAAA;EjE01WF;AACF;AiEv1WA;EACE;;IAEE,eAAA;EjEy1WF;EiEt1WA;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;EjEw1WF;AACF;AiEr1WA;EAEI;IACE,eAAA;EjEs1WJ;EiEn1WA;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;EjEq1WF;AACF;AkErtXA,sBAAA;AAEA;E9D2DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;E8DxDjE,WAAA;AlEguXF;;AkE7tXA;E9DsDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a8DzDsB;E9D0DtB,8B8D1D4B;E9D2D5B,0B8D3D4B;E9D4D5B,sB8D5D4B;E9D6D5B,yB8D7DoC;E9D8DpC,qB8D9DoC;E9D+DpC,iB8D/DoC;EACpC,WAAA;AlE0uXF;;AkEvuXA;E9DiDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B8DxEqB;E9DyErB,mB8DzEqB;AlEqvXvB;AkEnvXE;EACE,kBAAA;AlEqvXJ;AkElvXE;EAEE,iBAAA;AlEmvXJ;AkEhvXE;EACE,gBAAA;AlEkvXJ;;AkE9uXA;E9D+BE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJ8tXnE;;AkExvXA;EACE,wBAAA;AlE2vXF;;AkExvXA;E9DuBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B8D9CqB;E9D+CrB,mB8D/CqB;AlEswXvB;;AkEnwXA;E9DkBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a8DrBsB;E9DsBtB,8B8DtB4B;E9DuB5B,0B8DvB4B;E9DwB5B,sB8DxB4B;E9DyB5B,yB8DzBoC;E9D0BpC,qB8D1BoC;E9D2BpC,iB8D3BoC;AlEgxXtC;AkE9wXE;EACE,kBAAA;AlEgxXJ;;AkE5wXA;EACE,eAAA;AlE+wXF;;AkE5wXA;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlE+wXF;;AkEvwXE;E9DNA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a8DGwB;E9DFxB,8B8DE8B;E9DD9B,0B8DC8B;E9DA9B,sBAAA;EACA,yB8DDsC;E9DEtC,qB8DFsC;E9DGtC,iB8DHsC;EACpC,0DAAA;EACA,eAAA;AlEoxXJ;AkElxXI;EAEE,kBAAA;AlEmxXN;;AkE9wXA;EACE,aAAA;AlEixXF;;AkE9wXA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AlEixXF;;AkE9wXA;EACE,iBAAA;EACA,gBAAA;E9D9BA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJ2zXnE;AkEzxXE;EACE,iBAAA;AlE2xXJ;;AkEvxXA;EACE;IACE,mBAAA;ElE0xXF;AACF;AkEvxXA;EACE;I9D/BA,sBAAA;IACA,kBAAA;IACA,cAAA;I8D+BE,eAAA;IACA,oBAAA;ElE2xXF;EkExxXA;I9DrCA,sBAAA;IACA,kBAAA;IACA,cAAA;I8DqCE,eAAA;ElE4xXF;EkE1xXE;IACE,aAAA;ElE4xXJ;AACF;AkExxXA;EACE;IACE,cAAA;I9DtCF,+B8DuCuB;I9DtCvB,uB8DsCuB;IACrB,2BAAA;IACA,uBAAA;IACA,mBAAA;IACA,yBAAA;IACA,qBAAA;IACA,iBAAA;ElE2xXF;EkExxXA;IACE,gBAAA;IACA,eAAA;ElE0xXF;EkEvxXA;IACE,2BAAA;ElEyxXF;AACF;AmEt6XA,wBAAA;AAEA;E/DoFE,2B+DnFqB;E/DoFrB,mB+DpFqB;E/D0DrB,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;E+DvDjE,gCAAA;EACA,iBAAA;AnEk7XF;;AmE/6XA;EACE,eAAA;AnEk7XF;;AmE/6XA;EACE,kBAAA;AnEk7XF;;AmE/6XA;EACE,gBAAA;EACA,gBAAA;AnEk7XF;AmEh7XE;EACE,gBAAA;AnEk7XJ;;AmE96XA;EACE,W9DpBS;ED+FP,2B+D1EyB;E/D2EzB,4B+D3EyB;AnEk7X7B;;AmE/6XA;EACE,W9DzBS;E8D0BT,kBAAA;AnEk7XF;AmEh7XE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,W9DjCO;ALm9XX;;AmE96XA;EACE,aAAA;AnEi7XF;AmE/6XE;EACE,cAAA;AnEi7XJ;;AmE76XA;EACE,oBAAA;AnEg7XF;AmE96XE;E/DMA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B+D7BuB;E/D8BvB,mB+D9BuB;EACrB,mBAAA;AnE27XJ;;AmEv7XA;EACE,0BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AnE07XF;;AmEv7XA;EACE,kBAAA;EACA,c9D1DS;ALo/XX;AmEx7XE;EAGE,kBAAA;EACA,c9D7DO;ALq/XX;;AmEp7XA;EACE,eAAA;AnEu7XF;;AmEp7XA;EAEI;IACE,gBAAA;EnEs7XJ;EmEl7XA;IACE,eAAA;EnEo7XF;AACF;AmEj7XA;EACE;IACE,gBAAA;EnEm7XF;EmEj7XE;IACE,gBAAA;EnEm7XJ;EmE/6XA;IACE,eAAA;EnEi7XF;AACF;AmE96XA;EACE;IACE,gBAAA;EnEg7XF;EmE96XE;IACE,gBAAA;EnEg7XJ;AACF;AmE56XA;EACE;IACE,0BAAA;EnE86XF;AACF;AoE1iYA,0BAAA;AAGE;EhE0DA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,agE7DwB;EhE8DxB,8BgE9D8B;EhE+D9B,0BgE/D8B;EhEgE9B,sBgEhE8B;EhEiE9B,yBgEjEsC;EhEkEtC,qBgElEsC;EhEmEtC,iBgEnEsC;EhEuEtC,sBAAA;EACA,kBAAA;EACA,cAAA;EgEvEE,+BAAA;ApEsjYJ;AoEnjYE;EACE,+BAAA;ApEqjYJ;;AoEjjYA;EACE,yBjE2CY;AHygYd;;AoEjjYA;EACE,qEAAA;ApEojYF;;AoEjjYA;EACE,wCAAA;ApEojYF;;AoEjjYA;;EAEE,W/DrBS;E+DsBT,sBAAA;EhE3BA,wBgE4BA;EhE3BA,qBgE2BA;EhE1BA,mBgE0BA;EhEzBA,gBgEyBA;EACA,wCAAA;EACA,qBjE0BY;AH6hYd;;AoEpjYA;;;;EAIE,W/DhCS;E+DiCT,wCAAA;EACA,qBjEiBY;AHsiYd;;AoEpjYA;EACE,W/DtCS;E+DuCT,wCAAA;EACA,qBjEWY;AH4iYd;;AoEpjYA;EACE,W/D5CS;E+D6CT,wCAAA;EACA,qBjEKY;AHkjYd;;AoEpjYA;EACE,iBAAA;ApEujYF;;AoEpjYA;EACE,gBAAA;ApEujYF;;AoEpjYA;EACE;IhEJA,qBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,agECwB;IhEAxB,8BAAA;IACA,0BgED8B;IhEE9B,sBgEF8B;IhEG9B,yBgEHsC;IhEItC,qBgEJsC;IhEKtC,iBgELsC;IhEoBtC,+BgEnBuB;IhEoBvB,uBgEpBuB;EpEkkYvB;EoE/jYA;IACE,aAAA;EpEikYF;AACF;AoE9jYA;EAEI;IACE,iBAAA;EpE+jYJ;EoE5jYE;IACE,iBAAA;EpE8jYJ;AACF;AoE1jYA;EACE;IACE,eAAA;EpE4jYF;EoEzjYA;IACE,iBAAA;EpE2jYF;AACF","sourcesContent":["/*\r\nAuthor         : G-axon\r\nTemplate Name  : Jumbo React - Admin Template\r\nVersion        : 1.0\r\n*/\r\n/*=============================================================\r\n    Table of Contents:\r\n    =============================\r\n    A. Globals\r\n        01. Custom Animation\r\n    B. Base\r\n        01. Base Styles\r\n        02. Typography Styles\r\n    C. Layouts\r\n        01. App Layout Styles\r\n        02. Sidebar Styles\r\n        03. Header Styles\r\n        04. Main Content Styles\r\n        05. Footer Styles\r\n        06. Right Sidebar Styles\r\n    D. UI Components\r\n        01. Alert Styles\r\n        02. Avatar Styles\r\n        03. Badges Styles\r\n        04. Blockquotes Styles\r\n        05. Bottom Navigation Styles\r\n        06. Breadcrumb Styles\r\n        07. Button Styles\r\n        08. Button Group Styles\r\n        09. Callout Styles\r\n        10. Cards Styles\r\n        11. Charts Styles\r\n        12. Chips Styles\r\n        13. Carousel Styles\r\n        14. Color Picker Styles\r\n        15. Drawer Styles\r\n        16. E-commerce Styles\r\n        17. Grids List Styles\r\n        18. Icons Styles\r\n        19. Label Styles\r\n        20. List Styles\r\n        21. Nav Style\r\n        22. Pricing Styles\r\n        23. Progressbar Styles\r\n        24. Popover Styles\r\n        25. React Joyride Styles\r\n        26. Tables Styles\r\n        27. Tabs Styles\r\n        28. Testimonial Styles\r\n        29. Time Lines Style\r\n        30. Joyride Tour Styles\r\n        31. Form Styles\r\n    E. Pages\r\n        01. Login Styles\r\n        02. Error Styles\r\n        03. Editor Styles\r\n        04. Contact Page Styles\r\n        05. Portfolio Styles\r\n        06. Faqs Styles\r\n        07. Dashboard Styles\r\n    F. Slider\r\n    G. Modules\r\n        01. App Module Style\r\n        02. Chat Module Styles\r\n        03. Mails Module Styles\r\n        04. Contact Module Styles\r\n        05. Calendar Module Style\r\n  =============================================================*/\r\n//Custom Variables\r\n@import \"global/_global-dir\";\r\n//Custom Files\r\n@import \"base/_base-dir\";\r\n@import \"layout/_layout-dir\";\r\n@import \"ui/_ui-dir\";\r\n@import \"pages/_pages-dir\";\r\n@import \"slider/owl-carousel\";\r\n@import \"module/_module-dir\";","/* Globals\r\n   ========================================================================== */\r\n@import \"variables\";\r\n@import \"mixin\";\r\n@import \"place-holder\";\r\n@import \"sizes\";\r\n@import \"color\";\r\n@import \"custom-animation\";\r\n","//Place Holders\r\n%jr-menu-icon {\r\n  .menu-icon {\r\n    position: relative;\r\n    width: 70%;\r\n    height: 1px;\r\n    min-height: 1px;\r\n    color: inherit;\r\n    background-color: $gray-default;\r\n    display: block;\r\n    @include transition(all 0.4s ease);\r\n    margin: 6px 0;\r\n    cursor: pointer;\r\n\r\n    &:after,\r\n    &:before {\r\n      position: absolute;\r\n      display: block;\r\n      color: inherit;\r\n      background-color: inherit;\r\n      left: 0;\r\n      height: 1px;\r\n      min-height: 1px;\r\n      content: \"\";\r\n      @include transition(all 0.4s ease);\r\n    }\r\n\r\n    &:after {\r\n      width: 120%;\r\n      bottom: -6px;\r\n    }\r\n\r\n    &:before {\r\n      width: 130%;\r\n      top: -6px;\r\n    }\r\n  }\r\n  &:hover {\r\n    & .menu-icon {\r\n      width: 100%;\r\n      &:after,\r\n      &:before {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n%size-50 {\r\n  height: $size-50 !important;\r\n  width: $size-50 !important;\r\n  line-height: $size-50;\r\n}\r\n\r\n%size-60 {\r\n  height: $size-60 !important;\r\n  width: $size-60 !important;\r\n  line-height: $size-60;\r\n}\r\n\r\n%size-80 {\r\n  height: $size-80 !important;\r\n  width: $size-80 !important;\r\n  line-height: $size-80;\r\n}\r\n\r\n%size-100 {\r\n  height: $size-100 !important;\r\n  width: $size-100 !important;\r\n  line-height: $size-100;\r\n}\r\n\r\n%size-20 {\r\n  height: $size-20 !important;\r\n  width: $size-20 !important;\r\n  line-height: $size-20;\r\n}\r\n\r\n\r\n%size-30 {\r\n  height: $size-30 !important;\r\n  width: $size-30 !important;\r\n  line-height: $size-30;\r\n}\r\n\r\n%size-40 {\r\n  height: $size-40 !important;\r\n  width: $size-40 !important;\r\n  line-height: $size-40;\r\n}\r\n\r\n%size-120 {\r\n  height: $size-120 !important;\r\n  width: $size-120 !important;\r\n  line-height: $size-120;\r\n}\r\n\r\n%icon-addon {\r\n  display: inline-block;\r\n  text-align: center;\r\n  background-color: inherit;\r\n}\r\n\r\n%jr-card-style {\r\n  padding: $jr-card-padding;\r\n  margin-bottom: $jr-card-margin;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  border: $jr-border;\r\n  position: relative;\r\n}\r\n\r\n/* Ripple magic */\r\n%ripple-effect {\r\n  position: relative;\r\n  overflow: hidden;\r\n  &:after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 5px;\r\n    height: 5px;\r\n    background: rgba($white, 0.5);\r\n    opacity: 0;\r\n    @include border-radius(100%);\r\n    transform: scale(1, 1) translate(-50%);\r\n    transform-origin: 50% 50%;\r\n  }\r\n\r\n  &:hover:after {\r\n    animation: ripple 1s ease-out;\r\n  }\r\n}\r\n\r\n@keyframes ripple {\r\n  0% {\r\n    transform: scale(0, 0);\r\n    opacity: 0.5;\r\n  }\r\n  20% {\r\n    transform: scale(60, 60);\r\n    opacity: 0.3;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(100, 100);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes ripple {\r\n  0% {\r\n    transform: scale(0, 0);\r\n    opacity: 0.5;\r\n  }\r\n  20% {\r\n    transform: scale(60, 60);\r\n    opacity: 0.3;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(100, 100);\r\n  }\r\n}\r\n\r\n//Pulse Effect\r\n%pulse-effect {\r\n  display: block;\r\n  @include box-shadow (0 0 0 rgba($danger, 0.4));\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n@-webkit-keyframes pulse {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($danger, 0.4);\r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 10px rgba($danger, 0);\r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($danger, 0);\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($danger, 0.4);\r\n    box-shadow: 0 0 0 0 rgba($danger, 0.4);\r\n  }\r\n  70% {\r\n    -moz-box-shadow: 0 0 0 10px rgba($danger, 0);\r\n    box-shadow: 0 0 0 10px rgba($danger, 0);\r\n  }\r\n  100% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($danger, 0);\r\n    box-shadow: 0 0 0 0 rgba($danger, 0);\r\n  }\r\n}\r\n\r\n//Online Effect\r\n%online-effect {\r\n  display: block;\r\n  @include box-shadow (0 0 0 rgba($green, 0.4));\r\n  animation: online 2s infinite;\r\n}\r\n\r\n@-webkit-keyframes online {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($green, 0.4);\r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 10px rgba($green, 0);\r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($green, 0);\r\n  }\r\n}\r\n\r\n@keyframes online {\r\n  0% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($green, 0.4);\r\n    box-shadow: 0 0 0 0 rgba($green, 0.4);\r\n  }\r\n  70% {\r\n    -moz-box-shadow: 0 0 0 10px rgba($green, 0);\r\n    box-shadow: 0 0 0 10px rgba($green, 0);\r\n  }\r\n  100% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($green, 0);\r\n    box-shadow: 0 0 0 0 rgba($green, 0);\r\n  }\r\n}\r\n\r\n//Away Effect\r\n%away-effect {\r\n  display: block;\r\n  @include box-shadow (0 0 0 rgba($yellow, 0.4));\r\n  animation: away 2s infinite;\r\n}\r\n\r\n@-webkit-keyframes away {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($yellow, 0.4);\r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 10px rgba($yellow, 0);\r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($yellow, 0);\r\n  }\r\n}\r\n\r\n@keyframes away {\r\n  0% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($yellow, 0.4);\r\n    box-shadow: 0 0 0 0 rgba($yellow, 0.4);\r\n  }\r\n  70% {\r\n    -moz-box-shadow: 0 0 0 10px rgba($yellow, 0);\r\n    box-shadow: 0 0 0 10px rgba($yellow, 0);\r\n  }\r\n  100% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($yellow, 0);\r\n    box-shadow: 0 0 0 0 rgba($yellow, 0);\r\n  }\r\n}\r\n\r\n/*Different size images set in Equal block height and width*/\r\n%thumb-equal {\r\n  position: relative;\r\n  padding-bottom: 68%;\r\n  height: 0;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n%thumb-cover {\r\n  display: block;\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n%thumb-cover-img {\r\n  height: auto;\r\n  max-width: 100%;\r\n  min-height: 100%;\r\n  object-fit: cover;\r\n  width: 100%;\r\n}\r\n\r\n// Hover Effect On Bootstrap Components\r\n%link-hover {\r\n  color: $white !important;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    color: $white !important;\r\n  }\r\n}\r\n\r\n// Pointer\r\n%pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n//Remove Botton Shadow\r\n\r\n%btn-no-shadow {\r\n  &:not([disabled]):not(.disabled):active,\r\n  &:not([disabled]):not(.disabled).active {\r\n    background-image: none;\r\n    @include box-shadow(none);\r\n\r\n    &:focus {\r\n      @include box-shadow(none);\r\n    }\r\n  }\r\n}","@import \"../bootstrap/functions\";\r\n@import \"../bootstrap/variables\";\r\n@import \"../bootstrap/mixins\";\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n// @import url('https://fonts.googleapis.com/css?family=Nunito+Sans:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i');\r\n@import url(\"https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\r\n\r\n//# sourceMappingURL=roboto.css.map\r\n\r\n// import material icons\r\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: 'Roboto', sans-serif;\r\n$font-family-base: $font-family-sans-serif;\r\n\r\n// stylelint-enable value-keyword-case\r\n$font-size-base: 13px; // Assumes the browser default, typically `16px`\r\n$font-size-lg: ($font-size-base + 4);\r\n$font-size-sm: $font-size-base;\r\n\r\n$h1-font-size: 24px;\r\n$h2-font-size: 18px;\r\n$h3-font-size: 16px;\r\n$h4-font-size: 15px;\r\n$h5-font-size: 13px;\r\n$h6-font-size: 12px;\r\n\r\n$headings-margin-bottom: ($h1-font-size / 2);\r\n$headings-font-family: inherit;\r\n$headings-font-weight: 400;\r\n$headings-line-height: 1.2;\r\n$headings-color: inherit;\r\n\r\n//Border Radius\r\n$border-radius-sm: 2px;\r\n$border-radius: 4px;\r\n$border-radius-lg: 8px;\r\n$border-radius-xl: 10px !default;\r\n$border-radius-circle: 50% !default;\r\n\r\n//Bootstrap Card Variables\r\n$card-spacer-y: 24px;\r\n$card-spacer-x: 30px;\r\n$card-border-color: $border-color;\r\n$card-border-radius: $border-radius-lg;\r\n$card-inner-border-radius: $border-radius-lg;\r\n$list-group-border-radius: $border-radius-lg;\r\n\r\n//Grid Gutter Space Between\r\n$grid-gutter-width: 34px;\r\n\r\n//Mixin Values True and False\r\n$enable-shadows: true;\r\n\r\n$app-primary: #3f51b5 !default;\r\n$primary: $app-primary;\r\n$secondary: #E91E63;\r\n$gray-default: #808080 !default;\r\n\r\n$sidebar-bg: #f5f7f9 !default;\r\n$sidebar-text-color: #868e96 !default;\r\n$sidebar-bg-darken: darken($sidebar-bg, 3%);\r\n$sidebar-hover-color: $app-primary;\r\n\r\n$top-nav-bg: $app-primary !default;\r\n\r\n//Default shadow\r\n$shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\r\n$shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);\r\n$shadow-lg: 0 1px 8px -1px rgba(0, 0, 0, 0.20);\r\n$shadow-xl: 0 0 16px 0px rgba(0, 0, 0, 0.20);\r\n$avatar-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.50);\r\n\r\n//Custom Card Variables\r\n$jr-card-shadow: $shadow !default;\r\n$jr-card-margin: 34px !default;\r\n$jr-card-padding: 24px 30px !default;\r\n$jr-border: 1px solid $gray-400 !default;\r\n\r\n// Links\r\n$link-color: $app-primary;\r\n$link-hover-color: darken($app-primary, 10%);\r\n\r\n//Color Variables\r\n$success: #4caf50;\r\n$info: #00bcd4;\r\n$warning: #ff9800;\r\n$danger: #f44336;\r\n$light: #e8eaf6;\r\n$dark: $gray-800;\r\n$body-bg: #fff;\r\n$body-color: #5c5c5c;\r\n\r\n$theme-colors: (\r\n        \"primary\": $primary,\r\n        \"secondary\": $secondary,\r\n        \"success\": $success,\r\n        \"info\": $info,\r\n        \"warning\": $warning,\r\n        \"danger\": $danger,\r\n        \"light\": $light,\r\n        \"dark\": $dark\r\n);\r\n\r\n//Default Image Location\r\n$image_path: \"../assets/images\" !default;\r\n\r\n// Motion\r\n// https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves\r\n$transition-bezier: .05, .74, .27, .99 !default; // for nav, quickview\r\n\r\n$transition-ease: cubic-bezier(0.4, 0.0, 0.2, 1) !default;\r\n$transition-ease-out: cubic-bezier(0.0, 0.0, 0.2, 1) !default;\r\n$transition-ease-in: cubic-bezier(0.4, 0.0, 1, 1) !default;\r\n\r\n//Side Nav Width\r\n$side-nav-width: 200px !default;\r\n$mini-drawer-width: 80px !default;\r\n\r\n//App Bar Height\r\n$app-bar-height: 60px !default;\r\n\r\n//Footer Height\r\n$footer-height: 50px !default;\r\n\r\n//latter Spacing variables\r\n$letter-spacing-base: 3px !default;\r\n$letter-spacing-lg: 6px !default;\r\n$letter-spacing-xl: 8px !default;\r\n\r\n//Button Variables\r\n$btn-font-size-lg: $font-size-lg !default;\r\n$btn-font-size: $font-size-base !default;\r\n$btn-font-size-sm: $font-size-sm !default;\r\n$btn-font-size-xs: 10px !default;\r\n\r\n$btn-padding-lg: 16px 24px !default;\r\n$btn-padding: 12px 20px !default;\r\n$btn-padding-sm: 8px 15px !default;\r\n$btn-padding-xs: 6px 10px !default;\r\n\r\n$btn-fab-size-lg: 70px !default;\r\n$btn-fab-size-sm: 46px !default;\r\n$btn-fab-size-xs: 40px !default;\r\n\r\n$btn-line-height: 1.2;\r\n\r\n//Sizes Variables\r\n\r\n$size-20: 20px !default;\r\n$size-30: 30px !default;\r\n$size-40: 40px !default;\r\n$size-50: 50px !default;\r\n$size-60: 60px !default;\r\n$size-80: 80px !default;\r\n$size-100: 100px !default;\r\n$size-120: 120px !default;","// Box Shadow\r\n@mixin box-shadow($shadow...) {\r\n  -webkit-box-shadow: $shadow;\r\n  -moz-box-shadow: $shadow;\r\n  -o-box-shadow: $shadow;\r\n  box-shadow: $shadow;\r\n}\r\n\r\n// Single side border-radius\r\n@mixin border-radius($radius...) {\r\n  -webkit-border-radius: $radius;\r\n  -moz-border-radius: $radius;\r\n  border-radius: $radius;\r\n}\r\n\r\n// Single side box-sizing\r\n@mixin box-sizing($box-sizing) {\r\n  -webkit-box-sizing: $box-sizing;\r\n  -moz-box-sizing: $box-sizing;\r\n  box-sizing: $box-sizing;\r\n}\r\n\r\n// Clearfix\r\n\r\n@mixin clearfix() {\r\n  &:before,\r\n  &:after {\r\n    content: \" \"; // 1\r\n    display: table; // 2\r\n  }\r\n  &:after {\r\n    clear: both;\r\n  }\r\n}\r\n\r\n// Transitions\r\n@mixin transition($transition...) {\r\n  -webkit-transition: $transition;\r\n  -o-transition: $transition;\r\n  transition: $transition;\r\n}\r\n\r\n@mixin rotate($degrees) {\r\n  -webkit-transform: rotate($degrees);\r\n  -ms-transform: rotate($degrees); // IE9 only\r\n  -o-transform: rotate($degrees);\r\n  transform: rotate($degrees);\r\n}\r\n\r\n//Background Image\r\n@mixin background($imgpath,$position:0 0,$repeat: no-repeat,$size: cover) {\r\n  background: {\r\n    image: url($imgpath);\r\n    position: $position;\r\n    repeat: $repeat;\r\n    size: $size;\r\n  }\r\n}\r\n\r\n// Flex\r\n@mixin display-flex($flex: flex, $flex-direction: row, $flex-wrap: wrap) {\r\n  display: #{'-webkit'}-#{$flex};\r\n  display: #{'-moz'}-#{$flex};\r\n  display: #{'-ms'}-#{$flex};\r\n  display: #{'-o'}-#{$flex};\r\n  display: $flex;\r\n  -webkit-flex-direction: $flex-direction;\r\n  -ms-flex-direction: $flex-direction;\r\n  flex-direction: $flex-direction;\r\n  -webkit-flex-wrap: $flex-wrap;\r\n  -ms-flex-wrap: $flex-wrap;\r\n  flex-wrap: $flex-wrap;\r\n}\r\n\r\n@mixin flex($flex-grow: 1, $flex-shrink: 1, $flex-basis: auto) {\r\n  -webkit-flex: $flex-grow $flex-shrink $flex-basis;\r\n  -ms-flex: $flex-grow $flex-shrink $flex-basis;\r\n  flex: $flex-grow $flex-shrink $flex-basis;\r\n}\r\n\r\n@mixin justify-content($justify-content) {\r\n  -webkit-justify-content: $justify-content;\r\n  justify-content: $justify-content;\r\n}\r\n\r\n@mixin align-items($align-items) {\r\n  -webkit-align-items: $align-items;\r\n  align-items: $align-items;\r\n}\r\n\r\n//Border Radius\r\n\r\n// Single side border-radius\r\n\r\n@mixin border-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-top-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-top-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-right-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-right-radius: $radius;\r\n    border-bottom-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-bottom-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-bottom-right-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-left-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n\r\n//Mixin Hover\r\n\r\n// stylelint-disable indentation\r\n@mixin hover {\r\n  // TODO: re-enable along with mq4-hover-shim\r\n  //  @if $enable-hover-media-query {\r\n  //    // See Media Queries Level 4: https://drafts.csswg.org/mediaqueries/#hover\r\n  //    // Currently shimmed by https://github.com/twbs/mq4-hover-shim\r\n  //    @media (hover: hover) {\r\n  //      &:hover { @content }\r\n  //    }\r\n  //  }\r\n  //  @else {\r\n  &:hover {\r\n    @content;\r\n  }\r\n  //  }\r\n}\r\n\r\n@mixin hover-focus {\r\n  @if $enable-hover-media-query {\r\n    &:focus {\r\n      @content;\r\n    }\r\n    @include hover {\r\n      @content;\r\n    }\r\n  } @else {\r\n    &:focus,\r\n    &:hover {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin plain-hover-focus {\r\n  @if $enable-hover-media-query {\r\n    &,\r\n    &:focus {\r\n      @content;\r\n    }\r\n    @include hover {\r\n      @content;\r\n    }\r\n  } @else {\r\n    &,\r\n    &:focus,\r\n    &:hover {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin hover-focus-active {\r\n  @if $enable-hover-media-query {\r\n    &:focus,\r\n    &:active {\r\n      @content;\r\n    }\r\n    @include hover {\r\n      @content;\r\n    }\r\n  } @else {\r\n    &:focus,\r\n    &:active,\r\n    &:hover {\r\n      @content;\r\n    }\r\n  }\r\n}","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// Width and height Styles\r\n\r\n@each $prop, $abbrev in (width: w, height: h, max-width: mw, max-height: mh) {\r\n  @each $size, $length in $sizes {\r\n    .#{$abbrev}-#{$size} {\r\n      #{$prop}: $length !important;\r\n    }\r\n  }\r\n}\r\n","// Utility Color Classes\r\n\r\n//.success {\r\n//\r\n//}\r\n\r\n// Google Color Palette defined: http://www.google.com/design/spec/style/color.html\r\n\r\n$primary: (\r\n        \"base\": #3f51b5,\r\n        \"lighten-5\": #e8eaf6,\r\n        \"lighten-4\": #c5cae9,\r\n        \"lighten-3\": #9fa8da,\r\n        \"lighten-2\": #7986cb,\r\n        \"lighten-1\": #5c6bc0,\r\n        \"darken-1\": #3949ab,\r\n        \"darken-2\": #303f9f,\r\n        \"darken-3\": #283593,\r\n        \"darken-4\": #1a237e,\r\n        \"accent-1\": #8c9eff,\r\n        \"accent-2\": #536dfe,\r\n        \"accent-3\": #3d5afe,\r\n        \"accent-4\": #304ffe\r\n);\r\n\r\n$red: (\r\n        \"base\": #F44336,\r\n        \"lighten-5\": #FFEBEE,\r\n        \"lighten-4\": #FFCDD2,\r\n        \"lighten-3\": #EF9A9A,\r\n        \"lighten-2\": #E57373,\r\n        \"lighten-1\": #EF5350,\r\n        \"darken-1\": #E53935,\r\n        \"darken-2\": #D32F2F,\r\n        \"darken-3\": #C62828,\r\n        \"darken-4\": #B71C1C,\r\n        \"accent-1\": #FF8A80,\r\n        \"accent-2\": #FF5252,\r\n        \"accent-3\": #FF1744,\r\n        \"accent-4\": #D50000\r\n);\r\n\r\n$pink: (\r\n        \"base\": #e91e63,\r\n        \"lighten-5\": #fce4ec,\r\n        \"lighten-4\": #f8bbd0,\r\n        \"lighten-3\": #f48fb1,\r\n        \"lighten-2\": #f06292,\r\n        \"lighten-1\": #ec407a,\r\n        \"darken-1\": #d81b60,\r\n        \"darken-2\": #c2185b,\r\n        \"darken-3\": #ad1457,\r\n        \"darken-4\": #880e4f,\r\n        \"accent-1\": #ff80ab,\r\n        \"accent-2\": #ff4081,\r\n        \"accent-3\": #f50057,\r\n        \"accent-4\": #c51162\r\n);\r\n\r\n$purple: (\r\n        \"base\": #9C27B0,\r\n        \"lighten-5\": #f3e5f5,\r\n        \"lighten-4\": #e1bee7,\r\n        \"lighten-3\": #ce93d8,\r\n        \"lighten-2\": #ba68c8,\r\n        \"lighten-1\": #ab47bc,\r\n        \"darken-1\": #8e24aa,\r\n        \"darken-2\": #7b1fa2,\r\n        \"darken-3\": #6a1b9a,\r\n        \"darken-4\": #4a148c,\r\n        \"accent-1\": #ea80fc,\r\n        \"accent-2\": #e040fb,\r\n        \"accent-3\": #d500f9,\r\n        \"accent-4\": #aa00ff\r\n);\r\n\r\n$deep-purple: (\r\n        \"base\": #673ab7,\r\n        \"lighten-5\": #ede7f6,\r\n        \"lighten-4\": #d1c4e9,\r\n        \"lighten-3\": #b39ddb,\r\n        \"lighten-2\": #9575cd,\r\n        \"lighten-1\": #7e57c2,\r\n        \"darken-1\": #5e35b1,\r\n        \"darken-2\": #512da8,\r\n        \"darken-3\": #4527a0,\r\n        \"darken-4\": #311b92,\r\n        \"accent-1\": #b388ff,\r\n        \"accent-2\": #7c4dff,\r\n        \"accent-3\": #651fff,\r\n        \"accent-4\": #6200ea\r\n);\r\n\r\n$indigo: (\r\n        \"base\": #3f51b5,\r\n        \"lighten-5\": #e8eaf6,\r\n        \"lighten-4\": #c5cae9,\r\n        \"lighten-3\": #9fa8da,\r\n        \"lighten-2\": #7986cb,\r\n        \"lighten-1\": #5c6bc0,\r\n        \"darken-1\": #3949ab,\r\n        \"darken-2\": #303f9f,\r\n        \"darken-3\": #283593,\r\n        \"darken-4\": #1a237e,\r\n        \"accent-1\": #8c9eff,\r\n        \"accent-2\": #536dfe,\r\n        \"accent-3\": #3d5afe,\r\n        \"accent-4\": #304ffe\r\n);\r\n\r\n$blue: (\r\n        \"base\": #2196F3,\r\n        \"lighten-5\": #E3F2FD,\r\n        \"lighten-4\": #BBDEFB,\r\n        \"lighten-3\": #90CAF9,\r\n        \"lighten-2\": #64B5F6,\r\n        \"lighten-1\": #42A5F5,\r\n        \"darken-1\": #1E88E5,\r\n        \"darken-2\": #1976D2,\r\n        \"darken-3\": #1565C0,\r\n        \"darken-4\": #0D47A1,\r\n        \"accent-1\": #82B1FF,\r\n        \"accent-2\": #448AFF,\r\n        \"accent-3\": #2979FF,\r\n        \"accent-4\": #2962FF\r\n);\r\n\r\n$light-blue: (\r\n        \"base\": #03a9f4,\r\n        \"lighten-5\": #e1f5fe,\r\n        \"lighten-4\": #b3e5fc,\r\n        \"lighten-3\": #81d4fa,\r\n        \"lighten-2\": #4fc3f7,\r\n        \"lighten-1\": #29b6f6,\r\n        \"darken-1\": #039be5,\r\n        \"darken-2\": #0288d1,\r\n        \"darken-3\": #0277bd,\r\n        \"darken-4\": #01579b,\r\n        \"accent-1\": #80d8ff,\r\n        \"accent-2\": #40c4ff,\r\n        \"accent-3\": #00b0ff,\r\n        \"accent-4\": #0091ea\r\n);\r\n\r\n$cyan: (\r\n        \"base\": #00bcd4,\r\n        \"lighten-5\": #e0f7fa,\r\n        \"lighten-4\": #b2ebf2,\r\n        \"lighten-3\": #80deea,\r\n        \"lighten-2\": #4dd0e1,\r\n        \"lighten-1\": #26c6da,\r\n        \"darken-1\": #00acc1,\r\n        \"darken-2\": #0097a7,\r\n        \"darken-3\": #00838f,\r\n        \"darken-4\": #006064,\r\n        \"accent-1\": #84ffff,\r\n        \"accent-2\": #18ffff,\r\n        \"accent-3\": #00e5ff,\r\n        \"accent-4\": #00b8d4\r\n);\r\n\r\n$teal: (\r\n        \"base\": #009688,\r\n        \"lighten-5\": #e0f2f1,\r\n        \"lighten-4\": #b2dfdb,\r\n        \"lighten-3\": #80cbc4,\r\n        \"lighten-2\": #4db6ac,\r\n        \"lighten-1\": #26a69a,\r\n        \"darken-1\": #00897b,\r\n        \"darken-2\": #00796b,\r\n        \"darken-3\": #00695c,\r\n        \"darken-4\": #004d40,\r\n        \"accent-1\": #a7ffeb,\r\n        \"accent-2\": #64ffda,\r\n        \"accent-3\": #1de9b6,\r\n        \"accent-4\": #00bfa5\r\n);\r\n\r\n$green: (\r\n        \"base\": #4CAF50,\r\n        \"lighten-5\": #E8F5E9,\r\n        \"lighten-4\": #C8E6C9,\r\n        \"lighten-3\": #A5D6A7,\r\n        \"lighten-2\": #81C784,\r\n        \"lighten-1\": #66BB6A,\r\n        \"darken-1\": #43A047,\r\n        \"darken-2\": #388E3C,\r\n        \"darken-3\": #2E7D32,\r\n        \"darken-4\": #1B5E20,\r\n        \"accent-1\": #B9F6CA,\r\n        \"accent-2\": #69F0AE,\r\n        \"accent-3\": #00E676,\r\n        \"accent-4\": #00C853\r\n);\r\n\r\n$light-green: (\r\n        \"base\": #8bc34a,\r\n        \"lighten-5\": #f1f8e9,\r\n        \"lighten-4\": #dcedc8,\r\n        \"lighten-3\": #c5e1a5,\r\n        \"lighten-2\": #aed581,\r\n        \"lighten-1\": #9ccc65,\r\n        \"darken-1\": #7cb342,\r\n        \"darken-2\": #689f38,\r\n        \"darken-3\": #558b2f,\r\n        \"darken-4\": #33691e,\r\n        \"accent-1\": #ccff90,\r\n        \"accent-2\": #b2ff59,\r\n        \"accent-3\": #76ff03,\r\n        \"accent-4\": #64dd17\r\n);\r\n\r\n$lime: (\r\n        \"base\": #cddc39,\r\n        \"lighten-5\": #f9fbe7,\r\n        \"lighten-4\": #f0f4c3,\r\n        \"lighten-3\": #e6ee9c,\r\n        \"lighten-2\": #dce775,\r\n        \"lighten-1\": #d4e157,\r\n        \"darken-1\": #c0ca33,\r\n        \"darken-2\": #afb42b,\r\n        \"darken-3\": #9e9d24,\r\n        \"darken-4\": #827717,\r\n        \"accent-1\": #f4ff81,\r\n        \"accent-2\": #eeff41,\r\n        \"accent-3\": #c6ff00,\r\n        \"accent-4\": #aeea00\r\n);\r\n\r\n$yellow: (\r\n        \"base\": #ffeb3b,\r\n        \"lighten-5\": #fffde7,\r\n        \"lighten-4\": #fff9c4,\r\n        \"lighten-3\": #fff59d,\r\n        \"lighten-2\": #fff176,\r\n        \"lighten-1\": #ffee58,\r\n        \"darken-1\": #fdd835,\r\n        \"darken-2\": #fbc02d,\r\n        \"darken-3\": #f9a825,\r\n        \"darken-4\": #f57f17,\r\n        \"accent-1\": #ffff8d,\r\n        \"accent-2\": #ffff00,\r\n        \"accent-3\": #ffea00,\r\n        \"accent-4\": #ffd600\r\n);\r\n\r\n$amber: (\r\n        \"base\": #ffc107,\r\n        \"lighten-5\": #fff8e1,\r\n        \"lighten-4\": #ffecb3,\r\n        \"lighten-3\": #ffe082,\r\n        \"lighten-2\": #ffd54f,\r\n        \"lighten-1\": #ffca28,\r\n        \"darken-1\": #ffb300,\r\n        \"darken-2\": #ffa000,\r\n        \"darken-3\": #ff8f00,\r\n        \"darken-4\": #ff6f00,\r\n        \"accent-1\": #ffe57f,\r\n        \"accent-2\": #ffd740,\r\n        \"accent-3\": #ffc400,\r\n        \"accent-4\": #ffab00\r\n);\r\n\r\n$orange: (\r\n        \"base\": #ff9800,\r\n        \"lighten-5\": #fff3e0,\r\n        \"lighten-4\": #ffe0b2,\r\n        \"lighten-3\": #ffcc80,\r\n        \"lighten-2\": #ffb74d,\r\n        \"lighten-1\": #ffa726,\r\n        \"darken-1\": #fb8c00,\r\n        \"darken-2\": #f57c00,\r\n        \"darken-3\": #ef6c00,\r\n        \"darken-4\": #e65100,\r\n        \"accent-1\": #ffd180,\r\n        \"accent-2\": #ffab40,\r\n        \"accent-3\": #ff9100,\r\n        \"accent-4\": #ff6d00\r\n);\r\n\r\n$deep-orange: (\r\n        \"base\": #ff5722,\r\n        \"lighten-5\": #fbe9e7,\r\n        \"lighten-4\": #ffccbc,\r\n        \"lighten-3\": #ffab91,\r\n        \"lighten-2\": #ff8a65,\r\n        \"lighten-1\": #ff7043,\r\n        \"darken-1\": #f4511e,\r\n        \"darken-2\": #e64a19,\r\n        \"darken-3\": #d84315,\r\n        \"darken-4\": #bf360c,\r\n        \"accent-1\": #ff9e80,\r\n        \"accent-2\": #ff6e40,\r\n        \"accent-3\": #ff3d00,\r\n        \"accent-4\": #dd2c00\r\n);\r\n\r\n$brown: (\r\n        \"base\": #795548,\r\n        \"lighten-5\": #efebe9,\r\n        \"lighten-4\": #d7ccc8,\r\n        \"lighten-3\": #bcaaa4,\r\n        \"lighten-2\": #a1887f,\r\n        \"lighten-1\": #8d6e63,\r\n        \"darken-1\": #6d4c41,\r\n        \"darken-2\": #5d4037,\r\n        \"darken-3\": #4e342e,\r\n        \"darken-4\": #3e2723\r\n);\r\n\r\n$blue-gray: (\r\n        \"base\": #607d8b,\r\n        \"lighten-5\": #eceff1,\r\n        \"lighten-4\": #cfd8dc,\r\n        \"lighten-3\": #b0bec5,\r\n        \"lighten-2\": #90a4ae,\r\n        \"lighten-1\": #78909c,\r\n        \"darken-1\": #546e7a,\r\n        \"darken-2\": #455a64,\r\n        \"darken-3\": #37474f,\r\n        \"darken-4\": #263238\r\n);\r\n\r\n$gray: (\r\n        \"base\": #9e9e9e,\r\n        \"lighten-5\": #fafafa,\r\n        \"lighten-4\": #f5f5f5,\r\n        \"lighten-3\": #eeeeee,\r\n        \"lighten-2\": #e0e0e0,\r\n        \"lighten-1\": #bdbdbd,\r\n        \"darken-1\": #757575,\r\n        \"darken-2\": #616161,\r\n        \"darken-3\": #424242,\r\n        \"darken-4\": #212121\r\n);\r\n\r\n$shades: (\r\n        \"black\": #000000,\r\n        \"white\": #FFFFFF,\r\n        \"transparent\": transparent\r\n);\r\n\r\n$colors_palette: (\r\n        \"primary\": $primary,\r\n        \"red\": $red,\r\n        \"pink\": $pink,\r\n        \"purple\": $purple,\r\n        \"deep-purple\": $deep-purple,\r\n        \"indigo\": $indigo,\r\n        \"blue\": $blue,\r\n        \"light-blue\": $light-blue,\r\n        \"cyan\": $cyan,\r\n        \"teal\": $teal,\r\n        \"green\": $green,\r\n        \"light-green\": $light-green,\r\n        \"lime\": $lime,\r\n        \"yellow\": $yellow,\r\n        \"amber\": $amber,\r\n        \"orange\": $orange,\r\n        \"deep-orange\": $deep-orange,\r\n        \"brown\": $brown,\r\n        \"blue-grey\": $blue-gray,\r\n        \"grey\": $gray,\r\n        \"shades\": $shades\r\n) !default;\r\n\r\n// Color Classes\r\n\r\n@each $color_name, $color in $colors_palette {\r\n  @each $color_type, $color_value in $color {\r\n    @if $color_type == \"base\" {\r\n      .bg-#{$color_name} {\r\n        background-color: $color_value !important;\r\n      }\r\n      .text-#{$color_name} {\r\n        color: $color_value !important;\r\n        &.icon-outline {\r\n          border-color: $color_value !important;\r\n        }\r\n      }\r\n    } @else if $color_name != \"shades\" {\r\n      .bg-#{$color_name}.#{$color_type} {\r\n        background-color: $color_value !important;\r\n      }\r\n      .text-#{$color_name}.text-#{$color_type} {\r\n        color: $color_value !important;\r\n        &.icon-outline {\r\n          border-color: $color_value !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Shade classes\r\n@each $color, $color_value in $shades {\r\n  .bg-#{$color} {\r\n    background-color: $color_value !important;\r\n  }\r\n  .text-#{$color} {\r\n    color: $color_value !important;\r\n    &.icon-outline {\r\n      border-color: $color_value !important;\r\n    }\r\n  }\r\n}\r\n\r\n// usage: color(\"name_of_color\", \"type_of_color\")\r\n// to avoid to repeating map-get($colors, ...)\r\n\r\n@function color($color, $type) {\r\n  @if map-has-key($colors_palette, $color) {\r\n    $curr_color: map-get($colors_palette, $color);\r\n    @if map-has-key($curr_color, $type) {\r\n      @return map-get($curr_color, $type);\r\n    }\r\n  }\r\n  @warn \"Unknown `#{$color}` - `#{$type}` in $colors.\";\r\n  @return null;\r\n}\r\n\r\n\r\n","/*Custom Animation*/\r\n\r\n@keyframes flipCenter {\r\n  0% {\r\n    animation-timing-function: ease-in;\r\n    opacity: 0;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);\r\n  }\r\n  40% {\r\n    animation-timing-function: ease-in;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  60% {\r\n    opacity: 1;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  80% {\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  100% {\r\n    transform: perspective(100000px);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes flipCenter {\r\n  0% {\r\n    animation-timing-function: ease-in;\r\n    opacity: 0;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);\r\n  }\r\n  40% {\r\n    animation-timing-function: ease-in;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  60% {\r\n    opacity: 1;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  80% {\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  100% {\r\n    transform: perspective(100000px);\r\n  }\r\n}\r\n\r\n.flipCenter {\r\n  animation-name: flipCenter;\r\n  backface-visibility: visible;\r\n}\r\n\r\n@keyframes desployDown {\r\n  0% {\r\n    transform: scaleY(0);\r\n    transform-origin: center top 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scaleY(1);\r\n    transform-origin: center top 0;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes desployDown {\r\n  0% {\r\n    transform: scaleY(0);\r\n    transform-origin: center top 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scaleY(1);\r\n    transform-origin: center top 0;\r\n  }\r\n}\r\n\r\n.desployDown {\r\n  animation-name: desployDown;\r\n  backface-visibility: visible;\r\n}\r\n\r\n@keyframes fadeInRightTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fadeInRightTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.fadeInRightTiny {\r\n  animation-name: fadeInRightTiny;\r\n}\r\n\r\n@keyframes fadeInLeftTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fadeInLeftTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.fadeInLeftTiny {\r\n  animation-name: fadeInLeftTiny;\r\n}\r\n\r\n@keyframes slideInRightTiny {\r\n  0% {\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slideInRightTiny {\r\n  0% {\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.slideInRightTiny {\r\n  animation-name: slideInRightTiny;\r\n}\r\n\r\n@keyframes slideInLeftTiny {\r\n  0% {\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slideInLeftTiny {\r\n  0% {\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.slideInLeftTiny {\r\n  animation-name: slideInLeftTiny;\r\n}\r\n\r\n@keyframes slideInUpTiny {\r\n  0% {\r\n    transform: translate3d(0px, 5%, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slideInUpTiny {\r\n  0% {\r\n    transform: translate3d(0px, 5%, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.slideInUpTiny {\r\n  animation-name: slideInUpTiny;\r\n}\r\n\r\n/*Animation Durations*/\r\n.animation-duration-1 {\r\n  animation-duration: 0.1s;\r\n}\r\n\r\n.animation-duration-2 {\r\n  animation-duration: 0.2s;\r\n}\r\n\r\n.animation-duration-3 {\r\n  animation-duration: 0.3s;\r\n}\r\n\r\n.animation-duration-4 {\r\n  animation-duration: 0.4s;\r\n}\r\n\r\n.animation-duration-5 {\r\n  animation-duration: 0.5s;\r\n}\r\n\r\n.animation-duration-6 {\r\n  animation-duration: 0.6s;\r\n}\r\n\r\n.animation-duration-7 {\r\n  animation-duration: 0.7s;\r\n}\r\n\r\n.animation-duration-8 {\r\n  animation-duration: 0.8s;\r\n}\r\n\r\n.animation-duration-9 {\r\n  animation-duration: 0.9s;\r\n}\r\n\r\n.animation-duration-10 {\r\n  animation-duration: 1s;\r\n}\r\n\r\n.animation-duration-11 {\r\n  animation-duration: 1.1s;\r\n}\r\n\r\n.animation-duration-12 {\r\n  animation-duration: 1.2s;\r\n}\r\n\r\n.animation-duration-13 {\r\n  animation-duration: 1.3s;\r\n}\r\n\r\n.animation-duration-14 {\r\n  animation-duration: 1.4s;\r\n}\r\n\r\n.animation-duration-15 {\r\n  animation-duration: 1.5s;\r\n}\r\n\r\n.animation-duration-16 {\r\n  animation-duration: 1.6s;\r\n}\r\n\r\n.animation-duration-17 {\r\n  animation-duration: 1.7s;\r\n}\r\n\r\n.animation-duration-18 {\r\n  animation-duration: 1.8s;\r\n}\r\n\r\n.animation-duration-19 {\r\n  animation-duration: 1.9s;\r\n}\r\n\r\n.animation-duration-20 {\r\n  animation-duration: 2s;\r\n}\r\n\r\n.animation-duration-21 {\r\n  animation-duration: 2.1s;\r\n}\r\n\r\n.animation-duration-22 {\r\n  animation-duration: 2.2s;\r\n}\r\n\r\n.animation-duration-23 {\r\n  animation-duration: 2.3s;\r\n}\r\n\r\n.animation-duration-24 {\r\n  animation-duration: 2.4s;\r\n}\r\n\r\n.animation-duration-25 {\r\n  animation-duration: 2.5s;\r\n}\r\n\r\n.animation-duration-26 {\r\n  animation-duration: 2.6s;\r\n}\r\n\r\n.animation-duration-27 {\r\n  animation-duration: 2.7s;\r\n}\r\n\r\n.animation-duration-28 {\r\n  animation-duration: 2.8s;\r\n}\r\n\r\n.animation-duration-29 {\r\n  animation-duration: 2.9s;\r\n}\r\n\r\n.animation-duration-30 {\r\n  animation-duration: 3s;\r\n}\r\n\r\n.animation-duration-31 {\r\n  animation-duration: 3.1s;\r\n}\r\n\r\n.animation-duration-32 {\r\n  animation-duration: 3.2s;\r\n}\r\n\r\n.animation-duration-33 {\r\n  animation-duration: 3.3s;\r\n}\r\n\r\n.animation-duration-34 {\r\n  animation-duration: 3.4s;\r\n}\r\n\r\n.animation-duration-35 {\r\n  animation-duration: 3.5s;\r\n}\r\n\r\n.animation-duration-36 {\r\n  animation-duration: 3.6s;\r\n}\r\n\r\n.animation-duration-37 {\r\n  animation-duration: 3.7s;\r\n}\r\n\r\n.animation-duration-38 {\r\n  animation-duration: 3.8s;\r\n}\r\n\r\n.animation-duration-39 {\r\n  animation-duration: 3.9s;\r\n}\r\n\r\n.animation-duration-40 {\r\n  animation-duration: 4s;\r\n}\r\n\r\n//Animation Delay\r\n\r\n.animation-delay-1 {\r\n  animation-delay: 0.1s;\r\n}\r\n\r\n.animation-delay-2 {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.animation-delay-3 {\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n.animation-delay-4 {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n.animation-delay-5 {\r\n  animation-delay: 0.5s;\r\n}\r\n\r\n.animation-delay-6 {\r\n  animation-delay: 0.6s;\r\n}\r\n\r\n.animation-delay-7 {\r\n  animation-delay: 0.7s;\r\n}\r\n\r\n.animation-delay-8 {\r\n  animation-delay: 0.8s;\r\n}\r\n\r\n.animation-delay-9 {\r\n  animation-delay: 0.9s;\r\n}\r\n\r\n.animation-delay-10 {\r\n  animation-delay: 1s;\r\n}\r\n\r\n.animation-delay-11 {\r\n  animation-delay: 1.1s;\r\n}\r\n\r\n.animation-delay-12 {\r\n  animation-delay: 1.2s;\r\n}\r\n\r\n.animation-delay-13 {\r\n  animation-delay: 1.3s;\r\n}\r\n\r\n.animation-delay-14 {\r\n  animation-delay: 1.4s;\r\n}\r\n\r\n.animation-delay-15 {\r\n  animation-delay: 1.5s;\r\n}\r\n\r\n.animation-delay-16 {\r\n  animation-delay: 1.6s;\r\n}\r\n\r\n.animation-delay-17 {\r\n  animation-delay: 1.7s;\r\n}\r\n\r\n.animation-delay-18 {\r\n  animation-delay: 1.8s;\r\n}\r\n\r\n.animation-delay-19 {\r\n  animation-delay: 1.9s;\r\n}\r\n\r\n.animation-delay-20 {\r\n  animation-delay: 2s;\r\n}\r\n\r\n.animation-delay-21 {\r\n  animation-delay: 2.1s;\r\n}\r\n\r\n.animation-delay-22 {\r\n  animation-delay: 2.2s;\r\n}\r\n\r\n.animation-delay-23 {\r\n  animation-delay: 2.3s;\r\n}\r\n\r\n.animation-delay-24 {\r\n  animation-delay: 2.4s;\r\n}\r\n\r\n.animation-delay-25 {\r\n  animation-delay: 2.5s;\r\n}\r\n\r\n.animation-delay-26 {\r\n  animation-delay: 2.6s;\r\n}\r\n\r\n.animation-delay-27 {\r\n  animation-delay: 2.6s;\r\n}\r\n\r\n.animation-delay-28 {\r\n  animation-delay: 2.8s;\r\n}\r\n\r\n.animation-delay-29 {\r\n  animation-delay: 2.9s;\r\n}\r\n\r\n.animation-delay-30 {\r\n  animation-delay: 3s;\r\n}\r\n\r\n.animation-delay-31 {\r\n  animation-delay: 3.1s;\r\n}\r\n\r\n.animation-delay-32 {\r\n  animation-delay: 3.2s;\r\n}\r\n\r\n.animation-delay-33 {\r\n  animation-delay: 3.3s;\r\n}\r\n\r\n.animation-delay-34 {\r\n  animation-delay: 3.4s;\r\n}\r\n\r\n.animation-delay-35 {\r\n  animation-delay: 3.5s;\r\n}\r\n\r\n.animation-delay-36 {\r\n  animation-delay: 3.6s;\r\n}\r\n\r\n.animation-delay-37 {\r\n  animation-delay: 3.7s;\r\n}\r\n\r\n.animation-delay-38 {\r\n  animation-delay: 3.8s;\r\n}\r\n\r\n.animation-delay-39 {\r\n  animation-delay: 3.9s;\r\n}\r\n\r\n.animation-delay-40 {\r\n  animation-delay: 4s;\r\n}\r\n\r\n.animation-delay-41 {\r\n  animation-delay: 4.1s;\r\n}\r\n\r\n.animation-delay-42 {\r\n  animation-delay: 4.2s;\r\n}\r\n\r\n.animation-delay-43 {\r\n  animation-delay: 4.3s;\r\n}\r\n\r\n.animation-delay-44 {\r\n  animation-delay: 4.4s;\r\n}\r\n\r\n.animation-delay-45 {\r\n  animation-delay: 4.5s;\r\n}\r\n\r\n.animation-delay-46 {\r\n  animation-delay: 4.6s;\r\n}\r\n\r\n.animation-delay-47 {\r\n  animation-delay: 4.7s;\r\n}\r\n\r\n.animation-delay-48 {\r\n  animation-delay: 4.8s;\r\n}\r\n\r\n.animation-delay-49 {\r\n  animation-delay: 4.9s;\r\n}\r\n\r\n.animation-delay-50 {\r\n  animation-delay: 5s;\r\n}","/* Base\r\n   ========================================================================== */\r\n@import \"base\";\r\n@import \"typography\";","/*Base Styles*/\r\n\r\nhtml {\r\n  height: 100%;\r\n}\r\n\r\nbody {\r\n  font: {\r\n    family: $font-family-base;\r\n    size: $font-size-base;\r\n    weight: $font-weight-base;\r\n  }\r\n  color: $body-color;\r\n  background-color: $body-bg;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\nbody.ios-mobile-view-height {\r\n  height: auto !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n#nprogress .bar {\r\n  z-index: 5000 !important;\r\n  background: $app-primary !important;\r\n}\r\n\r\n#nprogress .peg {\r\n  @include box-shadow(0 0 10px $app-primary, 0 0 5px $app-primary !important);\r\n}\r\n\r\n#nprogress .spinner {\r\n  z-index: 5000 !important;\r\n}\r\n\r\n#nprogress .spinner-icon {\r\n  border-top-color: $app-primary !important;\r\n  border-left-color: $app-primary !important;\r\n}\r\n\r\n.ripple-effect {\r\n  @extend %ripple-effect;\r\n}\r\n\r\n.text-transform-none {\r\n  text-transform: none;\r\n}\r\n\r\n.br-break {\r\n  word-break: break-all !important;\r\n}\r\n\r\n.font-weight-semibold {\r\n  font-weight: 500 !important;\r\n}\r\n\r\n.z-index-20 {\r\n  z-index: 20;\r\n}\r\n\r\n.size-120 {\r\n  @extend %size-120;\r\n}\r\n\r\n.size-100 {\r\n  @extend %size-100;\r\n}\r\n\r\n.size-80 {\r\n  @extend %size-80;\r\n}\r\n\r\n.size-60 {\r\n  @extend %size-60;\r\n}\r\n\r\n.size-50 {\r\n  @extend %size-50;\r\n}\r\n\r\n.size-40 {\r\n  @extend %size-40;\r\n}\r\n\r\n.size-30 {\r\n  @extend %size-30;\r\n}\r\n\r\n.size-20 {\r\n  @extend %size-20;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: solid 1px $gray-300;\r\n}\r\n\r\n.col-with-divider div[class*=\"col-\"] {\r\n  border-left: solid 1px $gray-300;\r\n  &:first-child {\r\n    border: 0 none;\r\n  }\r\n}\r\n\r\n.height-100 {\r\n  height: 100px !important;\r\n}\r\n\r\n.height-150 {\r\n  height: 150px !important;\r\n}\r\n\r\n.height-130 {\r\n  height: 130px !important;\r\n}\r\n\r\n.height-200 {\r\n  height: 200px !important;\r\n}\r\n\r\n.max-width-100 {\r\n  max-width: 100px !important;\r\n}\r\n\r\n.max-height-120 {\r\n  max-height: 120px !important;\r\n}\r\n\r\n.right-arrow {\r\n  display: inline-block;\r\n  color: $app-primary;\r\n  text-transform: capitalize;\r\n  &:after {\r\n    content: \"\\f30f\";\r\n    font-family: \"Material-Design-Iconic-Font\";\r\n    color: $app-primary;\r\n    margin-left: 8px;\r\n    font-size: 20px;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  &:hover,\r\n  &:focus {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n.letter-spacing-base {\r\n  letter-spacing: $letter-spacing-base;\r\n}\r\n\r\n.letter-spacing-lg {\r\n  letter-spacing: $letter-spacing-lg;\r\n}\r\n\r\n.letter-spacing-xl {\r\n  letter-spacing: $letter-spacing-xl;\r\n}\r\n\r\n.page-heading {\r\n  margin-bottom: $jr-card-margin + 4px;\r\n\r\n  & .title {\r\n    text-transform: capitalize;\r\n    font-weight: 600;\r\n  }\r\n\r\n  & .breadcrumb {\r\n    padding: 0;\r\n    background-color: transparent;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.sub-heading {\r\n  font-size: $font-size-base;\r\n  color: $gray-500;\r\n  margin-bottom: 0;\r\n  &:not(:last-child) {\r\n    margin-bottom: 16px !important;\r\n  }\r\n}\r\n\r\n.manage-margin {\r\n  margin-bottom: 0;\r\n  & > * {\r\n    margin-bottom: 6px;\r\n    &:not(:last-child) {\r\n      margin-right: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n//Shadow\r\n.no-shadow {\r\n  @include box-shadow(none !important);\r\n}\r\n\r\n.shadow-sm {\r\n  @include box-shadow($shadow-sm);\r\n}\r\n\r\n.shadow {\r\n  @include box-shadow($shadow);\r\n}\r\n\r\n.shadow-lg {\r\n  @include box-shadow($shadow-lg);\r\n}\r\n\r\n.shadow-xl {\r\n  @include box-shadow($shadow-xl);\r\n}\r\n\r\n.avatar-shadow {\r\n  @include box-shadow($avatar-shadow);\r\n}\r\n\r\n.remove-table-border {\r\n  td, th {\r\n    border: 0 none;\r\n  }\r\n}\r\n\r\n//Media Object list\r\n.media-list {\r\n  margin-bottom: 10px;\r\n  &:not(:last-child) {\r\n    border-bottom: solid 1px $gray-200;\r\n    padding-bottom: 15px;\r\n    margin-bottom: 20px;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n.border-2 {\r\n  border: 2px solid $gray-400 !important;\r\n}\r\n\r\n.border-w2 {\r\n  border-width: 2px;\r\n}\r\n\r\n// Border Color Classes\r\n\r\n@each $color_name, $color in $colors_palette {\r\n  @each $color_type, $color_value in $color {\r\n    @if $color_type == \"base\" {\r\n      .border-#{$color_name} {\r\n        border-color: $color_value !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n//Center Crop image\r\n\r\n.center-crop-img {\r\n  position: relative;\r\n  width: 100%;\r\n  min-height: 120px;\r\n  overflow: hidden;\r\n\r\n  & img {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    height: 100%;\r\n    width: auto;\r\n    -webkit-transform: translate(-50%, -50%);\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  & img.portrait {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n}\r\n\r\n//Bootstrap Components Override\r\n\r\n//Buttons\r\n\r\na.btn-info {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-danger {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-warning {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-success {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-dark {\r\n  @extend %link-hover;\r\n}\r\n\r\n//Badges\r\na.badge-success {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-danger {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-warning {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-info {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-dark {\r\n  @extend %link-hover;\r\n}\r\n\r\n.pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.icon-btn {\r\n  height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 48px;\r\n  justify-content: center;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  color: $gray-600;\r\n\r\n  .header-notifications & {\r\n    padding: 0 4px;\r\n  }\r\n}\r\n\r\n.avatar {\r\n  width: 60px;\r\n  height: 60px;\r\n  text-align: center;\r\n  line-height: 60px;\r\n  color: #fafafa;\r\n}\r\n\r\n.avatar-lg {\r\n  width: 80px;\r\n  height: 80px;\r\n  line-height: 80px;\r\n  text-align: center;\r\n  color: #fafafa;\r\n}\r\n\r\n.avatar-sm {\r\n  width: 40px;\r\n  height: 40px;\r\n  text-align: center;\r\n  color: #fafafa;\r\n}\r\n.animated {\r\n  -webkit-animation-fill-mode: none !important;\r\n  animation-fill-mode: none !important\r\n}\r\n\r\n.overflow-hidden {\r\n  overflow: hidden;\r\n}\r\n\r\n.icons-showcase > div {\r\n  cursor: pointer;\r\n  padding: 7px 15px;\r\n  @include border-radius($border-radius);\r\n  overflow: hidden;\r\n  text-align: left;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.text-decoration {\r\n  text-decoration: none !important;\r\n}\r\n\r\n.row-5 {\r\n  margin-left: -5px;\r\n  margin-right: -5px;\r\n\r\n  & > [class*='col-'] {\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n  }\r\n}\r\n\r\n.font-size-16 {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.material-icons {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  padding-bottom: 3px;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  -webkit-appearance: none;\r\n  width: 10px;\r\n  height: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  border-radius: 4px;\r\n  background-image: linear-gradient(to bottom right, #ebebeb, #bebebe);\r\n  border: solid 1px #ababab;\r\n}\r\n\r\n::selection {\r\n  background-color:#006FC9;\r\n  color: #fff;\r\n}\r\n\r\nselect {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  padding: 2px 30px 2px 2px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.my-tooltip > .tooltip-inner {\r\n  background-color: #fff;\r\n  color: #808080;\r\n  border: 1px solid #d8dcdf;\r\n}\r\n\r\n.my-tooltip [class$=\"arrow\"] {\r\n  display: none;\r\n  // border-top: 5px solid red !important;\r\n}\r\n\r\n::-ms-clear {\r\n  display: none;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.hs-button {\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n  margin:0;\r\n  cursor:pointer;\r\n  display:inline-block;\r\n  font-weight:700;\r\n  line-height:12px;\r\n  position:relative;\r\n  text-align:center;\r\n  transition:all .15s linear;\r\n  background-color:#ff7a59;\r\n  border-color:#ff7a59;\r\n  color:#fff;\r\n  border-radius:3px;\r\n  border-style:solid;\r\n  border-width:1px;\r\n  font-size:14px;\r\n  padding:12px 24px\r\n}\r\n.hs-button:hover,.hs-button:focus {\r\n  background-color:#ff8f73;\r\n  border-color:#ff8f73\r\n}\r\n.hs-button:active {\r\n  background-color:#e66e50;\r\n  border-color:#e66e50\r\n}\r\nlabel {\r\n  font-size:14px;\r\n  width:130px;\r\n  text-align:right;\r\n  color:#33475b;\r\n  display:block;\r\n  float:none;\r\n  width:auto;\r\n  font-weight:500;\r\n  text-align:left;\r\n  line-height:20px;\r\n  padding-top:0;\r\n  margin-bottom:4px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.hs-video-form label {\r\n  color:#fff !important\r\n}\r\n.hs-video-form .hs-back-button{ \r\n  background-color:#fff;\r\n  width:20%;\r\n  height:38px;\r\n  margin-right:10px;\r\n  border:1px solid;\r\n  -webkit-border-radius:3px;\r\n  -moz-border-radius:3px;\r\n  -ms-border-radius:3px;\r\n  border-radius:3px\r\n}\r\n.hs-video-form .hs-button {\r\n  width:70%\r\n}\r\n.hs-video-form .hs-button span {\r\n  font-size:15px\r\n}\r\n.hs-video-form .hs-richtext {\r\n  color:#fff !important\r\n}\r\n.hs-video-form .legal-consent-container {\r\n  max-height:180px !important;\r\n  overflow-y:scroll !important\r\n}\r\n.hs-video-form .legal-consent-container:after {\r\n  content:\"\";\r\n  display:block;\r\n  height:100px;\r\n  width:100%\r\n}.hs-video-form .legal-consent-wrapper {\r\n  position:relative\r\n}\r\n.hs-video-form .legal-consent-overlay {\r\n  position:absolute;\r\n  pointer-events:none;\r\n  left:0;\r\n  bottom:0;\r\n  height:100px;\r\n  width:100%;\r\n  background:linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #292929 100%)\r\n}\r\n.hs-error-msgs label {\r\n  color:#f2545b\r\n}\r\n.hs-input {\r\n  display:inline-block;\r\n  width:90%;\r\n  max-width:500px;\r\n  height:40px;\r\n  padding:9px 10px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n  font-size:16px;\r\n  font-weight:normal;\r\n  line-height:22px;\r\n  color:#33475b;\r\n  border:1px solid #cbd6e2;\r\n  box-sizing:border-box;\r\n  -webkit-border-radius:3px;\r\n  -moz-border-radius:3px;\r\n  -ms-border-radius:3px;\r\n  border-radius:3px\r\n}\r\n.hs-input:not([type=file]) {\r\n  background-color:#f5f8fa\r\n}\r\n.hs-input[type=checkbox],.hs-input[type=radio] {\r\n  cursor:pointer;\r\n  width:auto;\r\n  height:auto;\r\n  padding:0;\r\n  margin:3px 5px 3px 0px;\r\n  line-height:normal;\r\n  border:none\r\n}\r\n.hs-input[type=file] {\r\n  padding:initial;\r\n  border:initial;\r\n  line-height:initial;\r\n  box-shadow:none\r\n}\r\nselect.is-placeholder {\r\n  color:#bfbfbf\r\n}\r\nselect.is-placeholder:focus {\r\n  color:#33475b\r\n}\r\n.hs-input:-moz-placeholder {\r\n  color:#bfbfbf\r\n}\r\n.hs-input::-webkit-input-placeholder {\r\n  color:#bfbfbf\r\n}\r\n.hs-input option:disabled {\r\n  color:#bfbfbf\r\n}\r\n.hs-input input,.hs-input textarea {\r\n  transition:border .2s linear\r\n}\r\n.hs-input:focus {\r\n  outline:none;\r\n  border-color:rgba(82,168,236,.8)\r\n}\r\ntextarea.hs-input{height:auto}select[multiple].hs-input {\r\n  height:inherit\r\n}\r\ninput.hs-input.error,div.field.error input,div.field.error textarea,div.field.error .chzn-choices,textarea.hs-input.error,select.hs-input.error {\r\n  border-color:#c87872 !important;\r\n}\r\ninput.hs-input.error:focus,div.field.error input:focus,div.field.error textarea:focus,div.field.error .chzn-choices:focus,textarea.hs-input.error:focus,select.hs-input.error:focus {\r\n  border-color:#b9554d !important;\r\n}\r\n.actions {\r\n  margin-top:18px;\r\n  margin-bottom:18px;\r\n  padding:17px 0px\r\n}\r\n.inputs-list {\r\n  margin:0 0 5px;\r\n  width:100%;\r\n  padding-left:5px\r\n}\r\n.inputs-list>li {\r\n  display:block;\r\n  padding:0;\r\n  width:100%;\r\n  padding-top:0\r\n}\r\n.inputs-list label {\r\n  display:block;\r\n  float:none;\r\n  width:auto;\r\n  padding:0;\r\n  line-height:18px;\r\n  text-align:left;\r\n  white-space:normal;\r\n  font-weight:normal\r\n}\r\n.inputs-list:first-child {\r\n  padding-top:6px\r\n}\r\n.inputs-list>li+li {\r\n  padding-top:2px\r\n}\r\nul.no-list {\r\n  list-style:none\r\n}\r\n.field {\r\n  margin-bottom:18px\r\n}\r\n.hs-field-desc {\r\n  color:#7c98b6;\r\n  margin:0px 0px 6px;\r\n  font-size:14px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.hs-form-required {\r\n  color:red\r\n}\r\n.hs-richtext {\r\n  margin-bottom:3px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n  line-height:24px;\r\n  font-size:14px;\r\n  color:#33475b\r\n}\r\n.hs-richtext hr {\r\n  text-align:left;\r\n  margin-left:0;\r\n  width:91%\r\n}\r\n.email-correction,.email-validation {\r\n  padding-top:3px;\r\n  font-size:12px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.email-correction a,.email-validation a {\r\n  cursor:pointer\r\n}\r\n@media(max-width: 400px),(min-device-width: 320px)and (max-device-width: 480px) {\r\n  .email-correction form .form-columns-2 .hs-form-field,.email-correction form .form-columns-3 .hs-form-field,.email-validation form .form-columns-2 .hs-form-field,.email-validation form .form-columns-3 .hs-form-field {\r\n    float:none;width:100%\r\n  }\r\n  .email-correction form .form-columns-2 .hs-form-field .hs-input,.email-correction form .form-columns-3 .hs-form-field .hs-input,.email-validation form .form-columns-2 .hs-form-field .hs-input,.email-validation form .form-columns-3 .hs-form-field .hs-input {\r\n    width:90%\r\n  }\r\n  .email-correction form .form-columns-2 .hs-form-field input[type=checkbox],.email-correction form .form-columns-2 .hs-form-field input[type=radio],.email-correction form .form-columns-3 .hs-form-field input[type=checkbox],.email-correction form .form-columns-3 .hs-form-field input[type=radio],.email-validation form .form-columns-2 .hs-form-field input[type=checkbox],.email-validation form .form-columns-2 .hs-form-field input[type=radio],.email-validation form .form-columns-3 .hs-form-field input[type=checkbox],.email-validation form .form-columns-3 .hs-form-field input[type=radio] {\r\n    width:24px\r\n  }\r\n}\r\n.hs-button,.hs-form-field input[type=text],.hs-form-field input[type=email],.hs-form-field input[type=phone],.hs-form-field input[type=number],.hs-form-field input[type=tel],.hs-form-field input[type=date],.hs-form-field textarea {\r\n  -webkit-appearance:none;\r\n  -moz-appearance:none\r\n}\r\n.hs-default-font-element,.hs-main-font-element {\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.hs-form label {\r\n  margin: 0!important;\r\n  font-family: 'Poppins', sans-serif!important;\r\n  // font-weight: bold!important;\r\n}\r\n.hs-form input[type=\"checkbox\"] {\r\n  margin: 0 10px 0 0!important;\r\n}\r\n.hs-form fieldset {\r\n  max-width: unset!important;\r\n}\r\n.hs-input {\r\n  max-width: unset!important;\r\n  font-family: 'Poppins', sans-serif!important;\r\n}\r\n.hs-form .input textarea {\r\n  width: 100%!important;\r\n}\r\n.hs-form .input select {\r\n  width: 100%!important;\r\n}\r\n.hs-form select {\r\n  margin: 0!important;\r\n}\r\n.hs-form textarea {\r\n  margin: 0!important;\r\n}\r\n.hs-form input[type=\"text\"], .hs-form input[type=\"email\"], .hs-form input[type=\"tel\"] {\r\n  margin: 0!important;\r\n}\r\n.hs-form input[type=\"file\" i]::-webkit-file-upload-button {\r\n  cursor: pointer!important;\r\n}\r\n.hs-form ::placeholder {\r\n  color: #bfbfbf!important;\r\n  font-weight: 400!important;\r\n  font-size: 14px!important;\r\n}\r\n.hs-form .input input[type=\"file\"] {\r\n  width: 100%!important;\r\n  margin: 0!important;\r\n}\r\n.hs-form .input input[type=\"text\"] {\r\n  width: 100%!important;\r\n  border: 1px solid #cbd6e2;\r\n  border-radius: 3px!important;\r\n}\r\n.hs-form .input input[type=\"text\"]::placeholder {\r\n  font-size: 14px!important;\r\n}\r\n.hs-field-desc {\r\n  text-align: left!important;\r\n}\r\n.hs-form body .hs-button.primary, body input[type=\"submit\"], body input[type=\"button\"] {\r\n  float: none!important;\r\n  margin: 0!important;\r\n}\r\n.hs-form .actions {\r\n  margin: 0!important;\r\n  text-align: left!important;\r\n}\r\n\r\n\r\n// .hs-form input[type=\"text\"],\r\n// .hs-form input[type=\"email\"],\r\n// .hs-form input[type=\"tel\"] {\r\n//     border: none;\r\n//     box-shadow: none;\r\n//     border-radius: 0;\r\n//     padding: '5px 0 5px 0';\r\n//     font-weight: 400;\r\n//     font-size: 14px;\r\n//     font-family: 'Roboto';\r\n//     letter-spacing: 2;\r\n//     line-height: 1.5;\r\n//     margin: 5px 0 10px 0;\r\n//     color: #0071B9;\r\n//     padding-bottom: 5px;\r\n//     border-bottom: solid #d8dcdf 1px;\r\n//     width: 100%;\r\n// }\r\n\r\n// .hs-form input[type=\"checkbox\"] {\r\n//     margin: 10px 10px 10px 0;\r\n// }\r\n\r\n// .hs-form input[type=\"text\"]:focus {\r\n//     outline: 0;\r\n// }\r\n\r\n// .hs-form input[type=\"email\"]:focus {\r\n//     outline: 0;\r\n// }\r\n\r\n// .hs-form input[type=\"tel\"]:focus {\r\n//     outline: 0;\r\n// }\r\n\r\n// .hs-form label {\r\n//     color: #0071B9;\r\n//     font-family: 'Roboto';\r\n//     margin: 10px 0;\r\n// }\r\n// .hs-form .hs-form-field > label {\r\n//     color: #0071B9;\r\n//     font-family: 'Roboto';\r\n//     margin: 10px 0;\r\n// }\r\n\r\n// .hs-form .hs-field-desc {\r\n//     color: #0071B9;\r\n//     font-family: 'Roboto';\r\n//     margin: 5px 0;\r\n// }\r\n\r\n// .hs-form select {\r\n//     background: whitesmoke;\r\n//     margin: 15px 0 25px 0;\r\n//     color: #5e7993;\r\n//     border-radius: 3px;\r\n//     font-family: 'Roboto';\r\n// }\r\n\r\n// .hs-form select:focus {\r\n//     outline: none;\r\n//     border: none;\r\n// }\r\n\r\n// .hs-form select:active {\r\n//     outline: none;\r\n//     border: none;\r\n// }\r\n\r\n\r\n\r\n// .hs-form .hs-richtext {\r\n//     color: #5e7993;\r\n//     font-family: 'Roboto';\r\n//     margin: 5px 0 20px 0;\r\n//     font-size: 14px;\r\n// }\r\n\r\n// .hs-form textarea {\r\n//     margin: 10px 0;\r\n//     color: #0071B9;\r\n//     border: 1px solid #d8dcdf;\r\n//     border-radius: 0.2rem;\r\n//     width: 100%;\r\n// }\r\n\r\n// .hs-form textarea:focus {\r\n//     outline: none;\r\n// }\r\n\r\n// body .hs-button.primary,\r\n// body input[type=\"submit\"],\r\n// body input[type=\"button\"] {\r\n//     background: #0071B9;\r\n//     color: #ffffff;\r\n//     border-radius: .2rem;\r\n//     padding: 1em;\r\n//     font-size: 14px;\r\n//     font-weight: 400;\r\n//     padding: 10px 20px;\r\n//     // margin: 0 5px;\r\n//     margin-bottom: -70px;\r\n//     font-family: 'Roboto';\r\n//     border: 1px solid #0071B9;\r\n//     -webkit-transition: all .3s ease-in-out;\r\n//     -moz-transition: all .3s ease-in-out;\r\n//     -ms-transition: all .3s ease-in-out;\r\n//     -o-transition: all .3s ease-in-out;\r\n//     transition: all .3s ease-in-out;\r\n//     margin: 30px 0 0 10px;\r\n// }\r\n\r\n// body .hs-button.primary:hover,\r\n// body input[type=\"submit\"]:hover,\r\n// body input[type=\"button\"]:hover {\r\n//     cursor: pointer;\r\n//     opacity: .8\r\n// }\r\n\r\n// body input[type=\"file\"] {\r\n//     margin: 25px 0 25px 0;\r\n//     font-family: 'Roboto';\r\n// }\r\n\r\n// .hs-form .hs-error-msgs label {\r\n//     color: #d8000c;\r\n//     font-size: 13px;\r\n//     padding-bottom: 5px;\r\n// }\r\n\r\n/* OVERRIDE DEFAULT REACT-DATES STYLES */\r\n/*# sourceMappingURL=app.css.map */\r\n\r\n/* Will edit everything selected including everything between a range of dates */\r\n.CalendarDay__selected_span {\r\n  background: #3392E6 !important;\r\n  border: 1px double #3392E6 !important;\r\n  color: white !important;\r\n}\r\n\r\n/* Will edit selected date or the endpoints of a range of dates */\r\n.CalendarDay__selected {\r\n  background: #3392E6 !important;\r\n  border: 1px double #3392E6 !important;\r\n  color: white !important;\r\n}\r\n \r\n/* Will edit when hovered over. _span style also has this property */\r\n.CalendarDay__selected:hover {\r\n  opacity: 0.8 !important;\r\n}\r\n \r\n/* Will edit when the second date (end date) in a range of dates */\r\n/* is not yet selected. Edits the dates between your mouse and said date */\r\n.CalendarDay__hovered_span:hover,\r\n.CalendarDay__hovered_span {\r\n  background: #3392E6 !important;\r\n}\r\n\r\n// Help Icon in lower right corner\r\n.DayPickerKeyboardShortcuts_show__bottomRight::before {\r\n  border-right: 33px solid #3392E6 !important;\r\n  border-right-color: #3392E6 !important;\r\n}\r\n\r\n.CalendarMonth_table  {\r\n  margin-top: 8px;\r\n}\r\n\r\n.SingleDatePicker_picker {\r\n  z-index: 100 !important;\r\n}\r\n\r\n.SingleDatePicker {\r\n  display: block !important;\r\n}\r\n\r\n.SingleDatePickerInput {\r\n  display: block !important;\r\n}\r\n\r\n.DateInput {\r\n  display: block !important;\r\n  width: 100% !important;\r\n}\r\n\r\n.DateInput_input {\r\n  font-size: 14px !important;\r\n  color: #808080 !important;\r\n  border: 1px solid #ced4da !important;\r\n  box-shadow: none !important;\r\n  border-radius: .25rem !important;\r\n  padding: 10px 0 5px 10px !important;\r\n  font-weight: 400 !important;\r\n  display: block !important;\r\n  width: 100% !important;\r\n  height: calc(2.25rem + 2px) !important;\r\n}\r\n\r\n.DateInput_input__focused {\r\n  border: 1px solid #ced4da !important;\r\n  border-radius: .25rem !important;\r\n}\r\n\r\n.DateRangePicker {\r\n  display: block !important;\r\n}\r\n\r\n.DateRangePickerInput {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: space-between !important;\r\n}\r\n\r\n.DateRangePickerInput_arrow {\r\n  padding: 0 10px !important;\r\n}\r\n\r\n.DateInput_input__disabled {\r\n  font-style: normal !important\r\n}\r\n\r\n// Hubspot Styling\r\n\r\n.hs-form input[type=\"text\"],\r\n.hs-form input[type=\"email\"],\r\n.hs-form input[type=\"tel\"] {\r\n    border: none;\r\n    box-shadow: none;\r\n    border-radius: 5;\r\n    padding: '5px 0 5px 0';\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    font-family: 'Roboto';\r\n    letter-spacing: 2;\r\n    line-height: 1.5;\r\n    margin: 5px 0 10px 0;\r\n    color: #0071B9;\r\n    padding-bottom: 5px;\r\n    border: 1px solid #cbd6e2;\r\n    width: 100%;\r\n}\r\n\r\n.hs-form input[type=\"checkbox\"] {\r\n    margin: 10px 10px 10px 0;\r\n}\r\n\r\n.hs-form input[type=\"text\"]:focus {\r\n    outline: 0;\r\n}\r\n\r\n.hs-form input[type=\"email\"]:focus {\r\n    outline: 0;\r\n}\r\n\r\n.hs-form input[type=\"tel\"]:focus {\r\n    outline: 0;\r\n}\r\n\r\n.hs-form label {\r\n    // color: #0071B9;\r\n    font-family: 'Roboto';\r\n    margin: 10px 0;\r\n}\r\n.hs-form .hs-form-field > label {\r\n    color: #0071B9;\r\n    font-family: 'Roboto';\r\n    margin: 10px 0;\r\n}\r\n\r\n.hs-form .hs-field-desc {\r\n    color: #33475b;\r\n    font-family: 'Roboto';\r\n    margin: 5px 0;\r\n}\r\n\r\n.hs-form select {\r\n    background: whitesmoke;\r\n    margin: 15px 0 25px 0;\r\n    color: #5e7993;\r\n    border-radius: 3px;\r\n    font-family: 'Roboto';\r\n}\r\n\r\n.hs-form select:focus {\r\n    outline: none;\r\n}\r\n\r\n.hs-form select:active {\r\n    outline: none;\r\n}\r\n\r\n\r\n\r\n.hs-form .hs-richtext {\r\n    color: #5e7993;\r\n    font-family: 'Roboto';\r\n    margin: 5px 0 20px 0;\r\n    font-size: 14px;\r\n}\r\n\r\n.hs-form textarea {\r\n    margin: 10px 0;\r\n    color: #0071B9;\r\n    border: 1px solid #d8dcdf;\r\n    border-radius: 0.2rem;\r\n    width: 100%;\r\n}\r\n\r\n.hs-form textarea:focus {\r\n    outline: none;\r\n}\r\n\r\nbody .hs-button.primary,\r\nbody input[type=\"submit\"],\r\nbody input[type=\"button\"] {\r\n    background: #0071B9;\r\n    color: #ffffff;\r\n    border-radius: .2rem;\r\n    padding: 1em;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    padding: 10px 20px;\r\n    // margin: 0 5px;\r\n    margin-bottom: -70px;\r\n    font-family: 'Roboto';\r\n    border: 1px solid #0071B9;\r\n    -webkit-transition: all .3s ease-in-out;\r\n    -moz-transition: all .3s ease-in-out;\r\n    -ms-transition: all .3s ease-in-out;\r\n    -o-transition: all .3s ease-in-out;\r\n    transition: all .3s ease-in-out;\r\n    margin: 30px 0 0 10px;\r\n}\r\n\r\nbody .hs-button.primary:hover,\r\nbody input[type=\"submit\"]:hover,\r\nbody input[type=\"button\"]:hover {\r\n    cursor: pointer;\r\n    opacity: .8\r\n}\r\n\r\nbody input[type=\"file\"] {\r\n    margin: 25px 0 25px 0;\r\n    font-family: 'Roboto';\r\n}\r\n\r\n.hs-form .hs-error-msgs label {\r\n    color: #d8000c;\r\n    font-size: 13px;\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.material-icons {\r\n  user-select: none;\r\n}\r\n\r\n.d-inline-block {\r\n  user-select: none;\r\n}\r\n\r\n","/*Typography Styles*/\r\nh1, h2, h3, h4, h5, h6,\r\n.h1, .h2, .h3, .h4, .h5, .h6 {\r\n  font-weight: $headings-font-weight;\r\n  margin: 0 0 $headings-margin-bottom;\r\n  color: $headings-color;\r\n}\r\n\r\nh1, .h1 {\r\n  font-size: $h1-font-size;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\nh2, .h2 {\r\n  font-size: $h2-font-size;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\nh3, .h3 {\r\n  font-size: $h3-font-size;\r\n}\r\n\r\nh4, .h4 {\r\n  font-size: $h4-font-size;\r\n}\r\n\r\nh5, .h5 {\r\n  font-size: $h5-font-size;\r\n}\r\n\r\nh6, .h6 {\r\n  font-size: $h6-font-size;\r\n}\r\n\r\n.text-strikethrough {\r\n  text-decoration: line-through !important;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  h1, .h1 {\r\n    font-size: $h2-font-size;\r\n    font-family: 'Poppins', sans-serif;\r\n  }\r\n\r\n  h2, .h2 {\r\n    font-size: $h3-font-size;\r\n    font-family: 'Poppins', sans-serif;\r\n  }\r\n\r\n  h3, .h3 {\r\n    font-size: $h4-font-size;\r\n  }\r\n}\r\n\r\n.desc-list {\r\n  margin-bottom: 0;\r\n  li {\r\n    padding: $jr-card-padding;\r\n    border-bottom: 1px solid $gray-400;\r\n    margin-left: -$jr-card-margin + 4px;\r\n    margin-right: -$jr-card-margin + 4px;\r\n\r\n    &:last-child {\r\n      border-bottom: 0 none;\r\n    }\r\n\r\n    & .card-title {\r\n      margin-bottom: 6px;\r\n    }\r\n\r\n  }\r\n\r\n  &.even-odd {\r\n    li {\r\n      border-bottom: 0 none;\r\n\r\n      &:nth-child(2n) {\r\n        background-color: $gray-300;\r\n      }\r\n    }\r\n  }\r\n}","/* Layouts\r\n   ========================================================================== */\r\n@import \"app-layout\";\r\n@import \"sidebar\";\r\n@import \"header\";\r\n@import \"navbar\";\r\n@import \"main-content\";\r\n@import \"footer\";\r\n@import \"right-sidebar\";","/*App Layout Styles*/\r\n\r\n#app-site,\r\n.app-main {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.app-container {\r\n  @include display-flex(flex, row, nowrap);\r\n  width: 100%;\r\n}\r\n\r\n.app-sidebar {\r\n  @include display-flex(flex, column, nowrap);\r\n  width: $side-nav-width;\r\n  min-width: $side-nav-width;\r\n  max-width: $side-nav-width;\r\n}\r\n\r\n.app-main-container {\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.app-header {\r\n  min-height: $app-bar-height;\r\n  z-index: 99;\r\n  position: relative;\r\n}\r\n\r\n.app-main-content-wrapper {\r\n  flex: 1;\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.app-container {\r\n  &.fixed-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n  }\r\n\r\n  &.collapsible-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n\r\n    & .app-main-container {\r\n      position: relative;\r\n    }\r\n  }\r\n\r\n  &.mini-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n\r\n    .app-sidebar {\r\n      width: $mini-drawer-width;\r\n      min-width: $mini-drawer-width;\r\n      max-width: $mini-drawer-width;\r\n    }\r\n  }\r\n}\r\n","/*Sidebar Styles*/\r\n\r\n.side-nav {\r\n  width: $side-nav-width;\r\n  background-color: $sidebar-bg !important;\r\n  color: $sidebar-text-color !important;\r\n  border-right: solid 1px $gray-200 !important;\r\n  z-index: 1250 !important;\r\n  height: 100%;\r\n\r\n  & .user-profile {\r\n    background-color: $sidebar-bg-darken;\r\n    padding: 13px 20px !important;\r\n  }\r\n\r\n  & .user-avatar {\r\n    margin: 0 15px 0 0 !important;\r\n    height: 44px !important;\r\n    width: 44px !important;\r\n    line-height: 44px;\r\n  }\r\n\r\n  & .user-detail {\r\n    & .user-name {\r\n      color: $sidebar-hover-color;\r\n      cursor: pointer;\r\n      font-size: $font-size-base;\r\n      font-weight: 400;\r\n      white-space: nowrap;\r\n    }\r\n  }\r\n}\r\n\r\n.user-detail {\r\n  & .user-name {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n/*Navbar Styles*/\r\nul.nav-menu {\r\n  position: relative;\r\n  font-size: $font-size-base;\r\n  list-style: outside none none;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\nul.nav-menu li {\r\n  position: relative;\r\n  margin-bottom: 1px;\r\n}\r\n\r\nul.nav-menu li.menu {\r\n  & + .nav-header {\r\n    margin-top: 40px;\r\n  }\r\n  & .sub-menu {\r\n    display: none;\r\n  }\r\n  &.open > .sub-menu {\r\n    display: block;\r\n  }\r\n\r\n  &.open {\r\n    & .menu.active > .sub-menu {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\nul.nav-menu li a {\r\n  color: $sidebar-text-color;\r\n  display: block;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  // text-transform: capitalize;\r\n  text-decoration: none;\r\n  @include border-radius(0);\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n    padding: 3px 8px 2px;\r\n  }\r\n}\r\n\r\nul.nav-menu {\r\n  & .nav-header {\r\n    color: $sidebar-text-color;\r\n    padding: 4px 22px;\r\n    font-size: 11px;\r\n    text-transform: uppercase;\r\n\r\n    &:first-child {\r\n      margin-top: 30px;\r\n    }\r\n  }\r\n}\r\n\r\nul.nav-menu > li.selected > a,\r\nul.nav-menu > li.open > a,\r\nul.nav-menu > li > a:hover,\r\nul.nav-menu > li > a:focus {\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\nul.nav-menu li.menu > a {\r\n  padding: 16px 20px;\r\n  border-left: 2px solid transparent;\r\n}\r\n\r\nul.nav-menu li.menu.open > a {\r\n  border-color: transparent;\r\n}\r\n\r\nul.nav-menu li.menu > a:focus:before,\r\nul.nav-menu li.menu > a:hover:before {\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\nul.nav-menu li i {\r\n  margin-right: 12px;\r\n  font-size: 15px;\r\n}\r\n\r\nul.nav-menu li ul {\r\n  list-style: outside none none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu li > a {\r\n  padding: 7px 20px 7px 56px;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu > li > ul > li > a {\r\n  padding-left: 76px;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu > li > ul > li > ul > li > a {\r\n  padding-left: 96px;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu > li > ul > li > ul > li > ul > li > a {\r\n  padding-left: 116px;\r\n}\r\n\r\nul.nav-menu li.menu > a:before {\r\n  color: $sidebar-text-color;\r\n  content: \"\\f2fb\";\r\n  display: inline-block;\r\n  float: right;\r\n  font: {\r\n    family: 'Material-Design-Iconic-Font';\r\n    size: 15px;\r\n  }\r\n  margin-left: 10px;\r\n  position: relative;\r\n  @include transition(all 300ms ease-in-out);\r\n  font-weight: normal;\r\n}\r\nul.nav-menu li.menu.no-arrow > a:before {\r\n  display: none;\r\n}\r\n\r\nul.nav-menu li.menu.selected > a:before,\r\nul.nav-menu li.menu.open > a:before,\r\nul.nav-menu li.menu > a:focus:before,\r\nul.nav-menu li.menu li > a:hover:before {\r\n  background-color: transparent;\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\nul.nav-menu li.menu.open > a:before,\r\nul.nav-menu li.menu.active > a:before {\r\n  @include rotate(90deg);\r\n}\r\n\r\nul.nav-menu li.menu .sub-menu li > a.active .nav-text {\r\n  padding: 3px 7px;\r\n  margin-left: -7px;\r\n  background-color: $sidebar-hover-color;\r\n  color: $white;\r\n  @include border-radius($border-radius);\r\n  display: inline-block;\r\n}\r\n\r\nul.nav-menu li.menu .sub-menu li > a:hover,\r\nul.nav-menu li.menu .sub-menu li > a:focus,\r\nul.nav-menu li.menu.open .sub-menu li > a.active:before,\r\nul.nav-menu li.menu .sub-menu li > a:focus:before,\r\nul.nav-menu li.menu .sub-menu li > a:hover:before {\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\n.app-container.mini-drawer {\r\n  & .side-nav {\r\n    @include transition($transition-base);\r\n    width: $mini-drawer-width;\r\n\r\n    & .nav-menu li span.nav-text,\r\n    & .customizer {\r\n      display: none;\r\n    }\r\n\r\n    & .user-profile .user-detail {\r\n      display: none !important;\r\n    }\r\n\r\n    & .nav-menu .menu.open > .sub-menu {\r\n      display: none !important;\r\n    }\r\n\r\n    & .nav-menu li {\r\n      text-align: center;\r\n      i {\r\n        margin-right: 0;\r\n      }\r\n\r\n      &.nav-header {\r\n        padding: 4px 5px;\r\n      }\r\n    }\r\n\r\n    & ul.nav-menu {\r\n      & li a {\r\n        padding: 16px 20px;\r\n      }\r\n      & ul.sub-menu li a {\r\n        padding-left: 30px;\r\n      }\r\n    }\r\n\r\n    & ul.nav-menu > li > a {\r\n      &:before {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    & .mini-logo-img-hover {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.app-container.mini-drawer {\r\n  & .side-nav:hover {\r\n    width: $side-nav-width;\r\n\r\n    & .nav-menu li span.nav-text {\r\n      display: inline-block !important;\r\n    }\r\n\r\n    & .user-profile .user-detail {\r\n      display: flex !important;\r\n    }\r\n\r\n    & .nav-menu .menu.open > .sub-menu {\r\n      display: block !important;\r\n    }\r\n\r\n    & .customizer {\r\n      display: flex !important;\r\n    }\r\n\r\n    & ul.nav-menu {\r\n      & li {\r\n        text-align: left;\r\n        & i {\r\n          margin-right: 16px;\r\n        }\r\n\r\n        & a {\r\n          padding: 16px 20px;\r\n        }\r\n\r\n        &.nav-header {\r\n          padding: 4px 22px;\r\n        }\r\n      }\r\n\r\n      & ul.sub-menu li a {\r\n        padding: 7px 20px 7px 56px;\r\n      }\r\n\r\n      & ul.sub-menu > li > ul > li > a {\r\n        padding-left: 76px;\r\n      }\r\n\r\n      & ul.sub-menu > li > ul > li > ul > li > a {\r\n        padding-left: 96px;\r\n      }\r\n\r\n      & ul.sub-menu > li > ul > li > ul > li > ul > li > a {\r\n        padding-left: 116px;\r\n      }\r\n    }\r\n\r\n    & ul.nav-menu > li > a {\r\n      &:before {\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    & .mini-logo-img {\r\n      display: none;\r\n    }\r\n\r\n    & .mini-logo-img-hover {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n.customizer {\r\n  padding: 20px 35px;\r\n  & img {\r\n    padding: 5px;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.user-info {\r\n  & ul {\r\n    & li {\r\n      font-size: 15px;\r\n    }\r\n  }\r\n}\r\n\r\n.rmc-drawer {\r\n  &-left &-sidebar,\r\n  &-right &-sidebar {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.rmc-drawer-sidebar {\r\n  position: fixed;\r\n  transition: -webkit-transform 0.3s ease-out;\r\n  transition: transform 0.3s ease-out;\r\n  overflow: hidden;\r\n\r\n  .rmc-drawer.rmc-drawer-left & {\r\n    left: 0;\r\n    -webkit-transform: translateX(-100%);\r\n    transform: translateX(-100%);\r\n    z-index: 903;\r\n  }\r\n\r\n  .rmc-drawer.rmc-drawer-right & {\r\n    right: 0;\r\n    -webkit-transform: translateX(100%);\r\n    transform: translateX(100%);\r\n    z-index: 903;\r\n  }\r\n\r\n  .rmc-drawer.rmc-drawer-top & {\r\n    z-index: 903;\r\n  }\r\n\r\n  .rmc-drawer.rmc-drawer-bottom & {\r\n    z-index: 903;\r\n  }\r\n}\r\n\r\n.rmc-drawer-draghandle {\r\n  @media (max-width: 1025px) {\r\n    background-color: transparent;\r\n  }\r\n}\r\n\r\n.drawer-container {\r\n  position: relative;\r\n  & .main {\r\n    position: relative;\r\n    padding: 10px;\r\n    box-sizing: border-box;\r\n  }\r\n}\r\n\r\n.rmc-drawer-overlay {\r\n  z-index: 902;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: opacity 0.3s ease-out;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  height: 100%;\r\n  min-width: 100% !important;\r\n}\r\n\r\n.app-sidebar {\r\n  &.rmc-drawer.rmc-drawer-docked {\r\n    position: relative;\r\n  }\r\n}","/*Header Styles*/\r\n.jr-menu-icon {\r\n  outline: none !important;\r\n  @include justify-content(flex-start !important);\r\n  @extend %size-30;\r\n  padding: 0 5px !important;\r\n  @extend %jr-menu-icon;\r\n  margin-right: 15px;\r\n  display: flex;\r\n  cursor: pointer;\r\n  align-items: center;\r\n}\r\n\r\n.app-main-header {\r\n  background-color: $white;\r\n  color: $gray-default;\r\n  max-height: 70px;\r\n  position: relative;\r\n\r\n  & .search-bar input {\r\n    @include transition($transition-base);\r\n    background-color: transparent;\r\n    color: $gray-default;\r\n    // font-size: 18px;\r\n    font-weight: 200;\r\n    & + .search-icon {\r\n      top: 0;\r\n      & i {\r\n        color: rgba($gray-default, 0.8);\r\n        font-size: 32px;\r\n      }\r\n    }\r\n    &::placeholder {\r\n      color: grey;\r\n\r\n    }\r\n\r\n    &:focus {\r\n      background-color: $body-bg;\r\n      color: $gray-default;\r\n      + .search-icon {\r\n        & i {\r\n          color: rgba($gray-default, 0.8);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .app-header & {\r\n    //box-shadow: rgb(222, 226, 230) 1px 1px 10px;\r\n    // border-bottom: 1px solid $border-color;\r\n  }\r\n\r\n  .jr-card & {\r\n    border: 1px solid $gray-400;\r\n    @include border-radius($border-radius-lg);\r\n  }\r\n}\r\n\r\n.app-logo {\r\n  margin-right: 12px;\r\n\r\n  & img {\r\n    height: 35px;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      height: 28px;\r\n    }\r\n  }\r\n\r\n  .app-header & {\r\n    margin-right: 20px;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      margin-right: auto;\r\n    }\r\n  }\r\n}\r\n\r\n//Logo disable condition\r\n.react-logo-white.d-block {\r\n  display: none !important;\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n  .react-logo-white.d-lg-block {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.sidebar-header {\r\n  min-height: 70px;\r\n  padding: 10px 22px;\r\n  // border-bottom: 1px solid $border-color;\r\n}\r\n\r\n.app-toolbar {\r\n  min-height: $app-bar-height;\r\n  padding: 0 17px 0 0;\r\n\r\n  & .search-bar {\r\n    margin-right: auto;\r\n    max-width: 320px;\r\n    width: 300px;\r\n\r\n    @media screen and (max-width: 1199px) {\r\n      width: 240px;\r\n    }\r\n\r\n    @media screen and (max-width: 1099px) {\r\n      width: 200px;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      margin-left: 40px;\r\n      width: 180px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 0 17px;\r\n  }\r\n\r\n  @media screen and (max-width: 1199px) {\r\n    padding: 0 17px;\r\n  }\r\n\r\n  .app-top-nav & {\r\n    min-height: 40px;\r\n  }\r\n}\r\n\r\n.app-header-horizontal {\r\n  & .app-toolbar .search-bar {\r\n    @media screen and (max-width: 1199px) {\r\n      margin-right: 10px;\r\n    }\r\n  }\r\n}\r\n\r\n.app-toolbar-special {\r\n  & .search-bar {\r\n    width: 200px;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      width: 280px;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      width: 200px;\r\n    }\r\n  }\r\n}\r\n\r\n.app-toolbar {\r\n  & .nav-searchbox {\r\n    & .search-bar {\r\n      margin-left: 0;\r\n      width: 100%;\r\n    }\r\n\r\n    & .search-bar input {\r\n      @include transition($transition-base);\r\n      background-color: $white;\r\n      color: $body-color;\r\n      & + .search-icon {\r\n        & i {\r\n          color: rgba($body-color, 0.8);\r\n        }\r\n      }\r\n\r\n      &:focus {\r\n        background-color: transparent;\r\n        color: $body-color;\r\n        + .search-icon {\r\n          & i {\r\n            color: rgba($body-color, 0.8);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.header-notifications {\r\n  margin-bottom: 0;\r\n\r\n  & li {\r\n    vertical-align: middle;\r\n  }\r\n\r\n  & .list-inline-item:not(:last-child) {\r\n    @media screen and (max-width: 449px) {\r\n      margin-right: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu {\r\n  @include box-shadow(none);\r\n}\r\n\r\n.quick-menu {\r\n\r\n  & .dropdown-menu {\r\n    padding: 5px 10px;\r\n    width: 350px;\r\n\r\n    & .jr-card-header {\r\n      margin: -5px -10px 5px;\r\n      padding: 10px 10px 10px 20px;\r\n      border-bottom: 1px solid $gray-300;\r\n      z-index: 10;\r\n    }\r\n\r\n    &:after {\r\n      border-left: 5px solid transparent;\r\n      border-right: 5px solid transparent;\r\n      border-bottom: 5px solid $white;\r\n      top: -9px;\r\n      content: \"\";\r\n      height: 9px;\r\n      position: absolute;\r\n      right: 8px;\r\n      width: 10px;\r\n    }\r\n\r\n    &:before {\r\n      border-left: 5px solid transparent;\r\n      border-right: 5px solid transparent;\r\n      border-bottom: 5px solid $black;\r\n      top: -10px;\r\n      content: \"\";\r\n      height: 10px;\r\n      position: absolute;\r\n      right: 8px;\r\n      width: 10px;\r\n    }\r\n\r\n    @media screen and (max-width: 449px) {\r\n      width: 230px;\r\n    }\r\n\r\n    @media screen and (max-width: 359px) {\r\n      width: 180px;\r\n    }\r\n  }\r\n\r\n  & .messages-list .user-avatar {\r\n    position: relative;\r\n  }\r\n\r\n  & .messages-list .badge {\r\n    position: absolute;\r\n    left: -4px;\r\n    top: -4px;\r\n    height: 16px;\r\n    width: 16px;\r\n    line-height: 16px;\r\n    text-align: center;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.app-header .nav-searchbox.quick-menu {\r\n  & .dropdown-menu {\r\n    width: 200px;\r\n    left: 0 !important;\r\n    right: auto !important;\r\n  }\r\n\r\n  & .dropdown-menu:after {\r\n    right: auto;\r\n    left: 8px;\r\n  }\r\n\r\n  & .dropdown-menu:before {\r\n    right: auto;\r\n    left: 8px;\r\n  }\r\n\r\n  @media screen and (max-width: 400px) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .app-header .nav-searchbox.quick-menu .dropdown-menu {\r\n    width: 200px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .app-header .nav-searchbox.quick-menu .dropdown-menu {\r\n    width: 100px;\r\n  }\r\n}\r\n\r\n.language-list li {\r\n  display: block !important;\r\n}\r\n\r\n.messages-list.language-list ul li {\r\n  padding: 7px 6px 6px;\r\n}\r\n\r\n.messages-list ul li {\r\n  position: relative;\r\n  padding: 20px 10px 14px;\r\n  border-bottom: 1px solid $gray-300;\r\n\r\n  & .user-name a {\r\n    color: $app-primary;\r\n  }\r\n\r\n  & .sub-heading {\r\n    font-size: 11px;\r\n    margin-bottom: 6px !important;\r\n\r\n    &.mb-0 {\r\n      margin-bottom: 0 !important;\r\n    }\r\n  }\r\n\r\n  &:last-child {\r\n    border-bottom: 0 none;\r\n  }\r\n\r\n  & .jr-btn {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  & .jr-btn-xs {\r\n    font-size: 11px !important;\r\n    padding: 5px !important;\r\n  }\r\n}\r\n\r\n.quick-menu {\r\n  & .icon-btn {\r\n    color: $gray-default;\r\n  }\r\n\r\n  & .icon-alert {\r\n    position: relative;\r\n\r\n    &:after {\r\n      display: block;\r\n      position: absolute;\r\n      content: \"\";\r\n      right: 0;\r\n      top: 0;\r\n      z-index: 10;\r\n      width: 8px;\r\n      height: 8px;\r\n      background-color: $danger;\r\n      @include border-radius(50%);\r\n      @extend %pulse-effect;\r\n    }\r\n  }\r\n\r\n  & i.animated.infinite {\r\n    -moz-animation-iteration-count: 25;\r\n    -webkit-animation-iteration-count: 25;\r\n    -o-animation-iteration-count: 25;\r\n    animation-iteration-count: 25;\r\n  }\r\n}\r\n\r\n.quick-menu {\r\n  & .dropdown-menu {\r\n    display: block;\r\n    visibility: hidden;\r\n    left: auto !important;\r\n    right: 0 !important;\r\n    opacity: 0;\r\n    transform: translate3d(0px, 100px, 0px) !important;\r\n    @include transition(all 200ms linear 0ms);\r\n  }\r\n\r\n  &.show .dropdown-menu {\r\n    opacity: 1;\r\n    transform: translate3d(0px, 30px, 0px) !important;\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n.user-nav .quick-menu {\r\n  & .dropdown-menu {\r\n    width: 200px;\r\n    padding: 0 0 15px;\r\n\r\n    &:after {\r\n      border-bottom-color: $body-bg;\r\n    }\r\n  }\r\n\r\n  & .user-profile {\r\n    position: relative;\r\n    padding: 20px 25px;\r\n    background-color: $body-bg;\r\n    margin-bottom: 15px;\r\n    @include border-radius(0.25rem 0.25rem 0 0);\r\n  }\r\n}\r\n\r\n.module-box-header-right {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n}\r\n\r\n.app-top-header {\r\n  position: relative;\r\n  z-index: 9999;\r\n}\r\n","/*Navbar Styles*/\r\n.app-main-menu {\r\n  & .navbar-nav {\r\n    @include display-flex();\r\n  }\r\n}\r\n\r\n.navbar-nav {\r\n  position: relative;\r\n\r\n  & li {\r\n    position: relative;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      & > ul.sub-menu {\r\n        opacity: 1;\r\n        visibility: visible;\r\n        top: 100%;\r\n      }\r\n\r\n      & > a {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n\r\n    & a {\r\n      display: block;\r\n      color: $sidebar-text-color;\r\n      padding: 10px 0;\r\n      font-size: 14px;\r\n    }\r\n\r\n    & a:hover,\r\n    & a:focus {\r\n      text-decoration: none;\r\n      color: $app-primary;\r\n    }\r\n\r\n    &.mega-menu {\r\n      position: static;\r\n    }\r\n\r\n    &.mega-menu ul.sub-menu {\r\n      @include display-flex();\r\n      width: 85%;\r\n      margin: 0 auto;\r\n      left: 0;\r\n      right: 0;\r\n\r\n      & li {\r\n        width: 25%;\r\n        padding: 0 15px;\r\n      }\r\n    }\r\n  }\r\n\r\n  & > li {\r\n    &:last-child {\r\n      ul.sub-menu {\r\n        left: auto;\r\n        right: 0;\r\n      }\r\n\r\n      ul.sub-menu ul.sub-menu {\r\n        left: auto;\r\n        right: 100%;\r\n        top: 50px;\r\n      }\r\n\r\n      ul.sub-menu li:hover > ul.sub-menu,\r\n      ul.sub-menu li:focus > ul.sub-menu {\r\n        top: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  & li.nav-item {\r\n    padding: 0 10px;\r\n\r\n    & > a {\r\n      padding: 23px 0;\r\n    }\r\n\r\n    &.active > a {\r\n      color: $app-primary;\r\n    }\r\n  }\r\n\r\n  & li.nav-item:hover > a,\r\n  & li.nav-item:focus > a,\r\n  & li.nav-item > a:hover,\r\n  & li.nav-item > a:focus {\r\n    color: $app-primary;\r\n  }\r\n\r\n  ul.sub-menu {\r\n    list-style: none;\r\n    border: solid 1px $gray-400;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 100px;\r\n    opacity: 0;\r\n    padding: 10px 0;\r\n    background-color: $white;\r\n    visibility: hidden;\r\n    @include border-radius(4px);\r\n    @include transition(all 0.5s ease-in-out);\r\n\r\n    & li {\r\n      & a {\r\n        padding: 5px 15px;\r\n        width: 200px;\r\n        font-size: 14px;\r\n\r\n        &.active {\r\n          color: $app-primary;\r\n        }\r\n      }\r\n\r\n      & > ul.sub-menu {\r\n        left: 100%;\r\n        right: auto;\r\n        top: 50px;\r\n      }\r\n\r\n      &:hover > ul.sub-menu,\r\n      &:focus > ul.sub-menu {\r\n        top: 0;\r\n      }\r\n\r\n      & a i {\r\n        margin-right: 10px;\r\n      }\r\n\r\n      &.active > a {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n  }\r\n\r\n  & .nav-arrow {\r\n    & > a {\r\n      position: relative;\r\n\r\n      &:before {\r\n        color: $sidebar-text-color;\r\n        content: \"\\f2fb\";\r\n        display: inline-block;\r\n        float: right;\r\n        font: {\r\n          family: 'Material-Design-Iconic-Font';\r\n          size: 15px;\r\n        }\r\n        margin-left: 10px;\r\n        position: relative;\r\n        @include transition(all 300ms ease-in-out);\r\n        font-weight: normal;\r\n      }\r\n    }\r\n\r\n    & a:hover,\r\n    & a:focus {\r\n      &:before {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &.active {\r\n      & > a:before {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n  }\r\n\r\n  ul.sub-menu-half {\r\n    @include display-flex();\r\n    width: 300px;\r\n\r\n    & li {\r\n      width: 50%;\r\n\r\n      & a {\r\n        width: 100%;\r\n\r\n        @media screen and (max-width: 1099px) {\r\n          font-size: 13px;\r\n        }\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 1099px) {\r\n      width: 262px;\r\n    }\r\n  }\r\n}\r\n\r\n.navbar-nav-mega {\r\n  position: static !important;\r\n}\r\n\r\n.app-top-nav {\r\n  background-color: $top-nav-bg;\r\n\r\n  & .navbar-nav {\r\n    & li.nav-item {\r\n      padding: 0 30px;\r\n    }\r\n\r\n    & li.nav-item > a {\r\n      color: $white;\r\n      padding: 13px 0;\r\n    }\r\n\r\n    & li.nav-item:hover > a,\r\n    & li.nav-item:focus > a,\r\n    & li.nav-item > a:hover,\r\n    & li.nav-item > a:focus,\r\n    & li.nav-item.active > a {\r\n      color: $secondary;\r\n    }\r\n\r\n    & ul.sub-menu {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}","/*Main Content Styles*/\r\n.app-main-content {\r\n  flex: 1;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.app-wrapper {\r\n  padding: 36px 40px 0 40px;\r\n  width: 100%;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 20px;\r\n  }\r\n}","/*Footer Styles*/\r\n\r\n.app-footer {\r\n  padding: 0 40px;\r\n  border-top: solid 1px darken($body-bg, 10%);\r\n  background-color: $body-bg;\r\n  color: $sidebar-text-color;\r\n  line-height: $footer-height;\r\n  min-height: $footer-height;\r\n\r\n  & a {\r\n    color: $sidebar-text-color;\r\n    &:hover {\r\n      color: $sidebar-hover-color;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 20px;\r\n  }\r\n\r\n  @media screen and (max-width: 400px) {\r\n    font-size: 12px;\r\n  }\r\n}","/*Right Sidebar Styles*/\r\n.color-theme {\r\n  @include display-flex(flex, column, nowrap);\r\n  max-width: 300px;\r\n  height: 100%;\r\n\r\n  @media screen and (max-width: 499px) {\r\n    max-width: 250px;\r\n  }\r\n}\r\n\r\n.color-theme-header {\r\n  background-color: $app-primary;\r\n  color: $white;\r\n  padding: 19px 25px 20px;\r\n  text-transform: uppercase;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-between);\r\n\r\n  & .color-theme-title {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.color-theme-body {\r\n  padding: 28px 25px;\r\n\r\n  & h3 {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  @media screen and (max-width: 499px) {\r\n    padding: 25px 15px;\r\n  }\r\n}\r\n\r\n.color-option {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  margin: 0 -7px 10px;\r\n\r\n  & li {\r\n    position: relative;\r\n    display: inline-block;\r\n    padding: 0 7px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  & li a {\r\n    height: 45px;\r\n    width: 45px;\r\n    line-height: 45px;\r\n    display: inline-block;\r\n    color: transparent !important;\r\n    position: relative;\r\n\r\n    &:before {\r\n      content: \"\\f26b\";\r\n      font-family: \"Material-Design-Iconic-Font\";\r\n      font-size: 20px;\r\n      height: 45px;\r\n      width: 45px;\r\n      line-height: 45px;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      color: $white;\r\n      text-align: center;\r\n      display: none;\r\n      z-index: 2;\r\n    }\r\n  }\r\n\r\n  & li a.active {\r\n    &:before {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n.cr-op-dark-sidebar {\r\n  & li a {\r\n    &:after {\r\n      content: '';\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      bottom: 0;\r\n      z-index: 1;\r\n      background-color: $body-color;\r\n      width: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n//Coustomizer css\r\n.theme-option {\r\n  position: fixed;\r\n  top: 10%;\r\n  right: 0;\r\n  z-index: 1500;\r\n  background-color: #0070cd;\r\n  @include border-left-radius($border-radius);\r\n  @include box-shadow(1px 1px 4px rgba($black, 0.5));\r\n  color: $white;\r\n\r\n  & span.icon-btn {\r\n    position: relative;\r\n    z-index: 1505;\r\n  }\r\n}\r\n\r\n.app-sidebar-content.right-sidebar .rmc-drawer-sidebar {\r\n  z-index: 1506;\r\n  color: $body-color;\r\n  background-color: $white;\r\n}\r\n\r\n//Switch button\r\n.material-switch {\r\n  margin-bottom: 24px;\r\n\r\n  & > input[type=\"checkbox\"] {\r\n    display: none;\r\n  }\r\n\r\n  & > label {\r\n    cursor: pointer;\r\n    height: 0;\r\n    position: relative;\r\n    width: 40px;\r\n\r\n    &:before {\r\n      background: rgb(0, 0, 0);\r\n      box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);\r\n      border-radius: 8px;\r\n      content: '';\r\n      height: 16px;\r\n      margin-top: -8px;\r\n      position: absolute;\r\n      opacity: 0.3;\r\n      transition: all 0.4s ease-in-out;\r\n      width: 40px;\r\n    }\r\n\r\n    &:after {\r\n      background: rgb(255, 255, 255);\r\n      border-radius: 16px;\r\n      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\r\n      content: '';\r\n      height: 24px;\r\n      left: -4px;\r\n      margin-top: -8px;\r\n      position: absolute;\r\n      top: -4px;\r\n      transition: all 0.3s ease-in-out;\r\n      width: 24px;\r\n    }\r\n  }\r\n\r\n  & > input[type=\"checkbox\"]:checked + label::before {\r\n    background: $black;\r\n    opacity: 0.5;\r\n  }\r\n\r\n  & > input[type=\"checkbox\"]:checked + label::after {\r\n    background: $gray-700;\r\n    left: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 499px) {\r\n  .color-theme .jr-btn {\r\n    padding: 10px 15px !important;\r\n  }\r\n}\r\n","/* UI Components\r\n   ========================================================================== */\r\n@import \"alert\";\r\n@import \"avatar\";\r\n@import \"badges\";\r\n@import \"blockquotes\";\r\n@import \"bottom-navigation\";\r\n@import \"breadcrumb\";\r\n@import \"button\";\r\n@import \"button-group\";\r\n@import \"callout\";\r\n@import \"card\";\r\n@import \"charts\";\r\n@import \"chip\";\r\n@import \"carousel\";\r\n@import \"color-picker\";\r\n@import \"date-input\";\r\n@import \"drawer\";\r\n@import \"e-commerce\";\r\n@import \"grid-list\";\r\n@import \"icons\";\r\n@import \"label\";\r\n@import \"list\";\r\n@import \"nav\";\r\n@import \"pricing-tables\";\r\n@import \"progressbar\";\r\n@import \"popover\";\r\n@import \"tables\";\r\n@import \"tabs\";\r\n@import \"testimonial\";\r\n@import \"timeline\";\r\n@import \"form\";\r\n@import \"ad-form\";\r\n@import \"input\";","/*Alert Styles*/\r\n.alert {\r\n  border: 0 none;\r\n  padding: 20px 24px;\r\n  @include border-radius($border-radius-lg);\r\n  position: relative;\r\n\r\n  & .close {\r\n    line-height: inherit;\r\n    font-weight: $font-weight-light;\r\n  }\r\n\r\n  & .alert-addon {\r\n    width: $size-60;\r\n    background-color: rgba($black, 0.2);\r\n    @include display-flex(flex, column, nowrap);\r\n    @include justify-content(center);\r\n    @include align-items(center);\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.alert-dismissible {\r\n  padding-right: $size-60;\r\n}\r\n\r\n.alert-addon-card {\r\n  padding-left: $size-80;\r\n}","/*Avatar Styles*/\r\n.user-avatar {\r\n  @extend %size-50;\r\n  display: -webkit-inline-flex;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-flex-wrap: nowrap;\r\n  -ms-flex-wrap: nowrap;\r\n  flex-wrap: nowrap;\r\n  position: relative;\r\n  overflow: hidden;\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n  -webkit-flex-shrink: 0;\r\n  flex-shrink: 0;\r\n  @include border-radius(50%);\r\n  -moz-user-select: none;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n  border: $jr-border;\r\n\r\n  &.avatar-shadow {\r\n    border: 0 none;\r\n  }\r\n}\r\n\r\n.user-profile {\r\n  @include display-flex();\r\n  @include align-items(flex-start);\r\n\r\n  & .user-detail {\r\n    -webkit-flex: 1;\r\n    flex: 1;\r\n    -ms-flex-align: center;\r\n    -webkit-align-self: center;\r\n    align-self: center;\r\n  }\r\n}\r\n\r\n.user-detail {\r\n  & .user-name {\r\n    margin-bottom: 2px;\r\n    font-weight: 400;\r\n    text-transform: capitalize;\r\n  }\r\n  & .user-description {\r\n    font-size: 12px;\r\n    margin-bottom: 0;\r\n    color: $gray-500;\r\n  }\r\n}\r\n\r\n.user-thumb {\r\n  position: relative;\r\n\r\n  .messages-list & {\r\n    margin-right: 8px;\r\n  }\r\n}\r\n","/*Badges Styles*/\r\n.badge {\r\n  font-weight: 400;\r\n  padding: 3px 8px;\r\n  line-height: inherit;\r\n  margin-bottom: 6px;\r\n  @include border-radius($border-radius-sm);\r\n\r\n  &:not(:last-child) {\r\n    margin-right: 15px;\r\n  }\r\n\r\n  table & {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.badge-pill {\r\n  @include border-radius(20px);\r\n}\r\n\r\n.badge-border {\r\n  border: 2px solid !important;\r\n}\r\n\r\n.badge-outline {\r\n  background-color: transparent;\r\n  border: $jr-border;\r\n}","/*Blockquotes Styles*/\r\nblockquote {\r\n  padding: 10px 0 10px 20px;\r\n  font-size: $font-size-base !important;\r\n\r\n  .blockquote-footer {\r\n    font-size: $font-size-base !important;\r\n  }\r\n}\r\n\r\n.blockquote {\r\n  border-left: 5px solid $gray-200;\r\n}\r\n\r\n.blockquote-reverse {\r\n  border-left: 0 none;\r\n  border-right: 5px solid $gray-200;\r\n  text-align: right;\r\n  padding-left: 0;\r\n  padding-right: 20px;\r\n}","/*Bottom Navigation Styles*/\r\n.bottom-navigation {\r\n  button {\r\n    min-width: 10px !important;\r\n  }\r\n}","/*Breadcrumb Styles*/\r\n.breadcrumb {\r\n  @include border-radius($border-radius-sm);\r\n}\r\n\r\n.breadcrumb-item + .breadcrumb-item::before {\r\n  content: '\\F2FB';\r\n  font: {\r\n    family: 'Material-Design-Iconic-Font';\r\n    size: 16px;\r\n  }\r\n  line-height: 1;\r\n  vertical-align: middle;\r\n}","/*Button Styles*/\r\nbutton {\r\n  outline: 0 none !important;\r\n  cursor: pointer;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.jr-btn {\r\n  position: relative;\r\n  display: inline-block;\r\n  font-size: $btn-font-size;\r\n  font-weight: $btn-font-weight;\r\n  // text-transform: capitalize;\r\n  line-height: $btn-line-height;\r\n  @include border-radius($border-radius);\r\n  vertical-align: top;\r\n  cursor: pointer;\r\n  text-align: center;\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    outline: 0 none;\r\n    text-decoration: none;\r\n    @include box-shadow(none !important);\r\n  }\r\n\r\n  .login-content & {\r\n    padding: 10px 35px;\r\n  }\r\n}\r\n\r\n.btn {\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    outline: 0 none;\r\n    text-decoration: none;\r\n    @include box-shadow(none !important);\r\n  }\r\n\r\n  .login-content & {\r\n    padding: 10px 35px;\r\n  }\r\n}\r\n\r\n.btn,\r\n.btn-info,\r\n.btn-success,\r\n.btn-warning,\r\n.btn-danger,\r\n.btn-light,\r\n.btn-dark,\r\n.btn-primary,\r\n.btn-secondary {\r\n  @extend %btn-no-shadow;\r\n  @include box-shadow(none !important);\r\n}\r\n\r\n.show > {\r\n  .btn,\r\n  .btn-info,\r\n  .btn-success,\r\n  .btn-warning,\r\n  .btn-danger,\r\n  .btn-light,\r\n  .btn-dark,\r\n  .btn-primary,\r\n  .btn-secondary {\r\n    &.dropdown-toggle:focus {\r\n      @include box-shadow(none !important);\r\n    }\r\n  }\r\n}\r\n\r\n.jr-btn,\r\n.jr-fab-btn,\r\n.jr-flat-btn,\r\n.btn {\r\n  margin-bottom: 6px;\r\n  // text-transform: capitalize;\r\n\r\n  &:not(:last-child) {\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .form-inline & {\r\n    margin-bottom: 0;\r\n    min-height: 35px;\r\n  }\r\n\r\n  .navbar & {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.btn-primary:focus, .btn-primary.focus {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.input-group > .input-group-prepend > .btn,\r\n.input-group > .input-group-append > .btn {\r\n  margin-right: 0;\r\n  margin-bottom: 0;\r\n  line-height: inherit;\r\n}\r\n\r\n.jr-fab-btn {\r\n  position: relative;\r\n  display: inline-flex;\r\n  @extend %size-50;\r\n  @include border-radius($border-radius-circle);\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n  background-color: map_get($gray, lighten-3);\r\n  overflow: hidden;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    outline: 0 none;\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n.jr-btn,\r\n.jr-flat-btn {\r\n  padding: $btn-padding;\r\n\r\n  & i + span,\r\n  & span + i {\r\n    margin-left: 6px;\r\n  }\r\n}\r\n\r\n.jr-flat-btn {\r\n  background-color: transparent;\r\n  color: $body-color;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    background-color: map_get($gray, lighten-4);\r\n    color: $body-color;\r\n  }\r\n}\r\n\r\n.jr-btn-group {\r\n  margin: 0 -8px;\r\n\r\n  &:not(:last-child) {\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  & .jr-btn,\r\n  & .jr-fab-btn {\r\n    margin: 0 8px 18px;\r\n  }\r\n}\r\n\r\n.jr-btn-rounded {\r\n  @include border-radius(50px !important);\r\n}\r\n\r\n.jr-btn-lg {\r\n  padding: $btn-padding-lg;\r\n}\r\n\r\n.jr-btn-sm {\r\n  padding: $btn-padding-sm;\r\n}\r\n\r\n.jr-btn-xs {\r\n  padding: $btn-padding-xs;\r\n}\r\n\r\n// Fab Button\r\n.jr-btn-fab-lg {\r\n  @extend %size-60;\r\n}\r\n\r\n.jr-btn-fab-sm {\r\n  @extend %size-40;\r\n}\r\n\r\n.jr-btn-fab-xs {\r\n  @extend %size-30;\r\n}\r\n\r\n.jr-btn-fab-lg,\r\n.jr-btn-lg {\r\n  font-size: $btn-font-size-lg;\r\n  & i {\r\n    font-size: calc(#{$btn-font-size-lg} + 2px);\r\n  }\r\n}\r\n\r\n.jr-btn-fab-sm,\r\n.jr-btn-sm {\r\n  font-size: calc(#{$btn-font-size-sm} - 2px);\r\n  & i {\r\n    font-size: calc(#{$btn-font-size-sm} - 2px);\r\n  }\r\n}\r\n\r\n.jr-btn-fab-xs,\r\n.jr-btn-xs {\r\n  font-size: $btn-font-size-xs;\r\n  & i {\r\n    font-size: $btn-font-size-xs;\r\n  }\r\n}\r\n\r\n.complex-btn-wrapper {\r\n  @include display-flex(flex, row, wrap);\r\n  min-width: 200px;\r\n  width: 100%;\r\n}\r\n\r\n.complex-btn {\r\n  position: relative;\r\n  height: 200px;\r\n  overflow: hidden;\r\n  width: 33.333%;\r\n  border: 0 none;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    width: 100%;\r\n    height: 100px;\r\n  }\r\n  &:hover {\r\n    z-index: 1;\r\n    & .img-btn-overlay {\r\n      opacity: 0.15;\r\n    }\r\n\r\n    & .img-marked {\r\n      opacity: 0;\r\n    }\r\n\r\n    & .img-title {\r\n      border: 4px solid currentColor;\r\n    }\r\n  }\r\n\r\n  .img-btn {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    display: flex;\r\n    @include align-items(center);\r\n    @include justify-content(center);\r\n    color: $white;\r\n  }\r\n  .img-src {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background-size: cover;\r\n    background-position: center 40%;\r\n  }\r\n\r\n  .img-btn-overlay {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background: $black;\r\n    opacity: 0.4;\r\n    @include transition(all 0.5s $transition-ease);\r\n  }\r\n\r\n  .img-title {\r\n    position: relative;\r\n    padding: 16px 32px 14px;\r\n  }\r\n  .img-marked {\r\n    height: 3px;\r\n    width: 18px;\r\n    background: $white;\r\n    position: absolute;\r\n    bottom: -2px;\r\n    left: calc(50% - 9px);\r\n    @include transition(all 0.5s $transition-ease);\r\n  }\r\n}\r\n\r\n.btn-group-mins {\r\n  margin: 0 -5px;\r\n\r\n  & .btn,\r\n  & .jr-btn {\r\n    margin: 0 5px 5px;\r\n  }\r\n}\r\n\r\n//buttons in label\r\n\r\n.jr-btn.jr-btn-label i {\r\n  background-color: rgba($white, 0.2);\r\n  width: $size-40;\r\n  height: 100%;\r\n  line-height: 42px;\r\n  text-align: center;\r\n}\r\n\r\n.jr-btn.jr-btn-label.left i {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.jr-btn.jr-btn-label.right i {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.jr-btn.jr-btn-label.left i + span {\r\n  margin-left: $size-30;\r\n}\r\n\r\n.jr-btn.jr-btn-label.right i + span {\r\n  margin-right: $size-30;\r\n  margin-left: 0;\r\n}\r\n\r\n.jr-btn.jr-btn-label.jr-btn-lg i {\r\n  line-height: 54px;\r\n}\r\n\r\n.jr-btn.jr-btn-label.jr-btn-sm i {\r\n  line-height: 32px;\r\n}\r\n\r\n.jr-btn.jr-btn-label.jr-btn-xs i {\r\n  line-height: 24px;\r\n  width: $size-30;\r\n}\r\n\r\n//Button function\r\n@each $color_name, $color in $colors_palette {\r\n  @each $color_type, $color_value in $color {\r\n    @if $color_type == \"base\" {\r\n      .btn-#{$color_name} {\r\n        background-color: $color_value;\r\n        color: $white;\r\n        &:hover,\r\n        &:focus {\r\n          background-color: darken($color_value, 5%);\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.jr-btn-shadow {\r\n  @include box-shadow(0 1px 5px 0 rgba($black, 0.2), 0 2px 2px 0 rgba($black, 0.14), 0 3px 1px -2px rgba($black, 0.12) !important);\r\n  &:hover,\r\n  &:focus {\r\n    @include box-shadow(0 1px 5px 0 rgba($black, 0.2), 0 2px 2px 0 rgba($black, 0.14), 0 3px 1px -2px rgba($black, 0.12) !important);\r\n  }\r\n\r\n  &:active {\r\n    @include box-shadow(none !important);\r\n  }\r\n}\r\n\r\n.jr-btn.disabled,\r\n.jr-btn.disabled {\r\n  pointer-events: none;\r\n  opacity: 0.65;\r\n}\r\n\r\n.jr-btn-default {\r\n  background-color: $white;\r\n  color: $body-color;\r\n  border: 1px solid $gray-300;\r\n  &:hover,\r\n  &:focus {\r\n    background-color: darken($white, 5%);\r\n    color: $body-color;\r\n  }\r\n}\r\n\r\n.jr-btn-secondary {\r\n  background-color: $secondary;\r\n  color: $white;\r\n  &:hover,\r\n  &:focus {\r\n    background-color: darken($secondary, 5%);\r\n    color: $white;\r\n  }\r\n}\r\n\r\n.jr-flat-btn.jr-btn-primary {\r\n  background-color: transparent;\r\n  color: $app-primary;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    background-color: rgba($app-primary, 0.12);\r\n    color: $app-primary;\r\n  }\r\n}\r\n\r\n.bg-primary {\r\n  & .jr-flat-btn.jr-btn-primary {\r\n    background-color: transparent;\r\n    color: $white;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      background-color: rgba($white, 0.12);\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.jr-flat-btn.jr-btn-secondary {\r\n  background-color: transparent;\r\n  color: $secondary;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    background-color: rgba($secondary, 0.12);\r\n    color: $secondary;\r\n  }\r\n}\r\n\r\n.bg-secondary {\r\n  & .jr-flat-btn.jr-btn-secondary {\r\n    background-color: transparent;\r\n    color: $white;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      background-color: rgba($white, 0.12);\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.jr-btn-hover:hover:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 1;\r\n  display: inline-block;\r\n  background-color: rgba($black, 0.06);\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  padding-right: 0.5625rem;\r\n  padding-left: 0.5625rem;\r\n}\r\n\r\n.action-btn {\r\n  height: $size-40;\r\n  width: $size-40;\r\n  display: -webkit-inline-flex;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  @include align-items(center);\r\n  @include justify-content(center);\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n  color: rgba($black, 0.54);\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    text-decoration: none;\r\n    color: rgba($black, 0.64);\r\n  }\r\n\r\n  .circle-check & {\r\n    height: 24px;\r\n    width: 24px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .chat-main-header & {\r\n    color: $white;\r\n  }\r\n}\r\n\r\n.action-replay .jr-btn-default {\r\n  font-size: 14px;\r\n  padding: 5px 10px;\r\n  border-color: $gray-600 !important;\r\n}\r\n\r\n.btn-outline-primary,\r\n.btn-outline-secondary {\r\n  &:focus {\r\n    @include box-shadow(none !important);\r\n  }\r\n}","/*Button Group Styles*/\r\n\r\n// stylelint-disable selector-no-qualifying-type\r\n\r\n// Make the div behave like a button\r\n.btn-group,\r\n.btn-group-vertical {\r\n  position: relative;\r\n  display: inline-flex;\r\n  vertical-align: middle; // match .btn alignment given font-size hack above\r\n\r\n  > .jr-btn {\r\n    position: relative;\r\n    flex: 0 1 auto;\r\n    border-color: $border-color;\r\n\r\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\r\n    // the borders properly\r\n    @include hover {\r\n      z-index: 2;\r\n    }\r\n    &:focus,\r\n    &:active,\r\n    &.active {\r\n      z-index: 2;\r\n    }\r\n\r\n    &.active {\r\n      background-color: $app-primary;\r\n      color: $white;\r\n      border-color: $app-primary;\r\n    }\r\n\r\n    &.jr-flat-btn {\r\n      border-color: transparent;\r\n      &.active {\r\n        background-color: transparent;\r\n        color: $app-primary;\r\n\r\n        &:hover,\r\n        &:focus {\r\n          background-color: rgba($app-primary, 0.12);\r\n          color: $app-primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  // Prevent double borders when buttons are next to each other\r\n  .jr-btn + .jr-btn,\r\n  .jr-btn + .btn-group,\r\n  .btn-group + .jr-btn,\r\n  .btn-group + .btn-group {\r\n    margin-left: -$input-btn-border-width;\r\n  }\r\n}\r\n\r\n.btn-group,\r\n.btn-group-vertical {\r\n\r\n  &.no-border > .btn-group > .jr-btn,\r\n  &.no-border > .btn-group-vertical > .jr-btn,\r\n  &.no-border > .jr-btn {\r\n    border-color: transparent;\r\n  }\r\n}\r\n\r\n// Optional: Group multiple button groups together for a toolbar\r\n.btn-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n\r\n  .input-group {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.btn-group > .jr-btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\r\n  border-radius: 0;\r\n}\r\n\r\n// Set corners individual because sometimes a single button can be in a .btn-group\r\n// and we need :first-child and :last-child to both match\r\n.btn-group > .jr-btn:first-child {\r\n  margin-left: 0;\r\n\r\n  &:not(:last-child):not(.dropdown-toggle) {\r\n    @include border-right-radius(0);\r\n  }\r\n}\r\n\r\n// Need .dropdown-toggle since :last-child doesn't apply given a .dropdown-menu\r\n// immediately after it\r\n.btn-group > .jr-btn:last-child:not(:first-child),\r\n.btn-group > .dropdown-toggle:not(:first-child) {\r\n  @include border-left-radius(0);\r\n}\r\n\r\n// Custom edits for including btn-groups within btn-groups (useful for including\r\n// dropdown buttons within a btn-group)\r\n.btn-group > .btn-group {\r\n  float: left;\r\n}\r\n\r\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .jr-btn {\r\n  border-radius: 0;\r\n}\r\n\r\n.btn-group > .btn-group:first-child:not(:last-child) {\r\n  > .jr-btn:last-child,\r\n  > .dropdown-toggle {\r\n    @include border-right-radius(0);\r\n  }\r\n}\r\n\r\n.btn-group > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {\r\n  @include border-left-radius(0);\r\n}\r\n\r\n\r\n// Sizing\r\n//\r\n// Remix the default button sizing classes into new ones for easier manipulation.\r\n\r\n.btn-group-sm > .jr-btn { @extend .jr-btn-sm; }\r\n.btn-group-lg > .jr-btn { @extend .jr-btn-lg; }\r\n\r\n\r\n//\r\n// Split button dropdowns\r\n//\r\n\r\n.jr-btn + .dropdown-toggle-split {\r\n  padding-right: $input-btn-padding-x * .75;\r\n  padding-left: $input-btn-padding-x * .75;\r\n\r\n  &::after {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.jr-btn-sm + .dropdown-toggle-split {\r\n  padding-right: $input-btn-padding-x-sm * .75;\r\n  padding-left: $input-btn-padding-x-sm * .75;\r\n}\r\n\r\n.jr-btn-lg + .dropdown-toggle-split {\r\n  padding-right: $input-btn-padding-x-lg * .75;\r\n  padding-left: $input-btn-padding-x-lg * .75;\r\n}\r\n\r\n// The clickable button for toggling the menu\r\n// Set the same inset shadow as the :active state\r\n.btn-group.show .dropdown-toggle {\r\n  @include box-shadow($btn-active-box-shadow);\r\n\r\n  // Show no shadow for `.btn-link` since it has no other button styles.\r\n  &.btn-link {\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Vertical button groups\r\n//\r\n\r\n.btn-group-vertical {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n\r\n  .jr-btn,\r\n  .btn-group {\r\n    width: 100%;\r\n  }\r\n\r\n  > .jr-btn + .jr-btn,\r\n  > .jr-btn + .btn-group,\r\n  > .btn-group + .jr-btn,\r\n  > .btn-group + .btn-group {\r\n    margin-top: -$input-btn-border-width;\r\n    margin-left: 0;\r\n  }\r\n\r\n  > .jr-btn {\r\n    &:not(:first-child):not(:last-child) {\r\n      border-radius: 0;\r\n    }\r\n\r\n    &:first-child:not(:last-child) {\r\n      @include border-bottom-radius(0);\r\n    }\r\n\r\n    &:last-child:not(:first-child) {\r\n      @include border-top-radius(0);\r\n    }\r\n  }\r\n\r\n  > .btn-group:not(:first-child):not(:last-child) > .jr-btn {\r\n    border-radius: 0;\r\n  }\r\n\r\n  > .btn-group:first-child:not(:last-child) {\r\n    > .jr-btn:last-child,\r\n    > .dropdown-toggle {\r\n      @include border-bottom-radius(0);\r\n    }\r\n  }\r\n\r\n  > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n\r\n\r\n\r\n[data-toggle=\"buttons\"] {\r\n  > .jr-btn,\r\n  > .btn-group > .jr-btn {\r\n    input[type=\"radio\"],\r\n    input[type=\"checkbox\"] {\r\n      position: absolute;\r\n      clip: rect(0,0,0,0);\r\n      //pointer-events: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Make the div behave like a button\r\n.btn-group,\r\n.btn-group-vertical {\r\n\r\n  // Over Write To jr btn Margin\r\n  > .jr-btn,\r\n  > .btn {\r\n    margin-right: 0;\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n","/*Callout Styles*/\r\n\r\n.grid-thumb-equal {\r\n  @extend %thumb-equal;\r\n\r\n  .card-image & {\r\n    padding-bottom: 82%;\r\n  }\r\n}\r\n\r\n.grid-thumb-cover {\r\n  @extend %thumb-cover;\r\n}\r\n\r\n.grid-thumb-cover img {\r\n  @extend %thumb-cover-img;\r\n}\r\n\r\n/*Product listing page style*/\r\n\r\n.product-row {\r\n  position: relative;\r\n  overflow: hidden;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(center);\r\n  text-align: right;\r\n\r\n  &.even {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.product-col {\r\n  order: 1;\r\n  width: 50%;\r\n}\r\n\r\n.odd .product-thumb {\r\n  order: 2;\r\n}\r\n\r\n.product-content {\r\n  padding: 20px 55px;\r\n}\r\n\r\n.product-row .grid-thumb-equal {\r\n  padding-bottom: 69%;\r\n}\r\n\r\n.product-thumb img {\r\n  width: 100%;\r\n}\r\n\r\n.product-content h4 {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n@media screen and (max-width: 1230px) {\r\n  .product-row .grid-thumb-equal {\r\n    padding-bottom: 71%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1199px) {\r\n  .product-content h4 {\r\n    margin-bottom: 10px;\r\n  }\r\n  .product-content {\r\n    padding: 20px 35px;\r\n  }\r\n  .product-row .grid-thumb-equal {\r\n    padding-bottom: 85%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .grid-thumb-equal {\r\n    .card-image & {\r\n      padding-bottom: 120%;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .product-row {\r\n    @include display-flex(flex, column);\r\n    text-align: center;\r\n\r\n    &.even {\r\n      text-align: center;\r\n    }\r\n  }\r\n\r\n  .product-content {\r\n    padding: 20px 0;\r\n  }\r\n\r\n  .product-col,\r\n  .odd .product-thumb {\r\n    order: 1;\r\n    width: 100%;\r\n  }\r\n  .product-row .grid-thumb-equal {\r\n    padding-bottom: 44%;\r\n  }\r\n\r\n  .grid-thumb-equal {\r\n    .card-image & {\r\n      padding-bottom: 44%;\r\n    }\r\n  }\r\n}","/*Cards Styles*/\r\n.profile-intro {\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  overflow: hidden;\r\n\r\n  img.avatar-circle {\r\n    display: inline-block;\r\n    @extend %size-120;\r\n    @include border-radius(50%);\r\n    @include box-shadow($shadow);\r\n    position: relative;\r\n    margin: 0 auto;\r\n    -webkit-transform: translateY(50px);\r\n    -ms-transform: translateY(50px);\r\n    transform: translateY(50px);\r\n    @include transition(all 0.4s ease-in-out);\r\n    z-index: 1;\r\n  }\r\n\r\n  &:hover {\r\n    & .avatar-circle {\r\n      @include transition(border-radius 0.4s ease 0.1s);\r\n      @include border-radius(25%);\r\n    }\r\n  }\r\n}\r\n\r\n.profile-intro {\r\n  & .card-image {\r\n    position: relative;\r\n    width: 100%;\r\n    min-height: 100%;\r\n    @include background('http://via.placeholder.com/1920x1072', center center);\r\n  }\r\n  & .pi-content {\r\n    padding: 70px 40px 24px;\r\n  }\r\n\r\n  & .pi-footer {\r\n    padding: 0 40px 24px;\r\n  }\r\n  & .icon {\r\n    display: inline-block;\r\n    @include transition(all 0.2s ease 0s);\r\n    color: theme-color(\"primary\");\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      -webkit-transform: scale(1.2);\r\n      -ms-transform: scale(1.2);\r\n      transform: scale(1.2);\r\n    }\r\n  }\r\n\r\n  & .icon:not(:last-child) {\r\n    margin-right: 10px;\r\n  }\r\n}\r\n\r\n.layer {\r\n  &:before {\r\n    display: block;\r\n    content: \"\";\r\n    background-color: rgba($black, 0.3);\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 0;\r\n  }\r\n}\r\n\r\n.card.jr-card-full-height,\r\n.jr-card.jr-card-full-height {\r\n  height: calc(100% - #{$jr-card-margin});\r\n\r\n  @media screen and (max-width: 575px) {\r\n    height: auto;\r\n  }\r\n}\r\n\r\n.jr-card {\r\n  @extend %jr-card-style;\r\n\r\n  & > .jr-card-body:first-child {\r\n    margin-top: 6px;\r\n  }\r\n\r\n  &.p-0 > .jr-card-body:first-child {\r\n    margin-top: 0;\r\n  }\r\n\r\n  & .jr-card-thumb {\r\n    margin: -24px -30px 0;\r\n\r\n    & .card-img {\r\n      @include border-radius($border-radius-lg $border-radius-lg 0 0);\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.jr-card-header {\r\n  margin-bottom: 24px;\r\n\r\n  .card-heading {\r\n    margin-bottom: (24px / 6);\r\n  }\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n\r\n    &:last-child {\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.jr-entry-header {\r\n  margin-bottom: 24px;\r\n\r\n  .entry-heading {\r\n    margin-bottom: (24px / 6);\r\n  }\r\n\r\n  .entry-description {\r\n    margin-bottom: 0;\r\n    font-size: 13px;\r\n    color: $gray-600;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.card {\r\n  margin-bottom: $jr-card-margin;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.card-header {\r\n  font-size: 16px;\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n\r\n    &:last-child {\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n}\r\n\r\n.card-title {\r\n  font-size: $h3-font-size;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.card-subtitle {\r\n  font-size: 14px;\r\n  color: $gray-700;\r\n\r\n  &:not(:last-child) {\r\n    margin-bottom: $h3-font-size;\r\n  }\r\n}\r\n\r\n.card-mt-footer {\r\n  padding: 0 15px 20px;\r\n  margin-top: -10px;\r\n}\r\n\r\n.jr-card-social {\r\n  font-size: 22px;\r\n  padding-top: 26px;\r\n}\r\n\r\n.social-link {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin: 0 -5px 10px;\r\n\r\n  & li {\r\n    padding: 0 5px;\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  & li a {\r\n    color: $body-color;\r\n  }\r\n\r\n  & li.active a,\r\n  & li a:hover,\r\n  & li a:focus {\r\n    color: $secondary;\r\n  }\r\n\r\n  .jr-card-social & {\r\n    margin-bottom: 0;\r\n    @include justify-content(space-around);\r\n  }\r\n}\r\n\r\n.jr-cart-ab {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-around);\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n  color: $white;\r\n  font-size: $h3-font-size;\r\n\r\n  & i {\r\n    vertical-align: middle;\r\n    font-size: 25px;\r\n  }\r\n}\r\n\r\n.img-overlay-card {\r\n  @include border-radius($border-radius-lg);\r\n  margin-bottom: $jr-card-margin;\r\n\r\n  @media screen and (max-width: 1199px) {\r\n    & .center-crop-img {\r\n      min-height: 135px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 767px) {\r\n    & .center-crop-img {\r\n      min-height: 160px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}","/*Charts Styles*/\r\n\r\n.chart-header {\r\n  padding: 15px 18px;\r\n  & .card-title {\r\n    h4 {\r\n      color: $white;\r\n      margin-bottom: 4px;\r\n    }\r\n  }\r\n\r\n  & .title h4 {\r\n    margin-bottom: 4px;\r\n  }\r\n  & p {\r\n    margin-bottom: 4px;\r\n  }\r\n}","/*Chips Styles*/\r\n.chip-outline {\r\n  background-color: transparent !important;\r\n  border: 1px solid $gray-500 !important;\r\n}\r\n","/*Carousel Styles*/\r\n\r\n.carousel-caption {\r\n  & h3 {\r\n    font-size: $h2-font-size;\r\n  }\r\n}\r\n\r\n.carousel-control-prev {\r\n  @extend %pointer;\r\n}\r\n\r\n.carousel-control-next {\r\n  @extend %pointer;\r\n}\r\n","/*Color Picker Styles*/\r\n\r\n.cp-color {\r\n  width: 36px;\r\n  height: 14px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.cp-swatch {\r\n  padding: 5px;\r\n  background: $white;\r\n  border-radius: 1px;\r\n  @include box-shadow(0 0 0 1px rgba($black, .1));\r\n  display: inline-block;\r\n  cursor: pointer;\r\n}\r\n\r\n.cp-popover {\r\n  position: absolute;\r\n  z-index: 2;\r\n}\r\n\r\n.cp-cover {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n}\r\n\r\n.photoshop-picker,\r\n.swatches-picker,\r\n.alpha-picker,\r\n.hue-picker {\r\n  width: 100% !important;\r\n}\r\n\r\n.material-picker {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n}\r\n\r\n.rc-time-picker-input {\r\n  height: 31px !important;\r\n}\r\n\r\n.date-btn {\r\n  display: inline-block;\r\n  vertical-align: top;\r\n}","// custom styling for the SingleDatePicker from the 'react-dates' package\n\n.dateInputCreateUser .DateInput, \n.dateInputCreateUser .SingleDatePickerInput { \n  background: transparent !important; \n}\n\n// user create form\n.dateInputCreateUser .DateInput_input {\n  font-size: 15px !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  border: none !important;\n  padding: 10px 0 5px 0px !important;\n  font-weight: 400 !important;\n  display: block !important;\n  width: 100% !important;\n  height: calc(2.25rem + 2px) !important;\n  outline: none !important;\n  background-color: transparent !important;\n  transition: .2s all ease-in-out;\n}\n\n.dateInputCreateUserDark .DateInput_input {\n  color: white !important;\n}\n\n.dateInputCreateUserWarn .DateInput_input {\n  color: red !important;\n}\n.dateInputCreateUserWarn .DateInput_input::placeholder {\n  color: red !important;\n}\n\n.dateInputCreateUser .DateInput_input::placeholder {\n  font-size: 15px !important;\n  transition: .2s all ease-in-out;\n  // color: rgb(216, 216, 216) !important;\n}\n\n.dateInputCreateUser .DateInput, \n.dateInputCreateUser .SingleDatePickerInput { \n  background: transparent !important; \n}\n\n// user edit form\n.dateInputEditUser .DateInput_input {\n  font-size: 12px !important;\n  font-family: 'roboto';\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  border: none !important;\n  padding: 5px 0px !important;\n  font-weight: 400 !important;\n  display: block !important;\n  width: 100% !important;\n  height: 28px !important;\n  outline: none !important;\n  background-color: transparent !important;\n  background: transparent !important;\n  transition: .2s all ease-in-out;\n}\n\n.dateInputEditUserDark .DateInput_input {\n  color: white !important;\n  background-color: #1c2938 !important;\n  background: #1c2938 !important;\n}\n\n.dateInputEditUserDark1 .DateInput_input {\n  color: #d5d5d5 !important;\n  background-color: #1C1C1C !important;\n  background: #1C1C1C !important;\n}\n\n.dateInputEditUserDark2 .DateInput_input {\n  color: #ebebed !important;\n  background-color: #333333 !important;\n  background: #333333 !important;\n}\n\n.dateInputEditUserDark3 .DateInput_input {\n  color: #e7e7e7 !important;\n  background-color: #262335 !important;\n  background: #262335 !important;\n}\n\n.dateInputEditUserLight1 .DateInput_input {\n  color: #949494 !important;\n  background-color: #ffffff !important;\n  background: #ffffff !important;\n}\n\n.dateInputEditUserLight2 .DateInput_input {\n  color: #333333 !important;\n  background-color: #fafafa !important;\n  background: #fafafa !important;\n}\n\n.dateInputEditUserContrast .DateInput_input {\n  color: #000000 !important;\n  background-color: transparent !important;\n  background: transparent !important;\n}\n\n.dateInputEditUser .DateInput_input::placeholder {\n  font-size: 12px !important;\n  transition: .2s all ease-in-out;\n  // color: rgb(216, 216, 216) !important;\n}\n","/*Drawer Styles*/\r\n\r\n.drawer {\r\n  width: 250px;\r\n}\r\n\r\n.full-drawer {\r\n  width: 100%;\r\n}","/*E-commerce Styles*/\r\n\r\n.product-item {\r\n  overflow: hidden;\r\n}\r\n\r\n.product-item-vertical {\r\n  @extend .product-item;\r\n\r\n  & .card-image .grid-thumb-equal {\r\n    padding-bottom: 110%;\r\n\r\n    @media screen and (max-width: 1199px) {\r\n      padding-bottom: 74%;\r\n    }\r\n\r\n    @media screen and (max-width: 991px) {\r\n      padding-bottom: 110%;\r\n    }\r\n\r\n    @media screen and (max-width: 829px) {\r\n      padding-bottom: 120%;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      padding-bottom: 44%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n","/*Grids List Styles*/\r\n\r\n.gl-image,\r\n.gl-list,\r\n.gl-advanced,\r\n.gl-single-line {\r\n  @include display-flex();\r\n  @include justify-content(space-around);\r\n  overflow: hidden;\r\n}\r\n\r\n.gl {\r\n  max-width: 100%;\r\n  max-height: 360px;\r\n  // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.\r\n  transform: translateZ(0);\r\n\r\n  &.row.no-gutters {\r\n    margin: 0 -2px;\r\n\r\n    & .col,\r\n    & > [class*=\"col-\"] {\r\n      padding-right: 2px;\r\n      padding-left: 2px;\r\n      margin-bottom: 4px;\r\n    }\r\n  }\r\n}\r\n\r\n.gl-single-line {\r\n  & .slg {\r\n    -ms-flex-wrap: nowrap;\r\n    -webkit-flex-wrap: nowrap;\r\n    flex-wrap: nowrap;\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n.title-gradient {\r\n  background: -webkit-linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: -o-linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n}\r\n\r\n.title-gradient-bottom {\r\n  background: -webkit-linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: -o-linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n}\r\n\r\n.g-title {\r\n  left: 0;\r\n  right: 0;\r\n  height: 48px;\r\n  display: flex;\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  align-items: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n}\r\n\r\n.grid {\r\n  height: 100%;\r\n  display: block;\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  & > img {\r\n    top: 50%;\r\n    left: 50%;\r\n    position: relative;\r\n    transform: translate(-50%, -50%);\r\n    display: flex;\r\n    padding: 0;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\n.g-ul {\r\n  display: flex;\r\n  padding: 0;\r\n  flex-wrap: wrap;\r\n  overflow-y: auto;\r\n  list-style: none;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.gradient-text {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-size: 20px;\r\n  color: white;\r\n}\r\n\r\n.title-gradient-bottom {\r\n  padding: 20px;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 48px;\r\n  display: flex;\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  align-items: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  background: -webkit-linear-gradient(0deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n  background: -o-linear-gradient(to top, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent 100%) !important;\r\n  background: linear-gradient(0deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n}\r\n\r\n.title-gradient-top {\r\n  padding: 10px;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 48px;\r\n  display: flex;\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  align-items: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n\r\n  background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent 100%) !important;\r\n  background: linear-gradient(180deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n}\r\n\r\n.grid-thumb img {\r\n  max-height: 185px;\r\n}\r\n\r\n.gl-advanced-grid {\r\n  position: relative;\r\n}\r\n","/*Icons Styles*/\r\n\r\n.icon {\r\n  display: inline-block;\r\n  @extend %size-30;\r\n  text-align: center;\r\n}\r\n\r\n.icons-wrapper {\r\n  display: inline-block;\r\n  & + .icons-wrapper {\r\n    margin-left: 25px;\r\n  }\r\n}\r\n\r\n.icon-addon {\r\n  @extend %icon-addon;\r\n}","/*Label Styles*/\r\nlabel {\r\n  margin-bottom: 0;\r\n}\r\n","/*List Styles*/\r\n\r\n.pinned-list {\r\n  position: relative;\r\n  height: 370px;\r\n  overflow: auto;\r\n  width: auto;\r\n}\r\n\r\n.user-list {\r\n  width: 100%;\r\n  padding: 20px 15px 10px;\r\n\r\n  &.card {\r\n    padding-left: 30px;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      padding-left: 15px;\r\n    }\r\n  }\r\n\r\n  & .user-avatar {\r\n    margin-right: 20px;\r\n    margin-bottom: 10px;\r\n    @extend %size-50;\r\n  }\r\n\r\n  & h3 {\r\n    font-weight: 700;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  & a[class*=\"meta-\"] i {\r\n    margin-right: 6px;\r\n  }\r\n\r\n  & a[class*=\"meta-\"]:hover {\r\n    text-decoration: none;\r\n  }\r\n\r\n  & a[class*=\"meta-\"] {\r\n    display: inline-block;\r\n    color: $body-color;\r\n    font-size: $font-size-sm;\r\n    font-weight: 700;\r\n  }\r\n}\r\n\r\n.user-list {\r\n  & .img-section {\r\n    width: 230px;\r\n    @media screen and (max-width: 649px) {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  & .description {\r\n    width: calc(100% - 300px);\r\n    @media screen and (max-width: 649px) {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  & .jr-btn-list {\r\n    & li:not(:last-child) {\r\n      margin-right: 10px;\r\n    }\r\n\r\n    & .btn-light {\r\n      background-color: darken(map_get($gray, lighten-2), 5%);\r\n      border-color: darken(map_get($gray, lighten-2), 5%);\r\n      color: $body-color;\r\n      font-weight: 600;\r\n\r\n      &:hover,\r\n      &:focus,\r\n      &:active {\r\n        background-color: darken(map_get($gray, lighten-2), 10%);\r\n        border-color: darken(map_get($gray, lighten-2), 10%);\r\n      }\r\n    }\r\n\r\n    &.badge-list {\r\n      & li:not(:last-child) {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.list-inline {\r\n  margin-left: -5px;\r\n  margin-right: -5px;\r\n  & li {\r\n    padding: 0 5px;\r\n    display: inline-block;\r\n\r\n    &.media {\r\n      display: flex;\r\n    }\r\n  }\r\n}\r\n\r\n.card-strip {\r\n  border-bottom: solid 1px $gray-300;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.jr-mbtn-list {\r\n  margin-left: -20px;\r\n}\r\n\r\n.img-res {\r\n\r\n    max-width: 100%;\r\n    height: auto;\r\n\r\n}","// Nav Style\r\n.nav-link {\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n}\r\n\r\n.card-header.bg-primary {\r\n  & .nav-link {\r\n    color: $white;\r\n\r\n    &.active,\r\n    &:hover,\r\n    &:focus {\r\n      color: $black;\r\n      background-color: $white;\r\n    }\r\n\r\n    &.disabled {\r\n      color: $gray-100;\r\n    }\r\n\r\n    &.disabled:hover {\r\n      color: $gray-900;\r\n    }\r\n  }\r\n}","/*Pricing Styles*/\r\n.pt-classic,\r\n.pt-default,\r\n.pt-dark,\r\n.pt-circle {\r\n\r\n  & .package {\r\n    position: relative;\r\n    padding: 0;\r\n    overflow: hidden;\r\n    @include border-radius(10px);\r\n    @include transition(all 0.5s ease-in-out);\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      -webkit-transform: scale(1.05);\r\n      -ms-transform: scale(1.05);\r\n      transform: scale(1.05);\r\n    }\r\n    &.highlight {\r\n      -webkit-transform: scale(1.05);\r\n      -ms-transform: scale(1.05); // IE9 only\r\n      -o-transform: scale(1.05);\r\n      transform: scale(1.05);\r\n      z-index: 2;\r\n    }\r\n  }\r\n  & .package-header {\r\n    padding: 35px;\r\n    text-align: center;\r\n\r\n    & > .price {\r\n      display: inline-block;\r\n      font-size: 36px;\r\n      font-weight: 700;\r\n      margin-left: 0;\r\n      margin-bottom: 12px;\r\n      & > i {\r\n        display: inline-block;\r\n        margin-right: 6px;\r\n        font-weight: bold;\r\n      }\r\n    }\r\n\r\n    & h5 {\r\n      color: inherit;\r\n    }\r\n  }\r\n\r\n  & .package-items {\r\n    list-style: none;\r\n    font-size: 14px;\r\n    margin: 0;\r\n    padding: 50px 50px 120px;\r\n\r\n    & li {\r\n      margin-bottom: 16px;\r\n      @include clearfix();\r\n      line-height: inherit;\r\n      & i {\r\n        float: left;\r\n        min-width: 20px;\r\n        margin-right: 16px;\r\n        line-height: inherit;\r\n      }\r\n\r\n      & span {\r\n        display: block;\r\n        overflow: hidden;\r\n      }\r\n    }\r\n  }\r\n\r\n  & .package-footer {\r\n    bottom: 0;\r\n    left: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    padding: 40px 50px;\r\n    text-align: center;\r\n\r\n    & .btn {\r\n      color: inherit;\r\n      padding: 10px 30px;\r\n      border: 0 none;\r\n    }\r\n  }\r\n}\r\n\r\n.pt-classic .package {\r\n  border: 0 none;\r\n  @include border-radius(0);\r\n}\r\n\r\n.pt-dark {\r\n  & .package {\r\n    &:hover {\r\n      @include border-radius(20px);\r\n    }\r\n  }\r\n}\r\n\r\n.pt-circle {\r\n  & .package-header {\r\n    @include border-radius(50%);\r\n    height: 224px;\r\n    width: 224px;\r\n    margin: 40px auto 0;\r\n    @include align-items(center);\r\n\r\n    & .price {\r\n      margin-top: 30px;\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 991px) {\r\n  .pt-classic,\r\n  .pt-default,\r\n  .pt-dark,\r\n  .pt-circle {\r\n    & .package-header {\r\n      padding: 30px 20px;\r\n    }\r\n    & .package-items {\r\n      padding: 30px 20px 120px;\r\n    }\r\n  }\r\n\r\n  .pt-circle {\r\n    & .package-header {\r\n      height: 204px;\r\n      width: 204px;\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n  .pt-classic,\r\n  .pt-default,\r\n  .pt-dark,\r\n  .pt-circle {\r\n    & .package {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.highlight {\r\n        -webkit-transform: scale(1);\r\n        -ms-transform: scale(1);\r\n        transform: scale(1);\r\n      }\r\n    }\r\n  }\r\n}\r\n","/*Progressbar Styles*/\r\n\r\n.pb-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.pb-btn-wrapper {\r\n  margin: 8px;\r\n  position: relative;\r\n  .btn-success {\r\n    background-color: map_get($green, base);\r\n    &:hover {\r\n      background-color: map_get($green, darken-2);\r\n    }\r\n  }\r\n}\r\n\r\n.fab-progress {\r\n  color: map_get($green, base);\r\n  position: absolute;\r\n  top: -6px;\r\n  left: -6px;\r\n  z-index: 1;\r\n}\r\n\r\n.btn-progress {\r\n  color: map_get($green, base);\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-top: -12px;\r\n  margin-left: -12px;\r\n}","/*Popover Styles*/\r\n.popover {\r\n  z-index: 1510;\r\n  max-height: 400px;\r\n}\r\n\r\n.popover-inner {\r\n  max-height: 400px;\r\n}\r\n\r\n.popover-header {\r\n  background-color: transparent;\r\n  border-bottom: 0 none;\r\n  color: $black;\r\n  font-size: $h2-font-size;\r\n  padding: 15px 20px 0;\r\n}\r\n\r\n.popover-body {\r\n  padding: 15px 20px;\r\n  max-height: 355px;\r\n  overflow: auto;\r\n}\r\n\r\n\r\n","/*Tables Styles*/\r\n\r\n.table-header {\r\n  padding-right: 2px !important;\r\n  min-height: 64px;\r\n  padding-left: 24px;\r\n  align-items: center;\r\n\r\n  &.highlight-light {\r\n    color: map_get($gray, darken-2);\r\n    background-color: map_get($gray, lighten-2);\r\n  }\r\n  &.highlight-dark {\r\n    color: $white;\r\n    background-color: map_get($gray, darken-2);\r\n  }\r\n}\r\n\r\n.spacer {\r\n  @include flex(1, 1, 100%);\r\n}\r\n\r\n.actions {\r\n  color: map_get($red, base);\r\n}\r\n\r\n.title {\r\n  @include flex(0, 0, auto);\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n  background-color: rgba($app-primary, 0.075);\r\n}\r\n\r\n.table-material {\r\n  width: 100% !important;\r\n  max-width: 100% !important;\r\n  background-color: $table-bg !important; // Reset for nesting within parents with `background-color`.\r\n\r\n  th,\r\n  td {\r\n    padding: $table-cell-padding !important;\r\n    vertical-align: top !important;\r\n    border-top: $table-border-width solid $table-border-color !important;\r\n  }\r\n\r\n  thead th {\r\n    vertical-align: bottom !important;\r\n    border-bottom: (2 * $table-border-width) solid $table-border-color !important;\r\n  }\r\n\r\n  tbody + tbody {\r\n    border-top: (2 * $table-border-width) solid $table-border-color !important;\r\n  }\r\n\r\n  .table-material {\r\n    background-color: $body-bg !important;\r\n  }\r\n}\r\n\r\n.d-flex-stretch {\r\n  @include align-items(stretch);\r\n  display: -webkit-flex;\r\n  display: -webkit-box;\r\n  display: -moz-flex;\r\n  display: -moz-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-flex-wrap: wrap;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.default-table {\r\n  margin-bottom: 0;\r\n  & thead th {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n  }\r\n  & td {\r\n    vertical-align: middle;\r\n  }\r\n}\r\n\r\n.table-unbordered {\r\n  & th,\r\n  & td {\r\n    border: 0 none !important;\r\n  }\r\n\r\n  & .th-border-b th {\r\n    border-bottom: 2px solid $gray-400 !important;\r\n  }\r\n}\r\n\r\n.table-responsive-material {\r\n  min-height: .01%;\r\n  overflow-x: auto;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .table-responsive-material {\r\n    width: 100%;\r\n    margin-bottom: 15px;\r\n    overflow-y: hidden;\r\n    -ms-overflow-style: -ms-autohiding-scrollbar;\r\n    border: 1px solid #ddd;\r\n  }\r\n  .table-responsive-material > .table {\r\n    margin-bottom: 0;\r\n  }\r\n  .table-responsive-material > .table > thead > tr > th,\r\n  .table-responsive-material > .table > tbody > tr > th,\r\n  .table-responsive-material > .table > tfoot > tr > th,\r\n  .table-responsive-material > .table > thead > tr > td,\r\n  .table-responsive-material > .table > tbody > tr > td,\r\n  .table-responsive-material > .table > tfoot > tr > td {\r\n    white-space: nowrap;\r\n  }\r\n  .table-responsive-material > .table-bordered {\r\n    border: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > thead > tr > th:first-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > th:first-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > th:first-child,\r\n  .table-responsive-material > .table-bordered > thead > tr > td:first-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > td:first-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > td:first-child {\r\n    border-left: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > thead > tr > th:last-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > th:last-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > th:last-child,\r\n  .table-responsive-material > .table-bordered > thead > tr > td:last-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > td:last-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > td:last-child {\r\n    border-right: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > tbody > tr:last-child > th,\r\n  .table-responsive-material > .table-bordered > tfoot > tr:last-child > th,\r\n  .table-responsive-material > .table-bordered > tbody > tr:last-child > td,\r\n  .table-responsive-material > .table-bordered > tfoot > tr:last-child > td {\r\n    border-bottom: 0;\r\n  }\r\n}\r\n\r\n.fst-td-br-tp-0 tr:first-child {\r\n  & td {\r\n    border-top: 0 none;\r\n  }\r\n}","/*Tabs Styles*/\r\n\r\n.tab {\r\n  min-width: 10px !important;\r\n}\r\n\r\n.tab-icon > span {\r\n  @include display-flex();\r\n}","/*Testimonial Styles*/\r\n\r\n.testimonial-in-bg {\r\n  background-color: rgba($black, 0.8);\r\n  box-shadow: 5px 5px 6px rgba($black, 0.06);\r\n  padding: 30px 30px 30px 150px;\r\n  overflow: hidden;\r\n  position: relative;\r\n\r\n  @media screen and (max-width: 450px) {\r\n    padding-left: 100px;\r\n  }\r\n\r\n  & .pic {\r\n    display: inline-block;\r\n    width: $size-80;\r\n    height: $size-80;\r\n    @include border-radius(50%);\r\n    overflow: hidden;\r\n    position: absolute;\r\n    top: 30px;\r\n    left: 20px;\r\n    border: 4px solid map_get($amber, darken-2);\r\n\r\n    @media screen and (max-width: 450px) {\r\n      width: $size-50;\r\n      height: $size-50;\r\n    }\r\n  }\r\n  & .pic img {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  & .description {\r\n    color: map_get($gray, lighten-1);\r\n    font-style: italic;\r\n    font-weight: 400;\r\n    line-height: 25px;\r\n    margin-bottom: 15px;\r\n    position: relative;\r\n\r\n    &:before {\r\n      content: \"\\f1b2\";\r\n      font: {\r\n        family: 'Material-Design-Iconic-Font';\r\n        size: 24px;\r\n      }\r\n      -moz-transform: scaleX(-1);\r\n      -webkit-transform: scaleX(-1);\r\n      -o-transform: scaleX(-1);\r\n      transform: scaleX(-1);\r\n      position: absolute;\r\n      left: -24px;\r\n    }\r\n  }\r\n  & .title {\r\n    color: map_get($amber, darken-2);\r\n    margin-bottom: 2px;\r\n  }\r\n}\r\n\r\n// Testimonials Simple\r\n.classic-testimonial {\r\n  text-align: center;\r\n\r\n  & .pic {\r\n    margin: 0 auto;\r\n    margin-bottom: 30px;\r\n    width: $size-120;\r\n    height: $size-120;\r\n\r\n    @media screen and (max-width: 500px) {\r\n      width: $size-80;\r\n      height: $size-80;\r\n    }\r\n  }\r\n  & .pic img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n}\r\n","/*Time Lines Style*/\r\n\r\n.timeline-left {\r\n  float: left;\r\n  margin-right: 20px;\r\n}\r\n\r\n.timeline-right {\r\n  float: right;\r\n  margin-left: 20px;\r\n}\r\n\r\n.timeline-circle {\r\n  @include border-radius(50%);\r\n}\r\n\r\n.timeline-section {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.timeline-item {\r\n  padding-bottom: 25px;\r\n  padding-left: 80px;\r\n  position: relative;\r\n\r\n  &:before {\r\n    border-left: solid 2px $gray-300;\r\n    content: \"\";\r\n    left: 25px;\r\n    position: absolute;\r\n    top: 25px;\r\n    bottom: -20px;\r\n    width: 2px;\r\n    z-index: 1;\r\n  }\r\n  &:first-child:before {\r\n    border-left-style: dashed;\r\n  }\r\n  &:last-child:before {\r\n    border-left-style: dashed;\r\n    bottom: 25px;\r\n  }\r\n}\r\n\r\n.timeline-badge {\r\n  //background-color: $gray-300;\r\n  @extend %size-50;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 16px;\r\n  z-index: 2;\r\n  font-size: 16px;\r\n  color: $white;\r\n  text-align: center;\r\n  @include border-radius($border-radius-circle);\r\n\r\n  &.timeline-img {\r\n    background-color: transparent;\r\n  }\r\n  & svg {\r\n    vertical-align: calc(100% - 56px);\r\n  }\r\n}\r\n\r\n.timeline-badge {\r\n  &.timeline-img:after {\r\n    display: none;\r\n  }\r\n\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 42px;\r\n    height: 42px;\r\n    background-color: transparent;\r\n    border: 4px solid $body-bg;\r\n    @include border-radius($border-radius-circle);\r\n    left: 4px;\r\n    top: 4px;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.timeline-img > img,\r\n.timeline-header-img > img {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.timeline-panel {\r\n  padding: 20px 30px;\r\n  position: relative;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  border: solid 1px $gray-200;\r\n\r\n  &:after,\r\n  &:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    border-style: solid;\r\n    display: inline-block;\r\n  }\r\n\r\n  &:before {\r\n    border-color: transparent $gray-300;\r\n    border-width: 10px 17px 10px 0;\r\n    left: -17px;\r\n    top: 30px;\r\n  }\r\n\r\n  &:after {\r\n    border-color: transparent $white;\r\n    border-width: 10px 16px 10px 0;\r\n    left: -16px;\r\n    top: 30px;\r\n  }\r\n}\r\n\r\n.timeline-no-padding {\r\n  padding: 0;\r\n}\r\n\r\n.timeline-no-shadow {\r\n  @include box-shadow(none);\r\n  &:before,\r\n  &:after {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.timeline-panel-header, .timeline-header-img {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.timeline-inverted {\r\n  & .timeline-left {\r\n    float: right;\r\n    margin-right: 0;\r\n    margin-left: 20px;\r\n  }\r\n}\r\n\r\n.timeline-heading {\r\n  overflow: hidden;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.timeline-body {\r\n  clear: both;\r\n}\r\n\r\n/*Gxtl Center Style*/\r\n.timeline-center {\r\n  & .timeline-item {\r\n    clear: both;\r\n    float: right;\r\n    width: 50%;\r\n    padding-left: 55px;\r\n\r\n    &:before {\r\n      left: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.timeline-center {\r\n  & .timeline-badge {\r\n    left: -25px;\r\n    right: auto;\r\n  }\r\n\r\n  & .timeline-time {\r\n    position: absolute;\r\n    top: 32px;\r\n    left: -150px;\r\n    right: auto;\r\n    z-index: 2;\r\n  }\r\n\r\n  & .timeline-inverted {\r\n    float: left;\r\n    text-align: right;\r\n    padding-left: 0;\r\n    padding-right: 55px;\r\n\r\n    &:before {\r\n      border-left: 0 none;\r\n      border-right: solid 2px $gray-300;\r\n      left: auto;\r\n      right: -2px;\r\n    }\r\n    & .timeline-badge {\r\n      left: auto;\r\n      right: -25px;\r\n    }\r\n\r\n    & .timeline-panel {\r\n      &:before {\r\n        border-width: 10px 0 10px 17px;\r\n        left: auto;\r\n        right: -17px;\r\n      }\r\n\r\n      &:after {\r\n        border-width: 10px 0 10px 16px;\r\n        left: auto;\r\n        right: -16px;\r\n      }\r\n    }\r\n\r\n    & .timeline-time {\r\n      position: absolute;\r\n      top: 32px;\r\n      right: -150px;\r\n      left: auto;\r\n      z-index: 2;\r\n    }\r\n  }\r\n}\r\n\r\n/*Gxtl Zigzag Style*/\r\n.timeline-zigzag {\r\n  & .timeline-item {\r\n    padding-left: 150px;\r\n\r\n    & + .timeline-item {\r\n      margin-top: -80px;\r\n    }\r\n  }\r\n\r\n  & .timeline-img {\r\n    width: 90px;\r\n    height: 90px;\r\n    left: 5px;\r\n    & > img {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  & .timeline-inverted .timeline-img {\r\n    right: 5px !important;\r\n  }\r\n\r\n  & .timeline-item:before {\r\n    @include rotate(35deg);\r\n    top: 20px;\r\n    bottom: 20px;\r\n  }\r\n\r\n  & .timeline-inverted {\r\n    padding-left: 0;\r\n    padding-right: 150px;\r\n    &:before {\r\n      @include rotate(-35deg);\r\n    }\r\n  }\r\n\r\n  & .timeline-item:first-child:before {\r\n    border-left-style: solid;\r\n  }\r\n\r\n  & .timeline-item:last-child:before {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.timeline-item:last-child:before {\r\n  bottom: 25px;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .timeline-zigzag .timeline-item + .timeline-item {\r\n    margin-top: -60px;\r\n  }\r\n\r\n  .timeline-zigzag .timeline-item:before {\r\n    bottom: 0;\r\n  }\r\n\r\n  .timeline-zigzag {\r\n    & .timeline-item {\r\n      padding-left: 120px;\r\n    }\r\n\r\n    & .timeline-inverted {\r\n      padding-right: 120px;\r\n      padding-left: 0;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .timeline-center {\r\n    & .timeline-item {\r\n      float: none;\r\n      padding-left: 80px;\r\n      width: auto;\r\n      &:before {\r\n        left: 25px;\r\n      }\r\n    }\r\n\r\n    & .timeline-badge {\r\n      left: 0;\r\n    }\r\n\r\n    & .timeline-inverted {\r\n      float: none;\r\n      text-align: left;\r\n      padding-right: 0;\r\n\r\n      &:before {\r\n        border-left: solid 2px $gray-300;\r\n        border-right: 0 none;\r\n        left: 24px;\r\n        right: auto;\r\n      }\r\n      & .timeline-badge {\r\n        right: auto;\r\n        left: 0;\r\n      }\r\n\r\n      & .timeline-panel {\r\n        &:before {\r\n          border-width: 10px 17px 10px 0;\r\n          left: -17px;\r\n          right: auto;\r\n        }\r\n        &:after {\r\n          border-width: 10px 16px 10px 0;\r\n          left: -16px;\r\n          right: auto;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .timeline-inverted {\r\n    & .timeline-panel-header {\r\n      float: none;\r\n    }\r\n\r\n    & .timeline-left {\r\n      float: left;\r\n      margin-left: 0;\r\n      margin-right: 20px;\r\n    }\r\n  }\r\n\r\n  .timeline-zigzag {\r\n    & .timeline-panel {\r\n      max-height: none;\r\n      min-height: 10px;\r\n      overflow-y: visible;\r\n    }\r\n\r\n    & .timeline-item {\r\n      padding-left: 100px;\r\n      & + .timeline-item {\r\n        margin-top: 0;\r\n      }\r\n\r\n      &:before {\r\n        transform: none;\r\n        top: 25px;\r\n        bottom: -25px;\r\n        left: 45px;\r\n      }\r\n\r\n      &:last-child:before {\r\n        bottom: 0;\r\n      }\r\n    }\r\n    & .timeline-inverted:before {\r\n      transform: none;\r\n    }\r\n  }\r\n\r\n  .timeline-center {\r\n    & .timeline-time,\r\n    & .timeline-inverted .timeline-time {\r\n      position: relative;\r\n      top: auto;\r\n      left: auto;\r\n      right: auto;\r\n      margin-bottom: 6px;\r\n    }\r\n\r\n    .timeline-time-item .timeline-panel::before {\r\n      top: 10px;\r\n    }\r\n\r\n    .timeline-time-item .timeline-panel::after {\r\n      top: 11px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .timeline-left {\r\n    float: none;\r\n    margin-right: 0;\r\n  }\r\n\r\n  .timeline-right {\r\n    float: none;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .timeline-inverted {\r\n    & .timeline-left {\r\n      float: none;\r\n      margin-right: 0;\r\n    }\r\n  }\r\n}","/*Form Styles*/\r\n@media screen and (max-width: 575px) {\r\n  .horizontal-stepper {\r\n    & p,\r\n    & span {\r\n      opacity: 0;\r\n      visibility: hidden;\r\n      font-size: 12px;\r\n    }\r\n\r\n    &.active {\r\n      & p,\r\n      & span {\r\n        opacity: 1;\r\n        visibility: visible;\r\n      }\r\n    }\r\n\r\n    & > *,\r\n    & > button > * {\r\n      @include display-flex(flex, column, nowrap);\r\n    }\r\n\r\n    & .stepperlabel,\r\n    & .stepperbutton,\r\n    & .stepperlabel span:first-child,\r\n    & .stepperbutton span:first-child {\r\n      opacity: 1;\r\n      visibility: visible;\r\n    }\r\n  }\r\n\r\n  .horizontal-stepper-linear {\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n  }\r\n}",".form-checkbox {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.form-checkbox > input {\r\n  height: 18px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  padding: 10px;\r\n  top: 0;\r\n  width: 18px;\r\n  z-index: 2;\r\n  cursor: pointer;\r\n}\r\n\r\n.form-control-checkbox .form-checkbox > input {\r\n  height: 48px;\r\n  width: 48px;\r\n}\r\n\r\n.form-control-checkbox .form-checkbox {\r\n  height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 48px;\r\n  justify-content: center;\r\n}\r\n\r\n.form-checkbox > input + .check {\r\n  border: 1px solid $sidebar-text-color;\r\n  border-radius: 2px;\r\n  color: $app-primary;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  height: 18px;\r\n  position: relative;\r\n  width: 18px;\r\n  z-index: -1;\r\n}\r\n\r\n.form-checkbox > input.sm + .check {\r\n  border: 1px solid $sidebar-text-color;\r\n  border-radius: 2px;\r\n  color: $app-primary;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  height: 14px;\r\n  position: relative;\r\n  top: 3px;\r\n  width: 14px;\r\n  z-index: -1;\r\n}\r\n\r\n.form-checkbox > input + .check i {\r\n  display: none;\r\n  left: 1px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 2px;\r\n}\r\n\r\n.form-checkbox > input.sm + .check i {\r\n  display: none;\r\n  left: 1px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 2px;\r\n}\r\n\r\n.form-checkbox > input:checked + span i {\r\n  display: block;\r\n  opacity: 1;\r\n}\r\n\r\n/*Radio and Checkbox styles*/\r\n\r\n.checkbox-replace {\r\n  padding-left: 20px;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"],\r\n.radio-replace input[type=\"radio\"] {\r\n  margin-left: -20px;\r\n  position: absolute;\r\n}\r\n\r\n.form-inline .checkbox-replace label {\r\n  padding-left: 5px;\r\n}\r\n\r\n.form-inline .checkbox-replace,\r\n.form-inline .radio-replace {\r\n  margin-right: 20px;\r\n}\r\n\r\n.form-inline .checkbox-replace:last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n.checkbox-replace label {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  position: relative;\r\n  padding-left: 5px;\r\n}\r\n\r\n.checkbox-replace label::before {\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 18px;\r\n  height: 18px;\r\n  left: 0;\r\n  top: 0;\r\n  margin-left: -20px;\r\n  margin-top: 2px;\r\n  border: 1px solid $sidebar-text-color;\r\n  border-radius: 3px;\r\n  background-color: $white;\r\n  @include transition (border 0.15s ease-in-out, color 0.15s ease-in-out);\r\n}\r\n\r\n.checkbox-replace label::after {\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 12px;\r\n  height: 12px;\r\n  left: 3px;\r\n  top: 5px;\r\n  margin-left: -20px;\r\n  font-size: 11px;\r\n  color: $gray-700;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"] {\r\n  opacity: 0;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:focus + label::before {\r\n  outline: 0 none;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:checked + label::after {\r\n  background-color: $gray-400;\r\n  content: \"\";\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:disabled + label {\r\n  opacity: 0.65;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:disabled + label::before {\r\n  background-color: $white;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.checkbox-replace.checkbox-inline {\r\n  margin-top: 0;\r\n}\r\n\r\n.checkbox-primary label::before {\r\n  border-color: $app-primary;\r\n}\r\n\r\n.checkbox-primary input[type=\"checkbox\"]:checked + label::after {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.checkbox-danger label::before {\r\n  border-color: $secondary;\r\n}\r\n\r\n.checkbox-danger input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $secondary;\r\n}\r\n\r\n.checkbox-info label::before {\r\n  border-color: $info;\r\n}\r\n\r\n.checkbox-info input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $info;\r\n}\r\n\r\n.checkbox-warning label::before {\r\n  border-color: $warning;\r\n}\r\n\r\n.checkbox-warning input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $warning;\r\n}\r\n\r\n.checkbox-success label::before {\r\n  border-color: $success;\r\n}\r\n\r\n.checkbox-success input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $success;\r\n}\r\n\r\n.radio-replace {\r\n  padding-left: 20px;\r\n}\r\n\r\n.radio-replace label {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  position: relative;\r\n  padding-left: 5px;\r\n}\r\n\r\n.radio-replace label::before {\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 18px;\r\n  height: 18px;\r\n  left: 0;\r\n  top: 0;\r\n  margin-left: -20px;\r\n  margin-top: 2px;\r\n  border: 1px solid $gray-400;\r\n  border-radius: 50%;\r\n  background-color: $white;\r\n  @include transition(border 0.15s ease-in-out);\r\n}\r\n\r\n.radio-replace label::after {\r\n  display: inline-block;\r\n  position: absolute;\r\n  content: \" \";\r\n  width: 12px;\r\n  height: 12px;\r\n  left: 3px;\r\n  top: 5px;\r\n  margin-left: -20px;\r\n  border-radius: 50%;\r\n  background-color: $gray-400;\r\n  @include rotate (scale(0, 0));\r\n  @include transition (transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33))\r\n}\r\n\r\n.radio-replace input[type=\"radio\"] {\r\n  opacity: 0;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:focus + label::before {\r\n  outline: 0 none;\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:checked + label::after {\r\n  @include rotate (scale(1, 1));\r\n\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:disabled + label {\r\n  opacity: 0.65;\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:disabled + label::before {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.radio-replace.radio-inline {\r\n  margin-top: 0;\r\n}\r\n\r\n.radio-primary input[type=\"radio\"] + label::after {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.radio-primary input[type=\"radio\"]:checked + label::before {\r\n  border-color: $app-primary;\r\n}\r\n\r\n.radio-primary input[type=\"radio\"]:checked + label::after {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.radio-danger input[type=\"radio\"] + label::after {\r\n  background-color: $secondary;\r\n}\r\n\r\n.radio-danger input[type=\"radio\"]:checked + label::before {\r\n  border-color: $secondary;\r\n}\r\n\r\n.radio-danger input[type=\"radio\"]:checked + label::after {\r\n  background-color: $secondary;\r\n}\r\n\r\n.radio-info input[type=\"radio\"] + label::after {\r\n  background-color: $info;\r\n}\r\n\r\n.radio-info input[type=\"radio\"]:checked + label::before {\r\n  border-color: $info;\r\n}\r\n\r\n.radio-info input[type=\"radio\"]:checked + label::after {\r\n  background-color: $info;\r\n}\r\n\r\n.radio-warning input[type=\"radio\"] + label::after {\r\n  background-color: $warning;\r\n}\r\n\r\n.radio-warning input[type=\"radio\"]:checked + label::before {\r\n  border-color: $warning;\r\n}\r\n\r\n.radio-warning input[type=\"radio\"]:checked + label::after {\r\n  background-color: $warning;\r\n}\r\n\r\n.radio-success input[type=\"radio\"] + label::after {\r\n  background-color: $success;\r\n}\r\n\r\n.radio-success input[type=\"radio\"]:checked + label::before {\r\n  border-color: $success;\r\n}\r\n\r\n.radio-success input[type=\"radio\"]:checked + label::after {\r\n  background-color: $success;\r\n}\r\n\r\n.form-horizontal .checkbox, .form-horizontal .checkbox-inline, .form-horizontal .radio, .form-horizontal .radio-inline {\r\n  padding-top: 7px;\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.form-horizontal .form-inline .checkbox,\r\n.form-horizontal .form-inline .checkbox-inline,\r\n.form-horizontal .form-inline .radio,\r\n.form-horizontal .form-inline .radio-inline {\r\n  padding-top: 0;\r\n}\r\n\r\n.form-horizontal .checkbox, .form-horizontal .radio {\r\n  min-height: 27px;\r\n}\r\n\r\n.form-wizard .tab-content .pager.wizard .first a {\r\n  margin-right: 8px;\r\n}\r\n\r\n.form-wizard .tab-content .pager.wizard .last a {\r\n  margin-left: 8px;\r\n}\r\n\r\n.wizard-navbar {\r\n  margin: 60px auto 20px;\r\n}\r\n\r\n.wizard-navbar > ul {\r\n  display: table;\r\n  width: 100%;\r\n  text-align: center;\r\n  margin: 0;\r\n  font-weight: 600;\r\n  padding: 0;\r\n  list-style: none outside none;\r\n  table-layout: fixed;\r\n}\r\n\r\n.wizard-navbar > ul li {\r\n  display: table-cell;\r\n  width: 1%;\r\n  position: relative;\r\n}\r\n\r\n.wizard-navbar > ul li a {\r\n  color: $sidebar-text-color;\r\n  position: relative;\r\n  padding: 0 10px;\r\n  display: block;\r\n  text-decoration: none;\r\n}\r\n\r\n.wizard-navbar > ul li a span.wz-number {\r\n  background-color: $gray-200;\r\n  border-radius: 50%;\r\n\r\n  color: $gray-500;\r\n  display: block;\r\n  height: 40px;\r\n  left: 50%;\r\n  line-height: 40px;\r\n  margin-left: -20px;\r\n  margin-top: -50px;\r\n  position: absolute;\r\n  text-align: center;\r\n  @include transition(all 300ms ease-in-out 0s);\r\n  width: 40px;\r\n  z-index: 5;\r\n}\r\n\r\n.wizard-navbar > ul li.completed a span.wz-number {\r\n  background-color: $app-primary;\r\n  color: $white;\r\n}\r\n\r\n.wizard-navbar > ul li a.active span.wz-number {\r\n  background-color: $secondary;\r\n  color: $white;\r\n}\r\n\r\n.wizard-navbar > ul li a.active,\r\n.wizard-navbar > ul li.completed a {\r\n  color: $gray-600;\r\n}\r\n\r\n.wizard-navbar > ul li a:before,\r\n.wizard-navbar > ul li a:after {\r\n  content: '';\r\n  position: absolute;\r\n  height: 4px;\r\n  width: 50%;\r\n  background-color: $gray-200;\r\n  top: -32px;\r\n  left: 0;\r\n}\r\n\r\n.wizard-navbar > ul li a:after {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n\r\n.wizard-navbar > ul li a.active:before,\r\n.wizard-navbar > ul li a.active:after {\r\n  background-color: $secondary;\r\n}\r\n\r\n.wizard-navbar > ul li.completed a:before,\r\n.wizard-navbar > ul li.completed a:after {\r\n  background-color: $app-primary;\r\n}\r\n\r\nlabel.error {\r\n  display: block;\r\n  color: $danger;\r\n  font-weight: 400;\r\n  margin: 5px 0;\r\n}\r\n\r\n@media screen and (max-width: 479px) {\r\n  .wizard-navbar > ul li a span.wz-label {\r\n    visibility: hidden;\r\n  }\r\n\r\n  .wizard-navbar > ul li a.active span.wz-label {\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n.form-checkbox-custom {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.form-checkbox-custom .check {\r\n  margin-right: 10px;\r\n}\r\n\r\n.react-switch {\r\n  vertical-align: middle;\r\n  margin-left: 4px;\r\n}\r\n","/*Input Styles*/\r\n::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n::-moz-placeholder { /* Firefox 19+ */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n:-ms-input-placeholder { /* IE 10+ */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n:-moz-placeholder { /* Firefox 18- */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n.module-box-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n  font-size: 14px;\r\n}\r\n\r\n.module-box-header ::-moz-placeholder { /* Firefox 19+ */\r\n  font-size: 14px;\r\n}\r\n\r\n.module-box-header :-ms-input-placeholder { /* IE 10+ */\r\n  font-size: 14px;\r\n}\r\n\r\n.module-box-header :-moz-placeholder { /* Firefox 18- */\r\n  font-size: 14px;\r\n}\r\n\r\n// Search Bar Style\r\n.search-bar {\r\n  background-color: $white;\r\n  position: relative;\r\n  & .form-group {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin-bottom: 0;\r\n  }\r\n  & input[type=\"search\"] {\r\n    padding-right: 50px;\r\n  }\r\n\r\n  & .search-icon {\r\n    background-color: transparent;\r\n    border: 0 none;\r\n    color: lighten($gray-600, 10%);\r\n    height: 36px;\r\n    width: 30px;\r\n  }\r\n\r\n  & .form-control {\r\n    box-shadow: none;\r\n    &.form-control-lg + .search-icon {\r\n      position: absolute;\r\n      right: 14px;\r\n      top: 6px;\r\n    }\r\n  }\r\n\r\n  & .search-icon {\r\n    position: absolute;\r\n    right: 14px;\r\n    top: 3px;\r\n  }\r\n\r\n  &.right-side-icon {\r\n    & input[type=\"search\"] {\r\n      padding-right: 16px;\r\n      padding-left: 50px;\r\n    }\r\n\r\n    & .search-icon {\r\n      position: absolute;\r\n      left: 14px;\r\n      top: 2px;\r\n    }\r\n\r\n    & .form-control {\r\n      box-shadow: none;\r\n      &.form-control-lg + .search-icon {\r\n        position: absolute;\r\n        left: 14px;\r\n        top: 6px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.nav-searchbox .search-bar input {\r\n  & + .search-icon {\r\n    & i {\r\n      color: rgba($body-color, 0.8);\r\n    }\r\n  }\r\n}\r\n\r\n/* Removing arrows for input type number in Chrome, Safari, Edge, Opera */\r\n.inputClassComponent::-webkit-outer-spin-button,\r\n.inputClassComponent::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Removing arrows for input type number in Firefox */\r\n.inputClassComponent[type=number] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .jr-card .app-main-header {\r\n    & .search-bar {\r\n      width: 150px;\r\n    }\r\n  }\r\n}","/* Pages\r\n   ========================================================================== */\r\n@import \"login\";\r\n@import \"error\";\r\n@import \"editor\";\r\n@import \"contact\";\r\n@import \"portfolio\";\r\n@import \"faq\";\r\n@import \"dashboard\";\r\n@import \"dropzone\";","/*Login Styles*/\r\n/*Login Styles*/\r\n\r\n.indexPage {\r\n  background-color: #f4f6f8;\r\n  height: 100vh;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  padding: 0;\r\n  margin: 0;\r\n  @media screen and (max-width: 575px) {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.landingPage {\r\n  background-color: #fff;\r\n  height: 680px;\r\n  background-position: bottom right;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  @media screen and (max-width: 575px) {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.login-container {\r\n  position: relative;\r\n  height: 100%;\r\n}\r\n\r\n.login-content {\r\n  width: 420px;\r\n  margin: auto;\r\n  padding: 35px 35px 20px;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  border: solid 1px $gray-400;\r\n  font-size: 14px;\r\n  max-width: 94%;\r\n}\r\n\r\n.login-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.login-content .form-control {\r\n  background-color: map_get($gray, lighten-4);\r\n\r\n  &:focus {\r\n    box-shadow: none;\r\n    border-color: $app-primary;\r\n  }\r\n}\r\n\r\n.login-content .btn, .login-content .jr-btn {\r\n  padding: 10px 35px !important;\r\n}\r\n\r\n.app-login-container {\r\n  position: relative;\r\n  max-width: 680px;\r\n  width: 94%;\r\n  margin: 0 auto;\r\n\r\n  & .loader-view {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    text-align: center;\r\n    top: 0;\r\n    bottom: 0;\r\n    z-index: 2;\r\n  }\r\n}\r\n\r\n.app-login-main-content {\r\n  @include display-flex();\r\n  background-color: $white;\r\n  @include box-shadow($shadow);\r\n  @include border-radius(10px);\r\n  font-size: 14px;\r\n  overflow: hidden;\r\n}\r\n\r\n.app-login-content {\r\n  padding: 35px 35px 20px;\r\n  width: 60%;\r\n  order: 1;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    width: 100%;\r\n    order: 2;\r\n  }\r\n}\r\n\r\n.app-login-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.app-login-content .form-control {\r\n  background-color: map_get($gray, lighten-4);\r\n\r\n  &:focus {\r\n    box-shadow: none;\r\n    border-color: $app-primary;\r\n  }\r\n}\r\n\r\n.app-login-content .btn, .login-content .jr-btn {\r\n  padding: 10px 35px !important;\r\n}\r\n\r\n.app-logo-content {\r\n  background-color: $app-primary;\r\n  padding: 35px 35px 20px;\r\n  width: 40%;\r\n  order: 2;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    width: 100%;\r\n    order: 1;\r\n  }\r\n}\r\n\r\n.app-social-block {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-between);\r\n\r\n  & .social-link,\r\n  & .social-link li {\r\n    margin: 0;\r\n  }\r\n\r\n  & .social-link span {\r\n    border: solid 1px $app-primary;\r\n    @include border-radius(50%);\r\n    color: $app-primary;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $white;\r\n      background-color: $app-primary;\r\n    }\r\n  }\r\n\r\n  & p {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n","/*Error Styles*/\r\n\r\n.page-error-container {\r\n  padding: 30px 0;\r\n  position: relative;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 15px 0;\r\n  }\r\n}\r\n\r\n.page-error-content {\r\n  margin: 0 auto;\r\n  padding: 40px 0;\r\n  width: 380px;\r\n  max-width: 94%;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    padding: 15px 0;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.error-code {\r\n  color: $gray-900;\r\n  font-size: 160px;\r\n  text-align: center;\r\n  line-height: 1;\r\n  font-weight: 600;\r\n  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);\r\n\r\n  @media screen and (max-width: 991px) {\r\n    font-size: 130px;\r\n  }\r\n\r\n  @media screen and (max-width: 767px) {\r\n    font-size: 100px;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    font-size: 80px;\r\n  }\r\n}\r\n\r\n.page-error-content h2 {\r\n  margin-bottom: $size-50;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n","/*Editor Styles*/\r\n.rdw-inline-wrapper {\r\n  @include display-flex();\r\n}\r\n\r\n.rdw-option-wrapper {\r\n  margin-bottom: 6px;\r\n}\r\n","/*Contact Page Styles*/\r\n\r\n.contact-form {\r\n  padding: 60px;\r\n}\r\n\r\n.contact-block {\r\n  & .contact-info {\r\n    list-style: none;\r\n    padding-left: 0;\r\n    margin-bottom: 0;\r\n    @include display-flex();\r\n    @include align-items(center);\r\n    -webkit-align-content: stretch;\r\n    -ms-flex-align: stretch;\r\n    align-content: stretch;\r\n\r\n    & li {\r\n      @include flex(1, 1, 0);\r\n      overflow: hidden;\r\n      padding: 10px 40px;\r\n      border-right: 2px solid $body-color;\r\n      word-wrap: break-word;\r\n\r\n      &:last-child {\r\n        border: 0 none;\r\n      }\r\n\r\n      & > i {\r\n        float: left;\r\n        font-size: 16px;\r\n        margin-right: 5px;\r\n      }\r\n\r\n      & .contact-body {\r\n        overflow: hidden;\r\n        & .icons-wrapper {\r\n          margin-top: 15px;\r\n          margin-left: 0;\r\n        }\r\n\r\n        & .icon {\r\n          background-color: map_get($indigo, 'lighten-1');\r\n          color: $white;\r\n          @include border-radius(50%);\r\n          margin-right: 6px;\r\n          margin-bottom: 6px;\r\n          &:last-child {\r\n            margin-right: 0;\r\n          }\r\n        }\r\n\r\n        & .twitter-icon {\r\n          background-color: map_get($light-blue, accent-2);\r\n        }\r\n\r\n        & .google-icon {\r\n          background-color: map_get($red, lighten-1);\r\n        }\r\n\r\n        & .linkedin-icon {\r\n          background-color: map_get($light-blue, darken-3);\r\n        }\r\n      }\r\n    }\r\n\r\n    &.vertical {\r\n      display: block;\r\n      margin-bottom: 0;\r\n      & li {\r\n        padding: 0 0 24px;\r\n        border-right: 0 none;\r\n        border-bottom: 2px solid $body-color;\r\n        margin-bottom: 24px;\r\n\r\n        &:last-child {\r\n          border: 0 none;\r\n          margin-bottom: 0;\r\n          padding-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .contact-form {\r\n    padding: 30px;\r\n  }\r\n\r\n  .contact-block {\r\n    & .contact-info {\r\n      display: block;\r\n      margin-bottom: 0;\r\n      & li {\r\n        padding: 0 0 24px;\r\n        border-right: 0 none;\r\n        border-bottom: 2px solid $body-color;\r\n        margin-bottom: 24px;\r\n\r\n        &:last-child {\r\n          border: 0 none;\r\n          margin-bottom: 0;\r\n          padding-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .content-section {\r\n    padding: 20px 10px 0;\r\n    text-align: center;\r\n    & h2 {\r\n      font-size: 28px;\r\n    }\r\n    & p {\r\n      font-size: 18px;\r\n    }\r\n  }\r\n}\r\n","/*Portfolio Styles*/\r\n\r\n.portfolio-section {\r\n  & .card-image {\r\n    margin-bottom: 20px;\r\n    & img {\r\n      width: 100%;\r\n      @include transition(all 1200ms ease);\r\n    }\r\n    &:hover {\r\n      & img {\r\n        -webkit-transform: scale(1.08);\r\n        -ms-transform: scale(1.08);\r\n        transform: scale(1.08);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.filter-with-bg-color {\r\n  & ul {\r\n    padding-left: 0;\r\n    margin: 0 -10px 45px;\r\n    & li {\r\n      display: inline-block;\r\n      margin-bottom: 10px;\r\n      padding: 0 10px;\r\n    }\r\n\r\n    & li a {\r\n      text-transform: uppercase;\r\n      font-size: 12px;\r\n      padding: 10px 24px;\r\n      border: 1px solid $app-primary;\r\n      display: block;\r\n      text-decoration: none;\r\n    }\r\n\r\n    & li a:hover,\r\n    & li a:focus,\r\n    & li a.active {\r\n      cursor: pointer;\r\n      background-color: $app-primary;\r\n      border-color: $app-primary;\r\n      color: $white;\r\n    }\r\n\r\n    @media screen and (max-width: 575px) {\r\n      margin-bottom: 15px;\r\n    }\r\n  }\r\n}","/*Faqs Styles*/\r\n\r\n.Collapsible {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n//The content within the collaspable ChatUserList\r\n.Collapsible__contentInner {\r\n  padding: 20px;\r\n  border: 1px solid $gray-200;\r\n  background-color: $white;\r\n  border-top: 0;\r\n\r\n  p {\r\n    margin-bottom: 10px;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n//The link which when clicked opens the collapsable ChatUserList\r\n.Collapsible__trigger {\r\n  display: block;\r\n  cursor: pointer;\r\n  font-weight: 400;\r\n  text-decoration: none;\r\n  position: relative;\r\n  padding: 18px 20px;\r\n  @include border-radius(8px);\r\n  background: theme-color(\"primary\");\r\n  color: $white;\r\n\r\n  &:after {\r\n    content: '\\f2f9';\r\n    font: {\r\n      family: 'Material-Design-Iconic-Font';\r\n      size: 20px;\r\n    }\r\n    position: absolute;\r\n    right: 24px;\r\n    top: 16px;\r\n    display: block;\r\n    transition: transform 300ms;\r\n  }\r\n\r\n  &.is-open {\r\n    @include border-radius(8px 8px 0 0);\r\n    &:after {\r\n      transform: rotateZ(180deg);\r\n    }\r\n  }\r\n}\r\n\r\n//SideNav\r\n.categories-list {\r\n  margin-bottom: 0;\r\n  & li {\r\n    margin-bottom: 10px;\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n  & li.active a {\r\n    color: $app-primary;\r\n  }\r\n  & .badge {\r\n    font-size: 9px;\r\n  }\r\n}\r\n\r\n.articles-section {\r\n  & .articles {\r\n    margin-bottom: 26px;\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.article-image {\r\n  display: block;\r\n  margin-bottom: 12px;\r\n  & > img {\r\n    @include border-radius(8px);\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.article-description {\r\n  & p {\r\n    font-weight: 500;\r\n    margin-bottom: 2px;\r\n  }\r\n}\r\n\r\n.meta-wrapper {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.meta-date,\r\n.meta-comment {\r\n  font-size: 14px;\r\n  color: $gray-500;\r\n  display: inline-block;\r\n  & i {\r\n    display: inline-block;\r\n    margin-right: 6px;\r\n  }\r\n}\r\n\r\n.meta-date {\r\n  & + .meta-comment {\r\n    margin-left: 10px;\r\n  }\r\n}\r\n\r\n\r\n","/*Dashboard Styles*/\r\n.box {\r\n  position: relative;\r\n\r\n  .box-top,\r\n  .box-bottom {\r\n    height: 100px;\r\n    padding: 32px 15px;\r\n    font-size: 40px;\r\n    line-height: 40px;\r\n    text-align: center;\r\n    font-weight: $display1-weight;\r\n    .size-h5 {\r\n      font-size: 24px;\r\n      margin-left: 2px;\r\n    }\r\n    .material-icons {\r\n      font-size: 40px;\r\n      line-height: 40px;\r\n    }\r\n  }\r\n\r\n  .box-bottom {\r\n    border-top: 1px solid rgba($black, .15);\r\n  }\r\n\r\n  .box-info {\r\n    position: absolute;\r\n    width: 100%;\r\n    top: 50%;\r\n    margin-top: -12px;\r\n    text-align: center;\r\n\r\n    span {\r\n      height: 24px;\r\n      display: inline-block;\r\n      padding: 4px 10px;\r\n      text-transform: uppercase;\r\n      line-height: 14px;\r\n      background-color: $white;\r\n      border: 1px solid rgba($black, .15);\r\n      font-size: 12px;\r\n      color: $text-muted;\r\n      border-radius: 1em;\r\n      .material-icons {\r\n        line-height: 14px;\r\n        font-size: 11px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.contact-list {\r\n  margin-bottom: 14px;\r\n\r\n  & i {\r\n    margin-right: 14px;\r\n    color: theme-color(\"primary\");\r\n  }\r\n\r\n  & .media {\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n.temp-section {\r\n\r\n  .temp-point,\r\n  .detail-icon {\r\n    font-size: 54px;\r\n  }\r\n}\r\n\r\n.assignment-table {\r\n  & tbody tr:nth-child(odd) {\r\n    background-color: $gray-300 !important;\r\n  }\r\n  & td {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n}\r\n\r\n.status-cell {\r\n  min-width: 100px;\r\n  max-width: 120px;\r\n  padding-right: 24px !important;\r\n  & .badge {\r\n    min-width: 70px;\r\n  }\r\n}\r\n\r\n.thumbnail-list {\r\n  margin-bottom: 0;\r\n  & .thumbnail-item {\r\n    padding: 0 2.5px;\r\n    display: inline-block;\r\n    width: 33.333%;\r\n    margin-bottom: 5px;\r\n\r\n    @media screen and (max-width: 767px) {\r\n      width: 50%;\r\n    }\r\n\r\n    @media screen and (max-width: 575px) {\r\n      width: 33.333%;\r\n    }\r\n  }\r\n}\r\n\r\n.post-list {\r\n  & .post-image .grid-thumb-equal {\r\n    padding-bottom: 100%;\r\n  }\r\n}\r\n\r\n/*Ecommerce Dashboard Styles*/\r\n.chart-f30 {\r\n  font-size: 30px;\r\n\r\n  @media screen and (max-width: 1099px) {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n.chart-f20 {\r\n  font-size: 20px;\r\n\r\n  @media screen and (max-width: 1099px) {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n.chart-order {\r\n  & .col-5 {\r\n    order: 2;\r\n    text-align: center;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      order: 1;\r\n    }\r\n  }\r\n\r\n  & .col-7 {\r\n    order: 1;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      order: 2;\r\n    }\r\n  }\r\n}\r\n\r\n.tab-notifications {\r\n  margin-left: -$jr-card-margin + 4px;\r\n  margin-right: -$jr-card-margin + 4px;\r\n  border-bottom: 1px solid $gray-500;\r\n\r\n  @media screen and (max-width: 567px) {\r\n    button,\r\n    button * {\r\n      font-size: 12px !important;\r\n    }\r\n  }\r\n}\r\n\r\n.chart-title {\r\n  & h2 {\r\n    font-size: 22px;\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.img-fluid {\r\n  width: 100%;\r\n}\r\n\r\n.comment-footer {\r\n  & button {\r\n    margin-bottom: 6px;\r\n  }\r\n}\r\n\r\n/*Intranet Dashboard Styles*/\r\n.net-chart {\r\n  padding-left: 80px;\r\n  padding-right: 15px;\r\n  min-height: 100px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n\r\n  & .jr-card-thumb {\r\n    margin: 0;\r\n    width: $size-50;\r\n    height: $size-50;\r\n    color: $white;\r\n    font-size: 20px;\r\n    @include border-radius($border-radius-circle);\r\n    @include display-flex(flex, column, nowrap);\r\n    @include justify-content(center);\r\n    @include align-items(center);\r\n    @include transition(all 100ms ease);\r\n    position: absolute;\r\n    left: 15px;\r\n  }\r\n\r\n  &:hover .jr-card-thumb {\r\n    width: 70px;\r\n    height: 100%;\r\n    font-size: 30px;\r\n    @include border-radius(0);\r\n    position: absolute;\r\n    left: 0;\r\n  }\r\n}\r\n\r\n.net-chart-hr {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  min-height: $size-120;\r\n  padding-right: 8px;\r\n  overflow: hidden;\r\n\r\n  & .jr-card-thumb {\r\n    margin: -30px 12px -30px -30px;\r\n    min-width: $size-100 + 5px;\r\n  }\r\n\r\n  & .grid-thumb-equal {\r\n    padding-bottom: 130%;\r\n  }\r\n\r\n  & .jr-card-body {\r\n    width: calc(100% - #{$size-100});\r\n  }\r\n}\r\n\r\n.user-profile {\r\n  padding: 10px 0;\r\n}\r\n\r\n.mh-120 {\r\n  min-height: $size-120;\r\n}\r\n\r\n.jr-card-header-top {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin-right: -16px;\r\n}\r\n\r\n.jr-card-header-color {\r\n  padding: 10px 20px 20px;\r\n  margin: -24px -30px 25px;\r\n}\r\n\r\n.todo-cell-group {\r\n  & .todo-cell {\r\n    &:not(:last-child) {\r\n      margin-bottom: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n.social-list-line {\r\n  position: relative;\r\n\r\n  &:not(:last-child):before {\r\n    border-left: solid 1px $gray-500;\r\n    content: \"\";\r\n    left: 20px;\r\n    position: absolute;\r\n    top: 5px;\r\n    bottom: 0;\r\n    width: 1px;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n\r\n.list-line-item {\r\n  position: relative;\r\n  padding-left: 40px;\r\n\r\n  &:not(:last-child):before {\r\n    border-left: solid 1px $gray-500;\r\n    content: \"\";\r\n    left: 20px;\r\n    position: absolute;\r\n    top: -25px;\r\n    bottom: -25px;\r\n    width: 1px;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.list-line-badge {\r\n  position: absolute;\r\n  left: 16px;\r\n  top: 15px;\r\n  z-index: 2;\r\n  @include border-radius(50%);\r\n  height: 10px;\r\n  width: 10px;\r\n  background-color: $gray-500;\r\n}\r\n\r\n.circle-shape {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 8px;\r\n  @include border-radius($border-radius-circle);\r\n}\r\n\r\n.project-list {\r\n  line-height: 1;\r\n\r\n  &:not(:last-child) {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  & .circle-shape {\r\n    margin-top: 4px;\r\n    margin-right: 16px;\r\n  }\r\n\r\n  & .project-name {\r\n    display: block;\r\n    margin-bottom: 4px;\r\n    color: $body-color;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $app-primary;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n.nav-pill-sales {\r\n  & li + li {\r\n    margin-right: -1px;\r\n  }\r\n  & .nav-link {\r\n    background-color: $gray-200;\r\n    border-radius: 0;\r\n    padding: 6px 15px;\r\n    color: $gray-600;\r\n    font-size: 13px;\r\n    border: $jr-border;\r\n\r\n    &.active {\r\n      background-color: $app-primary;\r\n      color: $white;\r\n      border-color: $app-primary;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n\r\n  & li:first-child .nav-link {\r\n    @include border-left-radius($border-radius);\r\n  }\r\n\r\n  & li:last-child .nav-link {\r\n    @include border-right-radius($border-radius);\r\n  }\r\n}\r\n\r\n.temp-week-list {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  color: lighten($gray-600, 8%);\r\n\r\n  & li:not(:last-child) {\r\n    margin-bottom: 10px;\r\n    @media screen and (max-width: 340px) {\r\n      margin-bottom: 20px;\r\n    }\r\n  }\r\n\r\n  & img {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n\r\n  & span {\r\n    display: inline-block;\r\n\r\n    &.temp-point {\r\n      margin: 0 20px;\r\n\r\n      @media screen and (max-width: 1199px) {\r\n        margin: 0 10px;\r\n      }\r\n\r\n      @media screen and (max-width: 1050px) {\r\n        margin: 0 5px;\r\n      }\r\n\r\n      @media screen and (max-width: 340px) {\r\n        margin: 0 20px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.temp-section {\r\n\r\n  .temp-point {\r\n    font-size: 36px;\r\n    font-weight: 700;\r\n    margin-bottom: 0;\r\n\r\n    & sub,\r\n    & sup {\r\n      font-size: 70%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n","/*Dropzone Styles*/\r\n.dropzone-card {\r\n  position: relative;\r\n}\r\n\r\n.dropzone {\r\n  margin-bottom: 20px;\r\n\r\n  & > div {\r\n    margin: 0 auto;\r\n    padding: 15px;\r\n    @include display-flex(flex, column, nowrap);\r\n    @include justify-content(center);\r\n\r\n    & :last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  & .btn {\r\n    margin-top: 20px;\r\n  }\r\n}\r\n\r\n.upload-file-list {\r\n  list-style: none;\r\n  padding-left: 0;\r\n\r\n  & li {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.form-group-dropzone {\r\n  & label {\r\n    margin-bottom: 6px;\r\n  }\r\n\r\n  & .form-control {\r\n    max-width: 200px;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n","/* Slider\r\n   ========================================================================== */\r\n.brand-logo {\r\n  @extend %thumb-equal;\r\n  border: 1px solid $gray-300;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  margin-bottom: 20px;\r\n  padding-bottom: 75%;\r\n\r\n  & .brand-logo-inner {\r\n    @extend %thumb-cover;\r\n    text-align: center;\r\n\r\n    &:before {\r\n      content: \"\";\r\n      display: inline-block;\r\n      height: 100%;\r\n      vertical-align: middle;\r\n    }\r\n\r\n    & img {\r\n      height: auto;\r\n      max-height: 100%;\r\n      max-width: 100%;\r\n      display: inline-block;\r\n      vertical-align: middle;\r\n      width: auto !important;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    @include transition(all 0.4s ease-in-out 0.1s);\r\n    background-color: darken($white, 5%);\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n.owl-app-frame {\r\n  &.owl-carousel .owl-item img {\r\n    display: inline-block;\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.carousel-item {\r\n  & img {\r\n    max-width: 100%;\r\n  }\r\n}","/* Modules\r\n   ========================================================================== */\r\n@import \"app-module\";\r\n@import \"chat\";\r\n@import \"mail\";\r\n@import \"contact\";\r\n@import \"calendar\";","/* App Module Style */\r\n\r\n.app-wrapper-module {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include align-items(stretch);\r\n  height: 100%;\r\n}\r\n\r\n.app-module {\r\n  position: relative;\r\n  @include display-flex(flex, row, nowrap);\r\n  margin: -36px -40px 0 -40px;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin: -20px;\r\n  }\r\n}\r\n\r\n.module-side {\r\n  position: relative;\r\n  z-index: 2;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(0, 1, 230px);\r\n  max-width: 230px;\r\n  min-width: 230px;\r\n}\r\n\r\n.module-side-header {\r\n  border-bottom: solid 1px $gray-200;\r\n  @include display-flex(flex, column, nowrap);\r\n\r\n  & .user-detail {\r\n    padding: 15px 10px;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.module-logo {\r\n  padding: 10px;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(center);\r\n  min-height: 78px;\r\n  font-size: 20px;\r\n  background-color: lighten($gray-100, 0.5%);\r\n  color: darken($gray-800, 2%);\r\n  & .zmdi {\r\n    font-size: 28px;\r\n  }\r\n}\r\n\r\n.module-user-info {\r\n  @include display-flex(flex, column, nowrap);\r\n}\r\n\r\n.module-user-detail {\r\n  font-size: 12px;\r\n}\r\n\r\n.module-side-content {\r\n  @extend .module-user-info;\r\n}\r\n\r\n.module-add-task {\r\n  @include display-flex();\r\n  padding: 24px;\r\n}\r\n\r\n.module-nav {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n\r\n  & li {\r\n    @include display-flex(flex, column, nowrap);\r\n  }\r\n\r\n  & li a {\r\n    padding: 12px 29px;\r\n    color: lighten($body-color, 20%);\r\n    @include display-flex();\r\n    @include align-items(center);\r\n    text-decoration: none;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $body-color;\r\n    }\r\n\r\n    &.active {\r\n      color: $app-primary;\r\n    }\r\n  }\r\n\r\n  & li i {\r\n    margin-right: 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  & li span {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  & li.module-nav-label {\r\n    padding: 12px 29px;\r\n  }\r\n}\r\n\r\n.module-box {\r\n  position: relative;\r\n  z-index: 2;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(1, 1, auto);\r\n  max-width: calc(100% - 231px);\r\n}\r\n\r\n.module-box-header {\r\n  padding: 10px 26px;\r\n  min-height: 79px;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  background-color: $white;\r\n  border-bottom: solid 1px $gray-200;\r\n\r\n  & .search-bar.right-side-icon {\r\n    min-width: 350px;\r\n\r\n    & .form-control {\r\n      @include border-radius(0);\r\n      height: 46px;\r\n      padding: 10px 18px 10px 40px;\r\n\r\n      &:focus {\r\n        background-color: $gray-100;\r\n      }\r\n    }\r\n\r\n    & .search-icon {\r\n      width: 25px;\r\n      height: 46px;\r\n      font-size: 16px;\r\n      left: 10px;\r\n      top: 0;\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.module-box-header-inner {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-between);\r\n}\r\n\r\n.module-box-content {\r\n  background-color: $white;\r\n  @include display-flex(flex, column, nowrap);\r\n}\r\n\r\n.module-box-topbar {\r\n  padding: 8px 12px;\r\n  @include display-flex();\r\n  border-bottom: solid 1px $gray-200;\r\n\r\n  & button + button {\r\n    @include border-radius(0);\r\n  }\r\n}\r\n\r\n.module-box-topbar-todo {\r\n  padding-left: 64px;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding-left: 27px;\r\n  }\r\n}\r\n\r\n.module-list-icon {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  padding-right: 10px;\r\n}\r\n\r\n.bar-icon {\r\n  margin-right: 15px;\r\n}\r\n\r\n.toolbar-separator {\r\n  border-left: solid 1px $gray-400;\r\n  height: 100%;\r\n  width: 1px;\r\n  margin: 0 12px;\r\n}\r\n\r\n.toolbar-left {\r\n  margin-left: auto;\r\n}\r\n\r\n.module-list {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n}\r\n\r\n.module-list-item {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  padding: 15px 28px;\r\n  border-bottom: solid 1px $gray-200;\r\n  z-index: 5;\r\n  position: relative;\r\n  cursor: pointer;\r\n\r\n  & > .check-label {\r\n    margin-left: 0;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  &.mail-cell {\r\n    padding-left: 12px;\r\n    @include align-items(start);\r\n  }\r\n}\r\n\r\n.module-detail-header {\r\n  margin-bottom: 10px;\r\n\r\n  & > .check-label {\r\n    margin-right: auto;\r\n  }\r\n}\r\n\r\n.module-list-info {\r\n  @include flex(1, 1, 0);\r\n  @include display-flex(flex, column, nowrap);\r\n  max-width: calc(100% - 169px);\r\n}\r\n\r\n.module-todo-content {\r\n  position: relative;\r\n\r\n  & .subject {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.module-list-actions {\r\n  text-align: right;\r\n}\r\n\r\n.app-module-sidenav {\r\n  background-color: $white;\r\n  border-right: solid 1px $gray-200;\r\n  position: relative;\r\n  z-index: 9;\r\n\r\n  & .chat-sidenav-main {\r\n    max-width: 300px;\r\n    min-width: 300px;\r\n    width: 90%;\r\n  }\r\n}\r\n\r\n.module-date {\r\n  max-width: 160px;\r\n\r\n  & > div:before {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.module-detail-item {\r\n  padding: 10px 28px;\r\n}\r\n\r\n.task-title {\r\n  font-size: 18px;\r\n}\r\n\r\n.chat-todo-avatar {\r\n  margin-right: 15px;\r\n}\r\n\r\n.modal-title {\r\n  @include display-flex();\r\n  @include justify-content(space-between);\r\n  @include align-items(center);\r\n  width: 100%;\r\n  font-size: 18px;\r\n}\r\n\r\n.loader-view-block {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n\r\n}\r\n\r\n.loader-view {\r\n  @extend .loader-view-block;\r\n}\r\n\r\n.module-date > div {\r\n  @include align-items(center);\r\n}\r\n\r\n@media screen and (max-width: 1199px) {\r\n  .module-side {\r\n    @include display-flex(block, row, nowrap);\r\n    @include flex(1);\r\n    max-width: $side-nav-width;\r\n    min-width: $side-nav-width;\r\n    background-color: $white;\r\n  }\r\n\r\n  .module-box-header {\r\n    position: relative;\r\n    min-height: 58px;\r\n    padding: 5px 26px 5px 75px;\r\n\r\n    & .drawer-btn {\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      z-index: 1;\r\n      border-right: solid 1px $gray-200;\r\n      height: 58px;\r\n      width: 56px;\r\n      @include border-radius(0);\r\n      font-size: 22px;\r\n    }\r\n\r\n    & .search-bar.right-side-icon .form-control {\r\n      height: 38px;\r\n      padding: 5px 18px 5px 40px;\r\n    }\r\n\r\n    & .search-bar.right-side-icon .search-icon {\r\n      height: 38px;\r\n    }\r\n  }\r\n\r\n  .chat-loader-view {\r\n    height: calc(100vh - 120px);\r\n  }\r\n\r\n  .module-box {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 991px) {\r\n  .modal-dialog {\r\n    max-width: 750px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .app-module {\r\n    padding-top: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 599px) {\r\n  .module-box-header .search-bar {\r\n    margin-left: 0;\r\n    max-width: none;\r\n\r\n    &.right-side-icon {\r\n      min-width: 250px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .module-list-item {\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .module-list-info {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .module-box-header {\r\n    & .nav-searchbox.quick-menu .dropdown-menu {\r\n      right: auto !important;\r\n      left: 0 !important;\r\n    }\r\n\r\n    & .search-bar.right-side-icon {\r\n      min-width: 200px;\r\n\r\n      & .form-control {\r\n        @include border-radius(0.25rem);\r\n      }\r\n    }\r\n\r\n    & .nav-searchbox.quick-menu .dropdown-menu {\r\n      &:after {\r\n        right: auto;\r\n        left: 9px;\r\n      }\r\n\r\n      &:before {\r\n        right: auto;\r\n        left: 9px;\r\n      }\r\n    }\r\n\r\n    & .search-bar {\r\n      padding-right: 2px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .module-box-header {\r\n    & .search-bar.right-side-icon {\r\n      min-width: 100px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 399px) {\r\n  .d-xs-flex {\r\n    display: flex !important;\r\n  }\r\n}\r\n","/*Chat Module Styles*/\r\n\r\n.chat-module {\r\n  @include flex();\r\n\r\n  &:before {\r\n    left: -29px;\r\n  }\r\n}\r\n\r\n.chat-module-box {\r\n  @include display-flex(flex, row, nowrap);\r\n  @include flex(1);\r\n  background-color: $gray-100;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.chat-sidenav {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(0, 1, 315px);\r\n  min-width: 315px;\r\n  border-right: solid 1px $gray-200;\r\n}\r\n\r\n.chat-box {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(1);\r\n  max-width: 100%;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.chat-sidenav-header {\r\n  @include display-flex(flex, column, nowrap);\r\n  padding: 25px 20px 12px;\r\n  background-color: lighten($gray-100, 0.5%);\r\n}\r\n\r\n.chat-user-hd {\r\n  @include display-flex();\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.chat-sidenav-header .search-wrapper {\r\n  @include display-flex(flex, column, nowrap);\r\n  margin-bottom: 0;\r\n\r\n  & .search-bar.right-side-icon {\r\n    @include flex();\r\n\r\n    & .form-control {\r\n      @include box-shadow(none);\r\n      @include border-radius(0);\r\n      padding-left: 42px;\r\n      height: 42px;\r\n    }\r\n\r\n    & .search-icon {\r\n      left: 10px;\r\n      top: 0;\r\n      height: 42px;\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.chat-avatar {\r\n  min-width: $size-50;\r\n\r\n  .chat-user-item & {\r\n    padding: 0 5px;\r\n    min-width: 10px;\r\n  }\r\n\r\n  .chat-user-hd & {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.chat-avatar-mode {\r\n  position: relative;\r\n  max-width: $size-50;\r\n\r\n  & .chat-mode {\r\n    display: block;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 2px;\r\n    z-index: 1;\r\n    width: 12px;\r\n    height: 12px;\r\n    border-radius: 50%;\r\n\r\n    &.small {\r\n      width: 8px;\r\n      height: 8px;\r\n    }\r\n\r\n    &.online {\r\n      background-color: map_get($green, base);\r\n      @extend %online-effect;\r\n    }\r\n\r\n    &.offline {\r\n      background-color: $white;\r\n      border: solid 1px map_get($green, base);\r\n      @extend %online-effect;\r\n    }\r\n\r\n    &.away {\r\n      background-color: map_get($yellow, darken-1);\r\n      @extend %away-effect;\r\n    }\r\n  }\r\n\r\n  .chat-main-header-info & {\r\n    max-width: $size-60;\r\n  }\r\n}\r\n\r\n.chat-sidenav-content {\r\n  background-color: $white;\r\n}\r\n\r\n.chat-sidenav-title {\r\n  padding: 10px 16px;\r\n  font-size: $font-size-base;\r\n  color: $info;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n}\r\n\r\n.chat-tabs-header {\r\n  background-color: lighten($gray-100, 0.5%) !important;\r\n}\r\n\r\n.chat-user {\r\n  @include display-flex(flex, column, nowrap);\r\n\r\n  &.chat-user-center {\r\n    @include justify-content(center);\r\n    @include align-items(center);\r\n\r\n    & .chat-avatar {\r\n      margin-left: auto;\r\n    }\r\n  }\r\n}\r\n\r\n.chat-user-item {\r\n  border-bottom: solid 1px $gray-200;\r\n  padding: 16px;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  cursor: pointer;\r\n  max-height: 96px;\r\n\r\n  &.active,\r\n  &:hover {\r\n    background-color: lighten($app-primary, 45%);\r\n  }\r\n}\r\n\r\n.chat-user-row {\r\n  margin: 0 -5px;\r\n  @include align-items(center);\r\n}\r\n\r\n.chat-info {\r\n  padding: 0 5px;\r\n\r\n  & p {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  & .h4 {\r\n    display: block;\r\n    margin-bottom: 3px;\r\n  }\r\n}\r\n\r\n.chat-info-des {\r\n  color: $gray-600;\r\n  font-size: 13px;\r\n}\r\n\r\n.chat-date {\r\n  padding: 0 5px;\r\n  text-align: right;\r\n}\r\n\r\n.chat-contact-col {\r\n  @extend .chat-info;\r\n}\r\n\r\n.chat-box-main {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  height: 100%;\r\n}\r\n\r\n.module-default {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n  height: 100%;\r\n  padding: 15px;\r\n}\r\n\r\n.s-128 {\r\n  font-size: 128px !important;\r\n  width: 128px !important;\r\n  height: 128px !important;\r\n  line-height: 128px !important;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.chat-main {\r\n  @include display-flex(flex, column, nowrap);\r\n}\r\n\r\n.chat-main-header {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  border-bottom: solid 1px $gray-200;\r\n  padding: 16px;\r\n  background-color: $white;\r\n  width: 100%;\r\n}\r\n\r\n.chat-main-header-info {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin-right: auto;\r\n}\r\n\r\n.chat-contact-name {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n.chat-main-footer {\r\n  @include display-flex(flex, column, nowrap);\r\n  border-top: solid 1px $gray-200;\r\n  padding: 16px;\r\n  background-color: $white;\r\n  width: 100%;\r\n\r\n  & .form-group {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.todo-main-footer {\r\n  padding: 6px 16px;\r\n}\r\n\r\n.chat-item {\r\n  padding: 16px;\r\n\r\n  & .bubble {\r\n    padding: 8px 12px;\r\n    background-color: $white;\r\n    @include border-radius(20px 20px 20px 0px);\r\n    position: relative;\r\n    margin-left: 16px;\r\n    max-width: 600px;\r\n    border: solid 1px $gray-400;\r\n  }\r\n\r\n  &.flex-row-reverse {\r\n    & .bubble {\r\n      margin-right: 16px;\r\n      margin-left: 0;\r\n      background-color: lighten($app-primary, 45%);\r\n      @include border-radius(20px 20px 0 20px);\r\n    }\r\n  }\r\n}\r\n\r\n.chat-btn {\r\n  font-size: 38px !important;\r\n  margin: 0 10px 0 -8px;\r\n}\r\n\r\n.chat-textarea {\r\n  height: 40px;\r\n  @include box-shadow(none);\r\n  @include border-radius(0);\r\n}\r\n\r\n.last-message-time {\r\n  font-size: 11px;\r\n  color: $gray-500;\r\n}\r\n\r\n@media screen and (max-width: 1399px) {\r\n  .s-128 {\r\n    font-size: 100px !important;\r\n    width: 100px !important;\r\n    height: 100px !important;\r\n    line-height: 100px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1199px) {\r\n  .chat-module {\r\n    margin: -24px -29px -23px;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .chat-main-header {\r\n    padding: 8px 24px;\r\n\r\n    & .size-60 {\r\n      height: 50px !important;\r\n      width: 50px !important;\r\n      line-height: 50px;\r\n    }\r\n\r\n    & button {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  .chat-main-header-info {\r\n    & .chat-avatar-mode {\r\n      max-width: 50px;\r\n    }\r\n  }\r\n\r\n  .chat-contact-name,\r\n  .chat-sidenav-title {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .chat-main-footer {\r\n    padding: 8px 16px;\r\n  }\r\n\r\n  .s-128 {\r\n    font-size: 128px !important;\r\n    width: 128px !important;\r\n    height: 128px !important;\r\n    line-height: 128px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .s-128 {\r\n    font-size: 100px !important;\r\n    width: 100px !important;\r\n    height: 100px !important;\r\n    line-height: 100px !important;\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .chat-sidenav-title,\r\n  .chat-contact-name {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .s-128 {\r\n    font-size: 80px !important;\r\n    width: 80px !important;\r\n    height: 80px !important;\r\n    line-height: 80px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .module-default {\r\n    h1 {\r\n      font-size: 17px;\r\n    }\r\n  }\r\n  .s-128 {\r\n    font-size: 40px !important;\r\n    width: 40px !important;\r\n    height: 40px !important;\r\n    line-height: 40px !important;\r\n  }\r\n}\r\n\r\n","/*Mails Module Styles*/\r\n\r\n.module-box-row {\r\n  @include display-flex();\r\n  width: 100%;\r\n}\r\n\r\n.module-box-column {\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n}\r\n\r\n.mail-user-info {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n\r\n  & .avatar {\r\n    margin-right: 10px;\r\n  }\r\n\r\n  & .time,\r\n  & button {\r\n    margin-left: auto;\r\n  }\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.module-list-item.mail-cell {\r\n  @include display-flex();\r\n}\r\n\r\n.mail-detail {\r\n  padding: 24px !important;\r\n}\r\n\r\n.mail-header {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n}\r\n\r\n.mail-header-content {\r\n  @include display-flex(flex, column, nowrap);\r\n\r\n  & .subject {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.show-detail {\r\n  cursor: pointer;\r\n}\r\n\r\n.text-truncate {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.module-list-content {\r\n  & .subject {\r\n    @extend .text-truncate;\r\n  }\r\n\r\n  & .message {\r\n    @include display-flex(flex, column, nowrap);\r\n    color: darken($gray-500, 10%);\r\n    font-size: 13px;\r\n\r\n    p {\r\n      @extend .text-truncate;\r\n      margin-bottom: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n.size {\r\n  margin: 5px 0;\r\n}\r\n\r\n.sender-name {\r\n  margin-right: 0;\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n}\r\n\r\n.mail-header-actions {\r\n  text-align: right;\r\n  min-width: 100px;\r\n  @include display-flex();\r\n\r\n  & .icon-btn:not(:last-child) {\r\n    margin-right: 3px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .module-list-item.mail-cell {\r\n    padding-right: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 576px) {\r\n  .mail-list {\r\n    @include flex(1, 1, auto);\r\n    max-width: 100%;\r\n    border-right: 0 none;\r\n  }\r\n\r\n  .mail-detail {\r\n    @include flex(1, 1, auto);\r\n    max-width: 100%;\r\n\r\n    & .module-list-scroll {\r\n      padding: 24px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 499px) {\r\n  .mail-header {\r\n    display: block;\r\n    @include align-items(flex-start);\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-flex-wrap: nowrap;\r\n    -ms-flex-wrap: nowrap;\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .mail-header-actions {\r\n    text-align: left;\r\n    min-width: 10px;\r\n  }\r\n\r\n  .MuiDialog-paperWidthSm-99 {\r\n    max-width: 250px !important;\r\n  }\r\n}","/*Contact Module Styles*/\r\n\r\n.contact-item {\r\n  @include align-items(center);\r\n  @include display-flex();\r\n  border-bottom: solid 1px $gray-200;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.contact-name {\r\n  font-size: 15px;\r\n}\r\n\r\n.modal-box {\r\n  position: relative;\r\n}\r\n\r\n.modal-w {\r\n  max-width: 400px;\r\n  min-width: 350px;\r\n\r\n  .modal-box-mail & {\r\n    min-width: 600px;\r\n  }\r\n}\r\n\r\n.modal-box-header {\r\n  color: $white;\r\n  @include border-top-radius(4px);\r\n}\r\n\r\n.modal-box-header h2 {\r\n  color: $white;\r\n  position: relative;\r\n\r\n  & button {\r\n    position: absolute;\r\n    right: 0;\r\n    top: -10px;\r\n    z-index: 1;\r\n    color: $white;\r\n  }\r\n}\r\n\r\n.modal-box-content {\r\n  padding: 24px;\r\n\r\n  & .avatar {\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.modal-box-footer {\r\n  padding: 0 24px 24px;\r\n\r\n  & .attach-file {\r\n    @include display-flex();\r\n    @include align-items(center);\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n.btn-fixed {\r\n  position: fixed !important;\r\n  right: 40px;\r\n  bottom: 60px;\r\n  z-index: 100;\r\n}\r\n\r\n.draggable-icon {\r\n  cursor: all-scroll;\r\n  color: $gray-600;\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    cursor: all-scroll;\r\n    color: $gray-900;\r\n  }\r\n}\r\n\r\n.module-side-nav {\r\n  padding: 20px 0;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .modal-w {\r\n    .modal-box-mail & {\r\n      min-width: 500px;\r\n    }\r\n  }\r\n\r\n  .modal-box-header h2 {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .modal-w {\r\n    min-width: 300px;\r\n\r\n    .modal-box-mail & {\r\n      min-width: 400px;\r\n    }\r\n  }\r\n\r\n  .modal-box-header h2 {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 419px) {\r\n  .modal-w {\r\n    min-width: 250px;\r\n\r\n    .modal-box-mail & {\r\n      min-width: 250px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .con-inf-mw-100 {\r\n    min-width: 100% !important;\r\n  }\r\n}\r\n","/* Calendar Module Style */\r\n\r\n.rbc-calendar {\r\n  .app-calendar & {\r\n    @include display-flex(flex, column, nowrap);\r\n    @include flex(1);\r\n    min-height: calc(100vh - 160px);\r\n  }\r\n\r\n  .app-cul-calendar & {\r\n    min-height: calc(100vh - 200px);\r\n  }\r\n}\r\n\r\n.rbc-event {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.rbc-event.rbc-selected {\r\n  background-color: darken($app-primary, 10%);\r\n}\r\n\r\n.rbc-slot-selection {\r\n  background-color: rgba($app-primary, 0.7);\r\n}\r\n\r\n.rbc-toolbar button:active,\r\n.rbc-toolbar button.rbc-active {\r\n  color: $white;\r\n  background-image: none;\r\n  @include box-shadow(none);\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-toolbar button:active:hover,\r\n.rbc-toolbar button.rbc-active:hover,\r\n.rbc-toolbar button:active:focus,\r\n.rbc-toolbar button.rbc-active:focus {\r\n  color: $white;\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-toolbar button:focus {\r\n  color: $white;\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-toolbar button:hover {\r\n  color: $white;\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-month-row {\r\n  min-height: 100px;\r\n}\r\n\r\n.rbc-event {\r\n  min-height: 50px;\r\n}\r\n\r\n@media screen and (max-width: 867px) {\r\n  .rbc-toolbar {\r\n    @include display-flex(flex, column, nowrap);\r\n    @include align-items(flex-start);\r\n  }\r\n\r\n  .rbc-toolbar .rbc-toolbar-label {\r\n    margin: 8px 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-height: 600px) {\r\n  .rbc-calendar {\r\n    .app-calendar & {\r\n      min-height: 400px;\r\n    }\r\n\r\n    .app-cul-calendar & {\r\n      min-height: 400px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 467px) {\r\n  .rbc-toolbar {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .rbc-toolbar button {\r\n    padding: 5px 10px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
